webpackJsonp([10],{

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialogComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RegistrationDialogComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ApplicationRejectActionDialogComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DashboardActionDialogComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ApplicationDashboardActionDialogComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ActiveInactiveDialogComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CSVErrorDialogComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ShowApplicationsDialogComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SelectApplicationsDialogComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WelcomeDialogComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BuAssignmentDialogComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(10);




var DialogComponent = /** @class */ (function () {
    function DialogComponent(dialog, dialogRef) {
        this.dialog = dialog;
        this.dialogRef = dialogRef;
        this.isConfirm = false;
    }
    DialogComponent.prototype.ngOnInit = function () {
    };
    DialogComponent.prototype.closeDialog = function () {
        this.dialog.closeAll();
    };
    DialogComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            template: __webpack_require__(1255)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_3__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_3__angular_material__["d" /* MdDialogRef */]])
    ], DialogComponent);
    return DialogComponent;
}());

var RegistrationDialogComponent = /** @class */ (function () {
    function RegistrationDialogComponent(dialog, dialogRef) {
        this.dialog = dialog;
        this.dialogRef = dialogRef;
        this.isConfirm = false;
    }
    RegistrationDialogComponent.prototype.ngOnInit = function () {
    };
    RegistrationDialogComponent.prototype.closeDialog = function () {
        this.dialog.closeAll();
    };
    RegistrationDialogComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            template: __webpack_require__(1256)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_3__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_3__angular_material__["d" /* MdDialogRef */]])
    ], RegistrationDialogComponent);
    return RegistrationDialogComponent;
}());

var ApplicationRejectActionDialogComponent = /** @class */ (function () {
    function ApplicationRejectActionDialogComponent(dialog, dialogRef, formBuilder) {
        this.dialog = dialog;
        this.dialogRef = dialogRef;
        this.formBuilder = formBuilder;
    }
    ApplicationRejectActionDialogComponent.prototype.buildForm = function () {
        var _this = this;
        this.RejectActionForm = this.formBuilder.group({
            reason: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_2__angular_forms__["g" /* Validators */].required])
        });
        this.RejectActionForm.valueChanges.subscribe(function (data) {
            _this.reasonDeatils = _this.RejectActionForm.getRawValue();
        });
    };
    ApplicationRejectActionDialogComponent.prototype.ngOnInit = function () {
        this.buildForm();
    };
    ApplicationRejectActionDialogComponent.prototype.closeDialog = function () {
        this.dialog.closeAll();
    };
    ApplicationRejectActionDialogComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            template: __webpack_require__(1251)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_3__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_3__angular_material__["d" /* MdDialogRef */], __WEBPACK_IMPORTED_MODULE_2__angular_forms__["h" /* FormBuilder */]])
    ], ApplicationRejectActionDialogComponent);
    return ApplicationRejectActionDialogComponent;
}());

var DashboardActionDialogComponent = /** @class */ (function () {
    function DashboardActionDialogComponent(dialog, dialogRef, formBuilder) {
        this.dialog = dialog;
        this.dialogRef = dialogRef;
        this.formBuilder = formBuilder;
        this.isApproved = false;
        this.isReject = false;
        this.RoleData = [
            {
                "id": 1,
                "name": "Service Partner"
            }, {
                "id": 2,
                "name": "Trade Partner"
            }
        ];
    }
    DashboardActionDialogComponent.prototype.buildForm = function () {
        var _this = this;
        this.ActionForm = this.formBuilder.group({
            approveGroup: this.formBuilder.group({
                /*role: this.formBuilder.control(null, [Validators.required]),*/
                selectedPartnerType: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_2__angular_forms__["g" /* Validators */].required]),
                customerNumber: this.formBuilder.control(this.row['customerNumber'] ? this.row['customerNumber'] : null, [__WEBPACK_IMPORTED_MODULE_2__angular_forms__["g" /* Validators */].required])
            }),
            rejectGroup: this.formBuilder.group({
                reason: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_2__angular_forms__["g" /* Validators */].required]),
            }),
            multiApproveGroup: this.formBuilder.group({
                /*role: this.formBuilder.control(null, [Validators.required]),*/
                selectedRadioValue: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_2__angular_forms__["g" /* Validators */].required])
            }),
            multiRejectGroup: this.formBuilder.group({
                reason: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_2__angular_forms__["g" /* Validators */].required]),
                selectedRadioValue: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_2__angular_forms__["g" /* Validators */].required])
            })
        });
        this.ActionForm.valueChanges.subscribe(function (data) {
            var actionFormDetails = _this.ActionForm.getRawValue();
            _this.approveDetails = actionFormDetails.approveGroup;
            _this.approveDetails['roleId'] = [];
            _this.approveDetails['roleId'].push(_this.approveDetails['role']);
            _this.rejectDetails = actionFormDetails.rejectGroup;
            _this.multiApproveDetails = actionFormDetails.multiApproveGroup;
            _this.multiApproveDetails['roleId'] = [];
            _this.multiApproveDetails['roleId'].push(_this.multiApproveDetails['role']);
            _this.multiRejectDetails = actionFormDetails.multiRejectGroup;
            if (_this.condition3Flag) {
                _this.multiApproveDetails['selectedRadioValue'] = "Approve All";
                _this.multiRejectDetails['selectedRadioValue'] = "Approve All";
            }
        });
    };
    DashboardActionDialogComponent.prototype.ngOnInit = function () {
        this.buildForm();
        if (!this.row['customerNumberMandatory']) {
            this.ActionForm.get('approveGroup').get('selectedPartnerType').setValidators(null);
            this.ActionForm.get('approveGroup').get('selectedPartnerType').updateValueAndValidity();
            this.ActionForm.get('approveGroup').get('customerNumber').setValidators(null);
            this.ActionForm.get('approveGroup').get('customerNumber').updateValueAndValidity();
        }
        if (this.condition2Flag != true) {
            this.ActionForm.get('multiApproveGroup').get('selectedRadioValue').setValidators(null);
            this.ActionForm.get('multiApproveGroup').get('selectedRadioValue').updateValueAndValidity();
            this.ActionForm.get('multiRejectGroup').get('selectedRadioValue').setValidators(null);
            this.ActionForm.get('multiRejectGroup').get('selectedRadioValue').updateValueAndValidity();
        }
    };
    DashboardActionDialogComponent.prototype.closeDialog = function () {
        this.dialog.closeAll();
    };
    DashboardActionDialogComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            template: __webpack_require__(1254)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_3__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_3__angular_material__["d" /* MdDialogRef */], __WEBPACK_IMPORTED_MODULE_2__angular_forms__["h" /* FormBuilder */]])
    ], DashboardActionDialogComponent);
    return DashboardActionDialogComponent;
}());

var ApplicationDashboardActionDialogComponent = /** @class */ (function () {
    function ApplicationDashboardActionDialogComponent(dialog, dialogRef, formBuilder) {
        this.dialog = dialog;
        this.dialogRef = dialogRef;
        this.formBuilder = formBuilder;
        this.isApproved = false;
        this.isReject = false;
    }
    ApplicationDashboardActionDialogComponent.prototype.buildForm = function () {
        var _this = this;
        this.ActionForm = this.formBuilder.group({
            multiApproveGroup: this.formBuilder.group({
                role: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_2__angular_forms__["g" /* Validators */].required]),
                selectedRadioValue: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_2__angular_forms__["g" /* Validators */].required]),
            }),
            multiRejectGroup: this.formBuilder.group({
                reason: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_2__angular_forms__["g" /* Validators */].required]),
                selectedRadioValue: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_2__angular_forms__["g" /* Validators */].required]),
            })
        });
        this.ActionForm.valueChanges.subscribe(function (data) {
            var actionFormDetails = _this.ActionForm.getRawValue();
            _this.multiApproveDetails = actionFormDetails.multiApproveGroup;
            _this.multiApproveDetails['selectedRoles'] = [];
            for (var d in _this.multiApproveDetails.role) {
                _this.multiApproveDetails['selectedRoles'].push(_this.multiApproveDetails.role[d]['id']);
            }
            _this.multiRejectDetails = actionFormDetails.multiRejectGroup;
            if (_this.condition3Flag) {
                _this.multiApproveDetails['selectedRadioValue'] = "Approve All";
                _this.multiRejectDetails['selectedRadioValue'] = "Approve All";
            }
        });
    };
    ApplicationDashboardActionDialogComponent.prototype.ngOnInit = function () {
        this.buildForm();
        if (this.condition2Flag != true) {
            this.ActionForm.get('multiApproveGroup').get('selectedRadioValue').setValidators(null);
            this.ActionForm.get('multiApproveGroup').get('selectedRadioValue').updateValueAndValidity();
            this.ActionForm.get('multiRejectGroup').get('selectedRadioValue').setValidators(null);
            this.ActionForm.get('multiRejectGroup').get('selectedRadioValue').updateValueAndValidity();
        }
    };
    ApplicationDashboardActionDialogComponent.prototype.closeDialog = function () {
        this.dialog.closeAll();
    };
    ApplicationDashboardActionDialogComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            template: __webpack_require__(1250)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_3__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_3__angular_material__["d" /* MdDialogRef */], __WEBPACK_IMPORTED_MODULE_2__angular_forms__["h" /* FormBuilder */]])
    ], ApplicationDashboardActionDialogComponent);
    return ApplicationDashboardActionDialogComponent;
}());

var ActiveInactiveDialogComponent = /** @class */ (function () {
    function ActiveInactiveDialogComponent(dialog, dialogRef) {
        this.dialog = dialog;
        this.dialogRef = dialogRef;
        this.isConfirm = false;
    }
    ActiveInactiveDialogComponent.prototype.ngOnInit = function () {
    };
    ActiveInactiveDialogComponent.prototype.closeDialog = function () {
        this.dialog.closeAll();
    };
    ActiveInactiveDialogComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            template: __webpack_require__(1249)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_3__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_3__angular_material__["d" /* MdDialogRef */]])
    ], ActiveInactiveDialogComponent);
    return ActiveInactiveDialogComponent;
}());

var CSVErrorDialogComponent = /** @class */ (function () {
    function CSVErrorDialogComponent(dialog, dialogRef) {
        this.dialog = dialog;
        this.dialogRef = dialogRef;
    }
    CSVErrorDialogComponent.prototype.ngOnInit = function () {
    };
    CSVErrorDialogComponent.prototype.closeDialog = function () {
        this.dialog.closeAll();
    };
    CSVErrorDialogComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            template: __webpack_require__(1253)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_3__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_3__angular_material__["d" /* MdDialogRef */]])
    ], CSVErrorDialogComponent);
    return CSVErrorDialogComponent;
}());

var ShowApplicationsDialogComponent = /** @class */ (function () {
    function ShowApplicationsDialogComponent(dialog, dialogRef) {
        this.dialog = dialog;
        this.dialogRef = dialogRef;
    }
    ShowApplicationsDialogComponent.prototype.ngOnInit = function () { };
    ShowApplicationsDialogComponent.prototype.closeDialog = function () {
        this.dialog.closeAll();
    };
    ShowApplicationsDialogComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            template: __webpack_require__(1258)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_3__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_3__angular_material__["d" /* MdDialogRef */]])
    ], ShowApplicationsDialogComponent);
    return ShowApplicationsDialogComponent;
}());

var SelectApplicationsDialogComponent = /** @class */ (function () {
    function SelectApplicationsDialogComponent(dialog, dialogRef, formBuilder) {
        this.dialog = dialog;
        this.dialogRef = dialogRef;
        this.formBuilder = formBuilder;
        this.settings = {};
        this.buildForm();
    }
    SelectApplicationsDialogComponent.prototype.buildForm = function () {
        var _this = this;
        this.ApplicationsForm = this.formBuilder.group({
            applicationsData: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_2__angular_forms__["g" /* Validators */].required])
        });
        this.ApplicationsForm.valueChanges.subscribe(function (data) {
            _this.ApplicationsFormDetails = _this.ApplicationsForm.getRawValue();
            _this.ApplicationsFormDetails['businessUnitId'] = _this.businessUnitId;
            _this.ApplicationsFormDetails['applicationId'] = [];
            for (var d in _this.ApplicationsFormDetails.applicationsData) {
                _this.ApplicationsFormDetails['applicationId'].push(_this.ApplicationsFormDetails.applicationsData[d]['id']);
            }
            _this.ApplicationsFormDetails.validate = _this.ApplicationsForm.valid;
        });
        this.ApplicationsForm.get('applicationsData').valueChanges.subscribe(function (data) {
            if (data != null && data.length > 0) {
                _this.applicationFlag = false;
            }
            else {
                _this.applicationFlag = true;
            }
        });
    };
    SelectApplicationsDialogComponent.prototype.ngOnInit = function () {
        this.settings = {
            singleSelection: false,
            text: "Select Application",
            labelKey: "name",
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            classes: "myclass custom-class"
        };
    };
    SelectApplicationsDialogComponent.prototype.closeDialog = function () {
        this.dialog.closeAll();
    };
    SelectApplicationsDialogComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            template: __webpack_require__(1257)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_3__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_3__angular_material__["d" /* MdDialogRef */], __WEBPACK_IMPORTED_MODULE_2__angular_forms__["h" /* FormBuilder */]])
    ], SelectApplicationsDialogComponent);
    return SelectApplicationsDialogComponent;
}());

var WelcomeDialogComponent = /** @class */ (function () {
    function WelcomeDialogComponent(dialog, dialogRef) {
        this.dialog = dialog;
        this.dialogRef = dialogRef;
    }
    WelcomeDialogComponent.prototype.ngOnInit = function () {
    };
    WelcomeDialogComponent.prototype.closeDialog = function () {
        this.dialog.closeAll();
    };
    WelcomeDialogComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            template: __webpack_require__(1259)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_3__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_3__angular_material__["d" /* MdDialogRef */]])
    ], WelcomeDialogComponent);
    return WelcomeDialogComponent;
}());

// Bu Assignment Dialog.
var BuAssignmentDialogComponent = /** @class */ (function () {
    function BuAssignmentDialogComponent(dialog, dialogRef) {
        this.dialog = dialog;
        this.dialogRef = dialogRef;
        this.isConfirm = false;
        this.closeBtn = false;
    }
    BuAssignmentDialogComponent.prototype.ngOnInit = function () {
    };
    BuAssignmentDialogComponent.prototype.closeDialog = function () {
        this.dialog.closeAll();
    };
    BuAssignmentDialogComponent.prototype.onChange = function (admin) {
        this.isConfirm = true;
        this.selectedAdminData = admin;
    };
    BuAssignmentDialogComponent.prototype.dialogClose = function (result) {
        this.closeBtn = result;
    };
    BuAssignmentDialogComponent.prototype.ngOnDestroy = function () {
        if (!this.closeBtn) {
            this.dialogRef.close(this.selectedAdminData);
        }
    };
    BuAssignmentDialogComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            template: __webpack_require__(1252)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_3__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_3__angular_material__["d" /* MdDialogRef */]])
    ], BuAssignmentDialogComponent);
    return BuAssignmentDialogComponent;
}());



/***/ }),

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APPCONFIG; });
function makeAppConfig() {
    var hostname = window.location.hostname;
    var isLocal = hostname.startsWith('localhost') || hostname.startsWith('127.0.0.1');
    var devTestUrl = 'whr-self-registration-uat.appspot.com';
    var hostUrl = 'https://backendservice-dot-' + (isLocal ? devTestUrl : hostname);
    var AppConfig = {
        brand: 'Beko Europe Partner Registration Portal',
        URL: hostUrl,
        translationUrl: '/_ah/api/noAuthApi/v1/i18nJson',
        translationVersion: 3,
        apiKey: 'AIzaSyC6hpVLEnGHyCEC-2sLZt4-AgUeil9Xdi0',
        google_client_id: '731139322915-nctt38kpf4dg8hufuo1kdaesod2dq2nd.apps.googleusercontent.com',
        validNameRegex: /^[a-zA-Z0-9`$%&*_+-:,. ']+$/,
        toasterDefaultTimeOut: 2000,
        toasterDefaultPositionClass: 'toast-bottom-right',
        // 'toast-top-left', 'toast-top-center', 'toast-top-right',
        // 'toast-bottom-left', 'toast-bottom-center', 'toast-bottom-right',
        toastrType: { error: 'error', info: 'info', wait: 'wait', success: 'success', warning: 'warning' },
        emailPattern: /^.+@.+\..+$/,
        user: '',
        layoutBoxed: false,
        navCollapsed: true,
        navBehind: false,
        fixedHeader: true,
        sidebarWidth: 'middle',
        theme: 'light',
        colorOption: '21',
        AutoCloseMobileNav: true,
        productLink: '',
        systemAdmin: 'SYSTEM_ADMIN',
        regionalAdmin: 'REGIONAL_ADMIN',
        BUManager: 'BU_MANAGER',
        applicationManager: 'APPLICATION_MANAGER',
        serviceOwner: 'SERVICE_OWNER',
        tradePartner: 'TRADE_PARTNER',
        subuser: 'SUBUSER'
    };
    return AppConfig;
}
var APPCONFIG = makeAppConfig();


/***/ }),

/***/ 1209:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1210:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1211:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1212:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1213:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1214:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1215:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1218:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 436,
	"./af.js": 436,
	"./ar": 444,
	"./ar-dz": 437,
	"./ar-dz.js": 437,
	"./ar-kw": 438,
	"./ar-kw.js": 438,
	"./ar-ly": 439,
	"./ar-ly.js": 439,
	"./ar-ma": 440,
	"./ar-ma.js": 440,
	"./ar-ps": 441,
	"./ar-ps.js": 441,
	"./ar-sa": 442,
	"./ar-sa.js": 442,
	"./ar-tn": 443,
	"./ar-tn.js": 443,
	"./ar.js": 444,
	"./az": 445,
	"./az.js": 445,
	"./be": 446,
	"./be.js": 446,
	"./bg": 447,
	"./bg.js": 447,
	"./bm": 448,
	"./bm.js": 448,
	"./bn": 450,
	"./bn-bd": 449,
	"./bn-bd.js": 449,
	"./bn.js": 450,
	"./bo": 451,
	"./bo.js": 451,
	"./br": 452,
	"./br.js": 452,
	"./bs": 453,
	"./bs.js": 453,
	"./ca": 454,
	"./ca.js": 454,
	"./cs": 455,
	"./cs.js": 455,
	"./cv": 456,
	"./cv.js": 456,
	"./cy": 457,
	"./cy.js": 457,
	"./da": 458,
	"./da.js": 458,
	"./de": 461,
	"./de-at": 459,
	"./de-at.js": 459,
	"./de-ch": 460,
	"./de-ch.js": 460,
	"./de.js": 461,
	"./dv": 462,
	"./dv.js": 462,
	"./el": 463,
	"./el.js": 463,
	"./en-au": 464,
	"./en-au.js": 464,
	"./en-ca": 465,
	"./en-ca.js": 465,
	"./en-gb": 466,
	"./en-gb.js": 466,
	"./en-ie": 467,
	"./en-ie.js": 467,
	"./en-il": 468,
	"./en-il.js": 468,
	"./en-in": 469,
	"./en-in.js": 469,
	"./en-nz": 470,
	"./en-nz.js": 470,
	"./en-sg": 471,
	"./en-sg.js": 471,
	"./eo": 472,
	"./eo.js": 472,
	"./es": 476,
	"./es-do": 473,
	"./es-do.js": 473,
	"./es-mx": 474,
	"./es-mx.js": 474,
	"./es-us": 475,
	"./es-us.js": 475,
	"./es.js": 476,
	"./et": 477,
	"./et.js": 477,
	"./eu": 478,
	"./eu.js": 478,
	"./fa": 479,
	"./fa.js": 479,
	"./fi": 480,
	"./fi.js": 480,
	"./fil": 481,
	"./fil.js": 481,
	"./fo": 482,
	"./fo.js": 482,
	"./fr": 485,
	"./fr-ca": 483,
	"./fr-ca.js": 483,
	"./fr-ch": 484,
	"./fr-ch.js": 484,
	"./fr.js": 485,
	"./fy": 486,
	"./fy.js": 486,
	"./ga": 487,
	"./ga.js": 487,
	"./gd": 488,
	"./gd.js": 488,
	"./gl": 489,
	"./gl.js": 489,
	"./gom-deva": 490,
	"./gom-deva.js": 490,
	"./gom-latn": 491,
	"./gom-latn.js": 491,
	"./gu": 492,
	"./gu.js": 492,
	"./he": 493,
	"./he.js": 493,
	"./hi": 494,
	"./hi.js": 494,
	"./hr": 495,
	"./hr.js": 495,
	"./hu": 496,
	"./hu.js": 496,
	"./hy-am": 497,
	"./hy-am.js": 497,
	"./id": 498,
	"./id.js": 498,
	"./is": 499,
	"./is.js": 499,
	"./it": 501,
	"./it-ch": 500,
	"./it-ch.js": 500,
	"./it.js": 501,
	"./ja": 502,
	"./ja.js": 502,
	"./jv": 503,
	"./jv.js": 503,
	"./ka": 504,
	"./ka.js": 504,
	"./kk": 505,
	"./kk.js": 505,
	"./km": 506,
	"./km.js": 506,
	"./kn": 507,
	"./kn.js": 507,
	"./ko": 508,
	"./ko.js": 508,
	"./ku": 510,
	"./ku-kmr": 509,
	"./ku-kmr.js": 509,
	"./ku.js": 510,
	"./ky": 511,
	"./ky.js": 511,
	"./lb": 512,
	"./lb.js": 512,
	"./lo": 513,
	"./lo.js": 513,
	"./lt": 514,
	"./lt.js": 514,
	"./lv": 515,
	"./lv.js": 515,
	"./me": 516,
	"./me.js": 516,
	"./mi": 517,
	"./mi.js": 517,
	"./mk": 518,
	"./mk.js": 518,
	"./ml": 519,
	"./ml.js": 519,
	"./mn": 520,
	"./mn.js": 520,
	"./mr": 521,
	"./mr.js": 521,
	"./ms": 523,
	"./ms-my": 522,
	"./ms-my.js": 522,
	"./ms.js": 523,
	"./mt": 524,
	"./mt.js": 524,
	"./my": 525,
	"./my.js": 525,
	"./nb": 526,
	"./nb.js": 526,
	"./ne": 527,
	"./ne.js": 527,
	"./nl": 529,
	"./nl-be": 528,
	"./nl-be.js": 528,
	"./nl.js": 529,
	"./nn": 530,
	"./nn.js": 530,
	"./oc-lnc": 531,
	"./oc-lnc.js": 531,
	"./pa-in": 532,
	"./pa-in.js": 532,
	"./pl": 533,
	"./pl.js": 533,
	"./pt": 535,
	"./pt-br": 534,
	"./pt-br.js": 534,
	"./pt.js": 535,
	"./ro": 536,
	"./ro.js": 536,
	"./ru": 537,
	"./ru.js": 537,
	"./sd": 538,
	"./sd.js": 538,
	"./se": 539,
	"./se.js": 539,
	"./si": 540,
	"./si.js": 540,
	"./sk": 541,
	"./sk.js": 541,
	"./sl": 542,
	"./sl.js": 542,
	"./sq": 543,
	"./sq.js": 543,
	"./sr": 545,
	"./sr-cyrl": 544,
	"./sr-cyrl.js": 544,
	"./sr.js": 545,
	"./ss": 546,
	"./ss.js": 546,
	"./sv": 547,
	"./sv.js": 547,
	"./sw": 548,
	"./sw.js": 548,
	"./ta": 549,
	"./ta.js": 549,
	"./te": 550,
	"./te.js": 550,
	"./tet": 551,
	"./tet.js": 551,
	"./tg": 552,
	"./tg.js": 552,
	"./th": 553,
	"./th.js": 553,
	"./tk": 554,
	"./tk.js": 554,
	"./tl-ph": 555,
	"./tl-ph.js": 555,
	"./tlh": 556,
	"./tlh.js": 556,
	"./tr": 557,
	"./tr.js": 557,
	"./tzl": 558,
	"./tzl.js": 558,
	"./tzm": 560,
	"./tzm-latn": 559,
	"./tzm-latn.js": 559,
	"./tzm.js": 560,
	"./ug-cn": 561,
	"./ug-cn.js": 561,
	"./uk": 562,
	"./uk.js": 562,
	"./ur": 563,
	"./ur.js": 563,
	"./uz": 565,
	"./uz-latn": 564,
	"./uz-latn.js": 564,
	"./uz.js": 565,
	"./vi": 566,
	"./vi.js": 566,
	"./x-pseudo": 567,
	"./x-pseudo.js": 567,
	"./yo": 568,
	"./yo.js": 568,
	"./zh-cn": 569,
	"./zh-cn.js": 569,
	"./zh-hk": 570,
	"./zh-hk.js": 570,
	"./zh-mo": 571,
	"./zh-mo.js": 571,
	"./zh-tw": 572,
	"./zh-tw.js": 572
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1218;

/***/ }),

/***/ 1242:
/***/ (function(module, exports) {

module.exports = ""

/***/ }),

/***/ 1243:
/***/ (function(module, exports) {

module.exports = ".loader-hidden {\n    visibility: hidden;\n}\n.loader-overlay {\n    position: absolute;\n    width:100%;\n    top:0;\n    left: 0;\n    opacity: 1;\n    z-index: 500000;\n}"

/***/ }),

/***/ 1244:
/***/ (function(module, exports) {

module.exports = "<button *ngIf=\"dashboard == 'admin' || dashboard == 'partners'\" type=\"submit\" (click)=\"performAction('delete')\" md-raised-button color=\"accent\" class=\"btn-w-sm btn-w-md color-white font-size-13 approve-reject\"><span class=\"btn-text\">{{ 'DELETE' | translate }}</span></button>\n<button *ngIf=\"(dashboard == 'adminList' || dashboard == 'managerList' || dashboard == 'applicationList') && childData['active'] == true\" type=\"submit\" (click)=\"performAction('inactive')\" md-raised-button color=\"warn\" class=\"btn-w-sm btn-w-md btn-red font-size-13 approve-reject\"><span class=\"btn-text\">{{ 'DEACTIVATE' | translate }}</span></button>\n<button *ngIf=\"(dashboard == 'adminList' || dashboard == 'managerList') && childData['active'] == false\" type=\"submit\" (click)=\"performAction('active')\" md-raised-button color=\"accent\" class=\"btn-w-sm btn-w-md color-white font-size-13 approve-reject\"><span class=\"btn-text\">{{ 'ACTIVE' | translate }}</span></button>"

/***/ }),

/***/ 1245:
/***/ (function(module, exports) {

module.exports = "<div class=\"container-fluid no-breadcrumbs page-dashboard\">\n    <div class=\"article\">\n        <div class=\"row\">\n            <div class=\"col-12\">\n                <h2 class=\"article-title color-black\">{{ 'User Dashboard' | translate | uppercase }}</h2>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-12 col-xl-6 col-lg-6 col-md-6 col-sm-6 text-right\">\n                <multi-approve-reject *ngIf=\"showCheckbox && selected.length >= 1\" [childData]=selected\n                                      [count]=count [dashboard]=adminText\n                                      [searchedFilters]=searchedFilters [selectedCount]=selectedCount\n                                      [totalCount]=totalCount></multi-approve-reject>\n            </div>\n        </div>\n        <div class=\"box customize-app-header-inner margin-bottom-15 padding-admin-box\">\n            <div class=\"row\">\n                <div class=\"col-12\">\n                    <form (keydown.enter)=\"$event.preventDefault()\" (ngSubmit)=\"search()\"\n                          class=\"table-filter-box max-width-175 custom-field-class\">\n                        <div>\n                            <md-select [(ngModel)]=\"selectedStatusId\" [ngModelOptions]=\"{standalone: true}\"\n                                       placeholder=\"{{ 'Status' | translate }}\">\n                                <md-option *ngFor=\"let statusData of StatusData\" [value]=\"statusData.id\">\n                                    {{statusData.name | lowercase | translate}}\n                                </md-option>\n                            </md-select>\n\n                        </div>\n                        <div>\n                            <md-select [(ngModel)]=\"selectedCountryId\" [ngModelOptions]=\"{standalone: true}\"\n                                       placeholder=\"{{ 'Country' | translate }}\">\n                                <md-option *ngFor=\"let country of Countries\" [value]=\"country.id\">\n                                    {{country.name | translate}}\n                                </md-option>\n                            </md-select>\n                        </div>\n                        <input type='text' style=\"margin-right: 15px;\" class=\"width-18\" placeholder=\"{{ 'Name' | translate }}\" [(ngModel)]=\"searchName\" [ngModelOptions]=\"{standalone: true}\"/>\n                        <input type='text' style=\"margin-right: 15px;\" class=\"width-18\" placeholder=\"{{ 'Email' | translate }}\" [(ngModel)]=\"searchEmail\" [ngModelOptions]=\"{standalone: true}\"/>\n                        <input type='text' style=\"margin-right: 15px;\" class=\"width-18\" placeholder=\"{{ 'WPASS Id' | translate | uppercase }}\" [(ngModel)]=\"searchWpass\" [ngModelOptions]=\"{standalone: true}\"/>\n                        <input type='text' style=\"margin-right: 15px;\" class=\"width-18\" placeholder=\"{{ 'Customer Number' | translate}}\" [(ngModel)]=\"searchCustomerNumber\" [ngModelOptions]=\"{standalone: true}\"/>\n                        <!--<input (inputChangedEvent)=\"autocompleteSearch($event, 'name')\" (selectEvent)=\"onSelectAutocomplete($event, 'name')\" [(ngModel)]=\"searchName\"\n                               [items]=\"Names\"\n                               [ngClass]=\"{'data-loading' : autocompleteLoader == 'name'}\"\n                               [ngModelOptions]=\"{standalone: true}\"\n                               class=\"Data-Search\"\n                               input-autocomplete placeholder=\"{{ 'Name' | translate}}\">\n                        <input (inputChangedEvent)=\"autocompleteSearch($event, 'email')\" (selectEvent)=\"onSelectAutocomplete($event, 'email')\" [(ngModel)]=\"searchEmail\"\n                               [items]=\"Emails\"\n                               [ngClass]=\"{'data-loading' : autocompleteLoader == 'email'}\"\n                               [ngModelOptions]=\"{standalone: true}\"\n                               class=\"Data-Search\"\n                               input-autocomplete placeholder=\"{{ 'Email' | translate }}\">\n                        <input (inputChangedEvent)=\"autocompleteSearch($event, 'wpass')\" (selectEvent)=\"onSelectAutocomplete($event, 'wpass')\"\n                               [(ngModel)]=\"searchWpass\" [items]=\"Wpass\"\n                               [ngClass]=\"{'data-loading' : autocompleteLoader == 'wpass'}\"\n                               [ngModelOptions]=\"{standalone: true}\"\n                               class=\"Data-Search\"\n                               input-autocomplete placeholder=\"{{ 'WPASS Id' | translate | uppercase }}\">-->\n\n                        <div class=\"action-btn\">\n                            <button class=\"btn-md\" md-raised-button title=\"Search\"\n                                    type=\"submit\">\n                                <md-icon class=\"material-icons\">search</md-icon>\n                                {{ 'Search' | translate }}\n                            </button>\n                        </div>\n                        <div class=\"action-btn\">\n                            <button (click)=\"resetSearch()\" class=\"btn-md\" color=\"primary\" md-raised-button\n                                    title=\"Reset Search\"\n                                    type=\"button\">\n                                <md-icon class=\"material-icons\">settings_backup_restore</md-icon>\n                                {{ 'Reset' | translate }}\n                            </button>\n                        </div>\n                        <div class=\"action-btn\">\n                            <button md-raised-button class=\"btn-w-xxs\" type=\"button\" color=\"accent\" (click)=\"downloadCsv('partner_requests')\" title=\"{{'download_csv' | translate}}\"> <md-icon class=\"material-icons\">cloud_download</md-icon></button>\n                        </div>\n                        <div class=\"action-btn\">\n                            <button md-raised-button class=\"btn-w-xxs\" type=\"button\" color=\"accent\" (click)=\"downloadCsv('subusers')\" title=\"{{'download_subuser_csv' | translate}}\"> <md-icon class=\"material-icons\">cloud_download</md-icon>&nbsp;&nbsp;<md-icon class=\"material-icons\">group</md-icon></button>\n                        </div>\n                    </form>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-12\">\n                    <div class=\"callout-1 collout-warn-1 mt-3\">\n                        <p>{{ 'filter_apply_info' | translate }}</p>\n                    </div>\n                </div>\n            </div>\n\n        </div>\n        <div *ngIf=\"showTable\" class=\"box box-default table-box table-responsive mdl-shadow--2dp\">\n            <ngx-datatable #table (page)='setPage($event,tableRows,false)'\n                           (select)='onSelect($event)' [columnMode]=\"'force'\" [count]=\"page.totalElements\" [externalPaging]=\"true\"\n                           [footerHeight]=\"70\" [headerHeight]=\"60\" [limit]=\"page.size\" [messages]=\"dataTableMessage\"\n                           [offset]=\"page.pageNumber\" [rowHeight]=\"'auto'\" [rows]=\"rows\" [scrollbarH]=\"true\"\n                           [selected]=\"selected\" [selectionType]=\"'checkbox'\"\n                           class=\"material\">\n\n                <ngx-datatable-column *ngIf=\"showCheckbox && !isSystemAdmin\" [canAutoResize]=\"false\" [checkboxable]=\"true\"\n                                      [draggable]=\"false\" [headerCheckboxable]=\"true\" [resizeable]=\"false\"\n                                      [sortable]=\"false\"\n                                      [width]=\"45\">\n                </ngx-datatable-column>\n\n                <ngx-datatable-column [width]=\"80\" name=\"{{ 'Name' | translate }}\" prop=\"Name\">\n                    <ng-template let-column=\"column\" let-sort=\"sortFn\" ngx-datatable-header-template>\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span style=\"color: blue;cursor: pointer\" title=\"{{row['Name']}}\">\n                            <a [routerLink]=\"getUserLink(row)\" [queryParams]=\"{ source: 'admin' }\">{{row['Name']}}</a>\n                        </span>\n                        <ul *ngIf=\"!row['userId_WPASS']\" style=\"margin-left: -40px; font-size: 12px;\n                                font-style: oblique;\" title=\"{{row['createdAt']}}\"> {{ 'Request Submission Date' | translate }}\n                            <li>{{row['createdAt']}}</li>\n                        </ul>\n                        <ul *ngIf=\"row['userId_WPASS']\" style=\"margin-left: -40px; font-size: 12px;\n                                    font-style: oblique;\" title=\"{{row['wpassCreatedAt']}}\"> {{ 'UserId Creation Date' | translate }}\n                            <li>{{row['wpassCreatedAt']}}</li>\n                        </ul>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column [width]=\"170\" name=\"{{ 'Business Units' | translate }}\" prop=\"businessUnits\">\n                    <ng-template let-column=\"column\" let-sort=\"sortFn\" ngx-datatable-header-template>\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span>\n                            <div *ngIf=\"row['businessUnits'] && row['businessUnits'].PENDING\">\n                                <p class=\"margin-bottom-3 font-size-13\"\n                                   style=\"color:orange\">{{'pending' | translate}}</p>\n                                <ul class=\"font-size-13 margin-bottom-5\">\n                                    <li *ngFor=\"let pending of row['businessUnits'].PENDING; let i = index\">\n                                        {{pending.name}}</li>\n                                </ul>\n                            </div>\n                            <div *ngIf=\"row['businessUnits'] && row['businessUnits'].APPROVED\">\n                                <p class=\"margin-bottom-3 font-size-13\"\n                                   style=\"color:green\">{{'approved' | translate}}</p>\n                                <ul class=\"font-size-13 margin-bottom-5\">\n                                    <li *ngFor=\"let approved of row['businessUnits'].APPROVED; let j = index\">\n                                        {{approved.name}}</li>\n                                </ul>\n                            </div>\n                            <div *ngIf=\"row['businessUnits'] && row['businessUnits'].REJECTED\">\n                                <p class=\"margin-bottom-3 font-size-13\" style=\"color:red\">{{'rejected' | translate}}</p>\n                                <ul class=\"font-size-13 margin-bottom-5\">\n                                    <li *ngFor=\"let rejected of row['businessUnits'].REJECTED; let k = index\">\n                                        {{rejected.name}}</li>\n                                </ul>\n                            </div>\n                        </span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column [width]=\"128\" name=\"{{ 'Email' | translate }}\" prop=\"email\">\n                    <ng-template let-column=\"column\" let-sort=\"sortFn\" ngx-datatable-header-template>\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span title=\"{{row['email']}}\">{{row['email']}}</span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column [width]=\"25\" name=\"WPASS Id\" prop=\"userId_WPASS\">\n                    <ng-template let-column=\"column\" let-sort=\"sortFn\" ngx-datatable-header-template>\n                        <span (click)=\"sort()\">{{'WPASS Id' | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span class=\"color-gray-filter\" title=\"{{row['userId_WPASS']}}\">{{row['userId_WPASS']}}</span>\n                        <div style=\"cursor: pointer\" *ngIf=\"!isSystemAdmin && row['userId_WPASS']\">\n                            <i title=\"{{'Reset Password' | translate}}\" (click)=\"forgetPassword(row['userId_WPASS'])\"\n                                class=\"nav-icon material-icons f-s-18 \">vpn_key</i>\n                            <i title=\"{{'unlock_account' | translate}}\" (click)=\"unlockAccount(row['userId_WPASS'])\"\n                                class=\"nav-icon material-icons f-s-18 m-l-20\">lock_open</i>\n                        </div>\n                    </ng-template>\n                </ngx-datatable-column>\n                <ngx-datatable-column [width]=\"16\" name=\"Country\" prop=\"countryName\">\n                    <ng-template let-column=\"column\" let-sort=\"sortFn\" ngx-datatable-header-template>\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span class=\"color-gray-filter\" title=\"{{row['countryName']}}\">{{row['countryName']}}</span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column [width]=\"50\" name=\"{{ 'Status' | translate }}\" prop=\"status\">\n                    <ng-template let-column=\"column\" let-sort=\"sortFn\" ngx-datatable-header-template>\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span *ngIf=\"row['status'] == 'Email Verification Pending'\" style=\"color:#e68811\">{{row['status'] | lowercase | translate}}</span>\n                        <span *ngIf=\"row['status'] == 'Pending'\" style=\"color:orange\">{{row['status'] | lowercase | translate}}</span>\n                        <span *ngIf=\"row['status'] == 'User ID Awaited'\" style=\"color:blue\">{{row['status'] | lowercase | translate}}</span>\n                        <span *ngIf=\"row['status'] == 'Approved'\" style=\"color:green\">{{row['status'] | lowercase | translate}}</span>\n                        <span *ngIf=\"row['status'] == 'Rejected'\" style=\"color:red\">{{row['status'] | lowercase | translate}}</span>\n                        <span *ngIf=\"row['status'] == 'Deletion Pending'\" style=\"color:blue\">{{row['status'] | lowercase | translate}}</span>\n                        <span *ngIf=\"row['status'] == 'Deleted'\" style=\"color:red\">{{row['status'] | lowercase | translate}}</span>\n                        <div *ngIf=\"row['status'] == 'Email Verification Pending' && !isSystemAdmin\" style=\"cursor: pointer; text-align: center;\">\n                            <i title=\"{{'resend' | translate}}\" (click)=\"resendEmailVerificationEmail(row['id'])\"\n                                class=\"nav-icon material-icons f-s-18 m-l-20\">mail_outline</i>\n                        </div>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column [width]=\"4\" name=\"{{ 'Sub Users' | translate }}\" prop=\"subUsers\">\n                    <ng-template let-column=\"column\" let-sort=\"sortFn\" ngx-datatable-header-template>\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span style=\"color: blue;cursor: pointer\">\n                            <a [routerLink]=\"['/app/partners-dashboard', row['id']]\">{{'view' | translate}}</a>\n                        </span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column *ngIf=\"!isSystemAdmin\" [width]=\"165\" name=\"{{ 'Action' | translate }}\"\n                                      prop=\"action\">\n                    <ng-template let-column=\"column\" let-sort=\"sortFn\" ngx-datatable-header-template>\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" let-rowIndex=\"rowIndex\" ngx-datatable-cell-template>\n                        <span *ngIf=\"row['actionFlag']\">\n                            <approve-reject [childData]=row [dashboard]=adminText></approve-reject>\n                        </span>\n                        <span\n                                *ngIf=\"!row['actionFlag'] && row['status'] != 'Deletion Pending' && row['status'] != 'Deleted'\">\n                            <activate-deactivate [childData]=row [dashboard]=adminText></activate-deactivate>\n                        </span>\n                    </ng-template>\n                </ngx-datatable-column>\n            </ngx-datatable>\n        </div>\n        <div *ngIf=\"!showTable\" class=\"box box-default\">\n            <div class=\"box-body\">\n                <div class=\"icon-box ibox-plain ibox-center\">\n                    <h3>{{ 'No Data' | translate }}</h3>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ 1246:
/***/ (function(module, exports) {

module.exports = "<angular-loader></angular-loader>\n<div myPreloader class=\"preloaderbar hide\"><span class=\"bar\"></span></div>\n<div class=\"full-height\"\n     [ngClass]=\"{'fixed-header'  : AppConfig.fixedHeader,\n                 'nav-collapsed' : AppConfig.navCollapsed,\n                 'nav-behind'    : AppConfig.navBehind,\n                 'layout-boxed'  : AppConfig.layoutBoxed,\n                 'theme-gray'    : AppConfig.theme == 'gray',\n                 'theme-dark'    : AppConfig.theme == 'dark',\n                 'sidebar-sm'    : AppConfig.sidebarWidth == 'small',\n                 'sidebar-lg'    : AppConfig.sidebarWidth == 'large'}\">\n    <router-outlet></router-outlet>\n</div>"

/***/ }),

/***/ 1247:
/***/ (function(module, exports) {

module.exports = "<div class=\"container-fluid no-breadcrumbs page-dashboard\">\n    <div class=\"article\">\n        <div class=\"row\">\n            <div class=\"col-12\">\n                <div class=\"d-flex  justify-content-between align-self-end flex-direction-row\">\n                    <h2 class=\"article-title color-black\">{{ 'Application Dashboard' | translate | uppercase }}</h2>\n\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-6 col-lg-12 text-right\">\n                <multi-approve-reject *ngIf=\"showCheckbox && selected.length >= 1\" [childData]=selected\n                    [searchedFilters]=searchedFilters [dashboard]=applicationText [selectedCount]=selectedCount\n                    [count]=count [totalCount]=totalCount></multi-approve-reject>\n            </div>\n        </div>\n                <div class=\"box customize-app-header-inner margin-bottom-15 padding-admin-box\">\n                        <div class=\"row\">\n                                <div class=\"col-12\">\n                    <form class=\"table-filter-box custom-textfield-class\"\n                          (ngSubmit)=\"search()\" (keydown.enter)=\"$event.preventDefault()\">\n                       \n                            <div>\n                            <md-select placeholder=\"{{ 'Status' | translate }}\"\n                                [(ngModel)]=\"selectedStatusId\" [ngModelOptions]=\"{standalone: true}\">\n                                <md-option *ngFor=\"let statusData of StatusData\" [value]=\"statusData.id\">\n                                    {{statusData.name | lowercase | translate}}\n                                </md-option>\n                            </md-select>\n                        </div>\n                        <div>\n                            <md-select placeholder=\"{{ 'Applications' | translate }}\" \n                                [(ngModel)]=\"selectedApplicationId\" [ngModelOptions]=\"{standalone: true}\">\n                                <md-option *ngFor=\"let application of applicationsName\" [value]=\"application.id\">\n                                    {{application.name | translate}}\n                                </md-option>\n                            </md-select>\n                        </div>\n                        <div>\n                            <md-select placeholder=\"{{ 'Country' | translate }}\"\n                                class=\"width-min-130 width-15 -2\" [(ngModel)]=\"selectedCountryId\"\n                                [ngModelOptions]=\"{standalone: true}\">\n                                <md-option *ngFor=\"let country of countries\" [value]=\"country.id\"\n                                    (click)=\"onCountryChange(country.id)\">\n                                    {{country.name | translate}}\n                                </md-option>\n                            </md-select>\n                        </div>\n                        <div>\n                            <md-select placeholder=\"{{ 'Business Unit' | translate }}\"\n                                class=\"width-min-130 width-15 -2\" [(ngModel)]=\"selectedBusinessUnit\"\n                                [ngModelOptions]=\"{standalone: true}\">\n                                <md-option *ngFor=\"let businessUnit of businessUnits\" [value]=\"businessUnit.id\">\n                                    {{businessUnit.name | translate}}\n                                </md-option>\n                            </md-select>\n                        </div>\n                            <input (inputChangedEvent)=\"autocompleteSearch($event, 'wpass')\" (selectEvent)=\"onSelectAutocomplete($event, 'wpass')\" [(ngModel)]=\"searchWpass\"\n                                   [items]=\"Wpass\"\n                                   [ngClass]=\"{'data-loading' : autocompleteLoader == 'wpass'}\"\n                                   [ngModelOptions]=\"{standalone: true}\"\n                                   class=\"Data-Search\"\n                                   input-autocomplete placeholder=\"{{ 'WPASS Id' | translate | uppercase }}\">\n\n                            <div class=\"action-btn\">\n                                <button md-raised-button class=\"btn-md\" type=\"submit\" title=\"Search\">\n                                    <md-icon class=\"material-icons\">search</md-icon> {{ 'Search' | translate }}\n                                </button>\n                            </div>\n                            <div class=\"action-btn\">\n                                <button md-raised-button class=\"btn-md\" color=\"primary\" type=\"button\"\n                                    (click)=\"resetSearch()\" title=\"Reset Search\">\n                                    <md-icon class=\"material-icons\">settings_backup_restore</md-icon>\n                                    {{ 'Reset' | translate }}\n                                </button>\n                            </div>\n                            <div class=\"action-btn\">\n                                <button md-raised-button class=\"btn-md btn-grn\" (click)=\"downloadCsv()\" type=\"button\"\n                                    title=\"{{'download_csv' | translate}}\"> <i class=\"nav-icon material-icons f-s-18 \">\n                                        cloud_download</i></button>\n                            </div>\n                       \n                    </form>\n                </div>\n            </div>\n                    \n                    <div class=\"row\">\n                        <div class=\"col-12\">\n                            <div class=\"callout-1 collout-warn-1\">\n                                <p>{{ 'filter_apply_info' | translate }}</p>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"box box-default table-box table-responsive mdl-shadow--2dp\" *ngIf=\"showTable\">\n                    <ngx-datatable #table class=\"material\" \n                        [messages]=\"dataTableMessage\" [rows]=\"rows\" [columnMode]=\"'force'\" [headerHeight]=\"60\"\n                        [rowHeight]=\"55\" [footerHeight]=\"70\" [externalPaging]=\"true\" [count]=\"page.totalElements\"\n                        [offset]=\"page.pageNumber\" [limit]=\"page.size\"  [scrollbarH]=\"true\"\n                         (page)='setPage($event,tableRows,false)'\n                        (select)='onSelect($event)'>\n\n                        <ngx-datatable-column *ngIf=\"showCheckbox\" [width]=\"45\" [sortable]=\"false\"\n                            [canAutoResize]=\"false\" [draggable]=\"false\" [resizeable]=\"false\" [headerCheckboxable]=\"true\"\n                            [checkboxable]=\"true\">\n                        </ngx-datatable-column>\n\n                        <ngx-datatable-column name=\"{{ 'Application Name' | translate }}\" prop=\"applicationName\"\n                            [width]=\"90\">\n                            <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                                <span (click)=\"sort()\">{{column.name | translate}}</span>\n                            </ng-template>\n                            <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                                <span title=\"{{row['applicationName']}}\" style=\"color: blue;cursor: pointer\">\n                                    <a\n                                        [routerLink]=\"['/app/view-request/viewApplicationRequest', row['id']]\">{{row['applicationName']}}</a>\n                                </span>\n                            </ng-template>\n                        </ngx-datatable-column>\n\n                        <ngx-datatable-column name=\"WPASS Id\" prop=\"userId_WPASS\" [width]=\"20\">\n                            <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                                <span (click)=\"sort()\">{{column.name | translate}}</span>\n                            </ng-template>\n                            <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                                <span class=\"color-gray-filter\"\n                                    title=\"{{row['userId_WPASS']}}\">{{row['userId_WPASS']}}</span>\n                            </ng-template>\n                        </ngx-datatable-column>\n\n                        <ngx-datatable-column name=\"{{ 'Business Units' | translate }}\" prop=\"businessUnitName\"\n                            [width]=\"115\">\n                            <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                                <span (click)=\"sort()\">{{column.name | translate}}</span>\n                            </ng-template>\n                            <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                                <span title=\"{{row['businessUnitName']}}\">{{row['businessUnitName']}}</span>\n                            </ng-template>\n                        </ngx-datatable-column>\n\n                        <ngx-datatable-column name=\"{{ 'Country Name' | translate }}\" prop=\"countryName\" [width]=\"115\">\n                            <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                                <span (click)=\"sort()\">{{column.name | translate}}</span>\n                            </ng-template>\n                            <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                                <span title=\"{{row['countryName'] | translate}}\">{{row['countryName'] | translate}}</span>\n                            </ng-template>\n                        </ngx-datatable-column>\n\n                        <ngx-datatable-column name=\"{{ 'Status' | translate }}\" prop=\"status\" [width]=\"105\">\n                            <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                                <span (click)=\"sort()\">{{column.name | translate}}</span>\n                            </ng-template>\n                            <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                                <span *ngIf=\"row['statusCode'] == 'PENDING'\" style=\"color:orange\">{{row['status'] | lowercase | translate}}</span>\n                                <span *ngIf=\"row['statusCode'] == 'APPROVED'\" style=\"color:green\">{{row['status'] | lowercase | translate}}</span>\n                                <span *ngIf=\"row['statusCode'] == 'AUTO_APPROVED'\" style=\"color:green\">{{row['status'] | lowercase | translate}}</span>\n                                <span *ngIf=\"row['statusCode'] == 'REVOKED'\" style=\"color:red\">{{row['status'] | lowercase | translate}}</span>\n                                <span *ngIf=\"row['statusCode'] == 'REJECTED'\" style=\"color:red\">{{row['status'] | lowercase | translate}}</span>\n                            </ng-template>\n                        </ngx-datatable-column>\n\n\n                        <ngx-datatable-column *ngIf=\"!isSystemAdmin\" name=\"{{ 'Action' | translate }}\" prop=\"action\"\n                            [width]=\"145\">\n                            <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                                <span (click)=\"sort()\">{{column.name | translate}}</span>\n                            </ng-template>\n                            <ng-template let-rowIndex=\"rowIndex\" let-row=\"row\" ngx-datatable-cell-template>\n                                <span *ngIf=\"row['statusCode'] == 'PENDING'\">\n                                    <button type=\"button\"\n                                        [routerLink]=\"['/app/view-request/viewApplicationRequest', row['id']]\"\n                                        md-raised-button color=\"accent\"\n                                        class=\"btn-w-sm btn-w-md color-white font-size-13 approve-reject\"><span\n                                            class=\"btn-text\">{{ 'APPROVE' | translate }}</span></button>\n                                    <span class=\"space-xs\"></span>\n                                    <button type=\"button\" (click)=\"rejectAction(row['id'], 'REJECTED')\" md-raised-button\n                                        class=\"btn-w-sm btn-w-md btn-red font-size-13 approve-reject\"><span\n                                            class=\"btn-text\">{{ 'REJECT' | translate }}</span></button>\n                                </span>\n                                <span *ngIf=\"row['statusCode'] == 'AUTO_APPROVED' || row['statusCode'] == 'APPROVED'\">\n                                    <button type=\"button\" (click)=\"saveRevokeData(row['id'])\" md-raised-button\n                                        class=\"btn-w-sm btn-w-md btn-org font-size-13 approve-reject\"><span\n                                            class=\"btn-text\">{{ 'REVOKE' | translate }}</span></button>\n                                </span>\n                            </ng-template>\n                        </ngx-datatable-column>\n\n                    </ngx-datatable>\n                </div>\n\n                <div class=\"box box-default\" *ngIf=\"!showTable\">\n                    <div class=\"box-body\">\n                        <div class=\"icon-box ibox-plain ibox-center\">\n                            <h3>{{ 'No Data' | translate }}</h3>\n                        </div>\n                    </div>\n                </div>\n            \n\n    </div>\n</div>"

/***/ }),

/***/ 1248:
/***/ (function(module, exports) {

module.exports = "<button type=\"submit\" (click)=\"performAction('approved')\" md-raised-button color=\"accent\" class=\"btn-w-sm btn-w-md color-white font-size-13 approve-reject\"><span class=\"btn-text\">{{ 'APPROVE' | translate }}</span></button>\n<span class=\"space-xs\"></span>\n<button type=\"submit\" (click)=\"performAction('rejected')\"  md-raised-button class=\"btn-w-sm btn-w-md btn-red font-size-13 approve-reject\"><span class=\"btn-text\">{{ 'REJECT' | translate }}</span></button>"

/***/ }),

/***/ 1249:
/***/ (function(module, exports) {

module.exports = "<div class=\"mdl-card mdl-card-full-width\" style=\"min-height: auto;\">\n    <div class=\"row\" style=\"padding-left: 16px; padding-right: 16px;padding-bottom: 16px;\">\n        <div class=\"col-md-12 margin-top-sm\">\n            <div class=\"margin-bottom-20\">\n                <p class=\"font-size-18\" *ngIf=\"activeDeactive\"> {{ msg | translate }} </p>\n                <h5 class=\"font-size-18\" *ngIf=\"!activeDeactive\"> {{ msg | translate }} </h5>\n                <p class=\"margin-top-neg-8\" *ngIf=\"note\"> {{ note | translate }} </p>\n                <p class=\"margin-top-neg-8\" *ngIf=\"systemSetting\"> {{ systemSetting | translate}} </p>\n            </div>\n            <div style=\"text-align: center;\">\n                <button *ngIf=\"!isConfirm\" md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-accent mat-raised-button\" (click)=\"dialogRef.close(true)\">{{ 'Close' | translate }}</button>\n                <button *ngIf=\"isConfirm\" md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-accent mat-raised-button\" (click)=\"dialogRef.close(true)\">{{ 'Confirm' | translate }}</button>\n                <button *ngIf=\"isConfirm\" md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-raised-button color-white btn-danger\" (click)=\"dialogRef.close(false)\">{{ 'Cancel' | translate }}</button>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ 1250:
/***/ (function(module, exports) {

module.exports = "<div class=\"mdl-card mdl-card-full-width select-overflow\" style=\"min-height: 200px !important;  max-height:500px !important;\">\n    <div class=\"row\" style=\"padding-left: 15px; padding-right: 15px;padding-bottom: 15px;\">\n\n        <div class=\"col-md-12 margin-top-sm\">\n            <h5 *ngIf=\"condition1Flag && (actionStatus=='APPROVE' || actionStatus=='Approve')\" class=\"font-size-17 margin-bottom-20\">{{ 'multi_rqst_approve_confirm' | translate }}</h5>\n            <h5 *ngIf=\"condition1Flag && (actionStatus=='REJECT' || actionStatus=='Reject')\" class=\"font-size-17 margin-bottom-20\">{{ 'multi_rqst_rjct_confirm' | translate }}</h5>\n            \n            <h5 *ngIf=\"condition2Flag\" class=\"font-size-17\"> {{ following_pages_request_notify | translate }}</h5>\n\n            <h5 *ngIf=\"condition2Flag && (actionStatus=='APPROVE' || actionStatus=='Approve')\" class=\"font-size-17 margin-top-neg-10 margin-bottom-30\">{{ 'rqst_approve_slctd_or_all_confirm' | translate }}</h5>\n            <h5 *ngIf=\"condition2Flag && (actionStatus=='REJECT' || actionStatus=='Reject')\" class=\"font-size-17 margin-top-neg-10 margin-bottom-30\">{{ 'rqst_rjct_slctd_or_all_confirm' | translate }}</h5>\n\n            <h5 *ngIf=\"condition3Flag && (actionStatus=='APPROVE' || actionStatus=='Approve')\" class=\"font-size-17 margin-bottom-20\">{{ 'rqst_approve_slctd_confirm' | translate }}</h5>\n            <h5 *ngIf=\"condition3Flag && (actionStatus=='REJECT' || actionStatus=='Reject')\" class=\"font-size-17 margin-bottom-20\">{{ 'rqst_rjct_slctd_confirm' | translate }}</h5>\n\n            <form role=\"form\" [formGroup]=\"ActionForm\" *ngIf=\"isReject\">\n                <fieldset formGroupName=\"multiRejectGroup\">\n                    <div class=\"form-group\">\n                        <md-radio-group *ngIf=\"condition2Flag\" class=\"md-radio-group-spacing\" formControlName=\"selectedRadioValue\">\n                            <md-radio-button value=\"Approve Selected\">Reject Selected</md-radio-button>\n                            <md-radio-button value=\"Approve All\">Reject All</md-radio-button>\n                        </md-radio-group>\n\n                        <md-input-container class=\"full-width\" [ngClass]=\"{'margin-top-10': condition2Flag}\">\n                            <textarea mdInput required #biography formControlName=\"reason\" placeholder=\"{{ 'Reject Reason' | translate }}\" maxlength=\"150\" rows=\"4\" value=\"\"></textarea>\n                            <md-hint align=\"end\">{{biography.value.length}} / 150</md-hint>\n                        </md-input-container>\n                    </div>\n\n                    <button md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs btn-red mat-raised-button\" (click)=\"dialogRef.close(false)\">{{ 'Cancel' | translate }}</button>\n                    <button *ngIf=\"isReject\" md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-accent mat-raised-button\" [disabled]=\"!ActionForm.get('multiRejectGroup').valid\" (click)=\"dialogRef.close(multiRejectDetails)\">{{ 'Confirm' | translate }}</button>\n                </fieldset>\n            </form>\n\n            <form role=\"form\" [formGroup]=\"ActionForm\" *ngIf=\"isApproved\">\n                <fieldset formGroupName=\"multiApproveGroup\">\n                    <div class=\"form-group margin-bottom-30\">\n                        <md-radio-group *ngIf=\"condition2Flag\" class=\"md-radio-group-spacing\" formControlName=\"selectedRadioValue\">\n                            <md-radio-button value=\"Approve Selected\">{{ 'Approve Selected' | translate }}</md-radio-button>\n                            <md-radio-button value=\"Approve All\">{{ 'Approve All' | translate }}</md-radio-button>\n                        </md-radio-group>\n\n                        <div>\n                            <angular2-multiselect [data]=\"roles\" [settings]=\"settings\" formControlName=\"role\"></angular2-multiselect>\n                        </div>\n                    </div>\n\n                    <button md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-raised-button btn-red\" (click)=\"dialogRef.close(false)\">{{ 'Cancel' | translate }}</button>\n                    <button *ngIf=\"isApproved\" md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-accent mat-raised-button\" [disabled]=\"!ActionForm.get('multiApproveGroup').valid\" (click)=\"dialogRef.close(multiApproveDetails)\">{{ 'Confirm' | translate }}</button>\n                </fieldset>\n            </form>\n\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ 1251:
/***/ (function(module, exports) {

module.exports = "<div class=\"mdl-card mdl-card-full-width\" style=\"min-height: auto;\">\n    <div class=\"row\" style=\"padding-left: 15px; padding-right: 15px;padding-bottom: 15px;\">\n        <div class=\"col-md-12 margin-top-sm\">\n            <h5 class=\"font-size-17 margin-bottom-20\"> {{ msg | translate }} </h5>\n\n            <form role=\"form\" [formGroup]=\"RejectActionForm\" *ngIf=\"isRejected\">\n                <fieldset>\n                    <div class=\"form-group\">\n                        <md-input-container class=\"full-width\">\n                            <textarea mdInput required #biography formControlName=\"reason\" placeholder=\"{{ 'Reject Reason' | translate }}\" maxlength=\"150\" rows=\"4\" value=\"\"></textarea>\n                            <md-hint align=\"end\">{{biography.value.length}} / 150</md-hint>\n                        </md-input-container>\n                    </div>\n\n                    <button md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs btn-red mat-raised-button\" (click)=\"dialogRef.close(false)\">{{ 'Cancel' | translate }}</button>\n                    <button md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-accent mat-raised-button\" [disabled]=\"!RejectActionForm.valid\" (click)=\"dialogRef.close(reasonDeatils.reason)\">{{ 'Confirm' | translate }}</button>\n                </fieldset>\n            </form>\n            <span *ngIf=\"isApproved\">\n                <button md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs btn-red mat-raised-button\" (click)=\"dialogRef.close(false)\">{{ 'Cancel' | translate }}</button>\n                <button md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-accent mat-raised-button\" (click)=\"dialogRef.close('approve')\">{{ 'Confirm' | translate }}</button>\n            </span>\n\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ 1252:
/***/ (function(module, exports) {

module.exports = "<div class=\"mdl-card mdl-card-full-width\" style=\"min-height: auto;\">\n    <div class=\"row\" style=\"padding-left: 16px; padding-right: 16px;padding-bottom: 16px;\">\n        <div class=\"col-md-12 margin-top-sm\" style=\"text-align: center;\">\n            <p> {{ msg | translate }} </p>\n            <h5 class=\"font-size-17 margin-bottom-20\">{{ 'pls_select_a_replace_for' | translate }}\n                    <span class=\"space-xs\"></span>{{ managerName}}</h5>\n           <div style=\"margin-bottom: 20px;\">\n            <md-select required [(ngModel)]=\"selectedAdmin\" placeholder=\"{{ 'Select Admin' | translate }}\" class=\"full-width margin-top-10\">\n                <md-option *ngFor=\"let admin of admins\" [value]=\"admin.id\"  (click)=\"onChange(admin)\" >\n                    {{admin.name}}\n                </md-option>\n            </md-select>\n        </div>\n            \n            <button  [disabled]=\"!isConfirm\" md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-accent mat-raised-button\">{{ 'Confirm' | translate }}</button>\n            <span class=\"space-xs\"></span>\n            <span class=\"space-xs\"></span>\n            <button  md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-raised-button\" (click)=\"dialogClose(true)\">{{ 'Close' | translate }}</button>\n        </div>\n    </div>\n</div> "

/***/ }),

/***/ 1253:
/***/ (function(module, exports) {

module.exports = "<div class=\"mdl-card mdl-card-full-width\" style=\"min-height: 100px !important;  max-height:500px !important;\">\n    <div class=\"row\" style=\"padding-left: 16px; padding-right: 16px;padding-bottom: 16px;\">\n        <div class=\"col-md-12 margin-top-sm\" style=\"text-align: center;\">\n            <p innerHTML=\"{{ msg | translate }}\"> </p>\n            <button md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-accent mat-raised-button\" (click)=\"dialogRef.close(true)\">{{ 'Close' | translate }}</button>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ 1254:
/***/ (function(module, exports) {

module.exports = "<div class=\"mdl-card mdl-card-full-width\" style=\"min-height: auto;\">\n    <div class=\"row\" style=\"padding-left: 15px; padding-right: 15px;padding-bottom: 15px;\">\n        <div class=\"col-md-12 margin-top-sm\" *ngIf=\"multiApproveRejectFlag == false\">\n            <h5 class=\"font-size-17 margin-bottom-20\"> {{ msg | translate }} </h5>\n\n            <form role=\"form\" [formGroup]=\"ActionForm\" *ngIf=\"isReject\">\n                <fieldset formGroupName=\"rejectGroup\">\n                    <div class=\"form-group\">\n                        <md-input-container class=\"full-width\">\n                            <textarea mdInput required #biography formControlName=\"reason\" placeholder=\"{{ 'Reject Reason' | translate }}\" maxlength=\"150\" rows=\"4\" value=\"\"></textarea>\n                            <md-hint align=\"end\">{{biography.value.length}} / 150</md-hint>\n                        </md-input-container>\n                    </div>\n\n                    <button md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs btn-red mat-raised-button\" (click)=\"dialogRef.close(false)\">{{ 'Cancel' | translate }}</button>\n                    <button *ngIf=\"isReject\" md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-accent mat-raised-button\" [disabled]=\"!ActionForm.get('rejectGroup').valid\" (click)=\"dialogRef.close(rejectDetails.reason)\">{{ 'Confirm' | translate }}</button>\n                </fieldset>\n            </form>\n\n            <form role=\"form\" [formGroup]=\"ActionForm\" *ngIf=\"isApproved\">\n                <fieldset formGroupName=\"approveGroup\">\n                    <div class=\"form-group\" [ngClass]=\"{'margin-bottom-30': row.customerNumberMandatory, 'margin-bottom-20': !row.customerNumberMandatory}\">\n\n                        <!--<md-select placeholder=\"{{ 'Select Role' | translate }}\" class=\"full-width margin-top-10 margin-bottom-20\" formControlName=\"role\">\n                            <md-option *ngFor=\"let roleData of RoleData\" [value]=\"roleData.id\">\n                                {{roleData.name}}\n                            </md-option>\n                        </md-select>-->\n                        <div fxLayout fxLayoutAlign=\"center center\" fxLayoutGap=\"30px\">\n                            <fieldset class=\"advise-partner-type\">\n                                <legend>&nbsp;Partner Type?&nbsp;</legend>\n                                <md-radio-group class=\"md-radio-group-spacing\" formControlName=\"selectedPartnerType\">\n                                    <md-radio-button value=\"Service Partner\">Service Partner</md-radio-button>\n                                    <md-radio-button value=\"Trade Partner\">Trade Partner</md-radio-button>\n                                </md-radio-group>\n                            </fieldset>\n                        </div>\n                        <br>\n\n                        <md-input-container class=\"full-width\" *ngIf=\"row.customerNumberMandatory\">\n                            <textarea mdInput type=\"text\" id=\"exampleInputCustomerNumber1\" formControlName=\"customerNumber\" placeholder=\"{{ 'Customer Number' | translate }}\" maxlength=\"10\" rows=\"1\" value=\"\"></textarea>\n                            <md-hint align=\"end\">{{customerNumberLength}} / 10</md-hint>\n                        </md-input-container>\n                    </div>\n\n                    <button md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-raised-button btn-red\" (click)=\"dialogRef.close(false)\">{{ 'Cancel' | translate }}</button>\n                    <button *ngIf=\"isApproved\" md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-accent mat-raised-button\" [disabled]=\"!ActionForm.get('approveGroup').valid\" (click)=\"dialogRef.close(approveDetails)\">{{ 'Confirm' | translate }}</button>\n                </fieldset>\n            </form>\n        </div>\n\n        <div class=\"col-md-12 margin-top-sm\" *ngIf=\"multiApproveRejectFlag == true\">\n            <h5 *ngIf=\"condition1Flag && (actionStatus=='APPROVE' || actionStatus=='Approve')\" class=\"font-size-17 margin-bottom-20\">{{ 'multi_rqst_approve_confirm' | translate }}</h5>\n            <h5 *ngIf=\"condition1Flag && (actionStatus=='REJECT' || actionStatus=='Reject')\" class=\"font-size-17 margin-bottom-20\">{{ 'multi_rqst_rjct_confirm' | translate }}</h5>\n            \n            <h5 *ngIf=\"condition2Flag\" class=\"font-size-17\"> {{ following_pages_request_notify | translate }}</h5>\n\n            <h5 *ngIf=\"condition2Flag && (actionStatus=='APPROVE' || actionStatus=='Approve')\" class=\"font-size-17 margin-top-neg-10 margin-bottom-30\">{{ 'rqst_approve_slctd_or_all_confirm' | translate }}</h5>\n            <h5 *ngIf=\"condition2Flag && (actionStatus=='REJECT' || actionStatus=='Reject')\" class=\"font-size-17 margin-top-neg-10 margin-bottom-30\">{{ 'rqst_rjct_slctd_or_all_confirm' | translate }}</h5>\n\n            <h5 *ngIf=\"condition3Flag && (actionStatus=='APPROVE' || actionStatus=='Approve')\" class=\"font-size-17 margin-bottom-20\">{{ 'rqst_approve_slctd_confirm' | translate }}</h5>\n            <h5 *ngIf=\"condition3Flag && (actionStatus=='REJECT' || actionStatus=='Reject')\" class=\"font-size-17 margin-bottom-20\">{{ 'rqst_rjct_slctd_confirm' | translate }}</h5>\n\n            <form role=\"form\" [formGroup]=\"ActionForm\" *ngIf=\"isReject\">\n                <fieldset formGroupName=\"multiRejectGroup\">\n                    <div class=\"form-group\">\n                        <md-radio-group *ngIf=\"condition2Flag\" class=\"md-radio-group-spacing\" formControlName=\"selectedRadioValue\">\n                            <md-radio-button value=\"Approve Selected\">{{'Reject Selected' | translate}}</md-radio-button>\n                            <md-radio-button value=\"Approve All\">{{'Reject All' | translate}}</md-radio-button>\n                        </md-radio-group>\n\n                        <md-input-container class=\"full-width\" [ngClass]=\"{'margin-top-10': condition2Flag}\">\n                            <textarea mdInput required #biography formControlName=\"reason\" placeholder=\"{{ 'Reject Reason' | translate }}\" maxlength=\"150\" rows=\"4\" value=\"\"></textarea>\n                            <md-hint align=\"end\">{{biography.value.length}} / 150</md-hint>\n                        </md-input-container>\n                    </div>\n\n                    <button md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs btn-red mat-raised-button\" (click)=\"dialogRef.close(false)\">{{ 'Cancel' | translate }}</button>\n                    <button *ngIf=\"isReject\" md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-accent mat-raised-button\" [disabled]=\"!ActionForm.get('multiRejectGroup').valid\" (click)=\"dialogRef.close(multiRejectDetails)\">{{ 'Confirm' | translate }}</button>\n                </fieldset>\n            </form>\n\n            <form role=\"form\" [formGroup]=\"ActionForm\" *ngIf=\"isApproved\">\n                <fieldset formGroupName=\"multiApproveGroup\">\n                    <div class=\"form-group margin-bottom-30\">\n                        <md-radio-group *ngIf=\"condition2Flag\" class=\"md-radio-group-spacing\" formControlName=\"selectedRadioValue\">\n                            <md-radio-button value=\"Approve Selected\">{{ 'Approve Selected' | translate }}</md-radio-button>\n                            <md-radio-button value=\"Approve All\">{{ 'Approve All' | translate }}</md-radio-button>\n                        </md-radio-group>\n\n                        <!--<div>\n                            <md-select placeholder=\"{{ 'Select Role' | translate }}\" class=\"full-width margin-top-15\" [ngClass]=\"{'margin-top-30': condition2Flag}\" formControlName=\"role\">\n                                <md-option *ngFor=\"let roleData of RoleData\" [value]=\"roleData.id\">\n                                    {{roleData.name}}\n                                </md-option>\n                            </md-select>\n                        </div>-->\n                    </div>\n\n                    <button md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-raised-button btn-red\" (click)=\"dialogRef.close(false)\">{{ 'Cancel' | translate }}</button>\n                    <button *ngIf=\"isApproved\" md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-accent mat-raised-button\" [disabled]=\"!ActionForm.get('multiApproveGroup').valid\" (click)=\"dialogRef.close(multiApproveDetails)\">{{ 'Confirm' | translate }}</button>\n                </fieldset>\n            </form>\n\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ 1255:
/***/ (function(module, exports) {

module.exports = "<div class=\"mdl-card mdl-card-full-width\" style=\"min-height: auto;\">\n    <div class=\"row\" style=\"padding-left: 16px; padding-right: 16px;padding-bottom: 16px;\">\n        <div class=\"col-md-12 margin-top-sm\" style=\"text-align: center;\">\n            <p> {{ msg | translate }} </p>\n            <button *ngIf=\"!isConfirm\" md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-accent mat-raised-button\" (click)=\"dialogRef.close(true)\">{{ 'Close' | translate }}</button>\n            <button *ngIf=\"isConfirm\" md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-accent mat-raised-button\" (click)=\"dialogRef.close(true)\">{{ 'Confirm' | translate }}</button>\n            <button *ngIf=\"isConfirm\" md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-raised-button color-white btn-danger\" (click)=\"dialogRef.close(false)\">{{ 'Cancel' | translate }}</button>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ 1256:
/***/ (function(module, exports) {

module.exports = "<div class=\"mdl-card mdl-card-full-width\" style=\"min-height: auto; width: 500px;\">\n    <div class=\"row\" style=\"padding-top:5px; padding-left: 14px; padding-right: 14px; padding-bottom: 13px;\">\n        <div class=\"col-md-12 margin-top-sm\">\n            <div class=\"row margin-bottom-25\">\n                <div class=\"col-md-10\">\n                    <h2 md-dialog-title class=\"margin-bottom-30\" style=\"font-weight: 500;\">{{ 'Registration Successful' | translate }}</h2>\n                </div>\n                <div class=\"col-md-2\">\n                    <i class=\"material-icons reg-check-icon\">check_circle</i>\n                </div>\n            </div>\n            <div class=\"text-center\">\n                <p class=\"reg-dialog-thanks\">{{ 'Thank You' | translate }}</p>\n                <p class=\"reg-dialog-msg margin-bottom-20\">{{ msg | translate }}</p>\n                <button *ngIf=\"!isConfirm\" md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-accent mat-raised-button\" (click)=\"dialogRef.close(true)\">{{ 'Close' | translate }}</button>\n                <button *ngIf=\"isConfirm\" md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-accent mat-raised-button\" (click)=\"dialogRef.close(true)\">{{ 'Confirm' | translate }}</button>\n                <button *ngIf=\"isConfirm\" md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-raised-button color-white btn-danger\" (click)=\"dialogRef.close(false)\">{{ 'Cancel' | translate }}</button>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ 1257:
/***/ (function(module, exports) {

module.exports = "<div class=\"mdl-card mdl-card-full-width select-overflow\" style=\"padding: 0px 4px 3px 4px !important; min-height: 160px; min-width: 280px !important;\">\n\n    <form role=\"form\" [formGroup]=\"ApplicationsForm\" (keydown.enter)=\"$event.preventDefault()\">\n        <fieldset>\n            <div class=\"row\">\n                <div class=\"col-md-12\">\n                    <angular2-multiselect [data]=\"applications\" [settings]=\"settings\" formControlName=\"applicationsData\"></angular2-multiselect>\n                </div>\n            </div>\n        </fieldset>\n    </form>\n\n    <div class=\"margin-top-20\" style=\"margin-left:18%\">\n        <button md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-raised-button btn-red\" (click)=\"dialogRef.close(false)\">{{ 'Cancel' | translate }}</button>\n        <button md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-accent mat-raised-button\" [disabled]=\"applicationFlag\" (click)=\"dialogRef.close(ApplicationsFormDetails)\">{{ 'Confirm' | translate }}</button>\n    </div>\n\n</div>"

/***/ }),

/***/ 1258:
/***/ (function(module, exports) {

module.exports = "<div class=\"mdl-card mdl-card-full-width\" style=\"padding: 0px 4px 3px 4px !important; min-height: 200px !important;  max-height:500px !important; min-width: 280px !important;\">\n    <h5>{{ 'Applications' | translate }}</h5>\n    <div class=\"box box-default table-box table-responsive mdl-shadow--2dp\">\n        <table class=\"mdl-data-table table-bordered\">\n            <thead>\n            <tr>\n                <th class=\"mdl-data-table__cell--non-numeric\" style=\"text-align: left!important;\">#</th>\n                <th class=\"mdl-data-table__cell--non-numeric\" style=\"text-align: left!important;\" *ngIf=\"!profileFlag\">{{ 'Applications' | translate }}</th>\n                <th class=\"mdl-data-table__cell--non-numeric\" style=\"text-align: left!important;\" *ngIf=\"profileFlag\">{{ 'Application Name' | translate }}</th>\n                <th class=\"mdl-data-table__cell--non-numeric\" style=\"text-align: left!important;\" *ngIf=\"profileFlag\">{{ 'Status' | translate }}</th>\n                <th class=\"mdl-data-table__cell--non-numeric\" style=\"text-align: left!important;\" *ngIf=\"profileFlag\">{{ 'Role' | translate }}</th>\n                <th class=\"mdl-data-table__cell--non-numeric\" style=\"text-align: left!important;\" *ngIf=\"profileFlag\">{{ 'Reject Reason' | translate }}</th>\n            </tr>\n            </thead>\n\n            <tbody>\n            <tr *ngFor=\"let appsList of apps; let i = index\">\n                <td class=\"mdl-data-table__cell--non-numeric\">{{i + 1}}</td>\n                <td class=\"mdl-data-table__cell--non-numeric\" *ngIf=\"!profileFlag\">{{appsList}}</td>\n                <td class=\"mdl-data-table__cell--non-numeric\" *ngIf=\"profileFlag\">{{appsList.applicationName}}</td>\n                <td class=\"mdl-data-table__cell--non-numeric\" *ngIf=\"profileFlag && appsList.status == 'Role Assignment Awaited'\"\n                    style=\"color: #e68811\">{{appsList.status}}\n                </td>\n                <td class=\"mdl-data-table__cell--non-numeric\" *ngIf=\"profileFlag && appsList.status == 'Auto Approved'\"\n                    style=\"color: lightgreen\">{{appsList.status}}\n                </td>\n                <td class=\"mdl-data-table__cell--non-numeric\" *ngIf=\"profileFlag && appsList.status == 'Pending'\"\n                    style=\"color: orange\">{{appsList.status}}\n                </td>\n                <td class=\"mdl-data-table__cell--non-numeric\" *ngIf=\"profileFlag && appsList.status == 'Approved'\"\n                    style=\"color: green\">{{appsList.status}}\n                </td>\n                <td class=\"mdl-data-table__cell--non-numeric\" *ngIf=\"profileFlag && appsList.status == 'Rejected'\"\n                    style=\"color: red\">{{appsList.status}}\n                </td>\n                <td class=\"mdl-data-table__cell--non-numeric\" *ngIf=\"profileFlag\">{{appsList.selectedRoleNames}}</td>\n                <td class=\"mdl-data-table__cell--non-numeric\" *ngIf=\"profileFlag\">{{appsList.message}}</td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n\n    <div [ngClass]=\"{'margin-left-40p': profileFlag, 'margin-left-37p': !profileFlag}\">\n        <button md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-accent mat-raised-button\" (click)=\"dialogRef.close(true)\">{{ 'Close' | translate }}</button>\n    </div>\n\n</div>"

/***/ }),

/***/ 1259:
/***/ (function(module, exports) {

module.exports = "<div class=\"mdl-card mdl-card-full-width\" style=\"min-height: auto; width: 780px;\">\n    <div class=\"row\" style=\"padding-left: 16px; padding-right: 16px;padding-bottom: 2px;\">\n        <div class=\"col-md-12 margin-top-sm\" style=\"text-align: center;\">\n\n            <h5 class=\"font-size-24\">{{ \"WelcomeLine1\" | translate }}</h5>\n            <h5 class=\"welcome-msg-heading\">{{ \"WelcomeLine2\" | translate }}</h5>\n            <p class=\"welcome-msg-name\">{{ 'WelcomeLine3' | translate }} :</p>\n            <p class=\"welcome-msg-list\">{{ 'WelcomeLine4' | translate }}</p>\n            <p class=\"welcome-msg-list\">{{ 'WelcomeLine5' | translate }}</p>\n            <p class=\"welcome-msg-list\">{{ \"WelcomeLine6\" | translate }}</p>\n            <p class=\"welcome-msg-list\">{{ 'WelcomeLine7' | translate }}</p>\n            <p class=\"welcome-msg-list\">{{ 'WelcomeLine8' | translate }}</p>\n\n            <button md-raised-button md-dialog-close type=\"button\" class=\"btn-w-xs mat-accent mat-raised-button margin-top-20\" (click)=\"dialogRef.close(true)\">{{ 'Close' | translate }}</button>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ 1260:
/***/ (function(module, exports) {

module.exports = "<section class=\"container-fluid no-breadcrumbs\">\n    <div class=\"row margin-top-15\">\n        <div class=\"col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7\">\n            <h2 class=\"article-title color-black\">{{ 'Data Upload' | translate }}</h2>\n        </div>\n        <div class=\"col-xl-5 col-lg-5 col-md-5 col-sm-5 col-5\">\n            <span class=\"space-xs\"></span>\n        </div>\n    </div>\n\n    <div class=\"mdl-card mdl-shadow--2dp mdl-card-full-width\">\n        <div class=\"card_title\">\n            <h2 class=\"mdl-card__title-text\">{{ 'Data Information' | translate }}</h2>\n        </div>\n        <form class=\"padding-r-l-user\" role=\"form\" [formGroup]=\"FileUploadForm\" (ngSubmit)=\"saveUploadCSVData()\">\n            <fieldset>\n                <div class=\"form-group margin-bottom-2-2\">\n                    <div class=\"row\">\n                        <div class=\"col-md-12 margin-bottom-40\">\n                            <md-radio-group class=\"md-radio-group-spacing\" formControlName=\"selectedRadioValue\">\n                                <md-radio-button class=\"width-32\" value=\"Role_Maintenance\">{{ 'Role Maintenance' | translate }}</md-radio-button>\n                                <md-radio-button value=\"User_Migration\">{{ 'User Migration' | translate }}</md-radio-button>\n                            </md-radio-group>\n                        </div>\n\n                        <div *ngIf=\"uploadAction\" class=\"col-md-4 margin-bottom-60\">\n                            <md-select required formControlName=\"countryId\" placeholder=\"{{ 'Country' | translate }}\" class=\"full-width max-width-80 margin-top-20\">\n                                <md-option *ngFor=\"let countryId of Countries\" [value]=\"countryId.id\">\n                                    {{countryId.name | translate}}\n                                </md-option>\n                            </md-select>\n                        </div>\n                        <div *ngIf=\"uploadAction\" class=\"col-md-4 margin-bottom-60\">\n                            <md-select required formControlName=\"businessUnitId\" placeholder=\"{{ 'Business Unit' | translate }}\" class=\"full-width max-width-80 margin-top-20\">\n                                <md-option *ngFor=\"let businessUnitId of BusinessUnit\" [value]=\"businessUnitId.id\">\n                                    {{businessUnitId.name}}\n                                </md-option>\n                            </md-select>\n                        </div>\n                        <div *ngIf=\"uploadAction\" class=\"col-md-4 margin-bottom-60\"></div>\n                        <div class=\"col-md-4\">\n                            <button md-raised-button class=\"btn-w-md btn-w-xs button-red-clr\" (click)=\"downloadSampleCSVFile()\" type=\"button\">{{ 'Download Sample CSV' | translate }}</button>\n                        </div>\n                        <div class=\"col-md-4 margin-top-neg-4\">\n                            <span class=\"font-size-16 label-color-gray\"> {{ 'Insert CSV file' | translate }}</span>\n                            <label for=\"files\" class=\"fileupload-input\">\n                                <i class=\"fa fa-cloud-upload\"></i> {{ 'Browse File' | translate }}\n                            </label>\n                            <input type=\"file\" id=\"files\" (change)=\"fileupload()\" ng2FileSelect [uploader]=\"uploader\"/>\n                        </div>\n                        <div class=\"col-md-4 margin-top-04\">\n                            <span *ngIf=\"csvName\" class=\"font-size-16 label-color-gray\"> {{ 'CSV Name' | translate }} : </span>\n                            <label> {{csvName}} </label>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <div *ngIf=\"showError\" class=\"col-md-12 callout callout-danger\">\n                        <h4 innerHTML=\"{{ errorMsg | translate }}\"></h4>\n                    </div>\n                    <span>\n                        <button md-raised-button class=\"btn-w-md btn-w-xs button-gray-clr approve-reject\" [routerLink]=\"['/app/file-upload/list']\" type=\"button\">{{ 'Cancel' | translate }}</button>\n                    </span>\n                    <span class=\"space-xs\"></span>\n                    <span class=\"space-xs\"></span>\n                    <span>\n                        <button md-raised-button class=\"btn-w-md btn-w-xs approve-reject\" type=\"submit\" color=\"primary\" [disabled]=\"!FileUploadForm.valid || !formDataFlag\">{{ 'Upload CSV' | translate }}</button>\n                    </span>\n                </div>\n            </fieldset>\n        </form>\n    </div>\n</section>"

/***/ }),

/***/ 1261:
/***/ (function(module, exports) {

module.exports = "\n<router-outlet></router-outlet>"

/***/ }),

/***/ 1262:
/***/ (function(module, exports) {

module.exports = "<div class=\"container-fluid no-breadcrumbs page-dashboard\">\n    <article class=\"article\">\n\n        <div class=\"row margin-top-20\">\n            <div class=\"col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9\">\n                <h2 class=\"article-title color-black\">{{ 'MIGRATION INFORMATION' | translate }}</h2>\n            </div>\n            <div class=\"col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3\">\n                <button md-raised-button color=\"accent\" class=\"btn-w-sm btn-w-md float-right\" [routerLink]=\"['/app/file-upload/add']\"><i class=\"material-icons\">cloud_upload </i> {{ 'Upload CSV' | translate | uppercase }}</button>\n            </div>\n        </div>\n\n        <div class=\"box box-default table-box table-responsive mdl-shadow--2dp\" *ngIf=\"showTable\">\n            <ngx-datatable #table class=\"material\"\n                           [messages]=\"dataTableMessage\"\n                           [rows]=\"rows\"\n                           [columnMode]=\"'force'\"\n                           [headerHeight]=\"60\"\n                           [rowHeight]=\"55\"\n                           [footerHeight]=\"70\"\n                           [externalPaging]=\"true\"\n                           [count]=\"page.totalElements\"\n                           [offset]=\"page.pageNumber\"\n                           [limit]=\"page.size\"\n                           [scrollbarH]=\"true\"\n                           (page)='setPage($event,tableRows,false)'>\n\n                <ngx-datatable-column name=\"{{ 'Type' | translate }}\" prop=\"type\" [width]=\"70\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                            <span title=\"{{row['type']}}\">{{row['type'] | translate}}</span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"{{ 'Country Name' | translate }}\" prop=\"countryName\" [width]=\"90\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span title=\"{{row['countryName']}}\">{{row['countryName'] | translate}}</span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"{{ 'Business Unit Name' | translate }}\" prop=\"businessUnitName\" [width]=\"115\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span title=\"{{row['businessUnitName']}}\">{{row['businessUnitName']}}</span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"Uploaded By\" prop=\"uploadBy\" [width]=\"100\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{'Uploaded By' | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span title=\"{{row['uploadBy']}}\">{{row['uploadBy']}}</span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"Uploaded At (UTC)\" prop=\"uploadedAt\" [width]=\"60\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{'Uploaded At' | translate}} (UTC)</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span title=\"{{row['uploadedAt']}}\">{{row['uploadedAt']}}</span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"{{ 'Status' | translate }}\" prop=\"status\" [width]=\"60\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span *ngIf=\"!row['error']\" style=\"color:green\">{{row['status'] | lowercase | translate}}</span>\n                        <span *ngIf=\"row['error']\" style=\"color:red\" (click)=\"showErrorMsg(row['message'])\">{{row['status'] | lowercase | translate}}<i class=\"material-icons margin-left-15\" title=\"Click to see the error message\">info</i></span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"Uploaded File\" prop=\"csvName\" [width]=\"115\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{'Uploaded File' | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span title=\"{{row['csvName']}}\">\n                            <a [href]=\"[row['csvUrl']]\" target=”_blank”>{{row['csvName']}}</a>\n                        </span>\n                    </ng-template>\n                </ngx-datatable-column>\n            </ngx-datatable>\n        </div>\n\n        <div class=\"box box-default\" *ngIf=\"!showTable\">\n            <div class=\"box-body\">\n                <div class=\"icon-box ibox-plain ibox-center\">\n                    <h3>{{ 'No Data' | translate }}</h3>\n                    <br>\n                    <button md-raised-button color=\"accent\" class=\"btn-w-sm btn-w-md\" [routerLink]=\"['/app/file-upload/add']\"><i class=\"material-icons\">add_circle_outline</i> {{ 'Upload CSV' | translate | uppercase }}</button>\n                </div>\n            </div>\n        </div>\n    </article>\n</div>"

/***/ }),

/***/ 1263:
/***/ (function(module, exports) {

module.exports = "<!DOCTYPE html>\n<div class=\"page-auth\">\n    <div class=\"main-body padding-8 max-width-460\">\n        <div class=\"card bg-color-white\">\n            <div class=\"card-content\">\n                <div class=\"logo-2\">\n                    <h3 class=\"icon-color\">{{'Reset Password' | translate}}</h3>\n                </div>\n                <form role=\"form\" [formGroup]=\"ForgetPasswordForm\" class=\"md-form-auth form-validation margin-bottom-40\">\n                    <fieldset>\n                        <div class=\"form-group\">\n                            <md-input-container class=\"full-width md-icon-left no-margin-bottom\">\n                                <md-icon class=\"material-icons\">perm_identity</md-icon>\n                                <input required mdInput placeholder=\"{{ 'WPASS User Id' | translate }}\" formControlName=\"userId_WPASS\" name=\"exampleWPASSID\">\n                            </md-input-container>\n                        </div>\n                        <p class=\"text-center text-small no-margin letter-spacing-0-8\">\n                            <strong>{{'after_reset_password_confirm' | translate}}</strong>\n                        </p>\n\n                        <div class=\"divider divider-md\"></div>\n                        <button md-raised-button type=\"submit\" color=\"primary\" class=\"float-right\" [disabled]=\"!ForgetPasswordForm.valid\" (click)=\"forgetPassword()\">{{'Reset' | translate}}</button>\n                    </fieldset>\n                </form>\n\n                <div class=\"additional-info\">\n                    <a [routerLink]=\"['/app/login']\" class=\"cursor-pointer font-size-1rem\">{{'Login' | translate}}</a>\n                </div>\n            </div>\n\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ 1264:
/***/ (function(module, exports) {

module.exports = "<section class=\"quickview-wrapper customizer hidden-lg-down\" id=\"quickview-customizer\">\n    <a class=\"customizer-close\" href=\"javascript:;\" myToggleQuickview=\"customizer\"><span class=\"material-icons\">close</span></a>\n    <a class=\"customizer-toggle\" href=\"javascript:;\" myToggleQuickview=\"customizer\"><span class=\"material-icons\">settings</span></a>\n\n    <div class=\"quickview-inner\" mySlimScroll>\n        <div>\n            <p class=\"customizer-header\">Customizer</p>\n            <p class=\"small no-margin\">Customize and preview in real time.</p>\n\n            <div class=\"divider divider-lg divider-solid\"></div>\n            <h4 class=\"section-header\">Layout Options</h4>\n            <div class=\"divider divider-sm\"></div>\n            <md-list>\n                <md-list-item>\n                    <p>Fixed Header</p>\n                    <md-slide-toggle class=\"md-secondary\" [(ngModel)]=\"AppConfig.fixedHeader\"></md-slide-toggle>\n                </md-list-item>\n                <md-list-item>\n                    <p>Collapsed Sidebar</p>\n                    <md-slide-toggle class=\"md-secondary\" [(ngModel)]=\"AppConfig.navCollapsed\"></md-slide-toggle>\n                </md-list-item>\n                <md-list-item>\n                    <p>Full Width Header</p>\n                    <md-slide-toggle class=\"md-secondary\" [(ngModel)]=\"AppConfig.navBehind\"></md-slide-toggle>\n                </md-list-item>\n                <md-list-item>\n                    <p>Boxed Layout</p>\n                    <md-slide-toggle class=\"md-secondary\" [(ngModel)]=\"AppConfig.layoutBoxed\"></md-slide-toggle>\n                </md-list-item>\n                <md-list-item>\n                    <p>Sidebar Width</p>\n                    <md-select class=\"no-margin\" [(ngModel)]=\"AppConfig.sidebarWidth\">\n                        <md-option value=\"small\">small</md-option>\n                        <md-option value=\"middle\" >middle</md-option>\n                        <md-option value=\"large\" >large</md-option>\n                    </md-select>\n                </md-list-item>\n            </md-list>\n\n\n            <div class=\"divider divider-lg divider-solid\"></div>\n            <h4 class=\"section-header\">Color Options</h4>\n            <p class=\"small no-margin\">Tip: Additionally, you can active \"Full Width Header\" above</p>\n            <div class=\"divider\"></div>\n            <div class=\"row\">\n                <div class=\"col-4\">\n                    <label class=\"color-option-check\">\n                        <input type=\"radio\" name=\"color\" value=\"11\" [(ngModel)]=\"AppConfig.colorOption\">\n                        <span class=\"color-option-item bg-color-page\">\n                            <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n                            <span class=\"bg-color-dark item-header\"></span>\n                            <span class=\"bg-color-light item-header\"></span>\n                            <span class=\"bg-color-dark\"></span>\n                        </span>\n                    </label>\n                    <label class=\"color-option-check\">\n                        <input type=\"radio\" name=\"color\" value=\"12\" [(ngModel)]=\"AppConfig.colorOption\">\n                        <span class=\"color-option-item bg-color-page\">\n                            <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n                            <span class=\"bg-color-primary item-header\"></span>\n                            <span class=\"bg-color-light item-header\"></span>\n                            <span class=\"bg-color-dark\"></span> \n                        </span>\n                    </label>\n                    <label class=\"color-option-check\">\n                        <input type=\"radio\" name=\"color\" value=\"13\" [(ngModel)]=\"AppConfig.colorOption\">\n                        <span class=\"color-option-item bg-color-page\">\n                            <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n                            <span class=\"bg-color-success item-header\"></span>\n                            <span class=\"bg-color-light item-header\"></span>\n                            <span class=\"bg-color-dark\"></span> \n                        </span>\n                    </label>\n                    <label class=\"color-option-check\">\n                        <input type=\"radio\" name=\"color\" value=\"14\" [(ngModel)]=\"AppConfig.colorOption\">\n                        <span class=\"color-option-item bg-color-page\">\n                            <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n                            <span class=\"bg-color-info item-header\"></span>\n                            <span class=\"bg-color-light item-header\"></span>\n                            <span class=\"bg-color-dark\"></span> \n                        </span>\n                    </label>\n                    <label class=\"color-option-check\">\n                        <input type=\"radio\" name=\"color\" value=\"15\" [(ngModel)]=\"AppConfig.colorOption\">\n                        <span class=\"color-option-item bg-color-page\">\n                            <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n                            <span class=\"bg-color-warning item-header\"></span>\n                            <span class=\"bg-color-light item-header\"></span>\n                            <span class=\"bg-color-dark\"></span> \n                        </span>\n                    </label>\n                    <label class=\"color-option-check\">\n                        <input type=\"radio\" name=\"color\" value=\"16\" [(ngModel)]=\"AppConfig.colorOption\">\n                        <span class=\"color-option-item bg-color-page\">\n                            <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n                            <span class=\"bg-color-danger item-header\"></span>\n                            <span class=\"bg-color-light item-header\"></span>\n                            <span class=\"bg-color-dark\"></span> \n                        </span>\n                    </label>\n                </div>\n\n                <div class=\"col-4\">\n                    <label class=\"color-option-check\">\n                        <input type=\"radio\" name=\"color\" value=\"21\" [(ngModel)]=\"AppConfig.colorOption\">\n                        <span class=\"color-option-item bg-color-page\">\n                            <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n                            <span class=\"bg-color-light item-header\"></span>\n                            <span class=\"bg-color-light item-header\"></span>\n                            <span class=\"bg-color-dark\"></span> \n                        </span>\n                    </label>\n                    <label class=\"color-option-check\">\n                        <input type=\"radio\" name=\"color\" value=\"22\" [(ngModel)]=\"AppConfig.colorOption\">\n                        <span class=\"color-option-item bg-color-page\">\n                            <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n                            <span class=\"bg-color-primary item-header\"></span>\n                            <span class=\"bg-color-primary item-header\"></span>\n                            <span class=\"bg-color-dark\"></span> \n                        </span>\n                    </label>\n                    <label class=\"color-option-check\">\n                        <input type=\"radio\" name=\"color\" value=\"23\" [(ngModel)]=\"AppConfig.colorOption\">\n                        <span class=\"color-option-item bg-color-page\">\n                            <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n                            <span class=\"bg-color-success item-header\"></span>\n                            <span class=\"bg-color-success item-header\"></span>\n                            <span class=\"bg-color-dark\"></span> \n                        </span>\n                    </label>\n                    <label class=\"color-option-check\">\n                        <input type=\"radio\" name=\"color\" value=\"24\" [(ngModel)]=\"AppConfig.colorOption\">\n                        <span class=\"color-option-item bg-color-page\">\n                            <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n                            <span class=\"bg-color-info item-header\"></span>\n                            <span class=\"bg-color-info item-header\"></span>\n                            <span class=\"bg-color-dark\"></span> \n                        </span>\n                    </label>\n                    <label class=\"color-option-check\">\n                        <input type=\"radio\" name=\"color\" value=\"25\" [(ngModel)]=\"AppConfig.colorOption\">\n                        <span class=\"color-option-item bg-color-page\">\n                            <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n                            <span class=\"bg-color-warning item-header\"></span>\n                            <span class=\"bg-color-warning item-header\"></span>\n                            <span class=\"bg-color-dark\"></span> \n                        </span>\n                    </label>\n                    <label class=\"color-option-check\">\n                        <input type=\"radio\" name=\"color\" value=\"26\" [(ngModel)]=\"AppConfig.colorOption\">\n                        <span class=\"color-option-item bg-color-page\">\n                            <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n                            <span class=\"bg-color-danger item-header\"></span>\n                            <span class=\"bg-color-danger item-header\"></span>\n                            <span class=\"bg-color-dark\"></span> \n                        </span>\n                    </label>                                 \n                </div>\n                <div class=\"col-4\">\n                    <label class=\"color-option-check\">\n                        <input type=\"radio\" name=\"color\" value=\"31\" [(ngModel)]=\"AppConfig.colorOption\">\n                        <span class=\"color-option-item bg-color-page\">\n                            <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n                            <span class=\"bg-color-dark item-header\"></span>\n                            <span class=\"bg-color-dark item-header\"></span>\n                            <span class=\"bg-color-light\"></span> \n                        </span>\n                    </label> \n                    <label class=\"color-option-check\">\n                        <input type=\"radio\" name=\"color\" value=\"32\" [(ngModel)]=\"AppConfig.colorOption\">\n                        <span class=\"color-option-item bg-color-page\">\n                            <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n                            <span class=\"bg-color-primary item-header\"></span>\n                            <span class=\"bg-color-primary item-header\"></span>\n                            <span class=\"bg-color-light\"></span> \n                        </span>\n                    </label>\n                    <label class=\"color-option-check\">\n                        <input type=\"radio\" name=\"color\" value=\"33\" [(ngModel)]=\"AppConfig.colorOption\">\n                        <span class=\"color-option-item bg-color-page\">\n                            <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n                            <span class=\"bg-color-success item-header\"></span>\n                            <span class=\"bg-color-success item-header\"></span>\n                            <span class=\"bg-color-light\"></span> \n                        </span>\n                    </label>\n                    <label class=\"color-option-check\">\n                        <input type=\"radio\" name=\"color\" value=\"34\" [(ngModel)]=\"AppConfig.colorOption\">\n                        <span class=\"color-option-item bg-color-page\">\n                            <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n                            <span class=\"bg-color-info item-header\"></span>\n                            <span class=\"bg-color-info item-header\"></span>\n                            <span class=\"bg-color-light\"></span> \n                        </span>\n                    </label>\n                    <label class=\"color-option-check\">\n                        <input type=\"radio\" name=\"color\" value=\"35\" [(ngModel)]=\"AppConfig.colorOption\">\n                        <span class=\"color-option-item bg-color-page\">\n                            <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n                            <span class=\"bg-color-warning item-header\"></span>\n                            <span class=\"bg-color-warning item-header\"></span>\n                            <span class=\"bg-color-light\"></span> \n                        </span>\n                    </label>\n                    <label class=\"color-option-check\">\n                        <input type=\"radio\" name=\"color\" value=\"36\" [(ngModel)]=\"AppConfig.colorOption\">\n                        <span class=\"color-option-item bg-color-page\">\n                            <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n                            <span class=\"bg-color-danger item-header\"></span>\n                            <span class=\"bg-color-danger item-header\"></span>\n                            <span class=\"bg-color-light\"></span> \n                        </span>\n                    </label>                                 \n                </div>\n            </div>\n\n\n\n            <div class=\"divider divider-lg divider-solid\"></div>\n            <h4 class=\"section-header\">Theme Options</h4>\n            <div class=\"divider\"></div>\n\n            <div class=\"row no-margin theme-options clearfix\">\n                <div class=\"col-4\">\n                    <label class=\"theme-option-check\">\n                        <input type=\"radio\" name=\"theme\" value=\"dark\" [(ngModel)]=\"AppConfig.theme\">\n                        <span class=\"theme-option-item bg-color-dark\">\n                            <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n                            <span>Dark</span>\n                        </span>\n                    </label>\n                </div>\n                <div class=\"col-4\">\n                    <label class=\"theme-option-check\">\n                        <input type=\"radio\" name=\"theme\" value=\"gray\" [(ngModel)]=\"AppConfig.theme\">\n                        <span class=\"theme-option-item bg-color-gray\">\n                            <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n                            <span>Gray</span>\n                        </span>\n                    </label>\n                </div>\n                <div class=\"col-4\">\n                    <label class=\"theme-option-check\">\n                        <input type=\"radio\" name=\"theme\" value=\"light\" [(ngModel)]=\"AppConfig.theme\">\n                        <span class=\"theme-option-item bg-color-page\">\n                            <span class=\"overlay\"><span class=\"material-icons\">check</span></span>\n                            <span>Light</span>\n                        </span>\n                    </label>\n                </div>\n            </div>\n            <div class=\"divider divider-lg divider-solid\"></div>\n            <div class=\"text-right\">\n                <a target=\"_blank\" [href]=\"AppConfig.productLink\">Download it Now</a>\n            </div>\n\n        </div>\n    </div>\n</section>"

/***/ }),

/***/ 1265:
/***/ (function(module, exports) {

module.exports = "<!--<div class=\"container-fluid padding-t-b-20\">\n    <span class=\"float-left\">\n        <span>Copyright © <a class=\"brand\" target=\"_blank\" [href]=\"AppConfig.productLink\">{{AppConfig.brand}}</a> {{AppConfig.year}}</span>\n    </span>\n    <span class=\"float-right\">\n        <span>Built with Love <i class=\"material-icons\">favorite_border</i></span>\n    </span>\n</div>-->\n"

/***/ }),

/***/ 1266:
/***/ (function(module, exports) {

module.exports = "<section class=\"app-header\">\n    <div class=\"app-header-inner\"\n         [ngClass]=\"{'bg-color-light': ['11','12','13','14','15','16','21'].indexOf(AppConfig.colorOption) >= 0,\n                     'bg-color-dark': AppConfig.colorOption === '31',\n                     'bg-color-primary': ['22','32'].indexOf(AppConfig.colorOption) >= 0,\n                     'bg-color-success': ['23','33'].indexOf(AppConfig.colorOption) >= 0,\n                     'bg-color-info': ['24','34'].indexOf(AppConfig.colorOption) >= 0,\n                     'bg-color-warning': ['25','35'].indexOf(AppConfig.colorOption) >= 0,\n                     'bg-color-danger': ['26','36'].indexOf(AppConfig.colorOption) >= 0}\">\n\n        <div class=\"brand left-header\" style=\"width:auto; padding:15px 0px 0px 0px;\">\n            <span (mouseenter)=\"toggleCollapsedNav()\">\n                <i class=\"material-icons home-icon\">menu</i>\n            </span>\n            <img src=\"/assets/images/logo/european_appliances_blue_transparent.png\" width=\"300px\" class=\"header-brand-logo\"/>\n        </div>\n\n        <div class=\"top-nav-right\">\n            <ul class=\"list-unstyled list-inline text-right\">\n                <li class=\"list-inline-item\" style=\"line-height: 4;\">\n                    <button md-button class=\"md-button header-btn header-profile-pic\" [mdMenuTriggerFor]=\"profileMenu\">\n                        <img *ngIf=\"userDetails.image != undefined\" src=\"{{userDetails.image}}\" alt=\"\" class=\"rounded img30_30 profile-image\">\n                        <i *ngIf=\"userDetails.image == undefined\" class=\"material-icons\"> person_outline </i>\n                    </button>\n                    <md-menu #profileMenu=\"mdMenu\" x-position=\"after\" y-position=\"below\" overlapTrigger=\"false\">\n                        <md-list dense>\n                            <md-list-item style=\"cursor:pointer;\" (click)=\"logout()\">\n                                <md-icon md-list-avatar class=\"profile-menu-list-item\">power_settings_new</md-icon>\n                                <h4 md-line>{{ 'Logout' | translate }}</h4>\n                            </md-list-item>\n                        </md-list>\n                    </md-menu>\n                </li>\n            </ul>\n        </div>\n\n    </div>\n</section>"

/***/ }),

/***/ 1267:
/***/ (function(module, exports) {

module.exports = "<my-app-sidenav></my-app-sidenav>\n\n<section id=\"page-container\" class=\"app-page-container\">\n    <my-app-header></my-app-header>\n\n    <div class=\"app-content-wrapper\">\n        <div class=\"app-content\">\n            <div class=\"full-height\">\n                <router-outlet></router-outlet>\n            </div>\n        </div>\n\n        <my-app-footer></my-app-footer>\n    </div>\n</section>\n\n<my-app-search-overlay></my-app-search-overlay>"

/***/ }),

/***/ 1268:
/***/ (function(module, exports) {

module.exports = "<section class=\"app-overlay\" mySearchOverlay>\n    <div class=\"app-overlay-inner\">\n        <div class=\"overlay-header\">\n            <a href=\"javascript:;\" id=\"overlay-close\" class=\"overlay-close\">\n                <i class=\"material-icons\">close</i>\n            </a>\n        </div>\n        <div class=\"overlay-content\">\n            <input id=\"overlay-search-input\"\n                   class=\"overlay-search-input\" \n                   placeholder=\"Search...\"\n                   >\n\n            <div class=\"text-small text-muted\">\n                <span>Press <em>Esc</em> key to dismiss</span>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ 1269:
/***/ (function(module, exports) {

module.exports = "<ul class=\"nav\" myAccordionNav myAppendSubmenuIcon mySlimScroll myHighlightActiveItems>\n        <li><a class=\"font-size-13\" md-button [routerLink]=\"['/app/profile']\"><i class=\"nav-icon material-icons\">person</i><span class=\"nav-text\">{{ 'Profile' | translate }}</span></a></li>\n    \n        <li *ngIf=\"isSystemAdmin || isBUManager || isRegionalAdmin\"><a class=\"font-size-13\" md-button [routerLink]=\"['/app/admin-dashboard']\"><i class=\"nav-icon material-icons\">list</i><span class=\"nav-text\">{{ 'Users Dashboard' | translate }}</span></a></li>\n    \n        <li *ngIf=\"isServiceOwner || isTradePartner\"><a class=\"font-size-13\" md-button [routerLink]=\"['/app/partners-dashboard']\"><i class=\"nav-icon material-icons\">list</i><span class=\"nav-text\">{{ 'Dashboard' | translate }}</span></a></li>\n    \n        <li *ngIf=\"isSystemAdmin || isApplicationManager\"><a class=\"font-size-13\" md-button [routerLink]=\"['/app/application-manager-dashboard']\"><i class=\"nav-icon material-icons\">list</i><span class=\"nav-text\">{{ 'Application Dashboard' | translate }}</span></a></li>\n    \n        <li *ngIf=\"isServiceOwner || isTradePartner\"><a class=\"font-size-13\" md-button [routerLink]=\"['/app/request-application/list']\"><i class=\"nav-icon material-icons\">assignment</i><span class=\"nav-text\">{{ 'Request Application' | translate }}</span></a></li>\n    \n        <li *ngIf=\"isSystemAdmin\"><a class=\"font-size-13\" md-button [routerLink]=\"['/app/manage-admin/list']\"><i class=\"nav-icon material-icons\">assignment</i><span class=\"nav-text\">{{ 'Admin Management' | translate }}</span></a></li>\n    \n        <li *ngIf=\"isSystemAdmin\"><a class=\"font-size-13\" md-button [routerLink]=\"['/app/manage-business-unit/list']\"><i class=\"nav-icon material-icons\">assignment</i><span class=\"nav-text\">{{ 'Business Unit Management' | translate }}</span></a></li>\n    \n        <li *ngIf=\"isSystemAdmin\"><a class=\"font-size-13\" md-button [routerLink]=\"['/app/manager-assignment/list']\"><i class=\"nav-icon material-icons\">assignment</i><span class=\"nav-text\">{{ 'bu_mngr_app_assignment' | translate }}</span></a></li>\n    \n        <li *ngIf=\"isSystemAdmin\"><a class=\"font-size-13\" md-button [routerLink]=\"['/app/wpass']\"><i class=\"nav-icon material-icons\">settings</i><span class=\"nav-text\">{{ 'System Settings' | translate }}</span></a></li>\n    \n        <li *ngIf=\"isSystemAdmin || isBUManager\"><a class=\"font-size-13\" md-button [routerLink]=\"['/app/file-upload/list']\"><i class=\"nav-icon material-icons\">cloud_upload</i><span class=\"nav-text\">{{ 'Data Migration' | translate }}</span></a></li>\n    \n        <li *ngIf=\"isSystemAdmin\"><a class=\"font-size-13\" md-button [routerLink]=\"['/app/application-management/list']\"><i class=\"nav-icon material-icons\">assignment</i><span class=\"nav-text\">{{ 'Application Management' | translate }}</span></a></li>\n    \n        <li *ngIf=\"isSystemAdmin\"><a class=\"font-size-13\" md-button [routerLink]=\"['/app/user-activity-logs']\"><i class=\"nav-icon material-icons\">subject</i><span class=\"nav-text\">{{ 'user_activity' | translate }}</span></a></li>\n\n        <li *ngIf=\"isSystemAdmin\"><a class=\"font-size-13\" md-button [routerLink]=\"['/app/translation-messages']\"><i class=\"nav-icon material-icons\">message</i><span class=\"nav-text\">{{ 'translation_messages' | translate }}</span></a></li>\n\n        <li *ngIf=\"isSystemAdmin\"><a class=\"font-size-13\" md-button [routerLink]=\"['/app/translation-email']\"><i class=\"nav-icon material-icons\">email</i><span class=\"nav-text\">{{ 'translation_email' | translate }}</span></a></li>\n\n        <li><a class=\"font-size-13\" md-button (click)=\"logout()\"><i class=\"nav-icon material-icons\">power_settings_new</i><span class=\"nav-text\">{{ 'Logout' | translate }}</span></a></li>\n    </ul>"

/***/ }),

/***/ 1270:
/***/ (function(module, exports) {

module.exports = "<nav class=\"app-sidebar\" myAutoCloseMobileNav (mouseleave)=\"toggleCollapsedNav()\"\n     [ngClass]=\"{'bg-color-light': ['21','31','32','33','34','35','36'].indexOf(AppConfig.colorOption) >= 0,\n                 'bg-color-dark': ['21','31','32','33','34','35','36'].indexOf(AppConfig.colorOption) < 0 }\">\n\n    <section class=\"sidebar-content\">\n        <my-app-sidenav-menu></my-app-sidenav-menu>\n    </section>\n\n    <section class=\"sidebar-footer\">\n        <!--<ul class=\"nav\">\n            <li><a md-button aria-label=\"menu\" target=\"_blank\" [href]=\"AppConfig.productLink\" ><i class=\"nav-icon material-icons\">help</i><span class=\"nav-text\"><span>Help</span> & <span>Support</span></span></a></li>\n        </ul>-->\n    </section>\n</nav>"

/***/ }),

/***/ 1271:
/***/ (function(module, exports) {

module.exports = "<!DOCTYPE html>\n<div class=\"cdk-overlay-container loader-cdk-overlay-container\" *ngIf=\"show\">\n    <div class=\"cdk-global-overlay-wrapper\" style=\"justify-content: center; align-items: center;\">\n        <div class=\"cdk-overlay-backdrop cdk-overlay-dark-backdrop cdk-overlay-backdrop-showing\"></div>\n        <div id=\"cdk-overlay-7\" class=\"cdk-overlay-pane\" dir=\"ltr\" style=\"position: static; pointer-events: auto;\">\n            <div tabindex=\"0\" class=\"cdk-visually-hidden cdk-focus-trap-anchor\"></div>\n            <md-progress-spinner mode=\"indeterminate\" role=\"progressbar\" _nghost-c13=\"\" ng-reflect-mode=\"indeterminate\" class=\"mat-progress-spinner\">\n                <svg _ngcontent-c13=\"\" preserveAspectRatio=\"xMidYMid meet\" viewBox=\"0 0 100 100\">\n                    <path _ngcontent-c13=\"\" d=\"M89.68482425609551,55.011459244852105A40,40 0 1,0 43.099905452208944,89.40036415100175\" style=\"stroke-width: 10;\"></path>\n                </svg>\n            </md-progress-spinner>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ 1272:
/***/ (function(module, exports) {

module.exports = "<!DOCTYPE html>\n<div class=\"page-auth\">\n    <div class=\"main-body\">\n        <div class=\"card bg-color-white login-card\">\n\n            <div class=\"card-content padding-0\">\n                <div class=\"logo-1\">\n                    <img class=\"login-logo\" src=\"assets\\images\\logo\\european_appliances_blue_transparent.png\"/>\n                    <p class=\"font-size-13 login-logo-text\">{{ 'WelcomeLine1' | translate }}</p>\n                </div>\n\n                <div class=\"box-body box-body-dotted box-body-less-dim-white text-left padding-0\">\n                    <h5 class=\"no-margin-top login-user\">{{ 'Login As Whirlpool Partner' | translate}}</h5>\n                    <form role=\"form\" [formGroup]=\"PartnersForm\" class=\"margin-bottom-19 padding-form\">\n                        <fieldset>\n                            <div class=\"form-group margin-bottom-17-5\">\n                                <div class=\"row\">\n                                    <div class=\"col-md-1 padding-l-r-18\">\n                                        <md-icon class=\"material-icons\">language</md-icon>\n                                    </div>\n                                    <div class=\"col-md-10\">\n                                        <md-select formControlName=\"languageId\" placeholder=\"{{ 'Language' | translate }}\" class=\"full-width\">\n                                            <md-option *ngFor=\"let languageId of languageDetails\" [value]=\"languageId.id\"> {{languageId.name}} </md-option>\n                                        </md-select>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"form-group margin-bottom-5 padding-r-13\">\n                                <md-input-container class=\"full-width md-icon-left\">\n                                    <md-icon class=\"material-icons\">perm_identity</md-icon>\n                                    <input mdInput id=\"exampleInputEmail\" formControlName=\"userId_WPASS\" placeholder=\"{{ 'User Id' | translate }}\">\n                                </md-input-container>\n                            </div>\n                            <div class=\"form-group padding-r-13\">\n                                <md-input-container class=\"full-width md-icon-left\">\n                                    <md-icon class=\"material-icons\">lock_outline</md-icon>\n                                    <input #input mdInput type=\"password\" id=\"exampleInputPassword\" formControlName=\"password\" placeholder=\"{{ 'Password' | translate }}\">\n                                </md-input-container>\n                                <p class=\" margin-0\" *ngIf=\"input.type === 'password'\"><i class=\"material-icons font-size-18 pass-useful-hint-login right-40\" (click)=\"showPassword(input)\">visibility</i></p>\n                                <p class=\" margin-0\" *ngIf=\"input.type ===  'text'\"><i class=\"material-icons font-size-18 pass-useful-hint-login right-40\" (click)=\"showPassword(input)\">visibility_off</i></p>\n                            </div>\n                            <div class=\"form-group row\">\n                                <div class=\"col-md-12 text-center\">\n                                    <button md-raised-button type=\"submit\" class=\"btn-w-md btn-w-xs width-114 margin-left-15\" color=\"primary\" [disabled]=\"!PartnersForm.valid\" (click)=\"digiAccessLogin()\">{{'Login' | translate}}</button>\n                                    <button md-raised-button type=\"button\" color=\"accent\" class=\"btn-w-md btn-w-xs width-114\" [routerLink]=\"['/registration']\">{{'Register' | translate}}</button>\n                                </div>\n                            </div>\n\n                            <div class=\"divider divider-dashed divider-md pull-in\"></div>\n\n                            <div class=\"text-center\">\n                                <img id=\"googleBtn\" class=\"cursor-pointer\" height=\"47\" width=\"230px\" src=\"assets/images/google-btn-admin.png\">\n                            </div>\n\n                        </fieldset>\n                    </form>\n\n                </div>\n            </div>\n\n        </div>\n        <div class=\"row login-last-text-padding\">\n            <div class=\"col-md-6 col-sm-6\">\n                <p class=\"mdl-typography--text-center color-white no-margin-bottom cursor-pointer\" [routerLink]=\"['/forgot-password']\"><u>{{'I forgot my password' | translate}}</u></p>\n            </div>\n            <div class=\"col-md-6 col-sm-6\">\n                <p class=\"mdl-typography--text-center color-white no-margin-bottom cursor-pointer\" [routerLink]=\"['/unlock-account']\"><u>{{'unlock_account' | translate}}</u></p>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ 1273:
/***/ (function(module, exports) {

module.exports = "<button type=\"submit\" (click)=\"checkStatus('approved')\" md-raised-button color=\"accent\" class=\"btn-w-sm btn-w-md color-white font-size-12px approve-reject\"><span class=\"btn-text\">{{ 'APPROVE SELECTED' | translate }}</span></button>\n<span class=\"space-xs\"></span>\n<button type=\"submit\" (click)=\"checkStatus('rejected')\"  md-raised-button class=\"btn-w-sm btn-w-md btn-red font-size-12px approve-reject\"><span class=\"btn-text\">{{ 'REJECT SELECTED' | translate }}</span></button>"

/***/ }),

/***/ 1274:
/***/ (function(module, exports) {

module.exports = "<section class=\"container-fluid\">\n\n    <div class=\"article-title\">Blank</div>\n\n</section>"

/***/ }),

/***/ 1275:
/***/ (function(module, exports) {

module.exports = "<div class=\"container-fluid no-breadcrumbs page-dashboard\">\n    <article class=\"article\">\n\n        <div class=\"row margin-top-20\">\n            <div class=\"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6\">\n                <h2 *ngIf=\"this.isServiceOwner || this.isTradePartner\" class=\"article-title color-black\">{{ 'Dashboard' | translate | uppercase }}</h2>\n                <h2 *ngIf=\"this.isRegionalAdmin || this.isBUManager\" class=\"article-title color-black\">{{ 'Sub Users' | translate | uppercase }}</h2>\n            </div>\n            <div class=\"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 text-right\" *ngIf=\"this.isRegionalAdmin || this.isBUManager\">\n                <button md-raised-button class=\"btn-w-sm btn-w-md approve-reject\" [routerLink]=\"['/app/admin-dashboard']\"><span class=\"btn-text\">{{ 'Back' | translate }}</span></button>\n                <!--<span class=\"space-xs\"></span>\n                <multi-approve-reject *ngIf=\"showCheckbox && selected.length >= 1\" [childData]=selected [searchedFilters]=searchedFilters [dashboard]=partnersText [selectedCount]=selectedCount [count]=count [totalCount]=totalCount></multi-approve-reject>-->\n            </div>\n            <div class=\"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 text-right\" *ngIf=\"this.isServiceOwner || this.isTradePartner\">\n                <button md-raised-button color=\"accent\" class=\"btn-w-md\" [routerLink]=\"['/app/user/add']\"><i class=\"material-icons\">add_circle_outline</i> {{ 'NEW USER' | translate }}</button>\n            </div>\n        </div>\n\n        <div class=\"box customize-app-header-inner margin-bottom-15\">\n            <div class=\"filter-padding\">\n                <div class=\"row margin-right-neg-5\">\n                    <div class=\"col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2\">\n                        <md-select placeholder=\"{{ 'Status' | translate }}\" class=\"full-width margin-top-10 filter-input\" [(ngModel)]=\"selectedStatusId\">\n                            <md-option *ngFor=\"let statusData of StatusData\" [value]=\"statusData.id\">\n                                {{statusData.name | lowercase | translate}}\n                            </md-option>\n                        </md-select>\n                    </div>\n                    <div class=\"col-xl-10 col-lg-10 col-md-10 col-sm-10 col-10\">\n                        <form class=\"row\" [formGroup]=\"PartnersFiltersForm\" (ngSubmit)=\"callUsersListbyAdminOrPartner()\" (keydown.enter)=\"$event.preventDefault()\">\n                            <div class=\"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12\">\n                                <input type='text' formControlName=\"firstName\"  class=\"filter-input-1 width-18\" placeholder=\"{{ 'Name' | translate }}\" />\n                                <input type='text' formControlName=\"email\"  class=\"filter-input-1 width-18\" placeholder=\"{{ 'Email' | translate }}\" />\n                                <input type='text' formControlName=\"wpassId\"  class=\"filter-input-1 width-18\" placeholder=\"{{ 'WPASS Id' | translate | uppercase }}\" (keyup)=\"disablefields($event.target.value)\" />\n                                <button md-raised-button class=\"btn-w-xxs\" type=\"submit\" [disabled]=\"!PartnersFiltersForm.valid\" title=\"Search\"> <md-icon class=\"material-icons\">search</md-icon> {{ 'Search' | translate }}</button>\n                                <span class=\"space-xs\"></span>\n                                <span class=\"space-xs\"></span>\n                                <button md-raised-button class=\"btn-w-xxs\" color=\"primary\" type=\"button\" (click)=\"resetSearch()\" title=\"Reset Search\"> <md-icon class=\"material-icons\">settings_backup_restore</md-icon> {{ 'Reset' | translate }}</button>\n                            </div>\n                        </form>\n                    </div>\n                </div>\n                <div class=\"callout-1 collout-warn-1\">\n                    <p>{{ 'filter_apply_info' | translate }}</p>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"box box-default table-box table-responsive mdl-shadow--2dp\" *ngIf=\"showTable\">\n            <ngx-datatable #table class=\"material\"\n                           [messages]=\"dataTableMessage\"\n                           [rows]=\"rows\"\n                           [columnMode]=\"'force'\"\n                           [headerHeight]=\"60\"\n                           [rowHeight]=\"55\"\n                           [footerHeight]=\"70\"\n                           [externalPaging]=\"true\"\n                           [count]=\"page.totalElements\"\n                           [offset]=\"page.pageNumber\"\n                           [limit]=\"page.size\"\n                           [scrollbarH]=\"true\"\n                           (page)='setPage($event,tableRows,false)'\n                           [selected]=\"selected\"\n                           [scrollbarH]=\"true\"\n                           [selectionType]=\"'checkbox'\"\n                           (page)='setPage($event,tableRows,false)'\n                           (select)='onSelect($event)'>\n\n                <ngx-datatable-column *ngIf=\"showCheckbox\"\n                                      [width]=\"45\"\n                                      [sortable]=\"false\"\n                                      [canAutoResize]=\"false\"\n                                      [draggable]=\"false\"\n                                      [resizeable]=\"false\"\n                                      [headerCheckboxable]=\"true\"\n                                      [checkboxable]=\"true\">\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"{{ 'Name' | translate }}\" prop=\"Name\" [width]=\"130\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{'Name' | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                            <span title=\"{{row['Name']}}\" style=\"color: blue;cursor: pointer\">\n                                <a [routerLink]=\"['/app/view-request/viewSubUsers', row['id']]\">{{row['Name']}}</a>\n                            </span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"{{ 'Role Name' | translate }}\" prop=\"roleName\" [width]=\"15\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span title=\"{{row['roleName']}}\">{{row['roleName']}}</span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"{{ 'Email' | translate }}\" prop=\"email\" [width]=\"160\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span title=\"{{row['email']}}\">{{row['email']}}</span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"WPASS Id\" prop=\"userId_WPASS\" [width]=\"45\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{'WPASS Id' | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span title=\"{{row['userId_WPASS']}}\">{{row['userId_WPASS']}}</span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"{{ 'Status' | translate }}\" prop=\"status\" [width]=\"100\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span *ngIf=\"row['status'] == 'Email Verification Pending'\" style=\"color:#e68811\">{{row['status'] | lowercase | translate}}</span>\n                        <span *ngIf=\"row['status'] == 'Pending'\" style=\"color:orange\">{{row['status'] | lowercase | translate}}</span>\n                        <span *ngIf=\"row['status'] == 'User ID Awaited'\" style=\"color:blue\">{{row['status'] | lowercase | translate}}</span>\n                        <span *ngIf=\"row['status'] == 'Approved'\" style=\"color:green\">{{row['status'] | lowercase | translate}}</span>\n                        <span *ngIf=\"row['status'] == 'Rejected'\" style=\"color:red\">{{row['status'] | lowercase | translate}}</span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"{{ 'Action' | translate }}\" prop=\"action\" [width]=\"120\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-rowIndex=\"rowIndex\" let-row=\"row\" ngx-datatable-cell-template>\n                        <span *ngIf=\"!urlId\">\n                            <span *ngIf=\"row['status'] != 'Deletion Pending' && row['status'] != 'Deleted'\">\n                                <activate-deactivate [childData]=row [dashboard]=partnersText></activate-deactivate>\n                            </span>\n                            <span *ngIf=\"row['status'] == 'Deletion Pending' && row['status'] == 'Deleted'\"></span>\n                        </span>\n                        <span *ngIf=\"urlId\">\n                            <!--<span *ngIf=\"row['status'] == 'Pending'\">\n                                <approve-reject [childData]=row [dashboard]=partnersText></approve-reject>\n                            </span>\n                            <span *ngIf=\"row['status'] != 'Pending'\"></span>-->\n                        </span>\n\n                    </ng-template>\n                </ngx-datatable-column>\n\n            </ngx-datatable>\n        </div>\n\n        <div class=\"box box-default\" *ngIf=\"!showTable\">\n            <div class=\"box-body\">\n                <div class=\"icon-box ibox-plain ibox-center\">\n                    <h3>{{ 'No Data' | translate }}</h3>\n                </div>\n            </div>\n        </div>\n\n    </article>\n</div>"

/***/ }),

/***/ 1276:
/***/ (function(module, exports) {

module.exports = "<div class=\"mdl-card mdl-card-full-width\" [ngClass]=\"{'min-width-395': action == 'changePassword'}\" style=\"min-height: auto;\">\n    <div class=\"row\" style=\"padding-top:5px; padding-left: 14px; padding-right: 14px; padding-bottom: 13px;\">\n        <div class=\"col-md-12 margin-top-sm\">\n\n            <div *ngIf=\"action == 'changeEmail'\">\n                <h1 md-dialog-title class=\"margin-bottom-10\">{{ 'Change Email Address' | translate }}?</h1>\n                <form [formGroup]=\"ProfileActionForm\">\n                    <fieldset formGroupName=\"emailGroup\">\n                        <div class=\" form-group margin-top-30 form-group\">\n                            <md-input-container class=\"full-width\">\n                                <input mdInput type=\"email\" placeholder=\"{{ 'Current Email Address' | translate }} *\" formControlName=\"currentEmailAddress\">\n                            </md-input-container>\n                        </div>\n                        <div class=\" form-group margin-top-30 form-group\">\n                            <md-input-container class=\"full-width\">\n                                <input mdInput type=\"email\" placeholder=\"{{ 'New Email Address' | translate }} *\" formControlName=\"email\">\n                            </md-input-container>\n                        </div>\n                        <div class=\" form-group margin-top-30 form-group\">\n                            <md-input-container class=\"full-width\">\n                                <input mdInput type=\"email\" placeholder=\"{{ 'Confirm Email Address' | translate }} *\" formControlName=\"confirmEmail\" appBlockCutCopyPaste>\n                            </md-input-container>\n                            <div *ngIf=\"ProfileActionForm.get('emailGroup').hasError('mismatch')\">\n                                <small ng-message='required'>{{ 'Email Id Mismatch' | translate }}</small>\n                            </div>\n                        </div>\n\n                        <div md-dialog-actions style=\"padding-left: 16px; padding-right: 16px; padding-bottom:26px;\">\n                            <button md-raised-button class=\"btn-success text-white\" (click)=\"changeEmailAddress()\" [disabled]=\"!ProfileActionForm.get('emailGroup').valid\">{{ 'Confirm' | translate }}</button>\n                            <span class=\"space-xs\"></span>\n                            <span class=\"space-xs\"></span>\n                            <span class=\"space-xs\"></span>\n                            <button md-raised-button (click)=\"dialogRef.close('Option 2')\">{{ 'Close' | translate }}</button>\n                        </div>\n                    </fieldset>\n                </form>\n            </div>\n\n            <div *ngIf=\"action == 'changePassword'\">\n                <h1 md-dialog-title class=\"margin-bottom-10\">{{ 'Change Password' | translate }}?</h1>\n                <form [formGroup]=\"ProfileActionForm\">\n                    <fieldset formGroupName=\"passwordGroup\">\n                        <div class=\"form-group margin-top-30 form-group\">\n                            <div class=\"row\">\n                                <div class=\"col-md-12\">\n                                    <md-input-container class=\"full-width\">\n                                        <input #input1 mdInput type=\"password\" placeholder=\"{{ 'Current Password' | translate }} *\" formControlName=\"currentPassword\">\n                                    </md-input-container>\n                                    <p class=\"margin-0\" *ngIf=\"input.type === 'password'\"><i class=\"material-icons font-size-18 pass-useful-hint right-40\" (click)=\"showPassword(input1)\">visibility</i></p>\n                                    <p class=\"margin-0\" *ngIf=\"input.type ===  'text'\"><i class=\"material-icons font-size-18 pass-useful-hint right-40\" (click)=\"showPassword(input1)\">visibility_off</i></p>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"form-group margin-top-25\">\n                            <div class=\"row\">\n                                <div class=\"col-md-12\">\n                                    <md-input-container class=\"full-width\">\n                                        <input #input mdInput type=\"password\" placeholder=\"{{ 'New Password' | translate }} *\" formControlName=\"password\">\n                                    </md-input-container>\n                                    <p class=\"margin-0\" *ngIf=\"input.type === 'password'\"><i class=\"material-icons font-size-18 pass-useful-hint right-40\" (click)=\"showPassword(input)\">visibility</i></p>\n                                    <p class=\"margin-0\" *ngIf=\"input.type ===  'text'\"><i class=\"material-icons font-size-18 pass-useful-hint right-40\" (click)=\"showPassword(input)\">visibility_off</i></p>\n\n                                    <div class=\"pass-hint pass-useful-hint right-10\">\n                                        <i class=\"material-icons font-size-17\" style=\"color: #717171db;\">info</i>\n                                        <div class=\"pass-content\" style=\"float: right !important; right: 0 !important;\">\n                                            <ul class=\"password-ul\" style=\"width: 353px;\">\n                                                <li>{{ 'pass_least_8_chars' | translate }}</li>\n                                                <li>{{ 'pass_one_upper_lower_char' | translate }}</li>\n                                                <li>{{ 'pass_one_number' | translate }}</li>\n                                                <li>{{ 'pass_no_userId' | translate }}</li>\n                                                <li>{{ 'pass_invalid_symbol' | translate }}</li>\n                                                <li>{{ 'pass_contains_firstname' | translate }}</li>\n                                                <li>{{ 'pass_contains_lastname' | translate }}</li>\n                                                <li>{{ 'pass_prevent_history' | translate }}</li>\n                                            </ul>\n                                        </div>\n                                    </div>\n                                    <div>\n                                        <small ng-message='required'>{{ passwordErrorMsg | translate }}</small>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"margin-top-25 form-group\">\n                            <div class=\"row\">\n                                <div class=\"col-md-12\">\n                                    <md-input-container class=\"full-width\">\n                                        <input #input2 mdInput type=\"password\" placeholder=\"{{ 'Confirm Password' | translate }} *\" formControlName=\"confirmPassword\">\n                                    </md-input-container>\n                                    <p class=\"margin-0\" *ngIf=\"input.type === 'password'\"><i class=\"material-icons font-size-18 pass-useful-hint right-40\" (click)=\"showPassword(input2)\">visibility</i></p>\n                                    <p class=\"margin-0\" *ngIf=\"input.type ===  'text'\"><i class=\"material-icons font-size-18 pass-useful-hint right-40\" (click)=\"showPassword(input2)\">visibility_off</i></p>\n                                    <div *ngIf=\"ProfileActionForm.get('passwordGroup').hasError('mismatch')\">\n                                        <small ng-message='required'>{{ 'Password Mismatch' | translate }}</small>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n\n                        <div md-dialog-actions style=\"padding-right: 16px; padding-bottom:35px;\">\n                            <button md-raised-button class=\"btn-success text-white\" (click)=\"changePassword()\" [disabled]=\"!ProfileActionForm.get('passwordGroup').valid\">{{ 'Confirm' | translate}}</button>\n                            <span class=\"space-xs\"></span>\n                            <span class=\"space-xs\"></span>\n                            <span class=\"space-xs\"></span>\n                            <button md-raised-button (click)=\"dialogRef.close('Option 2')\">{{ 'Close' | translate}}</button>\n                        </div>\n                    </fieldset>\n                </form>\n            </div>\n\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ 1277:
/***/ (function(module, exports) {

module.exports = "<section class=\"container-fluid no-breadcrumbs\">\n    <div class=\"row margin-top-15\">\n        <div class=\"col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7\">\n            <h2 class=\"article-title color-black\">{{ 'Profile' | translate | uppercase }}</h2>\n        </div>\n        <div class=\"col-xl-5 col-lg-5 col-md-5 col-sm-5 col-5\">\n            <span *ngIf=\"isServiceOwner || isTradePartner || isSubUser\" [ngClass]=\"{'float-right': flag == 'subUsers'}\">\n                <button md-raised-button color=\"primary\" class=\"btn-w-md\" (click)=\"performAction('changeEmail')\">{{ 'Change Email' | translate }}</button>\n                <span class=\"space-xs\"></span>\n                <button md-raised-button color=\"accent\" class=\"btn-w-md\" (click)=\"performAction('changePassword')\">{{ 'Change Password' | translate }}</button>\n            </span>\n            <span *ngIf=\"!isSystemAdmin && (flag == 'buManager' || flag == 'partners' || flag == 'applicationManager')\">\n                <span class=\"space-xs\"></span>\n                <button *ngIf=\"flag == 'buManager'\" md-raised-button class=\"btn-w-md approve-reject\" [routerLink]=\"['/app/admin-dashboard']\"><span class=\"btn-text\">{{ 'Back To Dashboard' | translate }}</span></button>\n                <button *ngIf=\"flag == 'partners'\" md-raised-button class=\"btn-w-md approve-reject\" [routerLink]=\"['/app/partners-dashboard']\"><span class=\"btn-text\">{{ 'Back To Dashboard' | translate }}</span></button>\n                <!--<button *ngIf=\"flag == 'applicationManager'\" md-raised-button class=\"btn-w-md approve-reject\" [routerLink]=\"['/app/application-manager-dashboard']\"><span class=\"btn-text\">{{ 'Back To Dashboard' | translate }}</span></button>-->\n            </span>\n        </div>\n    </div>\n\n    <div class=\"mdl-card mdl-shadow--2dp mdl-card-full-width\">\n        <div class=\"card_title\">\n            <h2 class=\"mdl-card__title-text\">{{ 'Profile Information' | translate }}</h2>\n        </div>\n        <form role=\"form\" [formGroup]=\"ProfileForm\">\n            <div class=\"row form-group form-content\">\n                <p class=\"col-md-12 font-size-18 usr-detail-page-p\"> {{ 'Personal Information' | translate }} </p>\n                <div class=\"col-md-4\">\n                    <label>{{ 'First Name' | translate }}</label>\n                    <p *ngIf=\"profileData\">{{profileData.firstName}}</p>\n                </div>\n                <div class=\"col-md-4\">\n                    <label>{{ 'Last Name' | translate }}</label>\n                    <p *ngIf=\"profileData\">{{profileData.lastName}}</p>\n                </div>\n                <div class=\"col-md-4 form-group\">\n                    <md-select formControlName=\"languageId\" placeholder=\"{{ 'Language' | translate }}\" class=\"full-width max-width-80 margin-top-37\">\n                        <md-option *ngFor=\"let languageData of LanguageData\" [value]=\"languageData.id\" (click)=\"onLanguageChange(languageData.id)\"> {{languageData.name}} </md-option>\n                    </md-select>\n                </div>\n                <div class=\"col-md-4\">\n                    <label>{{ 'Email' | translate }}</label>\n                    <p *ngIf=\"profileData\">{{profileData.email}}</p>\n                </div>\n                <div class=\"col-md-4\" *ngIf=\"flag == 'partners'\">\n                    <label>{{ 'Country' | translate }}</label>\n                    <p *ngIf=\"profileData\">{{profileData.countryName | translate}}</p>\n                </div>\n                <div class=\"col-md-4\" *ngIf=\"flag == 'partners'\">\n                    <label>{{ 'Status' | translate }}</label>\n                    <p *ngIf=\"profileData\">{{profileData.status | lowercase | translate}}</p>\n                </div>\n                <div class=\"col-md-4\">\n                    <label>{{ 'WPASS User Id' | translate }}</label>\n                    <p *ngIf=\"profileData\">{{profileData.userId_WPASS}}</p>\n                </div>\n            </div>\n\n            <div class=\"dotted-divider\"></div>\n\n            <div class=\"row form-group form-content\">\n                <p class=\"col-md-12 font-size-18 usr-detail-page-p\"> {{ 'Corporate Information' | translate }} </p>\n                <div class=\"col-md-4\" *ngIf=\"flag == 'partners'\">\n                    <label>{{ 'Request Submission Date' | translate }}</label>\n                    <p *ngIf=\"profileData\">{{profileData.createdAt}}</p>\n                </div>\n                <div class=\"col-md-4\" *ngIf=\"flag == 'partners'\">\n                    <label>{{ 'UserId Creation Date' | translate }}</label>\n                    <p *ngIf=\"profileData\">{{profileData.wpassCreatedAt}}</p>\n                </div>\n                <div class=\"col-md-4\" *ngIf=\"flag == 'partners'\">\n                    <!--<label>{{ 'Valid Till' | translate }}</label>\n                    <p *ngIf=\"profileData\">{{profileData.validTill}}</p>-->\n                </div>\n                <div class=\"col-md-4\" *ngIf=\"flag == 'partners'\">\n                    <label>{{ 'Company Name' | translate }}</label>\n                    <p *ngIf=\"profileData\">{{profileData.companyName}}</p>\n                </div>\n                <div class=\"col-md-4\" *ngIf=\"flag == 'partners'\">\n                    <label>{{ 'Company Address' | translate }}</label>\n                    <p *ngIf=\"profileData\">{{profileData.companyAddress}}</p>\n                </div>\n                <div class=\"col-md-4\" *ngIf=\"flag == 'partners'\">\n                    <label>{{ 'Company Phone' | translate }}</label>\n                    <p *ngIf=\"profileData\">{{profileData.companyPhone}}</p>\n                </div>\n                <div class=\"col-md-4\">\n                    <label>{{ 'Role' | translate }}</label>\n                    <p *ngIf=\"profileData\">{{profileData.roleName}}</p>\n                </div>\n            </div>\n\n            <div class=\"dotted-divider\" *ngIf=\"flag == 'partners'\"></div>\n\n            <div class=\"row form-group form-content\" *ngIf=\"flag == 'partners'\">\n                <p class=\"col-md-12 font-size-18 usr-detail-page-p\"> {{ 'Business Unit Information' | translate }} </p>\n\n                <div class=\"col-md-12\" style=\"padding: 20px 45px 0px 15px; !important;\">\n                    <div class=\"box box-default table-box table-responsive mdl-shadow--2dp\">\n                        <table class=\"mdl-data-table font-size-14\" *ngIf=\"businessUnitWithAppRolesProfile && businessUnitWithAppRolesProfile.length > 0\">\n                            <thead class=\"responsive-table-header-backgroud\">\n                            <tr>\n                                <th class=\"mdl-data-table__cell--non-numeric\" style=\"text-align: left!important;\">#</th>\n                                <th class=\"mdl-data-table__cell--non-numeric\">{{'Application Name' | translate }}</th>\n                                <th class=\"mdl-data-table__cell--non-numeric\">{{'Business Unit' | translate }}</th>\n                                <th class=\"mdl-data-table__cell--non-numeric\">{{'Customer Number' | translate }}</th>\n                                <th class=\"mdl-data-table__cell--non-numeric\">{{'Status' | translate }}</th>\n                                <th class=\"mdl-data-table__cell--non-numeric\">{{'Role' | translate }}</th>\n                            </tr>\n                            </thead>\n\n                            <tbody>\n                            <tr *ngFor=\"let appData of businessUnitWithAppRolesProfile, let i = index\">\n                                <td class=\"mdl-data-table__cell--non-numeric\">{{i + 1}}</td>\n                                <td class=\"mdl-data-table__cell--non-numeric\">\n                                    <a *ngIf=\"appData.url\" target=\"_blank\" href={{appData.url}}><i class=\"material-icons\"> near_me </i></a>\n                                    {{appData.applicationName}}\n                                </td>\n                                <td class=\"mdl-data-table__cell--non-numeric\">{{appData.businessUnitName}}</td>\n                                <td class=\"mdl-data-table__cell--non-numeric\">{{appData.customerNumber}}</td>\n                                <td class=\"mdl-data-table__cell--non-numeric\" *ngIf=\"appData.statusCode == 'AUTO_APPROVED' || appData.statusCode == 'APPROVED'\"\n                                    style=\"color: green\">{{appData.status | lowercase | translate}}\n                                </td>\n                                <td class=\"mdl-data-table__cell--non-numeric\" *ngIf=\"appData.statusCode == 'PENDING'\"\n                                    style=\"color: orange\">{{appData.status | lowercase | translate}}\n                                </td>\n                                <td class=\"mdl-data-table__cell--non-numeric\" *ngIf=\"appData.statusCode == 'REJECTED' || appData.statusCode == 'REVOKED'\"\n                                    style=\"color: red\">{{appData.status | lowercase | translate}}\n                                </td>\n                                <td class=\"mdl-data-table__cell--non-numeric\">{{appData.selectedRoleNames}}</td>\n                                <!--<td class=\"mdl-data-table__cell&#45;&#45;non-numeric color-blue cursor-pointer\" (click)=\"showApplicationsWithRoles(appData.applications)\">View</td>-->\n                            </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n\n                <!--<div class=\"col-md-12\" style=\"padding: 20px 45px 0px 15px; !important;\">\n                    <div class=\"box box-default table-box table-responsive mdl-shadow&#45;&#45;2dp\">\n                        <table class=\"mdl-data-table font-size-14\">\n                            <thead class=\"responsive-table-header-backgroud\">\n                            <tr>\n                                <th class=\"mdl-data-table__cell&#45;&#45;non-numeric\" style=\"text-align: left!important;\">#</th>\n                                <th class=\"mdl-data-table__cell&#45;&#45;non-numeric\">Business Unit</th>\n                                <th class=\"mdl-data-table__cell&#45;&#45;non-numeric\">Customer Number</th>\n                                <th class=\"mdl-data-table__cell&#45;&#45;non-numeric\">Status</th>\n                                <th class=\"mdl-data-table__cell&#45;&#45;non-numeric\">Message</th>\n                                <th class=\"mdl-data-table__cell&#45;&#45;non-numeric\">Applications</th>\n                            </tr>\n                            </thead>\n\n                            <tbody>\n                            <tr *ngFor=\"let data of businessUnitWithApplicationAndRoles, let i = index\">\n                                <td class=\"mdl-data-table__cell&#45;&#45;non-numeric\">{{i + 1}}</td>\n                                <td class=\"mdl-data-table__cell&#45;&#45;non-numeric\">{{data.businessUnitName}}</td>\n                                <td class=\"mdl-data-table__cell&#45;&#45;non-numeric\">{{data.customerNumber}}</td>\n                                <td class=\"mdl-data-table__cell&#45;&#45;non-numeric\" *ngIf=\"data.status == 'Pending'\"\n                                    style=\"color: orange\">{{data.status}}\n                                </td>\n                                <td class=\"mdl-data-table__cell&#45;&#45;non-numeric\" *ngIf=\"data.status == 'Approved'\"\n                                    style=\"color: green\">{{data.status}}\n                                </td>\n                                <td class=\"mdl-data-table__cell&#45;&#45;non-numeric\" *ngIf=\"data.status == 'Rejected'\"\n                                    style=\"color: red\">{{data.status}}\n                                </td>\n                                <td class=\"mdl-data-table__cell&#45;&#45;non-numeric\">{{data.message}}</td>\n\n                                <td class=\"mdl-data-table__cell&#45;&#45;non-numeric color-blue cursor-pointer\" (click)=\"showApplicationsWithRoles(data.applications)\">View</td>\n                            </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>-->\n            </div>\n\n        </form>\n    </div>\n</section>"

/***/ }),

/***/ 1278:
/***/ (function(module, exports) {

module.exports = "<!DOCTYPE html>\n<div class=\"page-auth\">\n    <div class=\"main-body width-70 padding-top-0-7 padding-bottom-0-9\">\n\n        <div class=\"mdl-card mdl-shadow--2dp mdl-card-full-width font-size-15\">\n            <div class=\"reg-card_title margin-bottom-20\">\n                <h5 class=\"mdl-card__title-text\">{{ 'Register Now' | translate }}</h5>\n            </div>\n\n            <form role=\"form\" class=\"padding-r-l\" (keydown.enter)=\"$event.preventDefault()\" [formGroup]=\"RegistrationForm\" (ngSubmit)=\"saveData()\">\n                <fieldset>\n                    <div class=\"form-group margin-bottom-1-5\">\n                        <p class=\"font-size-18\"> {{ 'Personal Information' | translate }} </p>\n                        <div class=\"row\">\n                            <div class=\"col-md-4 margin-bottom-8\">\n                                <md-input-container class=\"full-width\">\n                                    <input required mdInput id=\"exampleInputFirstName\" autocomplete=off formControlName=\"firstName\" placeholder=\"{{ 'First Name' | translate }}\">\n                                </md-input-container>\n                            </div>\n                            <div class=\"col-md-4 margin-bottom-8\">\n                                <md-input-container class=\"full-width\">\n                                    <input required mdInput id=\"exampleInputLastName\" autocomplete=off formControlName=\"lastName\" placeholder=\"{{ 'Last Name' | translate }}\">\n                                </md-input-container>\n                            </div>\n                            <div class=\"col-md-4 margin-bottom-8\">\n                                <md-input-container class=\"full-width\">\n                                    <input required type=\"email\" mdInput id=\"exampleInputEmail1\" formControlName=\"email\" placeholder=\"{{ 'Email' | translate }}\">\n                                </md-input-container>\n                            </div>\n                            <div class=\"col-md-4\">\n                                <div class=\"row\">\n                                    <div class=\"col-md-12\">\n                                        <md-input-container class=\"full-width\">\n                                            <input #input required mdInput type=\"password\" id=\"exampleInputNewPassword\" formControlName=\"password\" placeholder=\"{{ 'Create New Password' | translate }}\" title=\"Valid\" appBlockCutCopyPaste>\n                                        </md-input-container>\n\n                                        <p class=\" margin-0\" *ngIf=\"input.type === 'password'\"><i class=\"material-icons font-size-18 pass-useful-hint right-40\" (click)=\"showPassword(input)\">visibility</i></p>\n                                        <p class=\" margin-0\" *ngIf=\"input.type ===  'text'\"><i class=\"material-icons font-size-18 pass-useful-hint right-40\" (click)=\"showPassword(input)\">visibility_off</i></p>\n\n                                        <div class=\"pass-hint pass-useful-hint right-10\">\n                                            <i class=\"material-icons font-size-17\" style=\"color: #717171db;\">info</i>\n                                            <div class=\"pass-content\">\n                                                <ul class=\"password-ul\" style=\"width: 350px;\">\n                                                    <li>{{ 'pass_least_8_chars' | translate }}</li>\n                                                    <li>{{ 'pass_one_upper_lower_char' | translate }}</li>\n                                                    <li>{{ 'pass_one_number' | translate }}</li>\n                                                    <li>{{ 'pass_invalid_symbol' | translate }}</li>\n                                                    <li>{{ 'pass_contains_firstname' | translate }}</li>\n                                                    <li>{{ 'pass_contains_lastname' | translate }}</li>\n                                                </ul>\n                                            </div>\n                                        </div>\n                                        <div>\n                                            <small ng-message='required'>{{ passwordErrorMsg | translate }}</small>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"col-md-4\">\n                                <md-input-container class=\"full-width\" md-is-error=\"RegistrationForm.hasError('mismatch')\">\n                                    <input required mdInput type=\"password\" id=\"exampleConfirmPassword\" formControlName=\"confirmPassword\" placeholder=\"{{ 'Confirm Password' | translate }}\" appBlockCutCopyPaste>\n                                </md-input-container>\n                                <div *ngIf=\"RegistrationForm.hasError('mismatch')\">\n                                    <small ng-message='required'>{{ 'Password Mismatch' | translate }}</small>\n                                </div>\n                            </div>\n                            <div class=\"col-md-4\">\n                                <!--<select required formControlName=\"countryId\" class=\"full-width margin-top-10\">\n                                    <option value=\"null\" disabled selected>{{ 'Country' | translate }}</option>\n                                    <option *ngFor=\"let countryId of Countries\" [value]=\"countryId.id\">\n                                        {{countryId.name | translate}}\n                                    </option>\n                                </select>-->\n\n                                <md-select required formControlName=\"countryId\" placeholder=\"{{ 'Country' | translate }}\" class=\"full-width margin-top-10\">\n                                    <md-option *ngFor=\"let countryId of Countries\" [value]=\"countryId.id\">\n                                        {{countryId.name | translate}}\n                                    </md-option>\n                                </md-select>\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class=\"form-group margin-bottom-1-5\">\n                        <p class=\"font-size-18 margin-bottom-2-0\">{{ 'Corporate Information' | translate }}</p>\n                        <div class=\"row\">\n                            <div class=\"col-md-4 margin-bottom-7\">\n                                <md-select required formControlName=\"businessUnitId\" placeholder=\"{{ 'Business Unit' | translate }}\" class=\"full-width\">\n                                    <md-option *ngFor=\"let businessUnitId of BusinessUnit\" [value]=\"businessUnitId.id\">\n                                        {{businessUnitId.name}}\n                                    </md-option>\n                                </md-select>\n                            </div>\n                            <div class=\"col-md-4 margin-bottom-7\">\n                                <md-input-container class=\"full-width margin-top-neg-10\">\n                                    <input required mdInput id=\"exampleInputCompantName\" formControlName=\"companyName\" placeholder=\"{{ 'Company Name' | translate }}\">\n                                </md-input-container>\n                            </div>\n                            <div class=\"col-md-4 margin-bottom-7\">\n                                <md-input-container class=\"full-width margin-top-neg-10\">\n                                    <input mdInput id=\"exampleInputCompanyPhone\" formControlName=\"companyPhone\" placeholder=\"{{ 'Company Phone' | translate }}\">\n                                </md-input-container>\n                            </div>\n                            <div class=\"col-md-4 margin-bottom-7\">\n                                <md-select required formControlName=\"languageId\" placeholder=\"{{ 'Language' | translate }}\" class=\"full-width margin-top-11\">\n                                    <md-option *ngFor=\"let languageId of LanguageData\" [value]=\"languageId.id\">\n                                        {{languageId.name}}\n                                    </md-option>\n                                </md-select>\n                            </div>\n                            <div class=\"col-md-8\">\n                                <md-input-container class=\"full-width\">\n                                    <textarea mdInput type=\"text\" id=\"exampleInputCustomerNumber\" formControlName=\"customerNumber\" placeholder=\"{{ 'Customer Number' | translate }}\" maxlength=\"10\" rows=\"1\" value=\"\"></textarea>\n                                    <md-hint align=\"end\">{{customerNumberLength}} / 10</md-hint>\n                                </md-input-container>\n                            </div>\n                            <div class=\"col-md-12\">\n                                <md-input-container class=\"full-width\">\n                                    <textarea required mdInput #biography id=\"exampleInputCompanyAddress\" formControlName=\"companyAddress\" placeholder=\"{{ 'Company Address' | translate }}\" maxlength=\"130\" rows=\"1\" value=\"\"></textarea>\n                                    <md-hint align=\"end\">{{biography.value.length}} / 130</md-hint>\n                                </md-input-container>\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class=\"form-group margin-bottom-1-3\" *ngIf=\"RegistrationForm.controls['applications'].controls.length > 0\">\n                        <p class=\"font-size-18\"> {{ 'Application Details' | translate }} </p>\n\n                        <div class=\"row\">\n                            <div class=\"col-md-4\" *ngFor=\"let control of RegistrationForm.controls['applications'].controls; let i = index\" [formGroup]=\"RegistrationForm.controls['applications'].controls[i]\">\n                                <div class=\"row\">\n                                    <div class=\"col-md-9 margin-bottom-5\">\n                                        <md-input-container class=\"full-width reg-app\">\n                                            <input required mdInput title=\"{{control.controls.applicationName.value}}\" formControlName=\"applicationName\" placeholder=\"{{ 'Application Name' | translate }}\">\n                                        </md-input-container>\n                                    </div>\n                                    <!--<div class=\"col-md-4 margin-bottom-5\">\n                                        <md-input-container class=\"full-width\">\n                                            <input mdInput formControlName=\"customerNumber\" placeholder=\"{{ 'Customer Number' | translate }}\">\n                                        </md-input-container>\n                                    </div>-->\n                                    <div class=\"col-md-3 margin-bottom-5 margin-left-neg-20\">\n                                        <button md-raised-button type=\"button\" class=\"reg-app-button\" color=\"warn\" (click)=\"onDeleteRoleProperty(i)\" *ngIf=\"isApplicationRemovable && RegistrationForm.controls['applications'].controls.length > 1\" >\n                                            <i class=\"material-icons\">clear</i>\n                                        </button>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n\n                    </div>\n\n                    <div class=\"form-group\">\n                        <div class=\"row\">\n                            <div class=\"col-md-2\">\n                                <button md-raised-button class=\"btn-w-md btn-w-xs button-gray-clr\" [routerLink]=\"['/login']\">{{ 'Cancel' | translate}}</button>\n                            </div>\n                            <div class=\"col-md-2\">\n                                <button md-raised-button class=\"btn-w-md btn-w-xs\" type=\"submit\" color=\"primary\" [disabled]=\"!RegistrationForm.valid\">{{ 'Confirm' | translate}}</button>\n                            </div>\n                        </div>\n                    </div>\n                </fieldset>\n            </form>\n\n        </div>\n\n    </div>\n</div>"

/***/ }),

/***/ 1279:
/***/ (function(module, exports) {

module.exports = "<section class=\"container-fluid no-breadcrumbs\">\n    <div class=\"row margin-top-15\">\n        <div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8\">\n            <h2 class=\"article-title color-black\">{{ 'Admin Management' | translate }}</h2>\n        </div>\n        <div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4\">\n        </div>\n    </div>\n\n    <div class=\"mdl-card mdl-shadow--2dp mdl-card-full-width select-overflow\">\n        <div class=\"card_title\">\n            <h2 class=\"mdl-card__title-text\">{{ 'Create Admin' | translate }}</h2>\n        </div>\n        <form class=\"padding-r-l-user\" [formGroup]=\"AdminForm\" (ngSubmit)=\"saveAdminData()\" (keydown.enter)=\"$event.preventDefault()\">\n            <fieldset>\n                <div class=\"form-group margin-bottom-2-2\">\n                    <p class=\"font-size-18\"> {{ 'Personal Information' | translate }} </p>\n                    <div class=\"row margin-top-20\">\n                        <div class=\"col-md-6 margin-bottom-20\">\n                            <md-input-container class=\"full-width\">\n                                <input required mdInput id=\"exampleInputFirstName\" formControlName=\"firstName\" (keypress)=\"validateName($event)\" autocomplete=off placeholder=\"{{ 'First Name' | translate }}\">\n                            </md-input-container>\n                        </div>\n                        <div class=\"col-md-6 margin-bottom-20\">\n                            <md-input-container class=\"full-width\">\n                                <input required mdInput id=\"exampleInputLastName\" formControlName=\"lastName\" (keypress)=\"validateName($event)\" autocomplete=off placeholder=\"{{ 'Last Name' | translate }}\">\n                            </md-input-container>\n                        </div>\n                        <div class=\"col-md-6 margin-bottom-20\">\n                            <md-input-container class=\"full-width\">\n                                <input required type=\"email\" mdInput id=\"exampleInputEmail1\" formControlName=\"email\" placeholder=\"{{ 'Email' | translate }}\">\n                            </md-input-container>\n                        </div>\n                        <div class=\"col-md-6\">\n                            <md-select required formControlName=\"languageId\" placeholder=\"{{ 'Select Language' | translate }}\" [(ngModel)]=\"defaultLanguageId\" class=\"full-width margin-top-10\">\n                                <md-option *ngFor=\"let language of languages\" [value]=\"language.id\">\n                                    {{language.name}}\n                                </md-option>\n                            </md-select>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"form-group margin-bottom-2-2\">\n                    <p class=\"font-size-18 margin-bottom-2-0\"> {{ 'Corporate Information' | translate }} </p>\n                    <div class=\"row margin-top-20\">\n                        <div class=\"col-md-6\">\n                            <md-input-container class=\"full-width\" >\n                                <input required mdInput id=\"exampleInputWpassId\" (blur)=\"onBlurWpass()\" [(ngModel)]=\"wpassId\" formControlName=\"userId_WPASS\" placeholder=\"{{ 'WPASS User Id' | translate }}\">\n                            </md-input-container>\n                        </div>\n                        <div class=\"col-md-6 margin-top-neg-10\">\n                            <angular2-multiselect [data]=\"adminRoles\" (onSelect)=\"buroleSelect($event)\" \n                                                   [(ngModel)]=\"selectedAdminItems\"\n                                                  [settings]=\"settings\" formControlName=\"roleData\">\n                            </angular2-multiselect>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <span>\n                        <button md-raised-button class=\"btn-w-md btn-w-xs button-gray-clr approve-reject\" [routerLink]=\"['/app/manage-admin/list']\">{{ 'Cancel' | translate }}</button>\n                    </span>\n                    <span class=\"space-xs\"></span>\n                    <span class=\"space-xs\"></span>\n                    <span>\n                        <button md-raised-button class=\"btn-w-md btn-w-xs approve-reject\" type=\"submit\" color=\"primary\" [disabled]=\"!AdminForm.valid\">{{ 'Confirm' | translate }}</button>\n                    </span>\n                </div>\n            </fieldset>\n        </form>\n\n    </div>\n</section>"

/***/ }),

/***/ 1280:
/***/ (function(module, exports) {

module.exports = "<div class=\"container-fluid no-breadcrumbs page-dashboard\">\n    <article class=\"article\">\n\n        <div class=\"row margin-top-20\">\n            <div class=\"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6\">\n                <h2 class=\"article-title color-black\">{{ 'ADMIN LIST' | translate }}</h2>\n            </div>\n            <div class=\"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6\" *ngIf=\"isSystemAdmin\">\n                <button md-raised-button color=\"accent\" class=\"btn-w-sm btn-w-md float-right\" [routerLink]=\"['/app/manage-admin/add']\"><i class=\"material-icons\">add_circle_outline</i> {{ 'NEW ADMIN' | translate }}</button>\n            </div>\n        </div>\n\n        <div class=\"box customize-app-header-inner margin-bottom-15\">\n            <div class=\"filter-padding\">\n                <div class=\"row\">\n                    <div class=\"col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2\">\n                        <md-select required placeholder=\"{{ 'Select Role' | translate }}\" class=\"full-width margin-top-10 filter-input\" [(ngModel)]=\"defaulAdminId\">\n                            <md-option *ngFor=\"let adminRole of adminRoles\" [value]=\"adminRole.id\">\n                                {{adminRole.name}}\n                            </md-option>\n                        </md-select>\n                    </div>\n                    <div class=\"col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2\">\n                        <md-select required placeholder=\"{{ 'Status' | translate }}\" class=\"full-width margin-top-10 filter-input\" [(ngModel)]=\"selectedStatusId\">\n                            <md-option *ngFor=\"let statusData of StatusData\" [value]=\"statusData.id\">\n                                {{statusData.name | uppercase | translate}}\n                            </md-option>\n                        </md-select>\n                    </div>\n\n                    <div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8\">\n                        <form class=\"row\" [formGroup]=\"FiltersForm\" (ngSubmit)=\"search()\" (keydown.enter)=\"$event.preventDefault()\">\n                            <div class=\"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12\">\n                                <input type='text' formControlName=\"firstName\" class=\"filter-input-1 width-22-percent\" placeholder=\"{{ 'First Name' | translate }}\" />\n                                <input type='text' formControlName=\"email\" class=\"filter-input-1 width-22-percent\" placeholder=\"{{ 'Email' | translate }}\"/>\n                                <input type='text' formControlName=\"wpassId\" class=\"filter-input-1 width-22-percent\" placeholder=\"{{ 'WPASS Id' | translate | uppercase }}\" (keyup)=\"disablefields($event.target.value)\" />\n                                <button md-raised-button class=\"btn-w-xxs\" type=\"submit\" [disabled]=\"!FiltersForm.valid\" title=\"Search\"> <md-icon class=\"material-icons\">search</md-icon> {{ 'Search' | translate }}</button>\n                                <span class=\"space-xs\"></span>\n                                <span class=\"space-xs\"></span>\n                                <button md-raised-button class=\"btn-w-xxs\" color=\"primary\" type=\"button\" (click)=\"resetSearch()\" title=\"Reset Search\"> <md-icon class=\"material-icons\">settings_backup_restore</md-icon> {{ 'Reset' | translate }}</button>\n                            </div>\n                        </form>\n                    </div>\n                </div>\n                <div class=\"callout-1 collout-warn-1\">\n                    <p>{{ 'filter_apply_info' | translate }}</p>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"box box-default table-box table-responsive mdl-shadow--2dp\" *ngIf=\"showTable\">\n            <ngx-datatable #table class=\"material\"\n                           [messages]=\"dataTableMessage\"\n                           [rows]=\"rows\"\n                           [columnMode]=\"'force'\"\n                           [headerHeight]=\"60\"\n                           [rowHeight]=\"55\"\n                           [footerHeight]=\"70\"\n                           [externalPaging]=\"true\"\n                           [count]=\"page.totalElements\"\n                           [offset]=\"page.pageNumber\"\n                           [limit]=\"page.size\"\n                           [scrollbarH]=\"true\"\n                           (page)='setPage($event,tableRows,false)'>\n\n                <!--<ngx-datatable-column [width]=\"45\"\n                                      [sortable]=\"false\"\n                                      [canAutoResize]=\"false\"\n                                      [draggable]=\"false\"\n                                      [resizeable]=\"false\"\n                                      [headerCheckboxable]=\"true\"\n                                      [checkboxable]=\"true\">\n                </ngx-datatable-column>-->\n\n                <ngx-datatable-column name=\"{{ 'Name' | translate }}\" prop=\"Name\" [width]=\"90\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{'Name' | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                            <span title=\"{{row['Name']}}\" style=\"color: blue;cursor: pointer\">\n                                <a [routerLink]=\"['/app/manage-admin/view', row['id']]\">{{row['Name']}}</a>\n                            </span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"{{ 'Email' | translate }}\" prop=\"email\" [width]=\"155\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span title=\"{{row['email']}}\">{{row['email']}}</span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"{{ 'Role' | translate }}\" prop=\"roleName\" [width]=\"200\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span title=\"{{row['roleName']}}\">{{row['roleName']}}</span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"WPASS Id\" prop=\"userId_WPASS\" [width]=\"15\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{'WPASS Id' | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span class=\"color-gray-filter\" title=\"{{row['userId_WPASS']}}\">{{row['userId_WPASS']}}</span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"{{ 'Status' | translate }}\" prop=\"status\" [width]=\"10\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span *ngIf=\"row['status'] == 'Active'\" style=\"color:green\">{{row['status'] | uppercase | translate}}</span>\n                        <span *ngIf=\"row['status'] == 'Inactive'\" style=\"color:red\">{{row['status'] | uppercase | translate}}</span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"{{ 'Action' | translate }}\" prop=\"action\" [width]=\"145\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-rowIndex=\"rowIndex\" let-row=\"row\" ngx-datatable-cell-template>\n                         <span>\n                            <activate-deactivate [childData]=row [dashboard]=adminListText></activate-deactivate>\n                        </span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n            </ngx-datatable>\n        </div>\n\n        <div class=\"box box-default\" *ngIf=\"!showTable\">\n            <div class=\"box-body\">\n                <div class=\"icon-box ibox-plain ibox-center\">\n                    <h3>{{ 'No Data' | translate }}</h3>\n                    <br>\n                    <button md-raised-button *ngIf=\"isSystemAdmin\" color=\"accent\" class=\"btn-w-sm btn-w-md\" [routerLink]=\"['/app/manage-admin/add']\"><i class=\"material-icons\">add_circle_outline</i> {{ 'NEW ADMIN' | translate }}</button>\n                </div>\n            </div>\n        </div>\n    </article>\n</div>"

/***/ }),

/***/ 1281:
/***/ (function(module, exports) {

module.exports = "\n<router-outlet></router-outlet>"

/***/ }),

/***/ 1282:
/***/ (function(module, exports) {

module.exports = "<section class=\"container-fluid no-breadcrumbs\">\n    <div class=\"row margin-top-15\">\n        <div class=\"col-xl-10 col-lg-10 col-md-10 col-sm-10 col-10\">\n            <h2 class=\"article-title color-black\">{{ 'Admin Management' | translate }}</h2>\n        </div>\n        <div class=\"col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 text-right\">\n            <button *ngIf=\"!adminDetails.active\" md-raised-button class=\"btn-w-md approve-reject\" [routerLink]=\"['/app/manage-admin/list']\"><span class=\"btn-text\">{{ 'Back' | translate }}</span></button>\n        </div>\n    </div>\n\n    <div class=\"mdl-card mdl-shadow--2dp mdl-card-full-width select-overflow\">\n        <div class=\"card_title\">\n            <h2 class=\"mdl-card__title-text\">{{ 'View Admin' | translate }}</h2>\n        </div>\n        <form [formGroup]=\"AdminEditForm\" (ngSubmit)=\"saveAdminRole()\" (keydown.enter)=\"$event.preventDefault()\">\n            <fieldset>\n                <div class=\"row form-group form-content\">\n                    <p class=\"col-md-12 font-size-18 usr-detail-page-p\"> {{ 'Personal Information' | translate }} </p>\n                    <div class=\"col-md-4\">\n                        <label>{{ 'First Name' | translate }}</label>\n                        <p *ngIf=\"adminDetails\">{{adminDetails.firstName}}</p>\n                    </div>\n                    <div class=\"col-md-4\">\n                        <label>{{ 'Last Name' | translate }}</label>\n                        <p *ngIf=\"adminDetails\">{{adminDetails.lastName}}</p>\n                    </div>\n                    <div class=\"col-md-4\">\n                        <label>{{ 'Email' | translate }}</label>\n                        <p *ngIf=\"adminDetails\">{{adminDetails.email}}</p>\n                    </div>\n                    <div class=\"col-md-4\">\n                        <label>{{ 'Language' | translate }}</label>\n                        <p *ngIf=\"adminDetails\">{{adminDetails.languageName}}</p>\n                    </div>\n                </div>\n\n                <div class=\"dotted-divider\"></div>\n\n                <div class=\"row form-group form-content\">\n                    <p class=\"col-md-12 font-size-18 usr-detail-page-p\"> {{ 'Corporate Information' | translate }} </p>\n                    <div class=\"col-md-12 margin-top-08 margin-bottom-15 padding-r-45\" *ngIf=\"adminDetails.active\">\n                        <label class=\"margin-bottom-10\">{{ 'Role' | translate }}</label>\n                        <angular2-multiselect [data]=\"adminRoles\" [(ngModel)]=\"selectedItems\"\n                                              (onSelect)=\"buroleSelect($event)\" \n                                              [settings]=\"settings\" formControlName=\"roleData\">\n                        </angular2-multiselect>\n                    </div>\n                    <div class=\"col-md-4\" *ngIf=\"!adminDetails.active\">\n                        <label>{{ 'Role' | translate }}</label>\n                        <p *ngIf=\"adminDetails\">{{adminDetails.roleName}}</p>\n                    </div>\n                    <div class=\"col-md-4\">\n                        <label>{{ 'WPASS User Id' | translate }}</label>\n                        <p *ngIf=\"adminDetails\">{{adminDetails.userId_WPASS}}</p>\n                    </div>\n                    <div class=\"col-md-4\">\n                        <label>{{ 'Created At' | translate }}</label>\n                        <p *ngIf=\"adminDetails\">{{adminDetails.createdAt}}</p>\n                    </div>\n                </div>\n\n                <div class=\"form-group padding-r-l-admin-forms\" *ngIf=\"adminDetails.active\">\n                    <span>\n                        <button md-raised-button class=\"btn-w-md btn-w-xs button-gray-clr approve-reject\" [routerLink]=\"['/app/manage-admin/list']\">{{ 'Cancel' | translate }}</button>\n                    </span>\n                    <span class=\"space-xs\"></span>\n                    <span class=\"space-xs\"></span>\n                    <span>\n                        <button md-raised-button class=\"btn-w-md btn-w-xs approve-reject\" type=\"submit\" color=\"primary\" [disabled]=\"!AdminEditForm.valid\">{{ 'Confirm' | translate }}</button>\n                    </span>\n                </div>\n            </fieldset>\n        </form>\n\n    </div>\n</section>"

/***/ }),

/***/ 1283:
/***/ (function(module, exports) {

module.exports = "<section class=\"container-fluid no-breadcrumbs\">\n    <div class=\"row margin-top-15\">\n        <div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8\">\n            <h2 class=\"article-title color-black\">{{ 'Application Management' | translate }}</h2>\n        </div>\n        <div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4\">\n        </div>\n    </div>\n\n    <div class=\"mdl-card mdl-shadow--2dp mdl-card-full-width select-overflow\">\n        <div class=\"card_title\">\n            <h2 *ngIf=\"!idFlag\" class=\"mdl-card__title-text\">{{ 'Create Application' | translate }}</h2>\n            <h2 *ngIf=\"idFlag\" class=\"mdl-card__title-text\">{{ 'Update Application' | translate }}</h2>\n        </div>\n        <form class=\"padding-r-l-user\" [formGroup]=\"ApplicationForm\" (ngSubmit)=\"saveApplicationData()\" (keydown.enter)=\"$event.preventDefault()\">\n            <fieldset>\n                <div class=\"form-group margin-bottom-2-2\">\n                    <p class=\"font-size-18\"> {{ 'Application Details' | translate }} </p>\n                    <div class=\"row margin-top-20\">\n                        <div class=\"col-md-5 margin-bottom-20\">\n                            <md-input-container class=\"full-width\">\n                                <input required mdInput id=\"exampleInputApplicationName\" formControlName=\"applicationName\" placeholder=\"{{ 'Application Name' | translate }}\">\n                            </md-input-container>\n                        </div>\n                        <div class=\"col-md-5 margin-bottom-20\">\n                            <md-input-container class=\"full-width\">\n                                <input required mdInput id=\"exampleInputLdapApplicationId\" formControlName=\"ldapApplicationId\" placeholder=\"{{ 'Ldap Application Id' | translate }}\">\n                            </md-input-container>\n                        </div>\n                        <div class=\"col-md-5 margin-bottom-20\">\n                            <md-input-container class=\"full-width\">\n                                <input mdInput id=\"exampleInputApplicationUrl\" formControlName=\"url\" placeholder=\"{{ 'APP_URL' | translate }}\">\n                            </md-input-container>\n                        </div>\n                        <div class=\"col-md-5 margin-top-03\" *ngIf=\"idFlag\">\n                            <button md-raised-button type=\"button\" class=\"btn-w-xs max-width-58 max-width-58\" color=\"primary\" title=\"{{'Copy Invitation URL' | translate}}\" (click)=\"copyToClipboard()\">\n                                {{'Copy Invitation URL' | translate}}\n                            </button>\n                        </div>\n                        <div class=\"col-md-5 margin-bottom-20 margin-top-neg-4\" [ngClass]=\"{'margin-top-neg-10': idFlag}\" *ngIf=\"activeFlag\">\n                            <p *ngIf=\"idFlag\" class=\"font-size-13 margin-bottom-0-2 label-color-light-grey\"> {{ 'Manager' | translate }} </p>\n                            <angular2-multiselect [data]=\"managers\" [(ngModel)]=\"selectedItems\"\n                                                  [settings]=\"settings\" formControlName=\"managerData\">\n                            </angular2-multiselect>\n                        </div>\n                        <div class=\"margin-bottom-20\" *ngIf=\"activeFlag\" [ngClass]=\"{'col-md-5': idFlag, 'col-md-10': !idFlag}\">\n                            <div *ngIf=\"managersMessage != ''\" class=\"callout-2 callout-danger-2\" [ngClass]=\"{'margin-top-15': idFlag}\">\n                                <p>{{managersMessage | translate}}</p>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"form-group margin-bottom-0-8\" >\n                        <p class=\"font-size-18 margin-bottom-2-0\"> {{ \"Application Roles\" | translate }} </p>\n                        <div [ngClass]=\"{'d-none' : id}\" class=\"margin-bottom-20 font-size-15\">\n                            <md-checkbox  #specificCount  (change)=\"countSpecificFun($event)\" [checked]=\"forSpecificCountry\">{{ \"Country Specific Roles\" | translate }}</md-checkbox>\n                        </div>\n                <div  *ngIf=\"!specificCount.checked\" formArrayName=\"applicationRoles\">\n                    <div class=\"row\" *ngFor=\"let control of ApplicationForm.controls['applicationRoles'].controls; let i = index\" [formGroup]=\"ApplicationForm.controls['applicationRoles'].controls[i]\">\n                        <div class=\"col-md-4 margin-bottom-5\">\n                            <md-input-container class=\"full-width\">\n                                <input required mdInput  formControlName=\"name\" placeholder=\"{{ 'Role Name' | translate }}\">\n                            </md-input-container>\n                        </div>\n                        <div class=\"col-md-4 margin-bottom-5\">\n                            <md-input-container class=\"full-width\">\n                                <input required mdInput  formControlName=\"ldapRoleId\" placeholder=\"{{ 'LDAP Role Id' | translate }}\">\n                            </md-input-container>\n                        </div>\n                        <div class=\"col-md-2 margin-bottom-5 margin-top-18\" *ngIf=\"skipManagerApprovalFlag\">\n                            <md-checkbox formControlName=\"defaultRole\" (click)=\"onlyOneDefault(i, control.controls.defaultRole.value)\">{{'default' | translate}}</md-checkbox>\n                        </div>\n                        <div class=\"col-md-2 margin-bottom-5\">\n                            <button md-raised-button type=\"button\" class=\"btn-w-xs min-width-58\" color=\"warn\" (click)=\"onDeleteRoleProperty(i)\" *ngIf=\"ApplicationForm.controls['applicationRoles'].controls.length != 1 && !ApplicationForm.controls['applicationRoles'].value[i].isAssignFlag\">\n                                <i class=\"material-icons\">clear</i>\n                            </button>\n                            <span class=\"space-xs\"></span>\n                            <button md-raised-button type=\"button\" class=\"btn-w-xs min-width-58\" color=\"accent\" *ngIf=\"ApplicationForm.controls['applicationRoles'].controls.length != 0 && ApplicationForm.controls['applicationRoles'].controls.length == i+1\" (click)=\"onAddRoleProperty()\">\n                                <i class=\"material-icons\">add_circle_outline</i>\n                            </button>\n                        </div>\n                    </div>\n                     <div class=\"form-group margin-bottom-2-3\" *ngIf=\"skipManagerApprovalFlag \">\n                        <div *ngIf=\"skipManagerApprovalMessage != ''\" class=\"callout-2 callout-danger-2\" [ngClass]=\"{'margin-top-15': skipManagerApprovalFlag}\">\n                        <p>{{skipManagerApprovalMessage | translate}}</p>\n                        </div>\n                    </div>\n                </div> \n\n\n             <ng-container *ngIf=\"specificCount.checked\" >\n                    <div *ngIf=\" selectedCountryId=='' || selectedCountryId.length>0\" formArrayName=\"countries\">\n                        <div *ngFor=\"let item of ApplicationForm.controls['countries'].controls; let j = index\" formGroupName=\"{{j}}\">\n                            <div class=\"roleBox mb-3\" >\n                            <div class=\"panel-heading card-header\">\n                                <a class=\"btn btn-link\" >\n                                    <span class=\"ml-3\"> {{selectedContries[j].name | translate}} </span>\n                                </a>\n                                <button type=\"button\" class=\"btn-w-xs min-width-58 pt-1\" style=\"float: right\"  (click)=\"deleteCountry(j)\" *ngIf=\"!selectedContries[j].isAssignFlag\">\n                                    <i class=\"material-icons\">clear</i>\n                                </button>\n                            </div>\n                                <div class=\"card-body\" formArrayName=\"countryName\">\n                                    <div class=\"row p-3\" *ngFor=\"let control of item.controls['countryName'].controls; let i = index\" formGroupName=\"{{i}}\">\n                                        <div class=\"col-md-4 margin-bottom-5\">\n                                            <md-input-container class=\"full-width\">\n                                                <input required mdInput  formControlName=\"name\" placeholder=\"{{ 'Role Name' | translate }}\">\n                                            </md-input-container>\n                                        </div>\n                                        <div class=\"col-md-4 margin-bottom-5\">\n                                            <md-input-container class=\"full-width\">\n                                                <input required mdInput  formControlName=\"ldapRoleId\" placeholder=\"{{ 'LDAP Role Id' | translate }}\">\n                                            </md-input-container>\n                                        </div>\n                                        <div class=\"col-md-2 margin-bottom-5 margin-top-18\" *ngIf=\"skipManagerApprovalFlag\">\n                                            <md-checkbox formControlName=\"defaultRole\" (click)=\"onlyOneDefaultSpecific(j,i)\">{{'default' | translate}}</md-checkbox>\n                                        </div>\n                                        <div class=\"col-md-2 margin-bottom-5\">\n                                            <button md-raised-button type=\"button\" class=\"btn-w-xs min-width-58\" color=\"warn\" (click)=\"onDeleteRolePropertySelected(j,i)\" *ngIf=\"item.controls['countryName'].controls.length != 1 && !item.controls['countryName'].value[i].isAssignFlag\">\n                                                <i class=\"material-icons\">clear</i>\n                                            </button>\n                                            <span class=\"space-xs\"></span>\n                                            <button md-raised-button type=\"button\" class=\"btn-w-xs min-width-58\" color=\"accent\" *ngIf=\"item.controls['countryName'].controls.length != 0 && item.controls['countryName'].controls.length == i+1\" (click)=\"rolesAddForSelectedCountries(j)\">\n                                                <i class=\"material-icons\">add_circle_outline</i>\n                                            </button>\n                                        </div>\n                                    </div>\n\n                                    <div style=\"max-height: 55px;\">\n                                    <div class=\"\"  *ngIf=\"!countryWiseDefaults[j] && skipManagerApprovalFlag && skipManagerApprovalMessage!=''\">\n                                        <div  class=\"callout-2 callout-danger-2\" [ngClass]=\"{'margin-top-15': skipManagerApprovalFlag}\">\n                                            <p>{{skipManagerApprovalMessage | translate}}</p>\n                                        </div>\n                                    </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n<!-- **************************************************** FOR ACCORDION **************************************************** -->\n                <!-- <div class=\"panel-group\" id=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\">\n                    <div *ngIf=\" selectedCountryId=='' || selectedCountryId.length>0\">\n                        <div *ngFor=\"let item of ApplicationForm.controls['countries'].controls; let j = index\" formGroupName=\"{{j}}\">\n                            <div class=\"panel panel-default mb-3\" >\n                            <div class=\"panel-heading card-header\" role=\"tab\" id=\"heading{{j}}\">\n                                <h4 class=\"panel-title d-inline-block\">\n                                <a data-toggle=\"collapse\" class=\"btn btn-link\" data-parent=\"#accordion\" [href]=\"'#collapse'+j\" attr.aria-expanded=\"true\" attr.aria-controls=\"collapse{{j}}\">\n                                    <i class=\"accordion_icon fa fa-plus\"></i> <span class=\"ml-3\"> {{selectedContries[j]}} </span>\n                                </a>\n                                </h4>\n                                <button md-raised-button type=\"button\" class=\"btn-w-xs min-width-58\" style=\"float: right\" color=\"warn\" (click)=\"deleteCountry(j)\">\n                                    <i class=\"material-icons\">clear</i>\n                                  </button>\n                            </div>\n                            <div id=\"collapse{{j}}\" class=\"panel-collapse collapse\" role=\"tabpanel\" attr.aria-labelledby=\"heading{{j}}\">\n                                <div class=\"card-body\" formArrayName=\"countryName\">\n                                    <div class=\"row p-3\" *ngFor=\"let control of item.controls['countryName'].controls; let i = index\" formGroupName=\"{{i}}\">\n                                        <div class=\"col-md-4 margin-bottom-5\">\n                                            <md-input-container class=\"full-width\">\n                                                <input required mdInput id=\"exampleInputRoleName\" formControlName=\"name\" placeholder=\"{{ 'Role Name' | translate }}\">\n                                            </md-input-container>\n                                        </div>\n                                        <div class=\"col-md-4 margin-bottom-5\">\n                                            <md-input-container class=\"full-width\">\n                                                <input required mdInput id=\"exampleInputLdapRoleId\" formControlName=\"ldapRoleId\" placeholder=\"{{ 'LDAP Role Id' | translate }}\">\n                                            </md-input-container>\n                                        </div>\n                                        <div class=\"col-md-2 margin-bottom-5 margin-top-18\" *ngIf=\"skipManagerApprovalFlag\">\n                                            <md-checkbox formControlName=\"defaultRole\" (click)=\"onlyOneDefaultSpecific(j, i)\">{{'default' | translate}}</md-checkbox>\n                                        </div>\n                                        <div class=\"col-md-2 margin-bottom-5\">\n                                            <button md-raised-button type=\"button\" class=\"btn-w-xs min-width-58\" color=\"warn\" (click)=\"onDeleteRolePropertySelected(j,i)\" *ngIf=\"item.controls['countryName'].controls.length != 1 && !item.controls['countryName'].value[i].isAssignFlag\">\n                                                <i class=\"material-icons\">clear</i>\n                                            </button>\n                                            <span class=\"space-xs\"></span>\n                                            <button md-raised-button type=\"button\" class=\"btn-w-xs min-width-58\" color=\"accent\" *ngIf=\"item.controls['countryName'].controls.length != 0 && item.controls['countryName'].controls.length == i+1\" (click)=\"rolesAddForSelectedCountries(j)\">\n                                                <i class=\"material-icons\">add_circle_outline</i>\n                                            </button>\n                                        </div>\n                                    </div>\n                                    <div class=\"form-group margin-bottom-2-3\" *ngIf=\"skipManagerApprovalFlag && !countryWiseDefaults[j]\">\n                                        <div *ngIf=\"skipManagerApprovalMessage != ''\" class=\"callout-2 callout-danger-2\" [ngClass]=\"{'margin-top-15': skipManagerApprovalFlag}\">\n                                            <p>{{skipManagerApprovalMessage | translate}}</p>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            </div>\n                        </div>\n                    </div>\n                </div> -->\n<!-- ****************************************************************************************************** -->\n\n                      <div class=\"mt-5\">\n                        <label class=\"\">Select country:</label>\n                        <md-select placeholder=\"{{ 'Country' | translate }}\" #countrySelect \n                            class=\"width-min-130 width-15 -2 ml-4\" [(ngModel)]=\"selectedCountryId\"\n                            [ngModelOptions]=\"{standalone: true}\" (change)=\"onCountryChange($event)\">\n                            <md-option *ngFor=\"let country of countries\" [value]=\"country.id\">\n                                {{country.name | translate}}\n                            </md-option>\n                        </md-select>\n                     </div>\n                    <div class=\"form-group margin-bottom-2-3 mt-3\" *ngIf=\"forSpecificCountry\">\n                        <div *ngIf=\"selectedContries.length == 0\" class=\"callout-2 callout-danger-2\" [ngClass]=\"{'margin-top-15': skipManagerApprovalFlag}\">\n                        <p>{{skipManagerApprovalMessage | translate}}</p>\n                        </div>\n                    </div>\n                <hr class=\"pb-3\">\n                </ng-container>\n\n\n\n                </div>\n\n\n\n                <div class=\"form-group margin-bottom-3-2\">\n                    <div class=\"row margin-top-20\">\n                        <div class=\"col-md-4 margin-bottom-20 font-size-15\">\n                            <md-checkbox formControlName=\"multipleRole\">{{ \"Allow Multiple Roles\" | translate }}</md-checkbox>\n                        </div>\n                        <div class=\"col-md-4 margin-bottom-20 font-size-15\">\n                            <md-checkbox formControlName=\"customerNumberRequired\">{{ \"Customer Number Required\" | translate }}</md-checkbox>\n                        </div>\n                        <div class=\"col-md-4 margin-bottom-20 font-size-15\">\n                            <md-checkbox formControlName=\"skipManagerApproval\">{{ \"Skip Manager Approval\" | translate }}</md-checkbox>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"form-group\" *ngIf=\"activeFlag\">\n                    <span>\n                        <button md-raised-button class=\"btn-w-md btn-w-xs button-gray-clr approve-reject\" [routerLink]=\"['/app/application-management/list']\">{{ 'Cancel' | translate }}</button>\n                    </span>\n                    <span class=\"space-xs\"></span>\n                    <span class=\"space-xs\"></span>\n                    <span>\n                        <button md-raised-button class=\"btn-w-md btn-w-xs approve-reject\" type=\"submit\" color=\"primary\" [disabled]=\"!ApplicationForm.valid || !managersFlag || (skipManagerApprovalFlag && skipManagerApprovalMessage !='')\">{{ 'Confirm' | translate }}</button>\n                    </span>\n                </div>\n            </fieldset>\n        </form>\n\n    </div>\n</section>\n"

/***/ }),

/***/ 1284:
/***/ (function(module, exports) {

module.exports = "<div class=\"container-fluid no-breadcrumbs page-dashboard\">\n    <article class=\"article\">\n\n        <div class=\"row margin-top-20\">\n            <div class=\"col-xl-5 col-lg-5 col-md-5 col-sm-5 col-5\">\n                <h2 class=\"article-title color-black\">{{ 'APPLICATION LIST' | translate }}</h2>\n            </div>\n            <div class=\"col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7\" *ngIf=\"isSystemAdmin\">\n                <button md-raised-button color=\"accent\" class=\"btn-w-sm btn-w-md float-right\" [routerLink]=\"['/app/application-management/add']\"><i class=\"material-icons\">add_circle_outline</i> {{ 'NEW APPLICATION' | translate | uppercase }}</button>\n            </div>\n        </div>\n\n        <div class=\"box customize-app-header-inner margin-bottom-15\">\n            <div class=\"filter-padding\">\n                <div class=\"row\">\n                    <div class=\"col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2\">\n                        <md-select required placeholder=\"{{ 'Status' | translate }}\" class=\"full-width margin-top-10 filter-input\" [(ngModel)]=\"selectedStatusId\">\n                            <md-option *ngFor=\"let statusData of StatusData\" [value]=\"statusData.id\">\n                                {{statusData.name | uppercase | translate}}\n                            </md-option>\n                        </md-select>\n                    </div>\n\n                    <div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8\">\n                        <form class=\"row\" [formGroup]=\"FiltersForm\" (ngSubmit)=\"search()\" (keydown.enter)=\"$event.preventDefault()\">\n                            <div class=\"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12\">\n                                <input type='text' formControlName=\"applicationName\" class=\"filter-input-1 width-22-percent\" placeholder=\"{{ 'Application Name' | translate }}\" />\n                                <button md-raised-button class=\"btn-w-xxs\" type=\"submit\" [disabled]=\"!FiltersForm.valid\" title=\"Search\"> <md-icon class=\"material-icons\">search</md-icon> {{ 'Search' | translate }}</button>\n                                <span class=\"space-xs\"></span>\n                                <span class=\"space-xs\"></span>\n                                <button md-raised-button class=\"btn-w-xxs\" color=\"primary\" type=\"button\" (click)=\"resetSearch()\" title=\"Reset Search\"> <md-icon class=\"material-icons\">settings_backup_restore</md-icon> {{ 'Reset' | translate }}</button>\n                            </div>\n                        </form>\n                    </div>\n                </div>\n                <div class=\"callout-1 collout-warn-1\">\n                    <p>{{ 'filter_apply_info' | translate }}</p>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"box box-default table-box table-responsive mdl-shadow--2dp\" *ngIf=\"showTable\">\n            <ngx-datatable #table class=\"material\"\n                           [messages]=\"dataTableMessage\"\n                           [rows]=\"rows\"\n                           [columnMode]=\"'force'\"\n                           [headerHeight]=\"60\"\n                           [rowHeight]=\"55\"\n                           [footerHeight]=\"70\"\n                           [externalPaging]=\"true\"\n                           [count]=\"page.totalElements\"\n                           [offset]=\"page.pageNumber\"\n                           [limit]=\"page.size\"\n                           [scrollbarH]=\"true\"\n                           (page)='setPage($event,tableRows,false)'>\n\n                <!--<ngx-datatable-column [width]=\"45\"\n                                      [sortable]=\"false\"\n                                      [canAutoResize]=\"false\"\n                                      [draggable]=\"false\"\n                                      [resizeable]=\"false\"\n                                      [headerCheckboxable]=\"true\"\n                                      [checkboxable]=\"true\">\n                </ngx-datatable-column>-->\n\n                <ngx-datatable-column name=\"{{ 'Application Name' | translate }}\" prop=\"applicationName\" [width]=\"120\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                            <span title=\"{{row['applicationName']}}\" style=\"color: blue;cursor: pointer\">\n                                <a [routerLink]=\"['/app/application-management/view', row['id']]\">{{row['applicationName']}}</a>\n                            </span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"{{ 'Customer Number Required' | translate }}\" prop=\"customerNumberRequired\" [width]=\"120\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span *ngIf=\"row['customerNumberRequired']\" style=\"color:green\"><md-icon class=\"material-icons\">done</md-icon></span>\n                        <span *ngIf=\"!row['customerNumberRequired']\" style=\"color:red\"><md-icon class=\"material-icons\">clear</md-icon></span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"{{ 'Skip Manager Approval' | translate }}\" prop=\"skipManagerApproval\" [width]=\"100\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span *ngIf=\"row['skipManagerApproval']\" style=\"color:green\"><md-icon class=\"material-icons\">done</md-icon></span>\n                        <span *ngIf=\"!row['skipManagerApproval']\" style=\"color:red\"><md-icon class=\"material-icons\">clear</md-icon></span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"{{ 'Multiple Role' | translate }}\" prop=\"multipleRole\" [width]=\"100\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span *ngIf=\"row['multipleRole']\" style=\"color:green\"><md-icon class=\"material-icons\">done</md-icon></span>\n                        <span *ngIf=\"!row['multipleRole']\" style=\"color:red\"><md-icon class=\"material-icons\">clear</md-icon></span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"{{ 'Status' | translate }}\" prop=\"status\" [width]=\"70\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span *ngIf=\"row['status'] == 'Active'\" style=\"color:green\">{{row['status'] | uppercase | translate}}</span>\n                        <span *ngIf=\"row['status'] == 'Inactive'\" style=\"color:red\">{{row['status'] | uppercase | translate}}</span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"{{ 'Action' | translate }}\" prop=\"action\" [width]=\"200\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-rowIndex=\"rowIndex\" let-row=\"row\" ngx-datatable-cell-template>\n                         <span>\n                            <activate-deactivate [childData]=row [dashboard]=applicationListText></activate-deactivate>\n                        </span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n            </ngx-datatable>\n        </div>\n\n        <div class=\"box box-default\" *ngIf=\"!showTable\">\n            <div class=\"box-body\">\n                <div class=\"icon-box ibox-plain ibox-center\">\n                    <h3>{{ 'No Data' | translate }}</h3>\n                    <br>\n                    <button md-raised-button *ngIf=\"isSystemAdmin\" color=\"accent\" class=\"btn-w-sm btn-w-md\" [routerLink]=\"['/app/application-management/add']\"><i class=\"material-icons\">add_circle_outline</i> {{ 'NEW APPLICATION' | translate }}</button>\n                </div>\n            </div>\n        </div>\n    </article>\n</div>"

/***/ }),

/***/ 1285:
/***/ (function(module, exports) {

module.exports = "<router-outlet></router-outlet>"

/***/ }),

/***/ 1286:
/***/ (function(module, exports) {

module.exports = "<section class=\"container-fluid no-breadcrumbs\">\n    <div class=\"row margin-top-15\">\n        <div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8\">\n            <h2 class=\"article-title color-black\">{{ 'Manager Assignment' | translate }}</h2>\n        </div>\n        <div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4\">\n        </div>\n    </div>\n\n    <div class=\"mdl-card mdl-shadow--2dp mdl-card-full-width select-overflow\">\n        <div class=\"card_title\">\n            <h2 class=\"mdl-card__title-text\">{{ 'Assign Manager' | translate }}</h2>\n        </div>\n        <form class=\"padding-r-l-user\" [formGroup]=\"AddManagerForm\" (ngSubmit)=\"addManager()\" (keydown.enter)=\"$event.preventDefault()\">\n            <fieldset>\n                <div class=\"form-group margin-bottom-2-7\">\n                    <div class=\"row\">\n                        <div class=\"col-md-5 margin-bottom-30\">\n                            <md-select required formControlName=\"countryId\" placeholder=\"{{ 'Select Country' | translate }}\" class=\"full-width\">\n                                <md-option *ngFor=\"let country of countries\" [value]=\"country.id\">\n                                    {{country.name | translate}}\n                                </md-option>\n                            </md-select>\n                        </div>\n                        <div class=\"col-md-5 margin-bottom-30\">\n                            <md-select required formControlName=\"businessUnitId\" placeholder=\"{{ 'Select Business Unit' | translate }}\" class=\"full-width\">\n                                <md-option *ngFor=\"let businessUnit of businessUnits\" [value]=\"businessUnit.id\">\n                                    {{businessUnit.name}}\n                                </md-option>\n                            </md-select>\n                        </div>\n                        <div class=\"col-md-5 margin-bottom-10\">\n                            <!--<md-select required formControlName=\"managerId\" placeholder=\"{{ 'Select Admin' | translate }}\" class=\"full-width margin-top-10\">\n                                <md-option *ngFor=\"let admin of admins\" [value]=\"admin.id\">\n                                    {{admin.name}}\n                                </md-option>\n                            </md-select>-->\n                            <p class=\"font-size-13 margin-bottom-0-2 label-color-light-grey\"> {{ 'Managers' | translate }} </p>\n                            <angular2-multiselect [data]=\"admins\"\n                                                  [settings]=\"manager_settings\" formControlName=\"managerData\">\n                            </angular2-multiselect>\n                        </div>\n                        <div class=\"col-md-5 margin-bottom-10\">\n                            <p class=\"font-size-13 margin-bottom-0-2 label-color-light-grey\"> {{ 'Applications' | translate }} </p>\n                            <angular2-multiselect [data]=\"applications\"\n                                                  [settings]=\"application_settings\" formControlName=\"applicationData\">\n                            </angular2-multiselect>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <span>\n                        <button md-raised-button class=\"btn-w-md btn-w-xs button-gray-clr approve-reject\" type=\"button\" [routerLink]=\"['/app/manager-assignment/list']\">{{ 'Cancel' | translate }}</button>\n                    </span>\n                    <span class=\"space-xs\"></span>\n                    <span class=\"space-xs\"></span>\n                    <span>\n                        <button md-raised-button class=\"btn-w-md btn-w-xs approve-reject\" type=\"submit\" color=\"primary\" [disabled]=\"!AddManagerForm.valid\">{{ 'Confirm' | translate }}</button>\n                    </span>\n                </div>\n            </fieldset>\n        </form>\n\n    </div>\n</section>"

/***/ }),

/***/ 1287:
/***/ (function(module, exports) {

module.exports = "<router-outlet></router-outlet>"

/***/ }),

/***/ 1288:
/***/ (function(module, exports) {

module.exports = "<div class=\"container-fluid no-breadcrumbs page-dashboard\">\n    <article class=\"article\">\n\n        <div class=\"row margin-top-20\">\n            <div class=\"col-xl-10 col-lg-10 col-md-10 col-sm-10 col-10\">\n                <h2 class=\"article-title color-black\">{{ 'ASSIGNMENT LIST' | translate }}</h2>\n            </div>\n            <div class=\"col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2\" *ngIf=\"isSystemAdmin\">\n                <button md-raised-button color=\"accent\" class=\"btn-w-sm btn-w-md float-right\" [routerLink]=\"['/app/manager-assignment/add']\"><i class=\"material-icons\">add_circle_outline</i> {{ 'NEW ASSIGNMENT' | translate }}</button>\n            </div>\n        </div>\n\n        <div class=\"box customize-app-header-inner margin-bottom-15\">\n            <div class=\"filter-padding\">\n                <div class=\"row\">\n                    <div class=\"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 \">\n                        <form class=\"row margin-right-neg-5\" [formGroup]=\"ManagerFiltersForm\" (ngSubmit)=\"search()\" (keydown.enter)=\"$event.preventDefault()\">\n                            <div class=\"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12\">\n                                <md-select placeholder=\"{{ 'Status' | translate }}\" formControlName=\"selectedStatusId\" class=\"width-min-100 width-14 filter-input-2\">\n                                    <md-option *ngFor=\"let statusData of StatusData\" [value]=\"statusData.id\">\n                                        {{statusData.name | uppercase | translate}}\n                                    </md-option>\n                                </md-select>\n                                <md-select placeholder=\"{{ 'Country' | translate }}\" formControlName=\"countryId\" class=\"width-min-100 width-14 filter-input-2\">\n                                    <md-option *ngFor=\"let country of countries\" [value]=\"country.id\">\n                                        {{country.name | translate}}\n                                    </md-option>\n                                </md-select>\n                                <md-select placeholder=\"{{ 'Business Unit' | translate }}\" formControlName=\"businessUnitId\" class=\"width-min-100 width-14 filter-input-2\">\n                                    <md-option *ngFor=\"let businessUnit of businessUnits\" [value]=\"businessUnit.id\">\n                                        {{businessUnit.name | translate}}\n                                    </md-option>\n                                </md-select>\n                                <md-select placeholder=\"{{ 'Applications' | translate }}\" formControlName=\"selectedApplicationId\" class=\"width-min-100 width-14 filter-input-2\">\n                                    <md-option *ngFor=\"let application of applicationList\" [value]=\"application.id\">\n                                        {{application.name | translate}}\n                                    </md-option>\n                                </md-select>\n                                <!--<input type='text' formControlName=\"applicationName\" class=\"filter-input-2 width-14 width-min-100\" placeholder=\"{{ 'Application Name' | translate }}\" (keyup)=\"disablefields($event.target.value, 'appName')\" />-->\n\n                                <input type='text' formControlName=\"wpassId\" class=\"filter-input-2 width-14 width-min-100\" placeholder=\"{{ 'WPASS Id' | translate | uppercase }}\" (keyup)=\"disablefields($event.target.value, 'wpassId')\" />\n                                <button md-raised-button class=\"btn-w-xxs\" type=\"submit\" [disabled]=\"!ManagerFiltersForm.valid\" title=\"Search\"> <md-icon class=\"material-icons\">search</md-icon> {{ 'Search' | translate }}</button>\n                                <span class=\"space-xs\"></span>\n                                <span class=\"space-xs\"></span>\n                                <button md-raised-button class=\"btn-w-xxs\" color=\"primary\" type=\"button\" (click)=\"resetSearch()\" title=\"{{'Reset' | translate}}\"> <md-icon class=\"material-icons\">settings_backup_restore</md-icon>{{ 'Reset' | translate }}</button>\n                                <span class=\"space-xs\"></span>\n                                <span class=\"space-xs\"></span>\n                                <button md-raised-button class=\"btn-w-xxs\" color=\"accent\" type=\"button\" (click)=\"downloadBuMappingCsv()\" title=\"{{'download_csv' | translate}}\"> <md-icon class=\"material-icons\">cloud_download</md-icon></button>\n                            </div>\n                        </form>\n                    </div>\n                </div>\n                <div class=\"callout-1 collout-warn-1\">\n                    <p>{{ 'filter_apply_info' | translate }}</p>\n                </div>\n            </div>\n\n        </div>\n\n        <div class=\"box box-default table-box table-responsive mdl-shadow--2dp\" *ngIf=\"showTable\">\n            <ngx-datatable #table class=\"material\"\n                           [messages]=\"dataTableMessage\"\n                           [rows]=\"rows\"\n                           [columnMode]=\"'force'\"\n                           [headerHeight]=\"60\"\n                           [rowHeight]=\"55\"\n                           [footerHeight]=\"70\"\n                           [externalPaging]=\"true\"\n                           [count]=\"page.totalElements\"\n                           [offset]=\"page.pageNumber\"\n                           [limit]=\"page.size\"\n                           [scrollbarH]=\"true\"\n                           (page)='setPage($event,tableRows,false)'>\n\n                <!--<ngx-datatable-column [width]=\"45\"\n                                      [sortable]=\"false\"\n                                      [canAutoResize]=\"false\"\n                                      [draggable]=\"false\"\n                                      [resizeable]=\"false\"\n                                      [headerCheckboxable]=\"true\"\n                                      [checkboxable]=\"true\">\n                </ngx-datatable-column>-->\n\n                <ngx-datatable-column name=\"{{ 'Name' | translate }}\" prop=\"Name\" [width]=\"100\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                            <span title=\"{{row['Name']}}\" style=\"color: blue;cursor: pointer\">\n                                <a [routerLink]=\"['/app/manager-assignment/view', row['buAssociationId']]\">{{row['Name']}}</a>\n                            </span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"WPASS Id\" prop=\"userId_WPASS\" [width]=\"25\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{'WPASS Id' | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span class=\"color-gray-filter\" title=\"{{row['userId_WPASS']}}\">{{row['userId_WPASS']}}</span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"{{ 'Country' | translate }}\" prop=\"countryName\" [width]=\"30\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span class=\"color-gray-filter\" title=\"{{row['countryName']}}\">{{row['countryName'] | translate}}</span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"{{ 'Business Unit' | translate }}\" prop=\"businessUnitName\" [width]=\"100\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span class=\"color-gray-filter\" title=\"{{row['businessUnitName']}}\">{{row['businessUnitName']}}</span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"{{ 'Applications' | translate }}\" prop=\"applicationName\" [width]=\"50\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span *ngIf=\"row['applicationName']\" style=\"color:blue\" (click)=\"showApplications(row['applicationName'])\">{{'view' | translate}}</span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"{{ 'Status' | translate }}\" prop=\"status\" [width]=\"50\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span *ngIf=\"row['status'] == 'Active'\" style=\"color:green\">{{row['status'] | uppercase | translate}}</span>\n                        <span *ngIf=\"row['status'] == 'Inactive'\" style=\"color:red\">{{row['status'] | uppercase | translate}}</span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n            </ngx-datatable>\n        </div>\n\n        <div class=\"box box-default\" *ngIf=\"!showTable\">\n            <div class=\"box-body\">\n                <div class=\"icon-box ibox-plain ibox-center\">\n                    <h3>{{ 'No Data' | translate }}</h3>\n                    <br>\n                    <button md-raised-button *ngIf=\"isSystemAdmin\" color=\"accent\" class=\"btn-w-sm btn-w-md\" [routerLink]=\"['/app/manager-assignment/add']\"><i class=\"material-icons\">add_circle_outline</i> {{ 'NEW ASSIGNMENT' | translate }}</button>\n                </div>\n            </div>\n        </div>\n    </article>\n</div>"

/***/ }),

/***/ 1289:
/***/ (function(module, exports) {

module.exports = "<section class=\"container-fluid no-breadcrumbs\">\n    <div class=\"row margin-top-15\">\n        <div class=\"col-xl-10 col-lg-10 col-md-10 col-sm-10 col-10\">\n            <h2 class=\"article-title color-black\">{{ 'Manager Assignment' | translate }}</h2>\n        </div>\n        <div class=\"col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 text-right\">\n            <button *ngIf=\"!managerDetails.active\" md-raised-button class=\"btn-w-md approve-reject\" [routerLink]=\"['/app/manage-admin/list']\"><span class=\"btn-text\">{{ 'Back' | translate }}</span></button>\n        </div>\n    </div>\n\n    <div class=\"mdl-card mdl-shadow--2dp mdl-card-full-width select-overflow\">\n        <div class=\"card_title\">\n            <h2 class=\"mdl-card__title-text\">{{ 'View Manager' | translate }}</h2>\n        </div>\n        <form [formGroup]=\"ManagerEditForm\" (ngSubmit)=\"updateManagerDetails()\" (keydown.enter)=\"$event.preventDefault()\">\n            <fieldset>\n                <div class=\"row form-group form-content\">\n                    <p class=\"col-md-12 font-size-18 usr-detail-page-p\">{{ 'Personal Information' | translate }} </p>\n                    <div class=\"col-md-4\">\n                        <label>{{ 'First Name' | translate }}</label>\n                        <p *ngIf=\"managerDetails\">{{managerDetails.firstName}}</p>\n                    </div>\n                    <!--<div class=\"col-md-4\">\n                        <label>{{ 'Last Name' | translate }}</label>\n                        <p *ngIf=\"managerDetails\">{{managerDetails.lastName}}</p>\n                    </div>-->\n                    <div class=\"col-md-4\">\n                        <label>{{ 'WPASS Id' | translate }}</label>\n                        <p *ngIf=\"managerDetails\">{{managerDetails.userId_WPASS}}</p>\n                    </div>\n                    <div class=\"col-md-4\">\n                        <label>{{ 'Email' | translate }}</label>\n                        <p *ngIf=\"managerDetails\">{{managerDetails.email}}</p>\n                    </div>\n                </div>\n\n                <div class=\"dotted-divider\"></div>\n\n                <div class=\"row form-group form-content\">\n                    <p class=\"col-md-12 font-size-18 usr-detail-page-p\">{{ 'Corporate Information' | translate }} </p>\n                    <div class=\"col-md-4 margin-bottom-30\">\n                        <label>{{ 'Country' | translate }}</label>\n                        <p *ngIf=\"managerDetails\">{{managerDetails.countryName | translate}}</p>\n                    </div>\n                    <div class=\"col-md-4 margin-bottom-30\">\n                        <label>{{ 'Business Unit' | translate }}</label>\n                        <p *ngIf=\"managerDetails\">{{managerDetails.businessUnitName}}</p>\n                    </div>\n                    <div class=\"col-md-4 margin-bottom-30\">\n                        <label>{{ 'Created At' | translate }}</label>\n                        <p *ngIf=\"managerDetails\">{{managerDetails.createdAt}}</p>\n                    </div>\n                    <div class=\"col-md-5 margin-bottom-10\" *ngIf=\"managerDetails.active\">\n                        <!--<md-select required formControlName=\"managerId\" placeholder=\"{{ 'Select Admin' | translate }}\" class=\"full-width margin-top-10\">\n                            <md-option *ngFor=\"let admin of admins\" [value]=\"admin.id\">\n                                {{admin.name}}\n                            </md-option>\n                        </md-select>-->\n                        <p class=\"font-size-13 margin-bottom-0-2 label-color-light-grey\"> {{ 'Managers' | translate }} </p>\n                        <angular2-multiselect [data]=\"admins\" [(ngModel)]=\"selectedManagerItems\"\n                                              (onDeSelect)=\"OnManagerDeSelect($event)\"\n                                              [settings]=\"manager_settings\" formControlName=\"managerData\">\n                        </angular2-multiselect>\n                    </div>\n                    <div class=\"col-md-5 margin-bottom-10\" *ngIf=\"managerDetails.active\">\n                        <p class=\"font-size-13 margin-bottom-0-2 label-color-light-grey\"> {{ 'Applications' | translate }} </p>\n                        <angular2-multiselect [data]=\"applications\" [(ngModel)]=\"selectedApplicationItems\"\n                                              [settings]=\"application_settings\" (onDeSelect)=\"OnItemDeSelect($event)\"\n                                              (onDeSelectAll)=\"onDeSelectAll($event)\"formControlName=\"applicationData\">\n                        </angular2-multiselect>\n                    </div>\n                </div>\n\n                <div class=\"form-group padding-r-l-admin-forms\" *ngIf=\"managerDetails.active\">\n                    <span>\n                        <button md-raised-button class=\"btn-w-md btn-w-xs button-gray-clr approve-reject\" type=\"button\" [routerLink]=\"['/app/manager-assignment/list']\">{{ 'Cancel' | translate }}</button>\n                    </span>\n                    <span class=\"space-xs\"></span>\n                    <span class=\"space-xs\"></span>\n                    <span>\n                        <button md-raised-button class=\"btn-w-md btn-w-xs approve-reject\" type=\"submit\" color=\"primary\" [disabled]=\"!ManagerEditForm.valid\">{{ 'Confirm' | translate }}</button>\n                    </span>\n                </div>\n            </fieldset>\n        </form>\n\n    </div>\n</section>"

/***/ }),

/***/ 1290:
/***/ (function(module, exports) {

module.exports = "<section class=\"container-fluid no-breadcrumbs\">\n    <div class=\"row margin-top-10\">\n        <div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8\">\n            <h2 class=\"article-title color-black\">{{ 'System Settings' | translate }}</h2>\n        </div>\n        <div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4\">\n        </div>\n    </div>\n\n    <div class=\"mdl-card mdl-shadow--2dp mdl-card-full-width\">\n        <div class=\"card_title\">\n            <h2 class=\"mdl-card__title-text\">{{ 'WPASS Information' | translate }}</h2>\n        </div>\n        <form class=\"padding-r-l-user-password\" [formGroup]=\"WPASSForm\" (ngSubmit)=\"saveUserData()\" (keydown.enter)=\"$event.preventDefault()\">\n            <fieldset>\n                <div class=\"form-group margin-bottom-1-7\">\n                    <div class=\"row margin-top-20\">\n                        <div class=\"col-md-6 margin-bottom-20\">\n                            <md-input-container class=\"full-width\">\n                                <input required mdInput type=\"url\" id=\"exampleInputUrl\" formControlName=\"wpassUrl\" placeholder=\"{{ 'WPASS URL' | translate }}\">\n                            </md-input-container>\n                            <div *ngIf=\"WPASSForm.hasError('whitespace')\">\n                                <small ng-message='required'>Please enter valid url</small>\n                            </div>\n                        </div>\n                        <div class=\"col-md-6 margin-bottom-20\">\n                            <md-input-container class=\"full-width\">\n                                <input required mdInput id=\"exampleInputUserId\" formControlName=\"wpassAppUserId\" placeholder=\"{{ 'Application User Id' | translate }}\">\n                            </md-input-container>\n                        </div>\n\n                        <div class=\"col-md-12 margin-bottom-17-5 margin-top-15\">\n                            <md-checkbox align=\"end\" [checked]=\"isChecked\" (change)=\"toggle()\"> {{ 'Change Password' | translate }} </md-checkbox>\n                        </div>\n\n                        <div class=\"col-md-6 margin-bottom-20\">\n                            <div class=\"row\">\n                                <div class=\"col-md-11\">\n                                    <md-input-container class=\"full-width\">\n                                        <input required mdInput type=\"password\" id=\"exampleInputNewPassword\" formControlName=\"wpassAppUserPassword\" placeholder=\"{{ 'Password' | translate }}\" title=\"Valid\">\n                                    </md-input-container>\n                                </div>\n                                <div class=\"col-1\">\n                                    <div class=\"sash sash-white sash-danger sash-hight-223\">\n                                        <div>\n                                            <i class=\"material-icons\">info</i>\n                                            <ul class=\"sash-text password-ul\">\n                                                <li>{{ 'pass_least_8_chars' | translate }}</li>\n                                                <li>{{ 'pass_one_upper_lower_char' | translate }}</li>\n                                                <li>{{ 'pass_one_number' | translate }}</li>\n                                                <li>{{ 'pass_invalid_symbol' | translate }}</li>\n                                                <li>{{ 'pass_contains_firstname' | translate }}</li>\n                                                <li>{{ 'pass_contains_lastname' | translate }}</li>\n                                                <li>{{ 'pass_prevent_history' | translate }}</li>\n                                            </ul>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n\n                        </div>\n                        <div class=\"col-md-6 margin-bottom-20\">\n                            <md-input-container class=\"full-width\" md-is-error=\"WPASSForm.hasError('mismatch')\">\n                                <input required mdInput type=\"password\" id=\"exampleConfirmPassword\" formControlName=\"wpassAppUserConfirmPassword\" placeholder=\"{{ 'Confirm Password' | translate }}\" >\n                            </md-input-container>\n                            <div *ngIf=\"WPASSForm.hasError('mismatch')\">\n                                <small ng-message='required'>{{ 'Password Mismatch' | translate }}</small>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <span>\n                        <button md-raised-button class=\"btn-w-md btn-w-xs button-gray-clr approve-reject\" [routerLink]=\"['/app/profile']\">{{ 'Cancel' | translate }}</button>\n                    </span>\n                    <span class=\"space-xs\"></span>\n                    <span class=\"space-xs\"></span>\n                    <span>\n                        <button md-raised-button class=\"btn-w-md btn-w-xs approve-reject\" type=\"submit\" color=\"primary\" [disabled]=\"!WPASSForm.valid\">{{ 'Confirm' | translate }}</button>\n                    </span>\n                </div>\n            </fieldset>\n        </form>\n\n    </div>\n</section>"

/***/ }),

/***/ 1291:
/***/ (function(module, exports) {

module.exports = "<div class=\"container-fluid no-breadcrumbs page-dashboard\">\n    <article class=\"article\">\n        <div class=\"row margin-top-20\">\n            <div class=\"col-6 col-xl-6 col-lg-6 col-md-6 col-sm-6\">\n                <h2 class=\"article-title color-black\">{{ 'translation_email' | translate | uppercase }}</h2>\n            </div>\n            <div class=\"col-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 text-right\">\n            </div>\n        </div>\n        <div class=\"box customize-app-header-inner margin-bottom-15\">\n            <div class=\"filter-padding\">\n                <div class=\"row margin-right-neg-5\">\n\n                    <div class=\"col-8 col-xl-8 col-lg-8 col-md-8 col-sm-7\">\n                        <form [formGroup]=\"ProfileForm\" class=\"row custom-textfield-class\" (ngSubmit)=\"search()\"\n                            (keydown.enter)=\"$event.preventDefault()\">\n\n                            <div class=\"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12\">\n                                <div class=\"col-md-4 filter-select\">\n                                    <md-select formControlName=\"languageId\" placeholder=\"{{ 'Language' | translate }}\"\n                                        class=\"full-width max-width-80 margin-top-37\">\n                                        <md-option *ngFor=\"let languageData of LanguageData\" [value]=\"languageData.id\"\n                                            (click)=\"onLanguageChange(languageData.id)\"> {{languageData.name}}\n                                        </md-option>\n                                    </md-select>\n                                </div>\n                                <div style=\"margin-top: 15px;\">\n\n                                  \n                                </div>\n                            </div>\n                        </form>\n\n                    </div>\n\n                </div>\n\n                \n            </div>\n        </div>\n        <div class=\"row box customize-app-header-inner m-0\">\n            <div class=\"column\" style=\"width:23%; font-size: 12px\">\n                    <div class=\"table-box table-responsive\">\n                            <h5 class=\"p-l-16\"> {{ 'choose_subject' | translate }}</h5>\n                        <div  class=\"mdl-tabs vertical-mdl-tabs mdl-js-tabs mdl-js-ripple-effect box-default\">\n                            <div class=\"mdl-grid\">\n                                <div class=\"mdl-cell mdl-cell--2-col\">\n                                    <div class=\"mdl-tabs__tab-bar\"  *ngFor=\"let i of SubjectItems\">\n                                        <div class=\"mdl-tabs__tab \" title=\"{{i.text}}\" id=\"{{i.id}}\">\n                                            <span class=\"hollow-circle\" ></span>\n                                            <div (click)=\"selectEmail(i, i.id)\"\n                                            >{{i.text}}</div>\n                                       </div>\n                                    </div>\n                                </div>\n                            </div>\n                    </div>\n                    </div>\n            </div>\n            <div class=\"column\"   style=\"width:75%; font-size: 12px; padding:0% 2%;\">\n                    <div class=\"containerEditor\">\n\n                            <div class=\"ckeEditor-2\">\n                                   <h5> {{ 'email_subject' | translate }}</h5>\n                                    <textarea ng-model-options=\"{ updateOn: 'blur' }\" rows=3 autocomplete=\"off\" autocorrect=\"off\"\n                                    autocapitalize=\"off\" spellcheck=\"false\"  type=\"text\" [(ngModel)]=\"emailSubject\"\n                                    class=\"md-textarea form-control\" style=\"margin-bottom: 10px;\"></textarea>\n                                    <button md-raised-button  color=\"accent\" (click)=\"updateSubject()\">\n                                         {{ 'Update' | translate }}\n                                        </button>\n                            </div>\n                            \n                        <div class=\"ckeEditor-1\">\n                              \n                            <h5> {{ 'email_body' | translate }}</h5>\n                                <ckeditor [(ngModel)]=\"emailBody\"  \n                                [config]=\"{uiColor: '#ffffff'}\"\n                                debounce=\"500\"></ckeditor>\n                                <button md-raised-button  id=\"submit\" color=\"accent\" style=\"margin-top: 10px;\" (click)=\"updateBody()\">\n                                        {{ 'Update' | translate }}\n                                    </button>\n                        </div> \n            </div>\n        </div>\n       \n        \n        </div>\n        \n    </article>\n    \n</div>"

/***/ }),

/***/ 1292:
/***/ (function(module, exports) {

module.exports = "<div class=\"container-fluid no-breadcrumbs page-dashboard\">\n    <article class=\"article\">\n\n        <div class=\"row margin-top-20\">\n            <div class=\"col-12\">\n                <h2 class=\"article-title color-black\">{{ 'translation_messages' | translate | uppercase }}</h2>\n            </div>\n        </div>\n        <div class=\"box customize-app-header-inner margin-bottom-15 p-4\">\n            <div class=\"row\">\n                <div class=\"col-12\">\n                    <form [formGroup]=\"ProfileForm\" class=\"table-filter-box custom-textfield-class\"\n                        (ngSubmit)=\"search()\" (keydown.enter)=\"$event.preventDefault()\">\n                        <div>\n                            <md-select formControlName=\"languageId\" placeholder=\"{{ 'Language' | translate }}\">\n                                <md-option *ngFor=\"let languageData of LanguageData\" [value]=\"languageData.id\"\n                                    (click)=\"onLanguageChange(languageData.id)\"> {{languageData.name}}\n                                </md-option>\n                            </md-select>\n                        </div>\n                        <div>\n                        <input type='text' placeholder=\"{{ 'search_text' | translate }}\" [(ngModel)]=\"searchText\"\n                            [ngModelOptions]=\"{standalone: true}\" />\n                        </div>\n                        <div class=\"action-btn\">\n                            <button md-raised-button class=\"btn-md\" type=\"submit\" title=\"Search\">\n                                <md-icon class=\"material-icons\">search</md-icon> {{ 'Search' | translate }}\n                            </button>\n                        </div>\n                        <div class=\"action-btn\">\n                            <button md-raised-button class=\"btn-md\" color=\"primary\" type=\"button\"\n                                (click)=\"resetSearch()\" title=\"Reset Search\">\n                                <md-icon class=\"material-icons\">settings_backup_restore</md-icon>\n                                {{ 'Reset' | translate }}\n                            </button>\n                        </div>\n                    </form>\n                </div>\n            </div>\n            <div class=\"callout-1 collout-warn-1\">\n                <p>{{ 'filter_apply_info' | translate }}</p>\n            </div>\n        </div>\n        <div class=\"box box-default table-box table-responsive mdl-shadow--2dp\" *ngIf=\"showTable\">\n            <ngx-datatable #table class=\"material custom-md-table\" id=\"custom-md-table\" [rows]=\"rows\"\n                [columnMode]=\"'force'\" [headerHeight]=\"60\" [rowHeight]=\"\" [footerHeight]=\"70\" [externalPaging]=\"true\"\n                [count]=\"page.totalElements\" [offset]=\"page.pageNumber\" [limit]=\"page.size\" [scrollbarH]=\"true\"\n                (page)='setPage($event,tableRows,false)' (select)='onSelect($event)'>\n\n                <!-- <ngx-datatable-column *ngIf=\"showCheckbox\"\n                                              [width]=\"45\"\n                                              [sortable]=\"false\"\n                                              [canAutoResize]=\"false\"\n                                              [draggable]=\"false\"\n                                              [resizeable]=\"false\"\n                                              [headerCheckboxable]=\"true\"\n                                              [checkboxable]=\"true\">\n                        </ngx-datatable-column> -->\n\n\n\n                <ngx-datatable-column name=\"English\" prop=\"english\" [width]=\"400\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span>{{column.name}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span class=\"color-gray-filter\" title=\"{{row['english']}}\">{{row['english']}}</span>\n                    </ng-template>\n                </ngx-datatable-column>\n\n                <ngx-datatable-column name=\"{{ 'selected_language' | translate }}\" prop=\"selectLanguage\" [width]=\"600\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span>{{column.name}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n\n                        <textarea ng-model-options=\"{ updateOn: 'blur' }\" rows=3 autocomplete=\"off\" autocorrect=\"off\"\n                            autocapitalize=\"off\" spellcheck=\"false\" [(ngModel)]=\"language2[row.$$index]\" type=\"text\"\n                            class=\"md-textarea form-control\">{{row['selectLanguage']}}</textarea>\n                    </ng-template>\n                </ngx-datatable-column>\n                <ngx-datatable-column name=\"{{ 'Action' | translate }}\" prop=\"action\" [width]=\"100\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span>{{column.name | translate}}</span>\n                    </ng-template>\n                    <ng-template let-rowIndex=\"rowIndex\" let-row=\"row\" ngx-datatable-cell-template>\n\n                        <button md-raised-button [disabled]=\"language2[row.$$index] == row['selectLanguage']\"\n                            class=\"btn-w-sm btn-w-md color-white font-size-13 approve-reject\"\n                            (click)=\"updateBtn(row, language2[row.$$index])\" color=\"accent\">\n                            {{'Update' | translate}}\n                        </button>\n\n                    </ng-template>\n                </ngx-datatable-column>\n\n            </ngx-datatable>\n        </div>\n\n    </article>\n</div>"

/***/ }),

/***/ 1293:
/***/ (function(module, exports) {

module.exports = "<!DOCTYPE html>\n<div class=\"page-auth\">\n    <div class=\"main-body padding-8 max-width-460\">\n        <div class=\"card bg-color-white\">\n            <div class=\"card-content\">\n                <div class=\"logo-2\">\n                    <h3 class=\"icon-color\">{{'unlock_account' | translate}}</h3>\n                </div>\n                <form role=\"form\" [formGroup]=\"UnlockAccountForm\" class=\"md-form-auth form-validation margin-bottom-40\">\n                    <fieldset>\n                        <div class=\"form-group\">\n                            <md-input-container class=\"full-width md-icon-left no-margin-bottom\">\n                                <md-icon class=\"material-icons\">perm_identity</md-icon>\n                                <input required mdInput placeholder=\"{{ 'WPASS User Id' | translate }}\" formControlName=\"userId_WPASS\" name=\"exampleWPASSID\">\n                            </md-input-container>\n                        </div>\n                        <p class=\"text-center text-small no-margin letter-spacing-0-8\">\n                            <strong>{{'after_unlock_account_confirm' | translate}}</strong>\n                        </p>\n\n                        <div class=\"divider divider-md\"></div>\n                        <button md-raised-button type=\"submit\" color=\"primary\" class=\"float-right\" [disabled]=\"!UnlockAccountForm.valid\" (click)=\"unlockAccount()\">{{'Unlock' | translate}}</button>\n                    </fieldset>\n                </form>\n\n                <div class=\"additional-info\">\n                    <a [routerLink]=\"['/app/login']\" class=\"cursor-pointer font-size-1rem\">{{'Login' | translate}}</a>\n                </div>\n            </div>\n\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ 1294:
/***/ (function(module, exports) {

module.exports = "<div class=\"container-fluid no-breadcrumbs page-dashboard\">\n    <div class=\"article\">\n        <div class=\"row margin-top-20\">\n            <div class=\"col-12\">\n                <h2 class=\"article-title color-black\">{{ 'user_activity' | translate | uppercase }}</h2>\n            </div>\n        </div>\n        <div class=\"box customize-app-header-inner margin-bottom-15 p-4\">\n            <div class=\"row\">\n                <div class=\"col-12\">\n                    <div class=\"row \">\n                        <div class=\"col-12\">\n                            <label style=\"margin:0 !important; font-size: 11px !important;\">{{'from_date' | translate}}:&nbsp;&nbsp;</label>\n                        </div>\n                    </div>\n                    <div class=\"row \">\n                        <div class=\"col-12\">\n                            <form class=\"table-filter-box custom-textfield-class\" (ngSubmit)=\"search()\" (keydown.enter)=\"$event.preventDefault()\">\n                                <div class=\"datepicker-custom\">\n                                    <my-date-picker name=\"mydate\" [options]=\"myDatePickerOptions\" [(ngModel)]=\"model\"\n                                        placeholder=\"{{'select_a_date' | translate}}\" required>\n                                    </my-date-picker>\n                                </div>\n                                \n                                <input type='text' style=\"margin-right: 15px;\" class=\"width-18\" placeholder=\"{{ 'WPASS Id' | translate | uppercase }}\" [(ngModel)]=\"searchWpass\" [ngModelOptions]=\"{standalone: true}\"/>\n                                <!--<input (inputChangedEvent)=\"autocompleteSearch($event, 'wpass')\" (selectEvent)=\"onSelectAutocomplete($event, 'wpass')\" [(ngModel)]=\"searchWpass\"\n                                       [items]=\"Wpass\"\n                                       [ngClass]=\"{'data-loading' : autocompleteLoader == 'wpass'}\"\n                                       [ngModelOptions]=\"{standalone: true}\"\n                                       class=\"Data-Search\"\n                                       input-autocomplete placeholder=\"{{ 'WPASS Id' | translate | uppercase }}\">-->\n\n                                <div class=\"action-btn\">\n                                    <button md-raised-button class=\"btn-md\" type=\"submit\" title=\"Search\">\n                                        <md-icon class=\"material-icons\">search</md-icon> {{ 'Search' | translate }}\n                                    </button>\n                                </div>\n                                <div class=\"action-btn\">\n                                    <button md-raised-button class=\"btn-md\" color=\"primary\" type=\"button\"\n                                        (click)=\"resetSearch()\" title=\"Reset Search\">\n                                        <md-icon class=\"material-icons\">settings_backup_restore</md-icon>\n                                        {{ 'Reset' | translate }}\n                                    </button>\n                                </div>\n                            </form>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row \">\n                <div class=\"col-12\">\n                    <div class=\"callout-1 collout-warn-1\">\n                        <p>{{ 'filter_apply_info' | translate }}</p>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"box box-default table-box table-responsive mdl-shadow--2dp\" *ngIf=\"showTable\">\n            <ngx-datatable #table class=\"material custom-md-table\" id=\"custom-md-table\" [rows]=\"rows\"\n                [columnMode]=\"'force'\" [headerHeight]=\"60\" [rowHeight]=\"55\" [footerHeight]=\"70\" [externalPaging]=\"true\"\n                [count]=\"page.totalElements\" [offset]=\"page.pageNumber\" [limit]=\"page.size\" [scrollbarH]=\"true\"\n                (page)='setPage($event,tableRows,false)' (select)='onSelect($event)'>\n                <ngx-datatable-column name=\"{{ 'Name' | translate }}\" prop=\"username\" [width]=\"10\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span class=\"color-gray-filter\" title=\"{{row['username']}}\">{{row['username']}}</span>\n                    </ng-template>\n                </ngx-datatable-column>\n                <ngx-datatable-column name=\"{{ 'WPASS Id' | translate | uppercase }}\" prop=\"wpassId\" [width]=\"12\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span class=\"color-gray-filter\" title=\"{{row['wpassId']}}\">{{row['wpassId']}}</span>\n                    </ng-template>\n                </ngx-datatable-column>\n                <ngx-datatable-column name=\"{{ 'Created At' | translate }}\" prop=\"createdAt\" [width]=\"10\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span class=\"color-gray-filter\" title=\"{{row['createdAt']}}\">{{row['createdAt']}}</span>\n                    </ng-template>\n                </ngx-datatable-column>\n                <ngx-datatable-column name=\"{{ 'description' | translate }}\" prop=\"description\" [width]=\"470\">\n                    <ng-template let-column=\"column\" ngx-datatable-header-template let-sort=\"sortFn\">\n                        <span (click)=\"sort()\">{{column.name}}</span>\n                    </ng-template>\n                    <ng-template let-row=\"row\" ngx-datatable-cell-template>\n                        <span class=\"color-gray-filter\" [innerHTML]=\"row['description']\"> </span>\n                    </ng-template>\n                </ngx-datatable-column>\n            </ngx-datatable>\n        </div>\n        <div class=\"box box-default\" *ngIf=\"!showTable\">\n            <div class=\"box-body\">\n                <div class=\"icon-box ibox-plain ibox-center\">\n                    <h3>{{ 'No Data' | translate }}</h3>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ 1295:
/***/ (function(module, exports) {

module.exports = "<section class=\"container-fluid no-breadcrumbs\">\n    <div class=\"row margin-top-15\">\n        <div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8\">\n            <h2 class=\"article-title color-black\">{{ 'Request Application' | translate }}</h2>\n        </div>\n        <div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4\">\n        </div>\n    </div>\n\n    <div class=\"mdl-card mdl-shadow--2dp mdl-card-full-width select-overflow\">\n        <div class=\"card_title\">\n            <h2 class=\"mdl-card__title-text\">{{ 'NEW APPLICATION' | translate }}</h2>\n        </div>\n        <form class=\"padding-r-l-user\" [formGroup]=\"AddBusinessUnitForm\" (ngSubmit)=\"saveBusinessUnitData()\" (keydown.enter)=\"$event.preventDefault()\">\n            <fieldset>\n                <div class=\"form-group margin-bottom-2-2\">\n                    <p class=\"font-size-18\"> {{ 'Personal Information' | translate }} </p>\n                    <div class=\"row margin-top-20\">\n                        <div class=\"col-md-6 margin-bottom-20\">\n                            <md-input-container class=\"full-width\">\n                                <input required mdInput id=\"exampleCountry\" formControlName=\"country\" placeholder=\"{{ 'Country' | translate }}\">\n                            </md-input-container>\n                        </div>\n                        <div class=\"col-md-6 margin-bottom-20\">\n                            <md-select required formControlName=\"businessUnitId\" placeholder=\"{{ 'Select Business Unit' | translate }}\" class=\"full-width margin-top-10\" [(ngModel)]=\"selectedBusinessUnit\">\n                                <md-option *ngFor=\"let businessUnit of businessUnits\" [value]=\"businessUnit.id\">\n                                    {{businessUnit.name}}\n                                </md-option>\n                            </md-select>\n                        </div>\n                        <div class=\"col-md-6 margin-bottom-20\">\n                            <angular2-multiselect [data]=\"applications\"\n                                                  [settings]=\"settings\" formControlName=\"applicationData\">\n                            </angular2-multiselect>\n                        </div>\n                        <div class=\"col-md-6 margin-bottom-20\">\n                            <md-input-container class=\"full-width\">\n                                <input required type=\"email\" mdInput id=\"exampleCustomerNumber\" formControlName=\"customerNumber\" placeholder=\"{{ 'Customer Number' | translate }}\">\n                            </md-input-container>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <span>\n                        <button md-raised-button class=\"btn-w-md btn-w-xs button-gray-clr approve-reject\" [routerLink]=\"['/app/request-application/list']\">{{ 'Cancel' | translate }}</button>\n                    </span>\n                    <span class=\"space-xs\"></span>\n                    <span class=\"space-xs\"></span>\n                    <span>\n                        <button md-raised-button class=\"btn-w-md btn-w-xs approve-reject\" type=\"submit\" color=\"primary\" [disabled]=\"!AddBusinessUnitForm.valid\">{{ 'Confirm' | translate }}</button>\n                    </span>\n                </div>\n            </fieldset>\n        </form>\n\n    </div>\n</section>"

/***/ }),

/***/ 1296:
/***/ (function(module, exports) {

module.exports = "<div class=\"container-fluid no-breadcrumbs page-dashboard\">\n    <article class=\"article\">\n\n        <div class=\"row margin-top-20\">\n            <div class=\"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6\">\n                <h2 *ngIf=\"this.isServiceOwner || this.isTradePartner\" class=\"article-title color-black\">{{ 'my_requests' | translate | uppercase }}</h2>\n            </div>\n            <div class=\"col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 text-right\" *ngIf=\"this.isServiceOwner || this.isTradePartner\">\n                <button md-raised-button color=\"accent\" class=\"btn-w-md\" [routerLink]=\"['/app/request-application/add']\"><i class=\"material-icons\">add_circle_outline</i> {{ 'Request Application' | translate | uppercase }}</button>\n            </div>\n        </div>\n\n        <div class=\"box customize-app-header-inner margin-bottom-15\">\n            <div class=\"filter-padding\">\n                <div class=\"row margin-right-neg-5\">\n                    <div class=\"col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3\">\n                        <md-select placeholder=\"{{ 'Applications' | translate }}\" class=\"full-width margin-top-10 filter-input\" [(ngModel)]=\"selectedApplicationId\">\n                            <md-option *ngFor=\"let application of ApplicationData\" [value]=\"application.id\">\n                                {{application.name}}\n                            </md-option>\n                        </md-select>\n                    </div>\n                    <div class=\"col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9 margin-top-11\">\n                        <button md-raised-button class=\"btn-w-xxs\" type=\"button\" (click)=\"search()\" title=\"Search\"> <md-icon class=\"material-icons\">search</md-icon> {{ 'Search' | translate }}</button>\n                        <span class=\"space-xs\"></span>\n                        <span class=\"space-xs\"></span>\n                        <button md-raised-button class=\"btn-w-xxs\" color=\"primary\" type=\"button\" (click)=\"resetSearch()\" title=\"Reset Search\"> <md-icon class=\"material-icons\">settings_backup_restore</md-icon> {{ 'Reset' | translate }}</button>\n                    </div>\n                </div>\n                <div class=\"callout-1 collout-warn-1\">\n                    <p>{{ 'filter_apply_info' | translate }}</p>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"box box-default table-box table-responsive mdl-shadow--2dp\" *ngIf=\"showTable\">\n\n            <table class=\"mdl-data-table font-size-14\" *ngIf=\"businessUnitWithAppRolesProfile && businessUnitWithAppRolesProfile.length > 0\">\n                <thead class=\"responsive-table-header-backgroud\">\n                <tr>\n                    <th class=\"mdl-data-table__cell--non-numeric\" style=\"text-align: left!important;\">#</th>\n                    <th class=\"mdl-data-table__cell--non-numeric\">{{'Application Name' | translate }}</th>\n                    <th class=\"mdl-data-table__cell--non-numeric\">{{'Business Unit' | translate }}</th>\n                    <th class=\"mdl-data-table__cell--non-numeric\">{{'Customer Number' | translate }}</th>\n                    <th class=\"mdl-data-table__cell--non-numeric\">{{'Status' | translate }}</th>\n                    <th class=\"mdl-data-table__cell--non-numeric\">{{'Role' | translate }}</th>\n                </tr>\n                </thead>\n\n                <tbody>\n                <tr *ngFor=\"let appData of businessUnitWithAppRolesProfile, let i = index\">\n                    <td class=\"mdl-data-table__cell--non-numeric\">{{i + 1}}</td>\n                    <td class=\"mdl-data-table__cell--non-numeric\">\n                        <a *ngIf=\"appData.url\" target=\"_blank\" href={{appData.url}}><i class=\"material-icons\"> near_me </i></a>\n                        {{appData.applicationName}}\n                    </td>\n                    <td class=\"mdl-data-table__cell--non-numeric\">{{appData.businessUnitName}}</td>\n                    <td class=\"mdl-data-table__cell--non-numeric\">{{appData.customerNumber}}</td>\n                    <td class=\"mdl-data-table__cell--non-numeric\" *ngIf=\"appData.statusCode == 'AUTO_APPROVED' || appData.statusCode == 'APPROVED'\"\n                        style=\"color: green\">{{appData.status | lowercase | translate}}\n                    </td>\n                    <td class=\"mdl-data-table__cell--non-numeric\" *ngIf=\"appData.statusCode == 'PENDING'\"\n                        style=\"color: orange\">{{appData.status | lowercase | translate}}\n                    </td>\n                    <td class=\"mdl-data-table__cell--non-numeric\" *ngIf=\"appData.statusCode == 'REJECTED' || appData.statusCode == 'REVOKED'\"\n                        style=\"color: red\">{{appData.status | lowercase | translate}}\n                    </td>\n                    <td class=\"mdl-data-table__cell--non-numeric\">{{appData.selectedRoleNames}}</td>\n                    <!--<td class=\"mdl-data-table__cell&#45;&#45;non-numeric color-blue cursor-pointer\" (click)=\"showApplicationsWithRoles(appData.applications)\">View</td>-->\n                </tr>\n                </tbody>\n            </table>\n        </div>\n\n        <div class=\"box box-default\" *ngIf=\"!showTable\">\n            <div class=\"box-body\">\n                <div class=\"icon-box ibox-plain ibox-center\">\n                    <h3>{{ 'No Data' | translate }}</h3>\n                </div>\n            </div>\n        </div>\n\n    </article>\n</div>"

/***/ }),

/***/ 1297:
/***/ (function(module, exports) {

module.exports = "<router-outlet></router-outlet>"

/***/ }),

/***/ 1298:
/***/ (function(module, exports) {

module.exports = "<section class=\"container-fluid no-breadcrumbs\">\n    <div class=\"row margin-top-15\">\n        <div class=\"col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9\">\n            <h2 class=\"article-title color-black\">{{ 'Request Business Unit' | translate }}</h2>\n        </div>\n        <div class=\"col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right\">\n            <button *ngIf=\"businessUnitDetails.active\" md-raised-button color=\"accent\" class=\"btn-w-md approve-reject\"\n                    (click)=\"requestNewApplication(businessUnitDetails.businessUnitId)\"><i class=\"material-icons\">add_circle_outline</i>{{ 'Request Application' | translate }}\n            </button>\n            <span class=\"space-xs\"></span>\n            <span class=\"space-xs\"></span>\n            <button md-raised-button class=\"btn-w-md approve-reject\" [routerLink]=\"['/app/request-application/list']\">\n                <span class=\"btn-text\">{{ 'Back' | translate }}</span></button>\n        </div>\n    </div>\n\n    <div class=\"mdl-card mdl-shadow--2dp mdl-card-full-width select-overflow\">\n        <div class=\"card_title\">\n            <h2 class=\"mdl-card__title-text\">{{ 'View Business Unit' | translate }}</h2>\n        </div>\n        <div class=\"row form-group form-content\">\n            <p class=\"col-md-12 font-size-18 usr-detail-page-p\">{{ 'Corporate Information' | translate }} </p>\n            <div class=\"col-md-4\">\n                <label>{{ 'Country' | translate }}</label>\n                <p *ngIf=\"businessUnitDetails\">{{businessUnitDetails.countryName}}</p>\n            </div>\n            <div class=\"col-md-4\">\n                <label>{{ 'Business Unit Name' | translate }}</label>\n                <p *ngIf=\"businessUnitDetails\">{{businessUnitDetails.businessUnitName}}</p>\n            </div>\n            <div class=\"col-md-4\">\n                <label>{{ 'Customer Number' | translate }}</label>\n                <p *ngIf=\"businessUnitDetails\">{{businessUnitDetails.customerNumber}}</p>\n            </div>\n            <div class=\"col-md-4\">\n                <label>{{ 'status' | translate }}</label>\n                <p *ngIf=\"businessUnitDetails\">{{businessUnitDetails.status}}</p>\n            </div>\n        </div>\n\n        <div class=\"dotted-divider\"></div>\n\n        <div class=\"row form-group form-content\">\n            <p class=\"col-md-12 font-size-18 usr-detail-page-p\">{{ 'Applications Information' | translate }} </p>\n\n            <div class=\"col-md-12\" style=\"padding: 20px 45px 0px 15px; !important;\">\n                <div class=\"box box-default table-box table-responsive mdl-shadow--2dp\">\n                    <table class=\"mdl-data-table font-size-14\">\n                        <thead class=\"responsive-table-header-backgroud\">\n                        <tr>\n                            <th class=\"mdl-data-table__cell--non-numeric\" style=\"text-align: left!important;\">#</th>\n                            <th class=\"mdl-data-table__cell--non-numeric\">Application Name</th>\n                            <th class=\"mdl-data-table__cell--non-numeric\">Application Status</th>\n                            <th class=\"mdl-data-table__cell--non-numeric\">Rejection Message</th>\n                        </tr>\n                        </thead>\n\n                        <tbody>\n                        <tr *ngFor=\"let application of applications, let i = index\">\n                            <td class=\"mdl-data-table__cell--non-numeric\">{{i + 1}}</td>\n                            <td class=\"mdl-data-table__cell--non-numeric\">{{application.applicationName}}</td>\n                            <td class=\"mdl-data-table__cell--non-numeric\" *ngIf=\"application.status == 'Pending'\"\n                                style=\"color: orange\">{{application.status | lowercase | translate}}\n                            </td>\n                            <td class=\"mdl-data-table__cell--non-numeric\" *ngIf=\"application.status == 'Approved'\"\n                                style=\"color: green\">{{application.status | lowercase | translate}}\n                            </td>\n                            <td class=\"mdl-data-table__cell--non-numeric\" *ngIf=\"application.status == 'Rejected'\"\n                                style=\"color: red\">{{application.status | lowercase | translate}}\n                            </td>\n                            <td class=\"mdl-data-table__cell--non-numeric\">{{application.message}}</td>\n                        </tr>\n                        </tbody>\n                    </table>\n                </div>\n            </div>\n\n        </div>\n\n    </div>\n</section>"

/***/ }),

/***/ 1299:
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n    <div class=\"col-xl-12\">\n        <form class=\"padding-r-l-user\" [formGroup]=\"UserForm\" (ngSubmit)=\"saveUserData()\">\n            <fieldset>\n                <div class=\"form-group margin-bottom-1-7\">\n                    <p class=\"font-size-18\"> {{ 'Personal Information' | translate }} </p>\n                    <div class=\"row margin-top-20\">\n                        <div class=\"col-md-4 margin-bottom-10\">\n                            <md-input-container class=\"full-width\">\n                                <input required mdInput id=\"exampleInputFirstName\" formControlName=\"firstName\" (keypress)=\"validateName($event)\" onPaste=\"return false\" autocomplete=off placeholder=\"{{ 'First Name' | translate }}\">\n                            </md-input-container>\n                        </div>\n                        <div class=\"col-md-4 margin-bottom-10\">\n                            <md-input-container class=\"full-width\">\n                                <input required mdInput id=\"exampleInputLastName\" formControlName=\"lastName\" (keypress)=\"validateName($event)\" onPaste=\"return false\" autocomplete=off placeholder=\"{{ 'Last Name' | translate }}\">\n                            </md-input-container>\n                        </div>\n                        <div class=\"col-md-4 margin-bottom-10\">\n                            <md-input-container class=\"full-width\">\n                                <input required type=\"email\" mdInput id=\"exampleInputEmail1\" formControlName=\"email\" placeholder=\"{{ 'Email' | translate }}\">\n                            </md-input-container>\n                        </div>\n                        <div class=\"col-md-4\">\n                            <div class=\"row\">\n                                <div class=\"col-md-12\">\n                                    <md-input-container class=\"full-width\">\n                                        <input #input required mdInput type=\"password\" id=\"exampleInputNewPassword\" formControlName=\"password\" placeholder=\"{{ 'Create New Password' | translate }}\" title=\"Valid\">\n                                    </md-input-container>\n\n                                    <p class=\" margin-0\" *ngIf=\"input.type === 'password'\"><i class=\"material-icons font-size-18 pass-useful-hint right-40\" (click)=\"showPassword(input)\">visibility</i></p>\n                                    <p class=\" margin-0\" *ngIf=\"input.type ===  'text'\"><i class=\"material-icons font-size-18 pass-useful-hint right-40\" (click)=\"showPassword(input)\">visibility_off</i></p>\n\n                                    <div class=\"pass-hint pass-useful-hint right-10\">\n                                        <i class=\"material-icons font-size-17\" style=\"color: #717171db;\">info</i>\n                                        <div class=\"pass-content\">\n                                            <ul class=\"password-ul\" style=\"width: 350px;\">\n                                                <li>{{ 'pass_least_8_chars' | translate }}</li>\n                                                <li>{{ 'pass_one_upper_lower_char' | translate }}</li>\n                                                <li>{{ 'pass_one_number' | translate }}</li>\n                                                <li>{{ 'pass_no_userId' | translate }}</li>\n                                                <li>{{ 'pass_invalid_symbol' | translate }}</li>\n                                                <li>{{ 'pass_contains_firstname' | translate }}</li>\n                                                <li>{{ 'pass_contains_lastname' | translate }}</li>\n                                                <li>{{ 'pass_prevent_history' | translate }}</li>\n                                            </ul>\n                                        </div>\n                                    </div>\n                                    <div>\n                                        <small ng-message='required'>{{ passwordErrorMsg | translate }}</small>\n                                    </div>\n                                </div>\n                            </div>\n\n                        </div>\n                        <div class=\"col-md-4\">\n                            <md-input-container class=\"full-width\" md-is-error=\"RegistrationForm.hasError('mismatch')\">\n                                <input required mdInput type=\"password\" id=\"exampleConfirmPassword\" formControlName=\"confirmPassword\" placeholder=\"{{ 'Confirm Password' | translate }}\" >\n                            </md-input-container>\n                            <div *ngIf=\"UserForm.hasError('mismatch')\">\n                                <small ng-message='required'>{{ 'Password Mismatch' | translate }}</small>\n                            </div>\n                        </div>\n                        <div class=\"col-md-4 margin-top-10\">\n                            <md-select required formControlName=\"languageId\" placeholder=\"{{ 'Language' | translate }}\" class=\"full-width\">\n                                <md-option *ngFor=\"let languageId of LanguageDetails\" [value]=\"languageId.id\">\n                                    {{languageId.name}}\n                                </md-option>\n                            </md-select>\n                        </div>\n                    </div>\n                </div>\n\n\n                <div class=\"form-group\">\n                    <span>\n                        <button md-raised-button class=\"btn-w-md btn-w-xs button-gray-clr approve-reject\" [routerLink]=\"['/app/partners-dashboard']\">{{ 'Cancel' | translate }}</button>\n                    </span>\n                    <span class=\"space-xs\"></span>\n                    <span class=\"space-xs\"></span>\n                    <span>\n                        <button md-raised-button class=\"btn-w-md btn-w-xs approve-reject\" type=\"submit\" color=\"primary\" [disabled]=\"!UserForm.valid\">{{ 'Confirm' | translate }}</button>\n                    </span>\n                </div>\n            </fieldset>\n        </form>\n\n    </div>\n</div>"

/***/ }),

/***/ 1300:
/***/ (function(module, exports) {

module.exports = "<section class=\"container-fluid no-breadcrumbs\">\n    <div class=\"row margin-top-20\">\n        <div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 page-heading\" style=\"color: #2196f3;\">{{ 'Manage User' | translate }}</div>\n        <div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8\">\n            <span style=\"float:right\">\n                <button  md-raised-button class=\"btn-w-md approve-reject\" [routerLink]=\"['/app/partners-dashboard']\"><span class=\"btn-text\">{{ 'Back' | translate }}</span></button>\n            </span>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-xl-12 col-lg-12 col-md-12 col-sm-12\">\n            <div class=\"mdl-card mdl-shadow--2dp mdl-card-full-width select-overflow\">\n                <div class=\"card_title\">\n                    <h2 class=\"mdl-card__title-text\">{{ 'Add User' | translate }}</h2>\n                </div>\n                <router-outlet></router-outlet>\n            </div>\n        </div>\n    </div>\n</section>"

/***/ }),

/***/ 1301:
/***/ (function(module, exports) {

module.exports = "<div class=\"mdl-card mdl-card-full-width\" style=\"min-height: auto;\">\n    <div class=\"row\" style=\"padding-top:5px; padding-left: 14px; padding-right: 14px; padding-bottom: 13px;\">\n        <div class=\"col-md-12 margin-top-sm\">\n\n            <div *ngIf=\"action == 'changeEmail'\">\n                <h1 md-dialog-title class=\"margin-bottom-10\">{{ 'Change Email Address' | translate }}?</h1>\n                <form [formGroup]=\"EmailActionForm\">\n                    <fieldset formGroupName=\"emailGroup\">\n                        <div class=\" form-group margin-top-30 form-group\">\n                            <md-input-container class=\"full-width\">\n                                <input mdInput type=\"email\" placeholder=\"{{ 'Current Email Address' | translate }} *\" formControlName=\"currentEmailAddress\">\n                            </md-input-container>\n                        </div>\n                        <div class=\" form-group margin-top-30 form-group\">\n                            <md-input-container class=\"full-width\">\n                                <input mdInput type=\"email\" placeholder=\"{{ 'New Email Address' | translate }} *\" formControlName=\"email\">\n                            </md-input-container>\n                        </div>\n                        <div class=\" form-group margin-top-30 form-group\">\n                            <md-input-container class=\"full-width\">\n                                <input mdInput type=\"email\" placeholder=\"{{ 'Confirm Email Address' | translate }} *\" formControlName=\"confirmEmail\" appBlockCutCopyPaste>\n                            </md-input-container>\n                            <div *ngIf=\"EmailActionForm.get('emailGroup').hasError('mismatch')\">\n                                <small ng-message='required'>{{ 'Email Id Mismatch' | translate }}</small>\n                            </div>\n                        </div>\n\n                        <div md-dialog-actions style=\"padding-left: 16px; padding-right: 16px; padding-bottom:26px;\">\n                            <button md-raised-button class=\"btn-success text-white\" (click)=\"changeEmailAddress()\" [disabled]=\"!EmailActionForm.get('emailGroup').valid\">{{ 'Confirm' | translate }}</button>\n                            <span class=\"space-xs\"></span>\n                            <span class=\"space-xs\"></span>\n                            <span class=\"space-xs\"></span>\n                            <button md-raised-button (click)=\"dialogRef.close('Option 2')\">{{ 'Close' | translate }}</button>\n                        </div>\n                    </fieldset>\n                </form>\n            </div>\n\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ 1302:
/***/ (function(module, exports) {

module.exports = "<section class=\"container-fluid no-breadcrumbs\">\n    <div class=\"row margin-top-20\">\n        <div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 page-heading\" style=\"color: #2196f3;\">\n            <span style=\"color: #9e9ea3;font-weight: normal;\">{{ 'WPASS Id' | translate }}: </span> {{userId}}\n        </div>\n        <div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8\" style=\"float: right\">\n            <span *ngIf=\"isBUManager || isRegionalAdmin || isApplicationManager\" style=\"float: right\">\n                <button *ngIf=\"dynamicViewText == 'partnersView' || source == 'admin'\" md-raised-button class=\"btn-w-sm btn-w-md approve-reject\" [routerLink]=\"['/app/admin-dashboard']\"><span class=\"btn-text\">{{ 'Back' | translate }}</span></button>\n                <button *ngIf=\"source != 'admin' && dynamicViewText == 'subUsersView'\" md-raised-button class=\"btn-w-sm btn-w-md approve-reject\" [routerLink]=\"['/app/partners-dashboard', ownerId]\"><span class=\"btn-text\">{{ 'Back' | translate }}</span></button>\n                <!--<button *ngIf=\"dynamicViewText == 'applicationManagerView'\" md-raised-button class=\"btn-w-sm btn-w-md approve-reject\" [routerLink]=\"['/app/application-manager-dashboard', ownerId]\"><span class=\"btn-text\">{{ 'Back' | translate }}</span></button>-->\n                <span class=\"space-xs\"></span>\n                <span *ngIf=\"showApproveReject\">\n                    <approve-reject [childData]=data [dashboard]=dynamicViewText></approve-reject>\n                </span>\n            </span>\n\n            <span *ngIf=\"isServiceOwner || isTradePartner\" style=\"float: right\">\n                <button md-raised-button class=\"btn-w-sm btn-w-md approve-reject\" [routerLink]=\"['/app/partners-dashboard']\"><span class=\"btn-text\">{{ 'Back' | translate }}</span></button>\n                <span class=\"space-xs\"></span>\n                <button md-raised-button color=\"primary\" class=\"btn-w-md\" (click)=\"performAction('changeEmail')\">{{ 'Change Email' | translate }}</button>\n            </span>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12\">\n            <div class=\"mdl-card mdl-shadow--2dp mdl-card-full-width select-overflow\">\n                <div class=\"card_title\">\n                    <h2 class=\"mdl-card__title-text\">{{ 'User Information' | translate }}</h2>\n                </div>\n                <router-outlet></router-outlet>\n            </div>\n        </div>\n    </div>\n</section>"

/***/ }),

/***/ 1303:
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n    <div class=\"col-xl-12\">\n        <form [formGroup]=\"ApplicationsRequestForm\" (ngSubmit)=\"saveApplicationData()\" (keydown.enter)=\"$event.preventDefault()\">\n            <fieldset>\n                <div class=\"row form-group form-content\">\n                    <p class=\"col-md-12 font-size-18 usr-detail-page-p\"> {{ 'Personal Information' | translate }} </p>\n                    <div class=\"col-md-4\" *ngIf=\"ApplicationsRequestData && ApplicationsRequestData.userName\">\n                        <label>{{ 'First Name' | translate }}</label>\n                        <p *ngIf=\"ApplicationsRequestData\">{{ApplicationsRequestData.userName}}</p>\n                    </div>\n                    <div class=\"col-md-4\" *ngIf=\"ApplicationsRequestData && ApplicationsRequestData.userEmail\">\n                        <label>{{ 'Email' | translate }}</label>\n                        <p *ngIf=\"ApplicationsRequestData\">{{ApplicationsRequestData.userEmail}}</p>\n                    </div>\n                    <div class=\"col-md-4\">\n                        <label>{{ 'Country' | translate }}</label>\n                        <p *ngIf=\"ApplicationsRequestData\">{{ApplicationsRequestData.countryName | translate}}</p>\n                    </div>\n                </div>\n\n                <div class=\"dotted-divider\"></div>\n\n                <div class=\"row form-group form-content\">\n                    <p class=\"col-md-12 font-size-18 usr-detail-page-p\"> {{ 'Corporate Information' | translate }} </p>\n                    <div class=\"col-md-4\" *ngIf=\"ApplicationsRequestData && ApplicationsRequestData.businessUnitName\">\n                        <label>{{ 'Business Units' | translate }}</label>\n                        <p class=\"margin-bottom-1\" >{{ApplicationsRequestData.businessUnitName}}</p> <span class=\"font-size-16\"></span>\n                    </div>\n                    <div class=\"col-md-4\" *ngIf=\"ApplicationsRequestData && ApplicationsRequestData.customerNumber\">\n                        <label>{{ 'Customer Number' | translate }}</label>\n                        <p>{{ApplicationsRequestData.customerNumber}}</p>\n                    </div>\n                    <div class=\"col-md-4\">\n                        <label>{{ 'Status' | translate }}</label>\n                        <p *ngIf=\"ApplicationsRequestData\">{{ApplicationsRequestData.status | lowercase | translate}}</p>\n                    </div>\n                    <div class=\"col-md-4\" *ngIf=\"ApplicationsRequestData && ApplicationsRequestData.userId_WPASS\">\n                        <label>{{ 'WPASS User Id' | translate }}</label>\n                        <p class=\"margin-bottom-1\">{{ApplicationsRequestData.userId_WPASS}}</p> <span class=\"font-size-16\"></span>\n                    </div>\n                </div>\n\n                <div class=\"dotted-divider\"></div>\n\n                <div class=\"row form-group form-content\">\n                    <p class=\"col-md-12 font-size-18 usr-detail-page-p\"> {{ 'Applications Information' | translate }} </p>\n                    <div class=\"col-md-4\">\n                        <label>{{ 'Application Name' | translate }}</label>\n                        <p *ngIf=\"ApplicationsRequestData\">{{ApplicationsRequestData.applicationName}}</p>\n                    </div>\n                    <div class=\"col-md-4\" *ngIf=\"ApplicationsRequestData && ApplicationsRequestData.approverName\">\n                        <label>{{ 'Approver Name' | translate }}</label>\n                        <p *ngIf=\"ApplicationsRequestData\">{{ApplicationsRequestData.approverName}}</p>\n                    </div>\n                    <div [ngClass]=\"{'col-md-4': (ApplicationsRequestData && ApplicationsRequestData.approverName), 'col-md-2': (ApplicationsRequestData && !ApplicationsRequestData.approverName)}\">\n                        <label>{{ 'Created At' | translate }}</label>\n                        <p *ngIf=\"ApplicationsRequestData\">{{ApplicationsRequestData.createdAt}}</p>\n                    </div>\n                    <div class=\"col-md-10 margin-bottom-20 padding-r-45\" *ngIf=\"ApplicationsRequestData && ApplicationsRequestData.statusCode == 'REJECTED'\">\n                        <label>{{ 'Reject Reason' | translate }}</label>\n                        <div *ngIf=\"ApplicationsRequestData.message != ''\" class=\"callout-2 callout-danger-2\">\n                            <p>{{ApplicationsRequestData.message}}</p>\n                        </div>\n                    </div>\n                    <div class=\"col-md-6 margin-top-20 padding-r-45\" *ngIf=\"ApplicationsRequestData && ApplicationsRequestData.statusCode != 'REJECTED'\">\n                        <p class=\"partner-type-suggestion\" *ngIf=\"ApplicationsRequestData.partnerType && (!selectedItems || selectedItems.length==0)\">\n                            {{ 'BU manager suggested partner Type:' | translate }}&nbsp;<strong>{{ApplicationsRequestData.partnerType}}</strong>\n                        </p>\n                        <angular2-multiselect [data]=\"roles\" [(ngModel)]=\"selectedItems\"\n                                              [settings]=\"settings\" formControlName=\"selectedRoles\">\n                        </angular2-multiselect>\n                    </div>\n                </div>\n\n                <div  class=\"row form-group padding-r-l-admin-forms margin-top-15\">\n                    <div> \n                        <span>\n                            <button md-raised-button class=\"btn-w-md btn-w-xs button-gray-clr approve-reject\" type=\"button\" [routerLink]=\"['/app/application-manager-dashboard']\">{{ 'Cancel' | translate }}</button>\n                        </span>\n                        <span class=\"space-xs\"></span>\n                        <span class=\"space-xs\"></span>\n                        <span *ngIf=\"(ApplicationsRequestData && (ApplicationsRequestData.statusCode == 'APPROVED' || ApplicationsRequestData.statusCode == 'AUTO_APPROVED') && !isSystemAdmin)\">\n                            <button md-raised-button color=\"primary\" class=\"btn-w-md btn-w-xs approve-reject\" type=\"submit\">{{ 'Update' | translate }}</button>\n                        </span>\n                    </div>\n                    <span class=\"space-xs\"></span>\n                    <span class=\"space-xs\"></span>\n                    <span *ngIf=\"(ApplicationsRequestData && ApplicationsRequestData.statusCode == 'PENDING') && !isSystemAdmin\">\n                        <button  type=\"button\" [disabled]=showApproveButton (click)=\"appAction('APPROVED')\" md-raised-button color=\"accent\" class=\"btn-w-sm btn-w-md color-white font-size-13 approve-reject\"><span class=\"btn-text\">{{ 'APPROVE' | translate }}</span></button>\n                        <span class=\"space-xs\"></span>\n                        <button  type=\"button\" (click)=\"appAction('REJECTED')\"  md-raised-button class=\"btn-w-sm btn-w-md btn-red font-size-13 approve-reject\"><span class=\"btn-text\">{{ 'REJECT' | translate }}</span></button>\n                    </span>\n                </div>\n            </fieldset>\n        </form>\n    </div>\n</div>"

/***/ }),

/***/ 1304:
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n    <div class=\"col-xl-12\">\n        <form>\n            <div class=\"row form-group form-content\">\n                <p class=\"col-md-12 font-size-18 usr-detail-page-p\"> {{ 'Personal Information' | translate }} </p>\n                <div class=\"col-md-4\">\n                    <label>{{ 'First Name' | translate }}</label>\n                    <p *ngIf=\"formData\">{{formData.firstName}}</p>\n                </div>\n                <div class=\"col-md-4\">\n                    <label>{{ 'Last Name' | translate }}</label>\n                    <p *ngIf=\"formData\">{{formData.lastName}}</p>\n                </div>\n                <div class=\"col-md-4\">\n                    <label>{{ 'Email' | translate }}</label>\n                    <p>\n                        <span *ngIf=\"formData\">{{formData.email}}</span>\n                        <i *ngIf=\"!isEmailUpdating()\" class=\"fa fa-edit\" aria-hidden=\"true\" (click)=\"initUpdateEmail()\"></i>\n                        <br>\n                        <input id=\"newEmail\" *ngIf=\"isEmailUpdating()\" type=\"text\">\n                        <span class=\"update-btns\">\n                            <i *ngIf=\"isEmailUpdating()\" class=\"material-icons check-confirm\" (click)=\"updateEmail()\">check_circle</i>&nbsp;&nbsp;\n                            <i *ngIf=\"isEmailUpdating()\" class=\"material-icons cancel-update\" (click)=\"cancelUpdateEmail()\">highlight_off</i>\n                        </span>\n\n                    </p>\n                </div>\n                <div class=\"col-md-4\">\n                    <label>{{ 'Language' | translate }}</label>\n                    <p *ngIf=\"formData\">{{formData.languageName}}</p>\n                </div>\n                <div class=\"col-md-4\">\n                    <label>{{ 'Country' | translate }}</label>\n                    <p *ngIf=\"formData\">{{formData.countryName | translate}}</p>\n                </div>\n                <div class=\"col-md-4\">\n                    <label>{{ 'Role' | translate }}</label>\n                    <p *ngIf=\"formData\">{{formData.roleName}}</p>\n                </div>\n                <div class=\"col-md-4\">\n                    <label>{{ 'Status' | translate }}</label>\n                    <p *ngIf=\"formData\">{{formData.status | lowercase | translate}}</p>\n                </div>\n                <div class=\"col-md-4\" *ngIf=\"wPassIdFlag\">\n                    <label>{{ 'WPASS User Id' | translate }}</label>\n                    <p class=\"margin-bottom-1\">{{formData.userId_WPASS}}</p> <span class=\"font-size-16\"></span>\n                </div>\n                <div class=\"col-md-4\" *ngIf=\"ownerFlag\">\n                    <label>ESRP Owner Id</label>\n                    <p class=\"margin-bottom-1\">{{formData.ownerWpassId}}</p> <span class=\"font-size-16\"></span>\n                </div>\n            </div>\n\n            <div class=\"dotted-divider\"></div>\n\n            <div class=\"row form-group form-content\">\n                <p class=\"col-md-12 font-size-18 usr-detail-page-p\"> {{ 'Corporate Information' | translate }} </p>\n\n                <div class=\"col-md-4\">\n                    <label>{{ 'Request Submission Date' | translate }}</label>\n                    <p *ngIf=\"formData\">{{formData.createdAt}}</p>\n                </div>\n                <div class=\"col-md-4\" *ngIf=\"wPassIdFlag\">\n                    <label>{{ 'UserId Creation Date' | translate }}</label>\n                    <p *ngIf=\"formData\">{{formData.wpassCreatedAt}}</p>\n                </div>\n                <div class=\"col-md-4\" *ngIf=\"wPassIdFlag\">\n                    <!--<label>{{ 'Valid Till' | translate }}</label>\n                    <p *ngIf=\"formData\">{{formData.validTill}}</p>-->\n                </div>\n                <div class=\"col-md-4\">\n                    <label>{{ 'Company Name' | translate }}</label>\n                    <p *ngIf=\"formData\">{{formData.companyName}}</p>\n                </div>\n                <div class=\"col-md-4\" *ngIf=\"companyPhoneFlag\">\n                    <label>{{ 'Company Phone' | translate }}</label>\n                    <p *ngIf=\"formData\">{{formData.companyPhone}}</p>\n                </div>\n                <div class=\"col-md-4\">\n                    <label>{{ 'Company Address' | translate }}</label>\n                    <p *ngIf=\"formData\">{{formData.companyAddress}}</p>\n                </div>\n            </div>\n\n            <div class=\"dotted-divider\"></div>\n            <div class=\"row form-group form-content\">\n                <p class=\"col-md-12 font-size-18 usr-detail-page-p\"> {{ 'Business Unit Information' | translate }} </p>\n\n                <div class=\"col-md-12\" style=\"padding: 20px 45px 0px 15px; !important;\">\n                    <div class=\"box box-default table-box table-responsive mdl-shadow--2dp\">\n                        <table class=\"mdl-data-table font-size-14\" *ngIf=\"businessUnitWithAppRoles.length > 0\">\n                            <thead class=\"responsive-table-header-backgroud\">\n                            <tr>\n                                <th class=\"mdl-data-table__cell--non-numeric\" style=\"text-align: left!important;\">#</th>\n                                <th class=\"mdl-data-table__cell--non-numeric\">{{'Application Name' | translate }}</th>\n                                <th class=\"mdl-data-table__cell--non-numeric\">{{'Business Unit' | translate }}</th>\n                                <th class=\"mdl-data-table__cell--non-numeric\">\n                                    <div>\n                                        <span style=\"vertical-align:bottom;\">{{'Customer Number' | translate }}</span>&nbsp;\n                                        <md-checkbox [checked]=\"allCustomerNumberChecked\" (change)=\"toggleAllCustomerNumberCheck()\"></md-checkbox>\n                                    </div>\n                                </th>\n                                <th class=\"mdl-data-table__cell--non-numeric\">{{'Status' | translate }}</th>\n                                <th class=\"mdl-data-table__cell--non-numeric\">{{'Role' | translate }}</th>\n                            </tr>\n                            </thead>\n\n                            <tbody>\n                            <tr *ngFor=\"let appData of businessUnitWithAppRoles, let i = index\">\n                                <td class=\"mdl-data-table__cell--non-numeric\">{{i + 1}}</td>\n                                <td class=\"mdl-data-table__cell--non-numeric\">\n                                    <a *ngIf=\"appData.url\" target=\"_blank\" href={{appData.url}}><i class=\"material-icons\"> near_me </i></a>\n                                    {{appData.applicationName}}\n                                </td>\n                                <td class=\"mdl-data-table__cell--non-numeric\">{{appData.businessUnitName}}</td>\n                                <td class=\"mdl-data-table__cell--non-numeric\">\n                                    <span *ngIf=\"!customerNumberUpdating(appData.buAppId)\">{{appData.customerNumber}}</span>\n                                    <input id=\"cn-{{appData.buAppId}}\" *ngIf=\"customerNumberUpdating(appData.buAppId)\" type=\"text\">\n                                    &nbsp;&nbsp;\n                                    <i *ngIf=\"!customerNumberUpdating(appData.buAppId)\" class=\"fa fa-edit\" aria-hidden=\"true\" (click)=\"initUpdateCustomerNumber(appData.buAppId)\"></i>\n                                    <span class=\"update-btns\">\n                                        <i *ngIf=\"customerNumberUpdating(appData.buAppId)\" class=\"material-icons check-confirm\" (click)=\"updateCustomerNumber(appData.buAppId)\">check_circle</i>&nbsp;&nbsp;\n                                        <i *ngIf=\"customerNumberUpdating(appData.buAppId)\" class=\"material-icons cancel-update\" (click)=\"cancelUpdateCustomerNumber(appData.buAppId)\">highlight_off</i>\n                                    </span>\n                                </td>\n                                <td class=\"mdl-data-table__cell--non-numeric\" *ngIf=\"appData.statusCode == 'AUTO_APPROVED' || appData.statusCode == 'APPROVED'\"\n                                    style=\"color: green\">{{appData.status | lowercase | translate}}\n                                </td>\n                                <td class=\"mdl-data-table__cell--non-numeric\" *ngIf=\"appData.statusCode == 'PENDING'\"\n                                    style=\"color: orange\">{{appData.status | lowercase | translate}}\n                                </td>\n                                <td class=\"mdl-data-table__cell--non-numeric\" *ngIf=\"appData.statusCode == 'REJECTED' || appData.statusCode == 'REVOKED'\"\n                                    style=\"color: red\">{{appData.status | lowercase | translate}}\n                                </td>\n                                <td class=\"mdl-data-table__cell--non-numeric\">{{appData.selectedRoleNames}}</td>\n                                <!--<td class=\"mdl-data-table__cell&#45;&#45;non-numeric color-blue cursor-pointer\" (click)=\"showApplicationsWithRoles(appData.applications)\">View</td>-->\n                            </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n            </div>\n\n        </form>\n\n    </div>\n</div>"

/***/ }),

/***/ 1305:
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n    <div class=\"col-xl-12\">\n        <form>\n            <div class=\"row form-group form-content\">\n                <p class=\"col-md-12 font-size-18 usr-detail-page-p\">{{ 'Personal Information' | translate }} </p>\n                <div class=\"col-md-4\">\n                    <label>{{ 'First Name' | translate }}</label>\n                    <p *ngIf=\"formData\">{{formData.firstName}}</p>\n                </div>\n                <div class=\"col-md-4\">\n                    <label>{{ 'Last Name' | translate }}</label>\n                    <p *ngIf=\"formData\">{{formData.lastName}}</p>\n                </div>\n                <div class=\"col-md-4\">\n                    <label>{{ 'Email' | translate }}</label>\n                    <p>\n                        <span *ngIf=\"formData\">{{formData.email}}</span>\n                        <i *ngIf=\"!isEmailUpdating()\" class=\"fa fa-edit\" aria-hidden=\"true\" (click)=\"initUpdateEmail()\"></i>\n                        <br>\n                        <input id=\"newEmail\" *ngIf=\"isEmailUpdating()\" type=\"text\">\n                        <span class=\"update-btns\">\n                            <i *ngIf=\"isEmailUpdating()\" class=\"material-icons check-confirm\" (click)=\"updateEmail()\">check_circle</i>\n                            <i *ngIf=\"isEmailUpdating()\" class=\"material-icons cancel-update\" (click)=\"cancelUpdateEmail()\">highlight_off</i>\n                        </span>\n                    </p>\n                </div>\n                <div class=\"col-md-4\">\n                    <label>{{ 'Language' | translate }}</label>\n                    <p *ngIf=\"formData\">{{formData.languageName}}</p>\n                </div>\n                <div class=\"col-md-4\">\n                    <label>{{ 'Country' | translate }}</label>\n                    <p *ngIf=\"formData\">{{formData.countryName | translate}}</p>\n                </div>\n                <div class=\"col-md-4\">\n                    <label>{{ 'Role' | translate }}</label>\n                    <p *ngIf=\"formData\">{{formData.roleName}}</p>\n                </div>\n                <div class=\"col-md-4\">\n                    <label>{{ 'Status' | translate }}</label>\n                    <p *ngIf=\"formData\">{{formData.status}}</p>\n                </div>\n                <div class=\"col-md-4\" *ngIf=\"wPassIdFlag\">\n                    <label>{{ 'WPASS User Id' | translate }}</label>\n                    <p class=\"margin-bottom-1\">{{formData.userId_WPASS}}</p> <span class=\"font-size-16\"></span>\n                </div>\n                <div class=\"col-md-4\" *ngIf=\"ownerFlag\">\n                    <label>ESRP Owner Id</label>\n                    <p *ngIf=\"formData\">{{formData.ownerWpassId}}</p>\n                </div>\n            </div>\n\n            <div class=\"dotted-divider\"></div>\n\n            <div class=\"row form-group form-content\">\n                <p class=\"col-md-12 font-size-18 usr-detail-page-p\"> {{ 'Corporate Information' | translate }} </p>\n                <div class=\"col-md-4\">\n                    <label>{{ 'Added on' | translate }}</label>\n                    <p *ngIf=\"formData\">{{formData.createdAt}}</p>\n                </div>\n                <div class=\"col-md-4\" *ngIf=\"wPassIdFlag\">\n                    <label>{{ 'UserId Creation Date' | translate }}</label>\n                    <p *ngIf=\"formData\">{{formData.wpassCreatedAt}}</p>\n                </div>\n            </div>\n\n            <div class=\"dotted-divider\"></div>\n\n            <div class=\"row form-group form-content\">\n                <p class=\"col-md-12 font-size-18 usr-detail-page-p\"> {{ 'Business Unit Information' | translate }} </p>\n\n                <div class=\"col-md-12\" style=\"padding: 20px 45px 0px 15px; !important;\">\n                    <div class=\"box box-default table-box table-responsive mdl-shadow--2dp\">\n                        <table class=\"mdl-data-table font-size-14\" *ngIf=\"businessUnitWithAppRolesSubPartner.length > 0\">\n                            <thead class=\"responsive-table-header-backgroud\">\n                            <tr>\n                                <th class=\"mdl-data-table__cell--non-numeric\" style=\"text-align: left!important;\">#</th>\n                                <th class=\"mdl-data-table__cell--non-numeric\">{{'Application Name' | translate }}</th>\n                                <th class=\"mdl-data-table__cell--non-numeric\">{{'Business Unit' | translate }}</th>\n                                <th class=\"mdl-data-table__cell--non-numeric\">{{'Customer Number' | translate }}</th>\n                                <th class=\"mdl-data-table__cell--non-numeric\">{{'Status' | translate }}</th>\n                                <th class=\"mdl-data-table__cell--non-numeric\">{{'Role' | translate }}</th>\n                            </tr>\n                            </thead>\n\n                            <tbody>\n                            <tr *ngFor=\"let appData of businessUnitWithAppRolesSubPartner, let i = index\">\n                                <td class=\"mdl-data-table__cell--non-numeric\">{{i + 1}}</td>\n                                <td class=\"mdl-data-table__cell--non-numeric\">\n                                    <a *ngIf=\"appData.url\" target=\"_blank\" href={{appData.url}}><i class=\"material-icons\"> near_me </i></a>\n                                    {{appData.applicationName}}\n                                </td>\n                                <td class=\"mdl-data-table__cell--non-numeric\">{{appData.businessUnitName}}</td>\n                                <td class=\"mdl-data-table__cell--non-numeric\">{{appData.customerNumber}}</td>\n                                <td class=\"mdl-data-table__cell--non-numeric\" *ngIf=\"appData.statusCode == 'AUTO_APPROVED' || appData.statusCode == 'APPROVED'\"\n                                    style=\"color: green\">{{appData.status}}\n                                </td>\n                                <td class=\"mdl-data-table__cell--non-numeric\" *ngIf=\"appData.statusCode == 'PENDING'\"\n                                    style=\"color: orange\">{{appData.status}}\n                                </td>\n                                <td class=\"mdl-data-table__cell--non-numeric\" *ngIf=\"appData.statusCode == 'REJECTED' || appData.statusCode == 'REVOKED'\"\n                                    style=\"color: red\">{{appData.status}}\n                                </td>\n                                <td class=\"mdl-data-table__cell--non-numeric\">{{appData.selectedRoleNames}}</td>\n                                <!--<td class=\"mdl-data-table__cell&#45;&#45;non-numeric color-blue cursor-pointer\" (click)=\"showApplicationsWithRoles(appData.applications)\">View</td>-->\n                            </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n\n                <!--<div class=\"col-md-12\" style=\"padding: 20px 45px 0px 15px; !important;\">\n                    <div class=\"box box-default table-box table-responsive mdl-shadow&#45;&#45;2dp\">\n                        <table class=\"mdl-data-table font-size-14\">\n                            <thead class=\"responsive-table-header-backgroud\">\n                            <tr>\n                                <th class=\"mdl-data-table__cell&#45;&#45;non-numeric\" style=\"text-align: left!important;\">#</th>\n                                <th class=\"mdl-data-table__cell&#45;&#45;non-numeric\">Business Unit</th>\n                                <th class=\"mdl-data-table__cell&#45;&#45;non-numeric\">Customer Number</th>\n                                <th class=\"mdl-data-table__cell&#45;&#45;non-numeric\">Status</th>\n                                <th class=\"mdl-data-table__cell&#45;&#45;non-numeric\">Message</th>\n                                <th class=\"mdl-data-table__cell&#45;&#45;non-numeric\">Applications</th>\n                            </tr>\n                            </thead>\n\n                            <tbody>\n                            <tr *ngFor=\"let data of businessUnitWithApplicationAndRoles, let i = index\">\n                                <td class=\"mdl-data-table__cell&#45;&#45;non-numeric\">{{i + 1}}</td>\n                                <td class=\"mdl-data-table__cell&#45;&#45;non-numeric\">{{data.businessUnitName}}</td>\n                                <td class=\"mdl-data-table__cell&#45;&#45;non-numeric\">{{data.customerNumber}}</td>\n                                <td class=\"mdl-data-table__cell&#45;&#45;non-numeric\" *ngIf=\"data.status == 'Pending'\"\n                                    style=\"color: orange\">{{data.status}}\n                                </td>\n                                <td class=\"mdl-data-table__cell&#45;&#45;non-numeric\" *ngIf=\"data.status == 'Approved'\"\n                                    style=\"color: green\">{{data.status}}\n                                </td>\n                                <td class=\"mdl-data-table__cell&#45;&#45;non-numeric\" *ngIf=\"data.status == 'Rejected'\"\n                                    style=\"color: red\">{{data.status}}\n                                </td>\n                                <td class=\"mdl-data-table__cell&#45;&#45;non-numeric\">{{data.message}}</td>\n\n                                <td class=\"mdl-data-table__cell&#45;&#45;non-numeric color-blue cursor-pointer\" (click)=\"showApplicationsWithRoles(data.applications)\">View</td>\n                            </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>-->\n            </div>\n\n        </form>\n\n    </div>\n</div>"

/***/ }),

/***/ 132:
/***/ (function(module, exports) {

module.exports = ".datePicker {\n  float: left;\n  width: 30%; }\n\n::ng-deep .custom-field-class ng2-input-autocomplete {\n  overflow-wrap: break-word; }\n\n::ng-deep .custom-textfield-class ng2-input-autocomplete {\n  overflow-wrap: break-word; }\n\n::ng-deep .custom-md-table * {\n  height: auto !important; }\n\n::ng-deep .custom-md-table datatable-body-row {\n  height: auto !important; }\n\n::ng-deep .custom-md-table .datatable-body-cell {\n  white-space: normal !important;\n  overflow: visible !important;\n  height: auto !important;\n  line-height: 1.3 !important; }\n\n::ng-deep .custom-md-table .datatable-body-cell-label span {\n  white-space: normal !important;\n  overflow: visible !important; }\n\n::ng-deep .autocomplete ::-webkit-input-placeholder {\n  color: transparent; }\n\n::ng-deep .margin-tag {\n  margin-top: 15px; }\n\n::ng-deep .filter-select {\n  float: left;\n  margin-top: -16px !important;\n  margin-bottom: 19px; }\n\n::ng-deep textarea {\n  resize: none; }\n\n::ng-deep .f-s-18 {\n  font-size: 18px; }\n\n::ng-deep .m-l-20 {\n  margin-left: 21px; }\n\n/*Vertical Tabs*/\n.mdl-tabs__panel {\n  display: none; }\n\n.vertical-mdl-tabs .mdl-tabs__tab-bar {\n  -ms-flex-direction: column;\n  flex-direction: column;\n  height: inherit;\n  border-bottom: none; }\n\n.vertical-mdl-tabs .mdl-tabs__tab {\n  width: 100%;\n  height: auto;\n  line-height: 20px;\n  box-sizing: border-box;\n  letter-spacing: 0px;\n  overflow: visible !important;\n  border-bottom: 1px solid #b9c7d2;\n  padding: 8px;\n  cursor: pointer; }\n\n.md-pad {\n  padding-left: 5px; }\n\n.containerEditor {\n  background-color: #fff;\n  padding: 0px; }\n\n.vertical-mdl-tabs .mdl-tabs__tab:hover {\n  background: rgba(158, 158, 158, 0.34);\n  color: black; }\n\n.left-css {\n  background-color: #2d3440 !important;\n  color: #fbfafa !important;\n  border-radius: 4px !important; }\n\n.style1 {\n  background-color: #49b1ef;\n  border-top-right-radius: 50px;\n  border-bottom-right-radius: 50px;\n  width: 100%;\n  height: auto;\n  line-height: 20px;\n  box-sizing: border-box;\n  letter-spacing: 0px;\n  overflow: visible !important;\n  border-bottom: 0px solid #b9c7d2;\n  padding: 8px;\n  cursor: pointer; }\n\n.style2 {\n  width: 100%;\n  height: auto;\n  line-height: 20px;\n  box-sizing: border-box;\n  letter-spacing: 0px;\n  overflow: visible !important;\n  border-bottom: 1px solid #b9c7d2;\n  padding: 8px;\n  cursor: pointer;\n  background: #d4dee9d6 !important; }\n\n.vertical-mdl-tabs.mdl-tabs.is-upgraded a.mdl-tabs__tab.is-active:active {\n  border-right: 3px solid #ED462F; }\n\n.vertical-mdl-tabs.mdl-tabs.is-upgraded .mdl-tabs__tab.is-active:after {\n  content: inherit;\n  height: 0; }\n\n.vertical-mdl-tabs.mdl-tabs.is-upgraded .mdl-tabs__panel.is-active, .mdl-tabs__panel {\n  padding: 0 30px; }\n\n.vertical-mdl-tabs.mdl-tabs .mdl-tabs__tab {\n  text-align: left; }\n\n.text-center {\n  text-align: center; }\n\n.mdl-tabs.is-upgraded .mdl-tabs__tab.is-active {\n  color: #E21549; }\n\n.ckeEditor-1 {\n  width: 100%;\n  margin-bottom: 15px; }\n\n.ckeEditor-2 {\n  width: 100%;\n  margin-bottom: 15px; }\n\n.p-l-16 {\n  padding-left: 16px; }\n\n.m-0 {\n  margin: 0px !important; }\n\n.m-l.40 {\n  margin-left: -40px; }\n\n::ng-deep .custom-field-class input {\n  height: 35px !important;\n  border-radius: 3px !important;\n  border: 1px solid #ccc !important;\n  padding: 10px;\n  width: 100%;\n  max-width: 174px; }\n\n::ng-deep .custom-textfield-class input {\n  height: 35px !important;\n  border-radius: 3px !important;\n  border: 1px solid #ccc !important;\n  padding: 10px;\n  width: 100%; }\n\n::ng-deep .data-loading + ng2-input-autocomplete .autocomplete input {\n  background-color: #ffffff;\n  background-image: url(\"../assets/images/autocomplete-loader.gif\");\n  background-size: 18px 18px;\n  background-position: 96% 50%;\n  background-repeat: no-repeat; }\n\n::ng-deep .Data-Search + ng2-input-autocomplete .autocomplete ul {\n  height: 200px !important;\n  padding: 10px !important;\n  overflow-y: auto; }\n\n::ng-deep .Data-Search + ng2-input-autocomplete .autocomplete ul li {\n  cursor: pointer !important;\n  border-bottom: 0.5px solid #d4d4d4 !important; }\n\n::ng-deep .table-filter-box {\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  width: 100%;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-flow: wrap;\n      flex-flow: wrap; }\n  ::ng-deep .table-filter-box > .datepicker-custom {\n    min-width: 180px;\n    max-width: 100%; }\n    ::ng-deep .table-filter-box > .datepicker-custom button {\n      height: 90%; }\n  ::ng-deep .table-filter-box > div {\n    margin-right: 15px;\n    margin-bottom: 10px; }\n    ::ng-deep .table-filter-box > div:last-child {\n      margin-right: auto !important; }\n\n@media (max-width: 767px) {\n  ::ng-deep .action-btn-group {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-flow: wrap;\n        flex-flow: wrap;\n    -ms-flex-direction: row;\n        flex-direction: row; }\n    ::ng-deep .action-btn-group > .action-btn {\n      width: auto !important;\n      margin-bottom: 10px; }\n  ::ng-deep .table-filter-box {\n    -ms-flex-direction: column !important;\n        flex-direction: column !important; }\n    ::ng-deep .table-filter-box > div {\n      width: 100%; }\n    ::ng-deep .table-filter-box input {\n      width: 100% !important;\n      margin-bottom: 10px !important; } }\n"

/***/ }),

/***/ 148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActivateDeactivateModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_http__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_common__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__activate_deactivate_request_activate_deactivate_component__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ng2_translate__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(12);
/**
 * Created by shubham on 22/5/18.
 */









var ActivateDeactivateModule = /** @class */ (function () {
    function ActivateDeactivateModule() {
    }
    ActivateDeactivateModule = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
            imports: [
                __WEBPACK_IMPORTED_MODULE_2__angular_material__["a" /* MaterialModule */],
                __WEBPACK_IMPORTED_MODULE_2__angular_material__["e" /* MdTabsModule */],
                __WEBPACK_IMPORTED_MODULE_5__angular_common__["CommonModule"],
                __WEBPACK_IMPORTED_MODULE_4__angular_forms__["a" /* FormsModule */],
                __WEBPACK_IMPORTED_MODULE_4__angular_forms__["b" /* ReactiveFormsModule */],
                __WEBPACK_IMPORTED_MODULE_7_ng2_translate__["b" /* TranslateModule */].forRoot({
                    provide: __WEBPACK_IMPORTED_MODULE_7_ng2_translate__["c" /* TranslateLoader */],
                    //useFactory: (http: Http) => new TranslateStaticLoader(http, '/assets/i18n', '.json'),
                    useFactory: function (http) { return new __WEBPACK_IMPORTED_MODULE_7_ng2_translate__["a" /* TranslateStaticLoader */](http, __WEBPACK_IMPORTED_MODULE_8__config__["a" /* APPCONFIG */].URL + __WEBPACK_IMPORTED_MODULE_8__config__["a" /* APPCONFIG */].translationUrl, '?v=' + __WEBPACK_IMPORTED_MODULE_8__config__["a" /* APPCONFIG */].translationVersion); },
                    deps: [__WEBPACK_IMPORTED_MODULE_3__angular_http__["b" /* Http */]]
                })
            ],
            declarations: [
                __WEBPACK_IMPORTED_MODULE_6__activate_deactivate_request_activate_deactivate_component__["a" /* ActivateDeactivateComponent */]
            ],
            exports: [
                __WEBPACK_IMPORTED_MODULE_6__activate_deactivate_request_activate_deactivate_component__["a" /* ActivateDeactivateComponent */],
            ]
        })
    ], ActivateDeactivateModule);
    return ActivateDeactivateModule;
}());



/***/ }),

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HttpService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_http__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_catch__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_catch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_catch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__error_handler_service__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_Rx__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_Rx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_Rx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loader_loader_service__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dialog_dialog_component__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ng2_translate__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_services_common_service__ = __webpack_require__(24);
/**
 * Created by shubham on 27/2/18.
 */















var HttpService = /** @class */ (function () {
    function HttpService(http, router, LoaderService, dialog, sessionHandler, errorHandler, translate, commonService) {
        this.http = http;
        this.router = router;
        this.LoaderService = LoaderService;
        this.dialog = dialog;
        this.sessionHandler = sessionHandler;
        this.errorHandler = errorHandler;
        this.translate = translate;
        this.commonService = commonService;
        this.url = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].URL + "/_ah/api";
        this.headers = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["c" /* Headers */]({ 'Content-Type': 'application/json', 'apiKey': '' });
    }
    HttpService.prototype.getRequestWithoutAuth = function (url, showLoader) {
        var _this = this;
        if (showLoader) {
            this.showLoader();
        }
        var headers;
        headers = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["c" /* Headers */]({ 'Content-Type': 'application/json', 'apiKey': __WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].apiKey });
        return this.http.get(this.url + "/" + url, { headers: headers })
            .map(function (res) { return _this.errorCheckFunction(res.json(), url); })
            .catch(function (error) { return __WEBPACK_IMPORTED_MODULE_8_rxjs_Rx__["Observable"].throw(_this.handleError(error.json(), url)); });
    };
    HttpService.prototype.getRequestWithoutLoader = function (url) {
        var _this = this;
        this.sessionHandler.saveItem("timestamp", Math.round(new Date().getTime() / 1000.0));
        var loginDataArray = JSON.parse(this.sessionHandler.getItem("loginData"));
        var headers;
        var accessToken;
        if (loginDataArray) {
            accessToken = loginDataArray['accessToken'];
        }
        headers = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["c" /* Headers */]({ 'Content-Type': 'application/json', 'apiKey': __WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].apiKey, 'access-token': accessToken });
        return this.http.get(this.url + "/" + url, { headers: headers })
            .map(function (res) { return _this.errorCheckFunction(res.json(), url); })
            .catch(function (error) { return __WEBPACK_IMPORTED_MODULE_8_rxjs_Rx__["Observable"].throw(_this.handleError(error.json(), url)); });
    };
    HttpService.prototype.getRequest = function (url) {
        var _this = this;
        this.sessionHandler.saveItem("timestamp", Math.round(new Date().getTime() / 1000.0));
        this.showLoader();
        var loginDataArray = JSON.parse(this.sessionHandler.getItem("loginData"));
        var headers;
        var accessToken;
        if (loginDataArray) {
            accessToken = loginDataArray['accessToken'];
        }
        headers = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["c" /* Headers */]({ 'Content-Type': 'application/json', 'apiKey': __WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].apiKey, 'access-token': accessToken });
        return this.http.get(this.url + "/" + url, { headers: headers })
            .map(function (res) { return _this.errorCheckFunction(res.json(), url); })
            .catch(function (error) { return __WEBPACK_IMPORTED_MODULE_8_rxjs_Rx__["Observable"].throw(_this.handleError(error.json(), url)); });
    };
    HttpService.prototype.getRequestForAutocomplete = function (url) {
        var _this = this;
        this.sessionHandler.saveItem("timestamp", Math.round(new Date().getTime() / 1000.0));
        var loginDataArray = JSON.parse(this.sessionHandler.getItem("loginData"));
        var accessToken;
        var headers;
        if (loginDataArray) {
            accessToken = loginDataArray['accessToken'];
        }
        headers = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["c" /* Headers */]({ 'Content-Type': 'application/json', 'apiKey': __WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].apiKey, 'access-token': accessToken });
        return this.http.get(this.url + "/" + url, { headers: headers })
            .map(function (res) { return _this.errorCheckFunction(res.json(), url); })
            .catch(function (error) { return __WEBPACK_IMPORTED_MODULE_8_rxjs_Rx__["Observable"].throw(_this.handleError(error.json(), url)); });
    };
    HttpService.prototype.postRequest = function (body, api) {
        var _this = this;
        this.sessionHandler.saveItem("timestamp", Math.round(new Date().getTime() / 1000.0));
        this.showLoader();
        var loginDataArray = JSON.parse(this.sessionHandler.getItem("loginData"));
        var accessToken;
        var headers;
        if (loginDataArray) {
            accessToken = loginDataArray['accessToken'];
        }
        var bodyString = JSON.stringify(body);
        if (api == 'userOperationsApi/v1/digiAccessLogin' || api == 'userOperationsApi/v1/googleLogin' || api == 'userRegistrationsApi/v1/register/serviceOwner') {
            headers = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["c" /* Headers */]({ 'Content-Type': 'application/json', 'apiKey': __WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].apiKey });
        }
        else {
            headers = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["c" /* Headers */]({ 'Content-Type': 'application/json', 'apiKey': __WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].apiKey, 'access-token': accessToken });
        }
        var options = new __WEBPACK_IMPORTED_MODULE_2__angular_http__["d" /* RequestOptions */]({ headers: headers });
        return this.http.post(this.url + "/" + api, body, options)
            .map(function (res) { return _this.errorCheckFunction(res.json(), api); })
            .catch(function (error) { return __WEBPACK_IMPORTED_MODULE_8_rxjs_Rx__["Observable"].throw(_this.handleError(error.json(), api)); });
    };
    HttpService.prototype.noUserError = function () {
        localStorage.clear();
        //this.commonService.setLoginRedirectUrl(window.location.hash);
        this.router.navigateByUrl('/login');
        this.onEnd();
    };
    HttpService.prototype.onEnd = function () {
        this.hideLoader();
    };
    HttpService.prototype.showLoader = function () {
        this.LoaderService.show();
    };
    HttpService.prototype.hideLoader = function () {
        this.LoaderService.hide();
    };
    HttpService.prototype.handleError = function (e, api) {
        var _this = this;
        var errorJson = e;
        if (errorJson.error && (api == 'userOperationsApi/v1/googleLogin' || api == 'userOperationsApi/v1/digiAccessLogin')) {
            var msg = errorJson.error.message;
            this.translate.get(msg).subscribe(function (res) {
                alert(res);
            });
            /*this.dialogRef = this.dialog.open(DialogComponent);
             this.dialogRef.componentInstance.msg = errorJson.error.message;*/
        }
        else if (errorJson.error && (api != 'userOperationsApi/v1/googleLogin' && api != 'userOperationsApi/v1/digiAccessLogin')) {
            if (errorJson.error.code != 400 && errorJson.error.code != 412 && errorJson.error.code != 503) {
                this.errorHandler.handle(errorJson);
            }
            else if (errorJson.error.code == 412 || errorJson.error.code == 503) {
                this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_11__dialog_dialog_component__["a" /* DialogComponent */], { disableClose: true });
                this.dialogRef.componentInstance.msg = "Something_went_wrong";
            }
            else {
                this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_11__dialog_dialog_component__["a" /* DialogComponent */], { disableClose: true });
                this.dialogRef.componentInstance.msg = errorJson.error.message;
                if (errorJson.error.message == 'INVITATION_USED') {
                    this.dialogRef.afterClosed().subscribe(function (result) {
                        _this.router.navigateByUrl('/login');
                    });
                }
            }
        }
        this.hideLoader();
        return false;
    };
    HttpService.prototype.errorCheckFunction = function (jsonResult, api) {
        return jsonResult;
    };
    HttpService = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_http__["b" /* Http */], __WEBPACK_IMPORTED_MODULE_12__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_10__loader_loader_service__["a" /* LoaderService */], __WEBPACK_IMPORTED_MODULE_9__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_5__session_handler_service__["a" /* SessionHandler */],
            __WEBPACK_IMPORTED_MODULE_6__error_handler_service__["a" /* ErrorHandler */], __WEBPACK_IMPORTED_MODULE_13_ng2_translate__["d" /* TranslateService */], __WEBPACK_IMPORTED_MODULE_14__shared_services_common_service__["a" /* CommonService */]])
    ], HttpService);
    return HttpService;
}());



/***/ }),

/***/ 16:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SessionHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/**
 * Created by shubham on 27/2/18.
 */


var SessionHandler = /** @class */ (function () {
    function SessionHandler() {
    }
    SessionHandler.prototype.saveItem = function (key, value) {
        localStorage.setItem(key, value);
    };
    SessionHandler.prototype.getItem = function (key) {
        ;
        return localStorage.getItem(key);
    };
    SessionHandler.prototype.removeItem = function (key) {
        localStorage.removeItem(key);
    };
    SessionHandler.prototype.clearAllItems = function () {
        localStorage.clear();
    };
    SessionHandler.prototype.setRedirectionUrl = function (prevUrl) {
        this.prevUrl = prevUrl;
    };
    SessionHandler.prototype.getRedirectionUrl = function () {
        return this.prevUrl;
    };
    SessionHandler = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [])
    ], SessionHandler);
    return SessionHandler;
}());



/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayoutComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);


var LayoutComponent = /** @class */ (function () {
    function LayoutComponent() {
    }
    LayoutComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'my-app-layout',
            template: __webpack_require__(1267),
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [])
    ], LayoutComponent);
    return LayoutComponent;
}());



/***/ }),

/***/ 196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoaderService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__);
/**
 * Created by shubham on 27/2/18.
 */



var LoaderService = /** @class */ (function () {
    function LoaderService() {
        this.loaderSubject = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
        this.loaderState = this.loaderSubject.asObservable();
    }
    LoaderService.prototype.show = function () {
        this.loaderSubject.next({ show: true });
    };
    LoaderService.prototype.hide = function () {
        this.loaderSubject.next({ show: false });
    };
    LoaderService = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [])
    ], LoaderService);
    return LoaderService;
}());



/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProfileComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EmailPasswordActionDialogComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ng2_translate__ = __webpack_require__(17);
/**
 * Created by shubham on 20/4/18.
 */









var ProfileComponent = /** @class */ (function () {
    function ProfileComponent(dialog, httpService, sessionHandler, formBuilder, translate) {
        this.dialog = dialog;
        this.httpService = httpService;
        this.sessionHandler = sessionHandler;
        this.formBuilder = formBuilder;
        this.translate = translate;
        this.isSystemAdmin = false;
        this.isBUManager = false;
        this.isApplicationManager = false;
        this.isRegionalAdmin = false;
        this.isServiceOwner = false;
        this.isTradePartner = false;
        this.isSubUser = false;
        this.businessUnitsFlag = false;
        this.businessUnitWithApplicationAndRoles = [];
        this.businessUnitWithAppRolesProfile = [];
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* APPCONFIG */].systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* APPCONFIG */].BUManager)) {
                this.isBUManager = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* APPCONFIG */].applicationManager)) {
                this.isApplicationManager = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* APPCONFIG */].regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* APPCONFIG */].serviceOwner)) {
                this.isServiceOwner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* APPCONFIG */].tradePartner)) {
                this.isTradePartner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* APPCONFIG */].subuser)) {
                this.isSubUser = true;
            }
        }
        else {
            this.httpService.noUserError();
        }
        //Close Sidebar Initially
        __WEBPACK_IMPORTED_MODULE_4__config__["a" /* APPCONFIG */].navCollapsed = true;
        this.getLanguages();
        if (this.isSystemAdmin || this.isBUManager || this.isRegionalAdmin || this.isApplicationManager) {
            if (this.isSystemAdmin) {
                this.flag = 'systemAdmin';
            }
            if (this.isBUManager || this.isRegionalAdmin) {
                this.flag = 'buManager';
            }
            if (this.isApplicationManager) {
                this.flag = 'applicationManager';
            }
            this.profileData = this.userDetails;
            if (this.profileData.languageId) {
                this.setLanguage(this.profileData.languageId);
            }
        }
        this.checkNotAdminRole(false, true);
    }
    ProfileComponent.prototype.checkNotAdminRole = function (langFlag, getDataFlag) {
        if (this.isServiceOwner || this.isTradePartner) {
            this.flag = 'partners';
            if (getDataFlag) {
                this.getPartnersProfileData(langFlag);
            }
        }
        if (this.isSubUser) {
            this.flag = 'subUsers';
            if (getDataFlag) {
                this.getSubUsersProfileData(langFlag);
            }
        }
    };
    //Get Languages Details
    ProfileComponent.prototype.getLanguages = function () {
        var _this = this;
        this.httpService.getRequest('lookupDataOperationsApi/v1/language').subscribe(function (res) { _this.saveLanguageResponse(res); }, function (err) { _this.httpService.onEnd(); });
    };
    //Save Languages Response
    ProfileComponent.prototype.saveLanguageResponse = function (res) {
        if (res && res.items) {
            this.LanguageData = res.items;
        }
        this.httpService.onEnd();
    };
    ProfileComponent.prototype.getPartnersProfileData = function (langFlag) {
        var _this = this;
        this.httpService.getRequest('partnerOperationsApi/v1/partnerDetails').subscribe(function (res) { _this.savePartnersProfileData(res, langFlag); }, function (err) { _this.httpService.onEnd(); });
    };
    ProfileComponent.prototype.savePartnersProfileData = function (res, langFlag) {
        if (res) {
            this.profileData = res;
            if (this.profileData) {
                if (this.profileData.businessUnits) {
                    this.businessUnitsFlag = true;
                }
                if (this.profileData.languageId) {
                    this.setLanguage(this.profileData.languageId);
                }
                if (this.profileData.businessUnitWithApplicationAndRoles) {
                    this.businessUnitWithApplicationAndRoles = this.profileData.businessUnitWithApplicationAndRoles;
                    for (var businessUnit in this.businessUnitWithApplicationAndRoles) {
                        for (var appAndRoles in this.businessUnitWithApplicationAndRoles[businessUnit]['applications']) {
                            var temp = [];
                            temp['businessUnitName'] = this.businessUnitWithApplicationAndRoles[businessUnit]['businessUnitName'];
                            temp['customerNumber'] = this.businessUnitWithApplicationAndRoles[businessUnit]['customerNumber'];
                            temp['applicationName'] = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles]['applicationName'];
                            temp['selectedRoleNames'] = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles]['selectedRoleNames'];
                            temp['url'] = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles]['url'];
                            var actionObject = {};
                            if (this.businessUnitWithApplicationAndRoles[businessUnit]['statusCode'] != 'APPROVED') {
                                actionObject = this.businessUnitWithApplicationAndRoles[businessUnit];
                            }
                            else {
                                actionObject = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles];
                            }
                            temp['statusCode'] = actionObject['statusCode'];
                            temp['status'] = actionObject['status'];
                            temp['message'] = actionObject['message'];
                            this.businessUnitWithAppRolesProfile.push(temp);
                        }
                    }
                }
                /*if(this.profileData.businessUnitWithApplicationAndRoles){
                    this.businessUnitWithApplicationAndRoles = this.profileData.businessUnitWithApplicationAndRoles;

                    for(let appIndex in this.businessUnitWithApplicationAndRoles){
                        if(!this.businessUnitWithApplicationAndRoles[appIndex]['message']){
                            this.businessUnitWithApplicationAndRoles[appIndex]['message'] = "";
                        }
                    }
                }*/
            }
            if (langFlag) {
                this.setAppLanguage();
            }
            this.httpService.onEnd();
        }
        else if (res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = 'data_load_failed';
            this.httpService.onEnd();
        }
    };
    ProfileComponent.prototype.getSubUsersProfileData = function (langFlag) {
        var _this = this;
        this.httpService.getRequest('partnerOperationsApi/v1/companyUser').subscribe(function (res) { _this.saveSubUsersProfileData(res, langFlag); }, function (err) { _this.httpService.onEnd(); });
    };
    ProfileComponent.prototype.saveSubUsersProfileData = function (res, langFlag) {
        if (res) {
            this.profileData = res;
            if (this.profileData) {
                if (this.profileData.businessUnits) {
                    this.businessUnitsFlag = true;
                }
                if (this.profileData.languageId) {
                    this.setLanguage(this.profileData.languageId);
                }
            }
            if (langFlag) {
                this.setAppLanguage();
            }
            this.httpService.onEnd();
        }
        else if (res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = 'data_load_failed';
            this.httpService.onEnd();
        }
    };
    ProfileComponent.prototype.setLanguage = function (languageId) {
        this.responseLanguageId = languageId;
        this.buildForm();
    };
    ProfileComponent.prototype.buildForm = function () {
        var _this = this;
        this.ProfileForm = this.formBuilder.group({
            languageId: this.formBuilder.control(this.responseLanguageId, [__WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].required])
        });
        this.ProfileForm.valueChanges.subscribe(function (data) {
            _this.ProfileFormDetails = _this.ProfileForm.getRawValue();
        });
    };
    ProfileComponent.prototype.onLanguageChange = function (value) {
        var _this = this;
        this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
        this.dialogRef.componentInstance.msg = 'lang_update_confirm';
        this.dialogRef.componentInstance.isConfirm = true;
        this.dialogRef.afterClosed().subscribe(function (result) {
            if (result) {
                _this.httpService.postRequest(_this.ProfileFormDetails, 'userOperationsApi/v1/languageUpdate').subscribe(function (res) { _this.saveLnaguageChangeResponse(res); }, function (err) { _this.httpService.onEnd(); });
            }
            else {
                _this.ProfileForm.controls['languageId'].setValue(_this.responseLanguageId);
            }
        });
    };
    ProfileComponent.prototype.saveLnaguageChangeResponse = function (res) {
        this.httpService.onEnd();
        if (res) {
            this.profileData = res;
            this.setLanguage(this.profileData.languageId);
            this.sessionHandler.saveItem("loginData", JSON.stringify(res));
            this.setAppLanguage();
            if (this.isServiceOwner || this.isTradePartner || this.isSubUser) {
                this.checkNotAdminRole(true, false);
            }
        }
    };
    ProfileComponent.prototype.setAppLanguage = function () {
        this.sessionHandler.saveItem("languageId", this.profileData.languageId);
        this.translate.setDefaultLang(this.profileData.languageId);
        this.translate.use(this.profileData.languageId);
        this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
        this.dialogRef.componentInstance.msg = "lang_update_success";
    };
    ProfileComponent.prototype.performAction = function (action) {
        var _this = this;
        this.dialogRef = this.dialog.open(EmailPasswordActionDialogComponent);
        this.dialogRef.componentInstance.action = action;
        this.dialogRef.componentInstance.currentEmailAddress = this.profileData.email;
        this.dialogRef.componentInstance.userId = this.userDetails.id;
        this.dialogRef.componentInstance.userDetails = this.userDetails;
        this.dialogRef.afterClosed().subscribe(function (result) {
            _this.data = result;
        });
    };
    ProfileComponent.prototype.setProfileAction = function (action, profileFormData) {
        var _this = this;
        this.dialog.closeAll();
        if (action == 'changeEmail') {
            this.httpService.postRequest(profileFormData, 'userOperationsApi/v1/selfEmailUpdate').subscribe(function (res) { _this.saveResponse(res, 'changeEmail'); }, function (err) { _this.httpService.onEnd(); });
        }
        else if (action == 'changePassword') {
            this.httpService.postRequest(profileFormData, 'userOperationsApi/v1/changePassword').subscribe(function (res) { _this.saveResponse(res, 'changePassword'); }, function (err) { _this.httpService.onEnd(); });
        }
    };
    ProfileComponent.prototype.saveResponse = function (res, action) {
        this.httpService.onEnd();
        if (res) {
            if (action == 'changePassword') {
                this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
                this.dialogRef.componentInstance.msg = 'Password updated successfully';
            }
            else if (action == 'changeEmail') {
                this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
                this.dialogRef.componentInstance.msg = 'account_update_request_notify';
            }
        }
    };
    ProfileComponent.prototype.showApplicationsWithRoles = function (apps) {
        this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["k" /* ShowApplicationsDialogComponent */]);
        for (var appIndex in apps) {
            if (!apps[appIndex]['message']) {
                apps[appIndex]['message'] = "";
            }
        }
        this.dialogRef.componentInstance.apps = apps;
        this.dialogRef.componentInstance.profileFlag = true;
    };
    ProfileComponent.prototype.ngOnInit = function () {
        this.buildForm();
    };
    ProfileComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'my-profile',
            styles: [],
            template: __webpack_require__(1277),
            providers: []
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_5__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_2__shared_services_session_handler_service__["a" /* SessionHandler */],
            __WEBPACK_IMPORTED_MODULE_6__angular_forms__["h" /* FormBuilder */], __WEBPACK_IMPORTED_MODULE_8_ng2_translate__["d" /* TranslateService */]])
    ], ProfileComponent);
    return ProfileComponent;
}());

var EmailPasswordActionDialogComponent = /** @class */ (function () {
    function EmailPasswordActionDialogComponent(dialog, dialogRef, formBuilder, profileComponent) {
        this.dialog = dialog;
        this.dialogRef = dialogRef;
        this.formBuilder = formBuilder;
        this.profileComponent = profileComponent;
        this.emailPattern = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* APPCONFIG */].emailPattern;
        //passwordPattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/;
        this.passwordPattern = /^(?=.*?[A-Za-z])(?=.*?[0-9]).{5,}$/;
        this.passwordErrorMsg = '';
        this.changeEmail = 'changeEmail';
        this.changePass = 'changePassword';
    }
    EmailPasswordActionDialogComponent.prototype.buildForm = function () {
        var _this = this;
        this.ProfileActionForm = this.formBuilder.group({
            emailGroup: this.formBuilder.group({
                currentEmailAddress: this.formBuilder.control({ value: this.currentEmailAddress, disabled: true }, [__WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].pattern(this.emailPattern)]),
                email: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].pattern(this.emailPattern)]),
                confirmEmail: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].pattern(this.emailPattern)])
            }, { validator: this.checkEmail }),
            passwordGroup: this.formBuilder.group({
                currentPassword: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].required]),
                password: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].minLength(8), __WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].maxLength(8), __WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].pattern(this.passwordPattern)]),
                confirmPassword: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].pattern(this.passwordPattern)])
            }, { validator: this.checkPassword })
        });
        this.ProfileActionForm.valueChanges.subscribe(function (data) {
            var profileDetails = _this.ProfileActionForm.getRawValue();
            _this.profileEmailDetails = profileDetails.emailGroup;
            _this.profileEmailDetails['id'] = _this.userId;
            _this.profilePasswordDetails = profileDetails.passwordGroup;
        });
        this.ProfileActionForm.get('passwordGroup').get('password').valueChanges.subscribe(function (data) {
            _this.validatePassword(data);
        });
    };
    EmailPasswordActionDialogComponent.prototype.validatePassword = function (data) {
        if (data != null && data != "") {
            this.ProfileActionForm.get('passwordGroup').get('password').setErrors({ 'incorrect': true });
            var firstName = this.userDetails.firstName || '';
            var lastName = this.userDetails.lastName || '';
            var hasUpper = /[A-Z]/.test(data);
            var hasLower = /[a-z]/.test(data);
            var hasDigit = /[0-9]/.test(data);
            var minLength = data.length >= 8;
            var validSymbols = /^[a-zA-Z0-9!@#$%&*?]*$/.test(data);
            var containsFirstName = firstName && data.toLowerCase().includes(firstName.toLowerCase());
            var containsLastName = lastName && data.toLowerCase().includes(lastName.toLowerCase());
            if (!hasUpper || !hasLower) {
                this.passwordErrorMsg = "pass_one_upper_lower_char";
            }
            else if (!hasDigit) {
                this.passwordErrorMsg = "pass_one_number";
            }
            else if (!minLength) {
                this.passwordErrorMsg = "pass_least_8_chars";
            }
            else if (data.toLowerCase().includes(this.userDetails.userId_WPASS.toLowerCase())) {
                this.passwordErrorMsg = "pass_no_userId";
            }
            else if (!validSymbols) {
                this.passwordErrorMsg = "pass_invalid_symbol"; //new
            }
            else if (containsFirstName) {
                this.passwordErrorMsg = "pass_contains_firstname"; //new
            }
            else if (containsLastName) {
                this.passwordErrorMsg = "pass_contains_lastname"; //new
            }
            else {
                this.passwordErrorMsg = "";
                this.ProfileActionForm.get('passwordGroup').get('password').setErrors(null);
                return true;
            }
        }
        return false;
    };
    EmailPasswordActionDialogComponent.prototype.checkEmail = function (group) {
        if (group.get('email').value === group.get('confirmEmail').value) {
            return null;
        }
        else {
            group.get('confirmEmail').setErrors({ 'incorrect': true });
            return { 'mismatch': true };
        }
    };
    EmailPasswordActionDialogComponent.prototype.checkPassword = function (group) {
        if (group.get('password').value === group.get('confirmPassword').value) {
            group.get('confirmPassword').setErrors(null);
            return null;
        }
        else {
            group.get('confirmPassword').setErrors({ 'incorrect': true });
            return { 'mismatch': true };
        }
    };
    EmailPasswordActionDialogComponent.prototype.showPassword = function (input) {
        input.type = input.type === 'password' ? 'text' : 'password';
    };
    EmailPasswordActionDialogComponent.prototype.ngOnInit = function () {
        this.buildForm();
    };
    EmailPasswordActionDialogComponent.prototype.changeEmailAddress = function () {
        this.profileComponent.setProfileAction(this.changeEmail, this.profileEmailDetails);
    };
    EmailPasswordActionDialogComponent.prototype.changePassword = function () {
        if (!this.validatePassword(this.ProfileActionForm.get('passwordGroup').get('password').value)) {
            return;
        }
        this.profileComponent.setProfileAction(this.changePass, this.profilePasswordDetails);
    };
    EmailPasswordActionDialogComponent.prototype.closeDialog = function () {
        this.dialog.closeAll();
    };
    EmailPasswordActionDialogComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            providers: [ProfileComponent],
            template: __webpack_require__(1276)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_5__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_5__angular_material__["d" /* MdDialogRef */], __WEBPACK_IMPORTED_MODULE_6__angular_forms__["h" /* FormBuilder */], ProfileComponent])
    ], EmailPasswordActionDialogComponent);
    return EmailPasswordActionDialogComponent;
}());



/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ViewRequestComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmailActionDialogComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_services_common_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dialog_dialog_component__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ng2_translate__ = __webpack_require__(17);
/**
 * Created by shubham on 16/4/18.
 */











var ViewRequestComponent = /** @class */ (function () {
    function ViewRequestComponent(router, route, httpService, sessionHandler, dialog, commonService, translate) {
        var _this = this;
        this.router = router;
        this.route = route;
        this.httpService = httpService;
        this.sessionHandler = sessionHandler;
        this.dialog = dialog;
        this.commonService = commonService;
        this.translate = translate;
        this.data = [];
        this.isSystemAdmin = false;
        this.isBUManager = false;
        this.isApplicationManager = false;
        this.isRegionalAdmin = false;
        this.isServiceOwner = false;
        this.isTradePartner = false;
        this.isSubUser = false;
        this.showApproveReject = false;
        this.source = "partnersView";
        this.languageId = this.sessionHandler.getItem('languageId');
        if (!this.languageId) {
            this.languageId = "EN";
        }
        this.translate.use(this.languageId);
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* APPCONFIG */].systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* APPCONFIG */].BUManager)) {
                this.isBUManager = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* APPCONFIG */].applicationManager)) {
                this.isApplicationManager = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* APPCONFIG */].regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* APPCONFIG */].serviceOwner)) {
                this.isServiceOwner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* APPCONFIG */].tradePartner)) {
                this.isTradePartner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* APPCONFIG */].subuser)) {
                this.isSubUser = true;
            }
        }
        else {
            this.httpService.noUserError();
        }
        this.route.queryParams.subscribe(function (params) {
            _this.source = params['source'];
        });
        this.commonService.viewData.subscribe(function (value) {
            _this.data = value;
            if (_this.data) {
                if (_this.data.userId_WPASS) {
                    _this.userId = _this.data.userId_WPASS;
                }
                else {
                    _this.translate.get('pending').subscribe(function (res) {
                        _this.userId = res;
                    });
                }
                _this.id = _this.data.id;
                _this.ownerId = _this.data.ownerId;
                _this.userEmail = _this.data.email;
            }
            if (_this.isBUManager || _this.isRegionalAdmin || _this.isApplicationManager) {
                _this.commonService.viewDataFlag.subscribe(function (value) {
                    if (value) {
                        _this.dynamicViewText = value;
                        if (_this.dynamicViewText == 'subUsersView') {
                            _this.showApproveReject = false;
                        }
                        else if (_this.dynamicViewText == 'partnersView') {
                            if (_this.data['businessUnitWithApplicationAndRoles']) {
                                for (var _i = 0, _a = _this.data['businessUnitWithApplicationAndRoles']; _i < _a.length; _i++) {
                                    var businessUnit = _a[_i];
                                    if (businessUnit.statusCode == "PENDING" && businessUnit.sessionUserManager) {
                                        _this.showApproveReject = true;
                                        _this.data['businessUnitId'] = businessUnit.businessUnitId;
                                        break;
                                    }
                                    else {
                                        _this.showApproveReject = false;
                                    }
                                }
                            }
                            else {
                                _this.showApproveReject = false;
                            }
                        }
                        else {
                            _this.showApproveReject = false;
                        }
                    }
                });
            }
            else if (_this.isServiceOwner || _this.isTradePartner) { }
        });
    }
    ViewRequestComponent.prototype.performAction = function (action) {
        var _this = this;
        this.dialogRef = this.dialog.open(EmailActionDialogComponent);
        this.dialogRef.componentInstance.action = action;
        this.dialogRef.componentInstance.currentEmailAddress = this.userEmail;
        this.dialogRef.componentInstance.userId = this.id;
        this.dialogRef.afterClosed().subscribe(function (result) {
            _this.data = result;
        });
    };
    ViewRequestComponent.prototype.setProfileAction = function (action, profileFormData) {
        var _this = this;
        this.dialog.closeAll();
        if (action == 'changeEmail') {
            this.httpService.postRequest(profileFormData, 'userOperationsApi/v1/emailUpdate').subscribe(function (res) { _this.saveResponse(res, 'changeEmail'); }, function (err) { _this.httpService.onEnd(); });
        }
    };
    ViewRequestComponent.prototype.saveResponse = function (res, action) {
        this.httpService.onEnd();
        if (res) {
            if (action == 'changePassword') {
                this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_9__dialog_dialog_component__["a" /* DialogComponent */]);
                this.dialogRef.componentInstance.msg = 'Password updated successfully';
            }
            else if (action == 'changeEmail') {
                this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_9__dialog_dialog_component__["a" /* DialogComponent */]);
                this.dialogRef.componentInstance.msg = 'account_update_request_notify';
            }
        }
    };
    ViewRequestComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            template: __webpack_require__(1302)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_2__angular_router__["b" /* ActivatedRoute */], __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_4__shared_services_session_handler_service__["a" /* SessionHandler */],
            __WEBPACK_IMPORTED_MODULE_5__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_7__shared_services_common_service__["a" /* CommonService */], __WEBPACK_IMPORTED_MODULE_10_ng2_translate__["d" /* TranslateService */]])
    ], ViewRequestComponent);
    return ViewRequestComponent;
}());

var EmailActionDialogComponent = /** @class */ (function () {
    function EmailActionDialogComponent(dialog, dialogRef, formBuilder, viewRequestComponent) {
        this.dialog = dialog;
        this.dialogRef = dialogRef;
        this.formBuilder = formBuilder;
        this.viewRequestComponent = viewRequestComponent;
        this.emailPattern = __WEBPACK_IMPORTED_MODULE_8__config__["a" /* APPCONFIG */].emailPattern;
        this.changeEmail = 'changeEmail';
    }
    EmailActionDialogComponent.prototype.buildForm = function () {
        var _this = this;
        this.EmailActionForm = this.formBuilder.group({
            emailGroup: this.formBuilder.group({
                currentEmailAddress: this.formBuilder.control({ value: this.currentEmailAddress, disabled: true }, [__WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].pattern(this.emailPattern)]),
                email: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].pattern(this.emailPattern)]),
                confirmEmail: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].pattern(this.emailPattern)])
            }, { validator: this.checkEmail })
        });
        this.EmailActionForm.valueChanges.subscribe(function (data) {
            var profileDetails = _this.EmailActionForm.getRawValue();
            _this.EmailDetails = profileDetails.emailGroup;
            _this.EmailDetails['id'] = _this.userId;
        });
    };
    EmailActionDialogComponent.prototype.checkEmail = function (group) {
        if (group.get('email').value === group.get('confirmEmail').value) {
            return null;
        }
        else {
            group.get('confirmEmail').setErrors({ 'incorrect': true });
            return { 'mismatch': true };
        }
    };
    EmailActionDialogComponent.prototype.ngOnInit = function () {
        this.buildForm();
    };
    EmailActionDialogComponent.prototype.changeEmailAddress = function () {
        this.viewRequestComponent.setProfileAction(this.changeEmail, this.EmailDetails);
    };
    EmailActionDialogComponent.prototype.closeDialog = function () {
        this.dialog.closeAll();
    };
    EmailActionDialogComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            providers: [ViewRequestComponent],
            template: __webpack_require__(1301)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_5__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_5__angular_material__["d" /* MdDialogRef */], __WEBPACK_IMPORTED_MODULE_6__angular_forms__["h" /* FormBuilder */],
            ViewRequestComponent])
    ], EmailActionDialogComponent);
    return EmailActionDialogComponent;
}());



/***/ }),

/***/ 24:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommonService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__);
/**
 * Created by shubham on 27/2/18.
 */



var CommonService = /** @class */ (function () {
    function CommonService() {
        this.viewData = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
        this.viewDataFlag = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
        this.userData = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
        this.adminDashboard = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
        this.partnersDashboard = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
        this.applicationDashboard = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
        this.partnersView = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
        this.subUsersView = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
        this.adminList = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
        this.managerList = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
        this.applicationList = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
    }
    CommonService.prototype.setLoginRedirectUrl = function (url) {
        this.loginRedirectUrl = url;
    };
    CommonService.prototype.getLoginRedirectUrl = function () {
        return this.loginRedirectUrl;
    };
    CommonService.prototype.changeViewData = function (data, flag) {
        this.viewData.next(data);
        this.viewDataFlag.next(flag);
    };
    CommonService.prototype.changeUserData = function (data) {
        this.userData.next(data);
    };
    CommonService.prototype.changeAdminDashboardData = function () {
        this.adminDashboard.next();
    };
    CommonService.prototype.changePartnersDashboardData = function () {
        this.partnersDashboard.next();
    };
    CommonService.prototype.changeApplicationDashboardData = function () {
        this.applicationDashboard.next();
    };
    CommonService.prototype.changePartnerViewData = function () {
        this.partnersView.next();
    };
    CommonService.prototype.changeSubUserViewData = function () {
        this.subUsersView.next();
    };
    CommonService.prototype.changeAdminListDashboardData = function () {
        this.adminList.next();
    };
    CommonService.prototype.changeManagerListDashboardData = function () {
        this.managerList.next();
    };
    CommonService.prototype.changeApplicationListDashboardData = function () {
        this.applicationList.next();
    };
    CommonService.prototype.contains = function (value, term, caseInsensitiveSearch) {
        if (!value)
            return false;
        if (!term)
            return false;
        if (caseInsensitiveSearch) {
            value = value.toLowerCase();
            term = term.toLowerCase();
        }
        return (value.indexOf(term) != -1);
    };
    CommonService.prototype.equals = function (value1, value2, caseInsensitiveMatch) {
        if (!value1)
            return false;
        if (!value2)
            return false;
        if (caseInsensitiveMatch) {
            value1 = value1.toLowerCase();
            value2 = value2.toLowerCase();
        }
        return (value1 == value2);
    };
    CommonService.prototype.stopPropagationCheckBox = function (event) {
        if (event.stopPropagation) {
            event.stopPropagation(); // Standard
        }
        else {
            event.cancelBubble = true; // Old IE
        }
    };
    CommonService.prototype.getChoosenFile = function (event, componentModal, componentKey) {
        var file = event.srcElement.files[0];
        var fileName = file.name;
        var reader = new FileReader();
        reader.onload = function () {
            componentModal[componentKey] = { name: fileName, data: reader.result };
        }.bind(componentModal);
        reader.readAsDataURL(file);
    };
    CommonService = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [])
    ], CommonService);
    return CommonService;
}());



/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SharedModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__echarts_directive__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slim_scroll_directive__ = __webpack_require__(783);




var SharedModule = /** @class */ (function () {
    function SharedModule() {
    }
    SharedModule = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
            imports: [],
            declarations: [
                __WEBPACK_IMPORTED_MODULE_2__echarts_directive__["a" /* EChartsDirective */],
                __WEBPACK_IMPORTED_MODULE_3__slim_scroll_directive__["a" /* SlimScrollDirective */],
            ],
            exports: [
                __WEBPACK_IMPORTED_MODULE_2__echarts_directive__["a" /* EChartsDirective */],
                __WEBPACK_IMPORTED_MODULE_3__slim_scroll_directive__["a" /* SlimScrollDirective */],
            ]
        })
    ], SharedModule);
    return SharedModule;
}());



/***/ }),

/***/ 276:
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	return new Promise(function(resolve, reject) { reject(new Error("Cannot find module '" + req + "'.")); });
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = 276;

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdminDashboardComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_services_common_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__admin_datatable_admin_page__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__adminDashboardResultService__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ng2_translate__ = __webpack_require__(17);
/**
 * Created by shubham on 20/4/18.
 */














var AdminDashboardComponent = /** @class */ (function () {
    function AdminDashboardComponent(router, httpService, sessionHandler, dialog, formBuilder, serverResultsService, commonService, translate) {
        var _this = this;
        this.router = router;
        this.httpService = httpService;
        this.sessionHandler = sessionHandler;
        this.dialog = dialog;
        this.formBuilder = formBuilder;
        this.serverResultsService = serverResultsService;
        this.commonService = commonService;
        this.translate = translate;
        this.page = new __WEBPACK_IMPORTED_MODULE_10__admin_datatable_admin_page__["a" /* AdminPage */]();
        this.tableRows = [];
        this.filters = {};
        this.adminDashboardData = [];
        this.temp = [];
        this.Countries = [{
                "id": "",
                "name": "all",
                "code": "",
                "active": true,
                "createdAt": "2019-02-26T12:49:39.329Z"
            }];
        this.showTable = true;
        this.isSystemAdmin = false;
        this.isBUManager = false;
        this.isRegionalAdmin = false;
        this.isServiceOwner = false;
        this.isTradePartner = false;
        this.isSubUser = false;
        this.selected = [];
        this.selectedStatusId = 'PENDING';
        this.selectedCountryId = '';
        this.searchedFilters = { email: '', firstName: '', wpassId: '', customerNumber: '' };
        this.isDisabled = false;
        this.showCheckbox = false;
        this.wpassLogin = false;
        this.autocompleteLoader = "";
        this.searchName = "";
        this.searchEmail = "";
        this.searchWpass = "";
        this.searchCustomerNumber = "";
        this.Names = [];
        this.Emails = [];
        this.Wpass = [];
        this.CustomerNumbers = [];
        this.dataTableMessage = { 'selectedMessage': '', 'totalMessage': '' };
        this.StatusData = [{
                "id": "PENDING",
                "code": "",
                "name": "Pending"
            }];
        this.getUserList = function () {
            this.showTable = false;
        };
        this.saveUserList = function (res, filter) {
            if (res.errorStatus == 'Fail') {
                this.httpService.onEnd();
                this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
                this.dialogRef.componentInstance.msg = 'data_pull_fail';
            }
            else {
                if (res && Object.keys(res).length > 0) {
                    this.adminDashboardData = res;
                    this.rows = [];
                    this.rows['offset'] = res.offset;
                    this.count = res.count;
                    this.totalCount = res.totalCount;
                    if (this.adminDashboardData.list) {
                        var totalCount = 0;
                        if (parseInt(res.offset) == 0) {
                            localStorage.setItem('totalCount', res.totalCount);
                            totalCount = parseInt(res.totalCount);
                        }
                        else {
                            totalCount = parseInt(localStorage.getItem('totalCount'));
                        }
                        this.rows['totalCount'] = totalCount;
                        for (var data in this.adminDashboardData.list) {
                            if (this.isBUManager || this.isRegionalAdmin || this.isSystemAdmin) {
                                this.rows[data] = {};
                                this.rows[data]['id'] = this.adminDashboardData.list[data]['id'];
                                this.rows[data]['Name'] = this.adminDashboardData.list[data]['firstName'] + ' ' + this.adminDashboardData.list[data]['lastName'];
                                this.rows[data]['roleName'] = this.adminDashboardData.list[data]['roleName'];
                                this.rows[data]['email'] = this.adminDashboardData.list[data]['email'];
                                this.rows[data]['emailVerified'] = this.adminDashboardData.list[data]['emailVerified'];
                                if (this.adminDashboardData.list[data]['categorizedBusinessUnits'] && Object.keys(this.adminDashboardData.list[data]['categorizedBusinessUnits']).length > 0) {
                                    this.rows[data]['businessUnits'] = this.adminDashboardData.list[data]['categorizedBusinessUnits'];
                                }
                                else {
                                    this.rows[data]['businessUnits'] = {};
                                }
                                if (this.adminDashboardData.list[data]['userId_WPASS']) {
                                    this.rows[data]['userId_WPASS'] = this.adminDashboardData.list[data]['userId_WPASS'];
                                }
                                else {
                                    this.rows[data]['userId_WPASS'] = null;
                                }
                                if (this.adminDashboardData.list[data]['pendingSubUserCount']) {
                                    this.rows[data]['pendingSubUserCount'] = this.adminDashboardData.list[data]['pendingSubUserCount'];
                                }
                                else {
                                    this.rows[data]['pendingSubUserCount'] = 0;
                                }
                                this.rows[data]['languageId'] = this.adminDashboardData.list[data]['languageId'];
                                this.rows[data]['languageName'] = this.adminDashboardData.list[data]['languageName'];
                                this.rows[data]['countryId'] = this.adminDashboardData.list[data]['countryId'];
                                this.rows[data]['countryName'] = this.adminDashboardData.list[data]['countryName'];
                                this.rows[data]['companyName'] = this.adminDashboardData.list[data]['companyName'];
                                this.rows[data]['companyAddress'] = this.adminDashboardData.list[data]['companyAddress'];
                                this.rows[data]['companyPhone'] = this.adminDashboardData.list[data]['companyPhone'];
                                this.rows[data]['personalArea'] = this.adminDashboardData.list[data]['personalArea'];
                                this.rows[data]['costCenter'] = this.adminDashboardData.list[data]['costCenter'];
                                this.rows[data]['location'] = this.adminDashboardData.list[data]['location'];
                                this.rows[data]['contractorType'] = this.adminDashboardData.list[data]['contractorType'];
                                if ((this.adminDashboardData.list[data]['status'] == "Pending" || this.adminDashboardData.list[data]['status'] == "Approved")
                                    && this.adminDashboardData.list[data]['categorizedBusinessUnits'] && this.adminDashboardData.list[data]['categorizedBusinessUnits']['PENDING']) {
                                    for (var _i = 0, _a = this.adminDashboardData.list[data]['categorizedBusinessUnits']['PENDING']; _i < _a.length; _i++) {
                                        var businessUnit = _a[_i];
                                        if (businessUnit.status == 'PENDING' && businessUnit.sessionUserManager) {
                                            this.rows[data]['actionFlag'] = true;
                                            if (businessUnit.customerNumber) {
                                                this.rows[data]['customerNumber'] = businessUnit.customerNumber;
                                            }
                                            if (businessUnit.customerNumberMandatory) {
                                                this.rows[data]['customerNumberMandatory'] = businessUnit.customerNumberMandatory;
                                            }
                                            if (businessUnit.id) {
                                                this.rows[data]['businessUnitId'] = businessUnit.id;
                                            }
                                            break;
                                        }
                                        else {
                                            this.rows[data]['actionFlag'] = false;
                                        }
                                    }
                                }
                                else {
                                    this.rows[data]['actionFlag'] = false;
                                }
                                this.rows[data]['status'] = this.adminDashboardData.list[data]['status'];
                                this.rows[data]['createdAt'] = this.adminDashboardData.list[data]['createdAt'];
                                this.rows[data]['updatedAt'] = this.adminDashboardData.list[data]['updatedAt'];
                                this.rows[data]['wpassCreatedAt'] = this.adminDashboardData.list[data]['wpassCreatedAt'];
                            }
                            else {
                                //For Other Service Partner's
                                this.rows[data] = {};
                            }
                        }
                        this.showTable = true;
                        this.temp = this.rows;
                    }
                    else {
                        this.showTable = false;
                    }
                    var finalRows = [];
                    for (var f in this.rows) {
                        if (f != 'offset' && f != 'totalCount' && this.rows[f]) {
                            finalRows.push(this.rows[f]);
                        }
                        if (f == 'offset') {
                            finalRows['offset'] = this.rows['offset'];
                        }
                        if (f == 'totalCount') {
                            finalRows['totalCount'] = this.rows['totalCount'];
                        }
                    }
                    this.rows = finalRows;
                    this.setPage({ offset: this.rows['offset'] / this.page.size }, finalRows, filter);
                    this.httpService.onEnd();
                }
            }
        };
        //Close Sidebar Initially
        __WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].navCollapsed = true;
        this.page.pageNumber = 0;
        this.page.size = 20;
        this.adminText = 'admin';
        /*this.wpassLogin = JSON.parse(this.sessionHandler.getItem('wpassLogin'));
        if(this.wpassLogin != null && this.wpassLogin == true){
            this.dialogRef = this.dialog.open(WelcomeDialogComponent);
            this.dialogRef.afterClosed().subscribe(result => {
                localStorage.removeItem('wpassLogin');
            });
        }*/
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].BUManager)) {
                this.isBUManager = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].serviceOwner)) {
                this.isServiceOwner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].tradePartner)) {
                this.isTradePartner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].subuser)) {
                this.isSubUser = true;
            }
        }
        else {
            this.httpService.noUserError();
        }
        this.filters['offSet'] = this.page.pageNumber * this.page.size;
        this.filters['limit'] = this.page.size;
        if (this.isBUManager || this.isRegionalAdmin || this.isSystemAdmin) {
            this.getCountries();
            this.getStatusList();
            this.getUsersList(this.filters, this.selectedStatusId, this.selectedCountryId, this.searchEmail, this.searchName, this.searchWpass, this.searchCustomerNumber);
        }
        else {
            this.getUserList();
        }
        //Call when approve/delete from ApproveRejectComponent/ActiveInactiveComponent to get the updated list.
        this.commonService.adminDashboard.subscribe(function (value) {
            _this.getUsersList(_this.filters, _this.selectedStatusId, _this.selectedCountryId, _this.searchEmail, _this.searchName, _this.searchWpass, _this.searchCustomerNumber);
        });
    }
    AdminDashboardComponent.prototype.autocompleteSearch = function (term, filter) {
        var _this = this;
        if (filter == "name") {
            this.Names = [];
            this.searchName = term;
        }
        else if (filter == "email") {
            this.Emails = [];
            this.searchEmail = term;
        }
        else if (filter == "wpass") {
            this.Wpass = [];
            this.searchWpass = term;
        }
        else if (filter == "customerNumber") {
            this.CustomerNumbers = [];
            this.searchCustomerNumber = term;
        }
        if (term == "")
            return;
        var url = "/lookupDataOperationsApi/v1/partialSearch?type=" + filter + "&searchStr=" + term;
        this.autocompleteLoader = filter;
        this.httpService.getRequestForAutocomplete(url).subscribe(function (res) {
            if (res && res['items']) {
                var name_1 = res['items'];
                var filterArray = [];
                for (var index in name_1) {
                    filterArray.push(name_1[index]['name']);
                }
                if (filter == "name") {
                    _this.Names = filterArray;
                }
                else if (filter == "email") {
                    _this.Emails = filterArray;
                }
                else if (filter == "wpass") {
                    _this.Wpass = filterArray;
                }
            }
            _this.autocompleteLoader = "";
            _this.httpService.onEnd();
        }, function (err) {
            _this.autocompleteLoader = "";
            _this.httpService.onEnd();
        });
    };
    AdminDashboardComponent.prototype.onSelectAutocomplete = function (value, textFlag) {
        if (textFlag == "name") {
            this.searchName = value;
        }
        else if (textFlag == "email") {
            this.searchEmail = value;
        }
        else if (textFlag == "wpass") {
            this.searchWpass = value;
        }
        else if (textFlag == "customerNumber") {
            this.searchCustomerNumber = value;
        }
    };
    AdminDashboardComponent.prototype.search = function () {
        this.selected = [];
        this.filters['offSet'] = 0;
        /*if (this.searchName == undefined) {
            this.searchName = "";
        } else if(this.searchName != "" && this.Names.length > 0){
            if(this.checkAutocompleteWord(this.Names, this.searchName)){
                this.searchName = "";
            }
        }

        if (this.searchEmail == undefined) {
            this.searchEmail = "";
        } else if(this.searchEmail != "" && this.Emails.length > 0){
            if(this.checkAutocompleteWord(this.Emails, this.searchEmail)){
                this.searchEmail = "";
            }
        }

        if (this.searchWpass == undefined) {
            this.searchWpass = "";
        } else if(this.searchWpass != "" && this.Wpass.length > 0){
            if(this.checkAutocompleteWord(this.Wpass, this.searchWpass)){
                this.searchWpass = "";
            }
        }*/
        if (this.searchName == undefined) {
            this.searchName = "";
        }
        if (this.searchEmail == undefined) {
            this.searchEmail = "";
        }
        if (this.searchWpass == undefined) {
            this.searchWpass = "";
        }
        if (this.searchCustomerNumber == undefined) {
            this.searchCustomerNumber = "";
        }
        this.getUsersList(this.filters, this.selectedStatusId, this.selectedCountryId, this.searchEmail, this.searchName, this.searchWpass, this.searchCustomerNumber);
    };
    AdminDashboardComponent.prototype.checkAutocompleteWord = function (objArray, searchValue) {
        if (objArray.includes(searchValue)) {
            return false;
        }
        else {
            return true;
        }
    };
    AdminDashboardComponent.prototype.resetSearch = function () {
        this.searchName = "";
        this.searchEmail = "";
        this.searchWpass = "";
        this.searchCustomerNumber = "";
        this.Names = [];
        this.Emails = [];
        this.Wpass = [];
        this.selectedStatusId = "PENDING";
        this.selectedCountryId = "";
        this.search();
    };
    AdminDashboardComponent.prototype.getCountries = function () {
        var _this = this;
        this.httpService.getRequest('lookupDataOperationsApi/v1/countriesForAdmin').subscribe(function (res) {
            _this.saveCountries(res);
        }, function (err) {
            _this.httpService.onEnd();
        });
    };
    AdminDashboardComponent.prototype.saveCountries = function (res) {
        if (res && res.items) {
            this.Countries = this.Countries.concat(res.items);
        }
        this.httpService.onEnd();
    };
    AdminDashboardComponent.prototype.getStatusList = function () {
        var _this = this;
        this.httpService.getRequest("lookupDataOperationsApi/v1/registrationStatusFilter?includeDeleted=true").subscribe(function (res) {
            _this.saveStatusList(res);
        }, function (err) {
            _this.httpService.onEnd();
        });
    };
    AdminDashboardComponent.prototype.saveStatusList = function (res) {
        this.StatusData.push({ "id": "", "code": "", "name": "all" });
        if (res) {
            if (res.items) {
                for (var s in res.items) {
                    if (res.items[s]['id'] != 'PENDING') {
                        this.StatusData.push(res.items[s]);
                    }
                }
            }
        }
    };
    AdminDashboardComponent.prototype.getUserLink = function (row) {
        return row.roleName &&
            row.roleName.indexOf('Sub User') > -1
            ? ['/app/view-request/viewSubUsers', row.id, { source: 'admin' }]
            : ['/app/view-request/viewPartners', row.id];
    };
    AdminDashboardComponent.prototype.getUsersList = function (filter, selectedStatus, selectedCountryId, email, firstName, wpassId, customerNumber) {
        var _this = this;
        this.searchedFilters.email = email;
        this.searchedFilters.firstName = firstName;
        this.searchedFilters.wpassId = wpassId;
        this.searchedFilters.customerNumber = customerNumber;
        if (selectedStatus == 'PENDING') {
            this.showCheckbox = true;
        }
        else {
            this.showCheckbox = false;
        }
        this.httpService.getRequest("userRegistrationsApi/v1/user/list?limit=" + filter.limit + "&offset=" + filter.offSet + "&status=" + selectedStatus + "&countryId=" + selectedCountryId + "&email=" + email + "&firstName=" + firstName + "&wpassId=" + wpassId + "&customerNumber=" + customerNumber).subscribe(function (res) {
            _this.saveUserList(res, filter);
        }, function (err) {
            _this.httpService.onEnd();
        });
    };
    /**
     * Populate the table with new data based on the page number
     * @param page The page to select
     */
    AdminDashboardComponent.prototype.setPage = function (pageInfo, rows, filter) {
        var _this = this;
        this.page.pageNumber = pageInfo.offset;
        if (rows.length != 0) {
            this.serverResultsService.getResults(this.page, rows).subscribe(function (pageData) {
                _this.page = pageData.page;
                _this.tableRows = pageData.data;
                if (!filter) {
                    if (Object.keys(_this.tableRows).length == 0 || !_this.tableRows[0]['status']) {
                        _this.filters['offSet'] = _this.page.pageNumber * _this.page.size;
                        _this.getUsersList(_this.filters, _this.selectedStatusId, _this.selectedCountryId, _this.searchEmail, _this.searchName, _this.searchWpass, _this.searchCustomerNumber);
                    }
                }
            });
        }
        else {
            this.tableRows = [];
            this.page.totalElements = rows.length;
        }
    };
    AdminDashboardComponent.prototype.onSelect = function (_a) {
        var selected = _a.selected;
        var _b;
        this.selected.splice(0, this.selected.length);
        (_b = this.selected).push.apply(_b, selected);
        this.selectedCount = this.selected.length;
    };
    AdminDashboardComponent.prototype.forgetPassword = function (wpassId) {
        var _this = this;
        this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
        this.dialogRef.componentInstance.msg = 'sure_to_init_reset_process';
        this.dialogRef.componentInstance.isConfirm = true;
        this.dialogRef.afterClosed().subscribe(function (data) {
            if (data) {
                var body = { userId_WPASS: wpassId };
                _this.httpService.postRequest(body, 'userOperationsApi/v1/forgotPassword').subscribe(function (res) {
                    _this.processResponse(res, 'after_reset_password_notify');
                }, function (err) {
                    _this.httpService.onEnd();
                });
            }
            else {
            }
        });
    };
    AdminDashboardComponent.prototype.downloadCsv = function (action) {
        var loginDataArray = JSON.parse(this.sessionHandler.getItem("loginData"));
        var accessToken;
        if (loginDataArray) {
            accessToken = loginDataArray['accessToken'];
        }
        window.open(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].URL + '/export?access-token=' + accessToken + '&action=' + action + '&status=' + this.selectedStatusId + '&email=' + this.searchEmail + '&firstName=' + this.searchName + '&wpassId=' + this.searchWpass + '&customerNumber=' + this.searchCustomerNumber + '&countryId=' + this.selectedCountryId, '_blank');
    };
    AdminDashboardComponent.prototype.processResponse = function (res, msgCode) {
        if (res) {
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = msgCode;
            this.dialogRef.afterClosed().subscribe(function (result) {
            });
        }
        this.httpService.onEnd();
    };
    AdminDashboardComponent.prototype.unlockAccount = function (wpassId) {
        var _this = this;
        this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
        this.dialogRef.componentInstance.msg = 'sure_to_init_unlock_process';
        this.dialogRef.componentInstance.isConfirm = true;
        this.dialogRef.afterClosed().subscribe(function (data) {
            if (data) {
                var body = { userId_WPASS: wpassId };
                _this.httpService.postRequest(body, 'userOperationsApi/v1/unlockWpassUser').subscribe(function (res) {
                    _this.processResponse(res, 'account_unlock_succesfully');
                }, function (err) {
                    _this.httpService.onEnd();
                });
            }
        });
    };
    AdminDashboardComponent.prototype.resendEmailVerificationEmail = function (userId) {
        var _this = this;
        this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
        this.dialogRef.componentInstance.msg = 'sure_to_resend_email_verification_link';
        this.dialogRef.componentInstance.isConfirm = true;
        this.dialogRef.afterClosed().subscribe(function (data) {
            if (data) {
                var body = {};
                _this.httpService.postRequest(body, 'userRegistrationsApi/v1/resendNewRegistrationEmailVerificationEmail/' + userId).subscribe(function (res) {
                    _this.processResponse(res, 'email_sent_success');
                }, function (err) {
                    _this.httpService.onEnd();
                });
            }
        });
    };
    AdminDashboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.translate.get('total').subscribe(function (res) {
            _this.dataTableMessage.totalMessage = res;
        });
        this.translate.get('selected').subscribe(function (res) {
            _this.dataTableMessage.selectedMessage = res;
        });
    };
    AdminDashboardComponent.prototype.ngOnDestroy = function () {
        this.dialog.closeAll();
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"])(__WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__["DatatableComponent"]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__["DatatableComponent"])
    ], AdminDashboardComponent.prototype, "table", void 0);
    AdminDashboardComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'admin-dashboard',
            template: __webpack_require__(1245),
            styles: [__webpack_require__(132)],
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_4__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_6__angular_material__["c" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_9__angular_forms__["h" /* FormBuilder */], __WEBPACK_IMPORTED_MODULE_12__adminDashboardResultService__["a" /* AdminDashboardResultService */], __WEBPACK_IMPORTED_MODULE_8__shared_services_common_service__["a" /* CommonService */],
            __WEBPACK_IMPORTED_MODULE_13_ng2_translate__["d" /* TranslateService */]])
    ], AdminDashboardComponent);
    return AdminDashboardComponent;
}());



/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdminPage; });
/**
 * Created by shubham on 11/4/18.
 */
/**
 * An object used to get page information from the server
 */
var AdminPage = /** @class */ (function () {
    function AdminPage() {
        //The number of elements in the page
        this.size = 0;
        //The total number of elements
        this.totalElements = 0;
        //The total number of pages
        this.totalPages = 0;
        //The current page number
        this.pageNumber = 0;
    }
    return AdminPage;
}());



/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdminDashboardResultService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__admin_dashboard_admin_datatable_admin_page_data__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__admin_dashboard_admin_datatable_admin_dashboardList__ = __webpack_require__(749);





/**
 * A server used to mock a paged data result from a server
 */
var AdminDashboardResultService = /** @class */ (function () {
    function AdminDashboardResultService() {
        this.rows = {};
        this.adminDashboardData = {};
    }
    /**
     * A method that mocks a paged server response
     * @param page The selected page
     * @returns {any} An observable containing the employee data
     */
    AdminDashboardResultService.prototype.getResults = function (page, listData) {
        var _this = this;
        this.listData = listData;
        return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(listData).map(function (data) { return _this.getPageData(page); });
    };
    /**
     * Package companyData into a PagedData object based on the selected Page
     * @param page The page data used to get the selected data from companyData
     * @returns {PagedData<icsList>} An array of the selected data and page
     */
    AdminDashboardResultService.prototype.getPageData = function (page) {
        var pageData = new __WEBPACK_IMPORTED_MODULE_3__admin_dashboard_admin_datatable_admin_page_data__["a" /* AdminPageData */]();
        var offset = this.listData.offset;
        var raw = [];
        for (var l in this.listData) {
            if (Object.keys(this.listData[l]).length > 0) {
                raw[offset + parseInt(l)] = this.listData[l];
            }
        }
        if (this.listData.totalCount) {
            page.totalElements = this.listData.totalCount;
        }
        page.totalPages = page.totalElements / page.size;
        var start = page.pageNumber * page.size;
        var end = Math.min((start + page.size), page.totalElements);
        for (var i = start; i < end; i++) {
            if (raw[i]) {
                var jsonObj = raw[i];
                if (jsonObj) {
                    var list = new __WEBPACK_IMPORTED_MODULE_4__admin_dashboard_admin_datatable_admin_dashboardList__["a" /* AdminDashboardList */](jsonObj['id'], jsonObj['Name'], jsonObj['roleName'], jsonObj['email'], jsonObj['emailVerified'], jsonObj['businessUnits'], jsonObj['pendingSubUserCount'], jsonObj['userId_WPASS'], jsonObj['languageId'], jsonObj['languageName'], jsonObj['countryId'], jsonObj['countryName'], jsonObj['companyName'], jsonObj['companyAddress'], jsonObj['companyPhone'], jsonObj['personalArea'], jsonObj['costCenter'], jsonObj['location'], jsonObj['contractorType'], jsonObj['actionFlag'], jsonObj['status'], jsonObj['appStatus'], jsonObj['createdAt']);
                    pageData.data.push(list);
                }
            }
        }
        pageData.page = page;
        return pageData;
    };
    AdminDashboardResultService = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [])
    ], AdminDashboardResultService);
    return AdminDashboardResultService;
}());



/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApplicationsPage; });
/**
 * Created by shubham on 11/4/18.
 */
/**
 * An object used to get page information from the server
 */
var ApplicationsPage = /** @class */ (function () {
    function ApplicationsPage() {
        //The number of elements in the page
        this.size = 0;
        //The total number of elements
        this.totalElements = 0;
        //The total number of pages
        this.totalPages = 0;
        //The current page number
        this.pageNumber = 0;
    }
    return ApplicationsPage;
}());



/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApplicationsManagerDashboardComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_services_common_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__applications_datatable_applications_page__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__applicationsManagerDashboardResultService__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ng2_translate__ = __webpack_require__(17);
/**
 * Created by shubham on 20/10/18.
 */















var ApplicationsManagerDashboardComponent = /** @class */ (function () {
    function ApplicationsManagerDashboardComponent(router, httpService, sessionHandler, dialog, formBuilder, serverResultsService, commonService, translate) {
        var _this = this;
        this.router = router;
        this.httpService = httpService;
        this.sessionHandler = sessionHandler;
        this.dialog = dialog;
        this.formBuilder = formBuilder;
        this.serverResultsService = serverResultsService;
        this.commonService = commonService;
        this.translate = translate;
        this.page = new __WEBPACK_IMPORTED_MODULE_10__applications_datatable_applications_page__["a" /* ApplicationsPage */]();
        this.isSystemAdmin = false;
        this.isApplicationManager = false;
        this.isBUManager = false;
        this.isRegionalAdmin = false;
        this.isServiceOwner = false;
        this.isTradePartner = false;
        this.isSubUser = false;
        this.tableRows = [];
        this.filters = {};
        this.applicationsName = [];
        this.selectedApplicationId = '';
        this.isDisabled = false;
        this.selected = [];
        this.selectedStatusId = '';
        this.searchedFilters = { applicationName: '', wpassId: '' };
        this.showCheckbox = false;
        this.applicationsDashboardData = [];
        this.temp = [];
        this.showTable = true;
        this.Wpass = [];
        this.autocompleteLoader = "";
        this.searchWpass = "";
        this.countries = [];
        this.businessUnits = [];
        this.tempCountries = [{
                "id": "",
                "name": "all",
                "code": "",
                "active": true,
                "createdAt": "2019-02-26T12:49:39.329Z"
            }];
        this.tempBusinessUnits = [{
                "id": "",
                "name": "all",
                "codeISAM": "",
                "active": true,
                "createdAt": "2018-04-06T20:05:02.397Z",
                "updatedAt": "2018-05-31T06:41:54.303Z"
            }];
        this.selectedCountryId = "";
        this.selectedBusinessUnit = "";
        this.dataTableMessage = { 'selectedMessage': '', 'totalMessage': '' };
        this.StatusData = [{
                "id": "",
                "code": "",
                "name": "all"
            }];
        this.saveApplicationsList = function (res, filter) {
            if (res.errorStatus == 'Fail') {
                this.httpService.onEnd();
                this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
                this.dialogRef.componentInstance.msg = 'data_pull_fail';
            }
            else {
                if (res && Object.keys(res).length > 0) {
                    this.applicationsDashboardData = res;
                    this.rows = [];
                    this.rows['offset'] = res.offset;
                    this.count = res.count;
                    this.totalCount = res.totalCount;
                    if (this.applicationsDashboardData.list) {
                        var totalCount = 0;
                        if (parseInt(res.offset) == 0) {
                            localStorage.setItem('totalCount', res.totalCount);
                            totalCount = parseInt(res.totalCount);
                        }
                        else {
                            totalCount = parseInt(localStorage.getItem('totalCount'));
                        }
                        this.rows['totalCount'] = totalCount;
                        for (var data in this.applicationsDashboardData.list) {
                            if (this.isBUManager || this.isRegionalAdmin || this.isApplicationManager || this.isSystemAdmin) {
                                this.rows[data] = {};
                                this.rows[data]['id'] = this.applicationsDashboardData.list[data]['id'];
                                this.rows[data]['applicationId'] = this.applicationsDashboardData.list[data]['applicationId'];
                                this.rows[data]['applicationName'] = this.applicationsDashboardData.list[data]['applicationName'];
                                if (this.applicationsDashboardData.list[data]['applicationRoles'] && Object.keys(this.applicationsDashboardData.list[data]['applicationRoles']).length > 0) {
                                    var multipleApplicationRoles = [];
                                    for (var roles in this.applicationsDashboardData.list[data]['applicationRoles']) {
                                        if (this.applicationsDashboardData.list[data]['applicationRoles'][roles]['roleName']) {
                                            multipleApplicationRoles.push(this.applicationsDashboardData.list[data]['applicationRoles'][roles]);
                                            this.rows[data]['applicationRoles'] = multipleApplicationRoles;
                                        }
                                        else {
                                            this.rows[data]['applicationRoles'] = null;
                                        }
                                    }
                                }
                                else {
                                    this.rows[data]['applicationRoles'] = null;
                                }
                                if (this.applicationsDashboardData.list[data]['userId_WPASS']) {
                                    this.rows[data]['userId_WPASS'] = this.applicationsDashboardData.list[data]['userId_WPASS'];
                                }
                                else {
                                    this.rows[data]['userId_WPASS'] = null;
                                }
                                this.rows[data]['businessUnitId'] = this.applicationsDashboardData.list[data]['businessUnitId'];
                                this.rows[data]['businessUnitName'] = this.applicationsDashboardData.list[data]['businessUnitName'];
                                this.rows[data]['countryId'] = this.applicationsDashboardData.list[data]['countryId'];
                                this.rows[data]['countryName'] = this.applicationsDashboardData.list[data]['countryName'];
                                if (this.applicationsDashboardData.list[data]['approverId']) {
                                    this.rows[data]['approverId'] = this.applicationsDashboardData.list[data]['approverId'];
                                    this.rows[data]['approverName'] = this.applicationsDashboardData.list[data]['approverName'];
                                }
                                else {
                                    this.rows[data]['approverId'] = null;
                                    this.rows[data]['approverName'] = null;
                                }
                                this.rows[data]['multipleRole'] = this.applicationsDashboardData.list[data]['multipleRole'];
                                if (this.applicationsDashboardData.list[data]['reason']) {
                                    this.rows[data]['reason'] = this.applicationsDashboardData.list[data]['reason'];
                                }
                                else {
                                    this.rows[data]['reason'] = null;
                                }
                                this.rows[data]['status'] = this.applicationsDashboardData.list[data]['status'];
                                this.rows[data]['statusCode'] = this.applicationsDashboardData.list[data]['statusCode'];
                                this.rows[data]['updatedAt'] = this.applicationsDashboardData.list[data]['updatedAt'];
                            }
                            else {
                                //For Other Service Partner's
                                this.rows[data] = {};
                            }
                        }
                        this.showTable = true;
                        this.temp = this.rows;
                    }
                    else {
                        this.showTable = false;
                    }
                    var finalRows = [];
                    for (var f in this.rows) {
                        if (f != 'offset' && f != 'totalCount' && this.rows[f]) {
                            finalRows.push(this.rows[f]);
                        }
                        if (f == 'offset') {
                            finalRows['offset'] = this.rows['offset'];
                        }
                        if (f == 'totalCount') {
                            finalRows['totalCount'] = this.rows['totalCount'];
                        }
                    }
                    this.rows = finalRows;
                    this.setPage({ offset: this.rows['offset'] / this.page.size }, finalRows, filter);
                    this.httpService.onEnd();
                }
            }
        };
        //Close Sidebar Initially
        __WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].navCollapsed = true;
        this.page.pageNumber = 0;
        this.page.size = 20;
        this.applicationText = 'applicationManagerView';
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].applicationManager)) {
                this.isApplicationManager = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].BUManager)) {
                this.isBUManager = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].serviceOwner)) {
                this.isServiceOwner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].tradePartner)) {
                this.isTradePartner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].subuser)) {
                this.isSubUser = true;
            }
        }
        else {
            this.httpService.noUserError();
        }
        this.filters['offSet'] = this.page.pageNumber * this.page.size;
        this.filters['limit'] = this.page.size;
        if (this.isBUManager || this.isRegionalAdmin || this.isApplicationManager || this.isSystemAdmin) {
            this.getCountries();
            this.getBusinessUnitAll();
            this.getStatusList();
            this.getApplicationsName();
            this.getApplicationsList(this.filters, this.selectedStatusId, this.selectedApplicationId, this.searchWpass, this.selectedBusinessUnit, this.selectedCountryId);
        }
        else {
            this.showTable = false;
        }
        //Call when approve/delete from ApproveRejectComponent/ActiveInactiveComponent to get the updated list.
        this.commonService.applicationDashboard.subscribe(function (value) {
            _this.getApplicationsList(_this.filters, _this.selectedStatusId, _this.selectedApplicationId, _this.searchWpass, _this.selectedBusinessUnit, _this.selectedCountryId);
        });
    }
    /*buildForm() {
        this.ApplicationsFiltersForm = this.formBuilder.group({
            wpassId: this.formBuilder.control(''),
        });
        this.ApplicationsFiltersForm.valueChanges.subscribe(data => {
            this.wpassId = this.ApplicationsFiltersForm.get('wpassId').value;
        });
    }*/
    ApplicationsManagerDashboardComponent.prototype.getCountries = function () {
        var _this = this;
        this.httpService.getRequest('lookupDataOperationsApi/v1/countriesForAdmin').subscribe(function (res) { _this.saveCountries(res); }, function (err) { _this.httpService.onEnd(); });
    };
    ApplicationsManagerDashboardComponent.prototype.saveCountries = function (res) {
        if (res && res.items) {
            this.countries = this.tempCountries.concat(res.items);
        }
    };
    ApplicationsManagerDashboardComponent.prototype.onCountryChange = function (countryId) {
        //this.businessUnits = [];
        this.businessUnits = this.tempBusinessUnits;
        if (countryId != "") {
            this.selectedBusinessUnit = "";
            this.getBusinessUnitForCountry(countryId);
        }
        else {
            this.getBusinessUnitAll();
        }
    };
    ApplicationsManagerDashboardComponent.prototype.getBusinessUnitForCountry = function (countryId) {
        var _this = this;
        this.httpService.getRequestWithoutLoader('lookupDataOperationsApi/v1/buForSelectedCountry/' + countryId).subscribe(function (res) { _this.saveBusinessUnitForCountry(res); }, function (err) { _this.httpService.onEnd(); });
    };
    ApplicationsManagerDashboardComponent.prototype.saveBusinessUnitForCountry = function (res) {
        if (res && res.items) {
            //this.businessUnits = res.items;
            this.businessUnits = this.tempBusinessUnits.concat(res.items);
        }
        this.httpService.onEnd();
    };
    ApplicationsManagerDashboardComponent.prototype.getBusinessUnitAll = function () {
        var _this = this;
        this.httpService.getRequestWithoutAuth('lookupDataOperationsApi/v1/businessUnit', true).subscribe(function (res) { _this.saveBusinessUnitAll(res); }, function (err) { _this.httpService.onEnd(); });
    };
    ApplicationsManagerDashboardComponent.prototype.saveBusinessUnitAll = function (res) {
        if (res && res.items) {
            this.businessUnits = this.tempBusinessUnits.concat(res.items);
            this.httpService.onEnd();
        }
    };
    ApplicationsManagerDashboardComponent.prototype.autocompleteSearch = function (term, filter) {
        var _this = this;
        if (filter == "wpass") {
            this.Wpass = [];
            this.searchWpass = term;
        }
        if (term == "")
            return;
        var url = "/lookupDataOperationsApi/v1/partialSearch?type=" + filter + "&searchStr=" + term;
        this.autocompleteLoader = filter;
        this.httpService.getRequestForAutocomplete(url).subscribe(function (res) {
            if (res && res['items']) {
                var name_1 = res['items'];
                var filterArray = [];
                for (var index in name_1) {
                    filterArray.push(name_1[index]['name']);
                }
                if (filter == "wpass") {
                    _this.Wpass = filterArray;
                }
            }
            _this.autocompleteLoader = "";
            _this.httpService.onEnd();
        }, function (err) {
            _this.autocompleteLoader = "";
            _this.httpService.onEnd();
        });
    };
    ApplicationsManagerDashboardComponent.prototype.onSelectAutocomplete = function (value, textFlag) {
        if (textFlag == "wpass") {
            this.searchWpass = value;
        }
    };
    ApplicationsManagerDashboardComponent.prototype.search = function () {
        this.selected = [];
        this.filters['offSet'] = 0;
        if (this.searchWpass == undefined) {
            this.searchWpass = "";
        }
        else if (this.searchWpass != "" && this.Wpass.length > 0) {
            if (this.checkAutocompleteWord(this.Wpass, this.searchWpass)) {
                this.searchWpass = "";
            }
        }
        this.getApplicationsList(this.filters, this.selectedStatusId, this.selectedApplicationId, this.searchWpass, this.selectedBusinessUnit, this.selectedCountryId);
    };
    ApplicationsManagerDashboardComponent.prototype.resetSearch = function () {
        /*this.ApplicationsFiltersForm.controls['wpassId'].enable();
        this.ApplicationsFiltersForm.reset();*/
        this.selectedApplicationId = "";
        this.searchWpass = '';
        this.selectedStatusId = "";
        this.Wpass = [];
        this.countries = [];
        this.businessUnits = [];
        this.selectedBusinessUnit = "";
        this.selectedCountryId = "";
        this.getCountries();
        this.getBusinessUnitAll();
        this.search();
    };
    ApplicationsManagerDashboardComponent.prototype.checkAutocompleteWord = function (objArray, searchValue) {
        if (objArray.includes(searchValue)) {
            return false;
        }
        else {
            return true;
        }
    };
    ApplicationsManagerDashboardComponent.prototype.getStatusList = function () {
        var _this = this;
        this.httpService.getRequest("applicationOperationApi/v1/getApplicationStatusList").subscribe(function (res) { _this.saveStatusList(res); }, function (err) { _this.httpService.onEnd(); });
    };
    ApplicationsManagerDashboardComponent.prototype.saveStatusList = function (res) {
        if (res) {
            if (res.items) {
                for (var s in res.items) {
                    this.StatusData.push(res.items[s]);
                }
            }
        }
    };
    ApplicationsManagerDashboardComponent.prototype.getApplicationsName = function () {
        var _this = this;
        this.httpService.getRequest("applicationOperationApi/v1/applicationsForDropdown").subscribe(function (res) { _this.saveApplicationsName(res); }, function (err) { _this.httpService.onEnd(); });
    };
    ApplicationsManagerDashboardComponent.prototype.saveApplicationsName = function (res) {
        if (res && res.items) {
            var tempApp = [{ "id": "", "code": "", "name": "all" }];
            this.applicationsName = tempApp.concat(res.items);
        }
    };
    ApplicationsManagerDashboardComponent.prototype.getApplicationsList = function (filter, selectedStatus, applicationId, wpassId, selectedBusinessUnit, selectedCountryId) {
        var _this = this;
        this.searchedFilters.wpassId = wpassId;
        if (selectedStatus == 'PENDING' && applicationId != '') {
            this.showCheckbox = true;
        }
        else {
            this.showCheckbox = false;
        }
        this.httpService.getRequest("/applicationOperationApi/v1/applicationRequestsForManager?limit=" + filter.limit + "&offset=" + filter.offSet + "&status=" + selectedStatus + "&applicationId=" + applicationId + "&wpassId=" + wpassId + "&businessUnitId=" + selectedBusinessUnit + "&countryId=" + selectedCountryId).subscribe(function (res) { _this.saveApplicationsList(res, filter); }, function (err) { _this.httpService.onEnd(); });
    };
    /**
     * Populate the table with new data based on the page number
     * @param page The page to select
     */
    ApplicationsManagerDashboardComponent.prototype.setPage = function (pageInfo, rows, filter) {
        var _this = this;
        this.page.pageNumber = pageInfo.offset;
        if (rows.length != 0) {
            this.serverResultsService.getResults(this.page, rows).subscribe(function (pageData) {
                _this.page = pageData.page;
                _this.tableRows = pageData.data;
                if (!filter) {
                    if (Object.keys(_this.tableRows).length == 0 || !_this.tableRows[0]['status']) {
                        _this.filters['offSet'] = _this.page.pageNumber * _this.page.size;
                        _this.getApplicationsList(_this.filters, _this.selectedStatusId, _this.selectedApplicationId, _this.searchWpass, _this.selectedBusinessUnit, _this.selectedCountryId);
                    }
                }
            });
        }
        else {
            this.tableRows = [];
            this.page.totalElements = rows.length;
        }
    };
    ApplicationsManagerDashboardComponent.prototype.rejectAction = function (id, status) {
        var _this = this;
        this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["h" /* ApplicationRejectActionDialogComponent */]);
        this.dialogRef.componentInstance.isRejected = true;
        this.dialogRef.componentInstance.msg = 'rqst_rjct_confirm';
        this.dialogRef.afterClosed().subscribe(function (result) {
            if (result) {
                var data = {};
                data['id'] = id;
                data['status'] = status;
                data['message'] = result;
                var today = new Date();
                var dd = ('0' + today.getDate()).slice(-2);
                var mm = ('0' + (today.getMonth() + 1)).slice(-2);
                var yyyy = today.getFullYear();
                data['approvalDate'] = yyyy + '' + mm + '' + dd;
                _this.httpService.postRequest(data, 'applicationOperationApi/v1/approveApplicationRequest').subscribe(function (res) {
                    _this.saveResponse(res, status);
                }, function (err) {
                    _this.httpService.onEnd();
                });
            }
        });
    };
    ApplicationsManagerDashboardComponent.prototype.saveResponse = function (res, status) {
        var _this = this;
        this.httpService.onEnd();
        var statusTxt;
        if (res) {
            if (status == 'REJECTED') {
                statusTxt = 'Rejected Successfully';
            }
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = statusTxt;
            this.dialogRef.afterClosed().subscribe(function (result) {
                _this.getApplicationsList(_this.filters, _this.selectedStatusId, _this.selectedApplicationId, _this.searchWpass, _this.selectedBusinessUnit, _this.selectedCountryId);
            });
        }
    };
    ApplicationsManagerDashboardComponent.prototype.onSelect = function (_a) {
        var selected = _a.selected;
        var _b;
        this.selected.splice(0, this.selected.length);
        (_b = this.selected).push.apply(_b, selected);
        this.selectedCount = this.selected.length;
    };
    ApplicationsManagerDashboardComponent.prototype.downloadCsv = function () {
        var loginDataArray = JSON.parse(this.sessionHandler.getItem("loginData"));
        var accessToken;
        if (loginDataArray) {
            accessToken = loginDataArray['accessToken'];
        }
        window.open(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].URL + '/export?access-token=' + accessToken + '&action=application_requests&status=' + this.selectedStatusId + '&applicationId=' + this.selectedApplicationId + '&wpassId=' + this.searchWpass + '&businessUnitId=' + this.selectedBusinessUnit + '&countryId=' + this.selectedCountryId, '_blank');
    };
    ApplicationsManagerDashboardComponent.prototype.saveRevokeData = function (id) {
        var _this = this;
        this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
        this.dialogRef.componentInstance.isConfirm = true;
        this.dialogRef.componentInstance.msg = "app_revoke_confirm";
        this.dialogRef.afterClosed().subscribe(function (result) {
            if (result) {
                var user_application_id = { id: id };
                _this.httpService.postRequest(user_application_id, 'applicationOperationApi/v1/revokeAllApplicationRoles').subscribe(function (res) {
                    _this.dialogRef = _this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
                    _this.dialogRef.componentInstance.msg = "request_success";
                    _this.httpService.onEnd();
                }, function (err) {
                    _this.httpService.onEnd();
                    _this.dialogRef = _this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
                    _this.dialogRef.componentInstance.msg = "request_failed";
                    _this.httpService.onEnd();
                });
            }
        });
    };
    /* saveApplicationDataApi(){
        this.httpService.postRequest(this.ApplicationsRequestFormDetails,'applicationOperationApi/v1/updateUserApplicationRoles').subscribe(
            res => {
                this.saveApplicationResponse(res);
            },
            err => { this.httpService.onEnd(); }
        );
    } */
    ApplicationsManagerDashboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        //this.buildForm();
        this.translate.get('total').subscribe(function (res) {
            _this.dataTableMessage.totalMessage = res;
        });
        this.translate.get('selected').subscribe(function (res) {
            _this.dataTableMessage.selectedMessage = res;
        });
    };
    ApplicationsManagerDashboardComponent.prototype.ngOnDestroy = function () {
        this.dialog.closeAll();
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"])(__WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__["DatatableComponent"]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__["DatatableComponent"])
    ], ApplicationsManagerDashboardComponent.prototype, "table", void 0);
    ApplicationsManagerDashboardComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'applications-manager-dashboard',
            template: __webpack_require__(1247),
            styles: [__webpack_require__(132)],
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_4__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_6__angular_material__["c" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_9__angular_forms__["h" /* FormBuilder */], __WEBPACK_IMPORTED_MODULE_12__applicationsManagerDashboardResultService__["a" /* ApplicationsManagerDashboardResultService */], __WEBPACK_IMPORTED_MODULE_8__shared_services_common_service__["a" /* CommonService */],
            __WEBPACK_IMPORTED_MODULE_13_ng2_translate__["d" /* TranslateService */]])
    ], ApplicationsManagerDashboardComponent);
    return ApplicationsManagerDashboardComponent;
}());



/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApplicationsManagerDashboardResultService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applications_manager_dashboard_applications_datatable_applications_page_data__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__applications_manager_dashboard_applications_datatable_applications_dashboardList__ = __webpack_require__(753);





/**
 * A server used to mock a paged data result from a server
 */
var ApplicationsManagerDashboardResultService = /** @class */ (function () {
    function ApplicationsManagerDashboardResultService() {
        this.rows = {};
        this.applicationsDashboardData = {};
    }
    /**
     * A method that mocks a paged server response
     * @param page The selected page
     * @returns {any} An observable containing the employee data
     */
    ApplicationsManagerDashboardResultService.prototype.getResults = function (page, listData) {
        var _this = this;
        this.listData = listData;
        return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(listData).map(function (data) { return _this.getPageData(page); });
    };
    /**
     * Package companyData into a PagedData object based on the selected Page
     * @param page The page data used to get the selected data from companyData
     * @returns {PagedData<icsList>} An array of the selected data and page
     */
    ApplicationsManagerDashboardResultService.prototype.getPageData = function (page) {
        var pageData = new __WEBPACK_IMPORTED_MODULE_3__applications_manager_dashboard_applications_datatable_applications_page_data__["a" /* ApplicationsPageData */]();
        var offset = this.listData.offset;
        var raw = [];
        for (var l in this.listData) {
            if (Object.keys(this.listData[l]).length > 0) {
                raw[offset + parseInt(l)] = this.listData[l];
            }
        }
        if (this.listData.totalCount) {
            page.totalElements = this.listData.totalCount;
        }
        page.totalPages = page.totalElements / page.size;
        var start = page.pageNumber * page.size;
        var end = Math.min((start + page.size), page.totalElements);
        for (var i = start; i < end; i++) {
            if (raw[i]) {
                var jsonObj = raw[i];
                if (jsonObj) {
                    var list = new __WEBPACK_IMPORTED_MODULE_4__applications_manager_dashboard_applications_datatable_applications_dashboardList__["a" /* ApplicationsDashboardList */](jsonObj['id'], jsonObj['applicationId'], jsonObj['applicationName'], jsonObj['userId_WPASS'], jsonObj['businessUnitId'], jsonObj['businessUnitName'], jsonObj['countryId'], jsonObj['countryName'], jsonObj['approverId'], jsonObj['approverName'], jsonObj['multipleRole'], jsonObj['reason'], jsonObj['status'], jsonObj['statusCode'], jsonObj['updatedAt']);
                    pageData.data.push(list);
                }
            }
        }
        pageData.page = page;
        return pageData;
    };
    ApplicationsManagerDashboardResultService = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [])
    ], ApplicationsManagerDashboardResultService);
    return ApplicationsManagerDashboardResultService;
}());



/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApproveRejectRequestModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_http__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_common__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__approve_reject_request_approve_reject_component__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ng2_translate__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(12);
/**
 * Created by shubham on 29/4/18.
 */









var ApproveRejectRequestModule = /** @class */ (function () {
    function ApproveRejectRequestModule() {
    }
    ApproveRejectRequestModule = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
            imports: [
                __WEBPACK_IMPORTED_MODULE_2__angular_material__["a" /* MaterialModule */],
                __WEBPACK_IMPORTED_MODULE_2__angular_material__["e" /* MdTabsModule */],
                __WEBPACK_IMPORTED_MODULE_5__angular_common__["CommonModule"],
                __WEBPACK_IMPORTED_MODULE_4__angular_forms__["a" /* FormsModule */],
                __WEBPACK_IMPORTED_MODULE_4__angular_forms__["b" /* ReactiveFormsModule */],
                __WEBPACK_IMPORTED_MODULE_7_ng2_translate__["b" /* TranslateModule */].forRoot({
                    provide: __WEBPACK_IMPORTED_MODULE_7_ng2_translate__["c" /* TranslateLoader */],
                    //useFactory: (http: Http) => new TranslateStaticLoader(http, '/assets/i18n', '.json'),
                    useFactory: function (http) { return new __WEBPACK_IMPORTED_MODULE_7_ng2_translate__["a" /* TranslateStaticLoader */](http, __WEBPACK_IMPORTED_MODULE_8__config__["a" /* APPCONFIG */].URL + __WEBPACK_IMPORTED_MODULE_8__config__["a" /* APPCONFIG */].translationUrl, '?v=' + __WEBPACK_IMPORTED_MODULE_8__config__["a" /* APPCONFIG */].translationVersion); },
                    deps: [__WEBPACK_IMPORTED_MODULE_3__angular_http__["b" /* Http */]]
                })
            ],
            declarations: [
                __WEBPACK_IMPORTED_MODULE_6__approve_reject_request_approve_reject_component__["a" /* ApproveRejectComponent */]
            ],
            exports: [
                __WEBPACK_IMPORTED_MODULE_6__approve_reject_request_approve_reject_component__["a" /* ApproveRejectComponent */],
            ]
        })
    ], ApproveRejectRequestModule);
    return ApproveRejectRequestModule;
}());



/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddFileComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_http__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_services_common_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_Rx__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_Rx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_rxjs_Rx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dialog_dialog_component__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ng2_translate__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ng2_file_upload__ = __webpack_require__(576);
/**
 * Created by shubham on 11/6/18.
 */














var AddFileComponent = /** @class */ (function () {
    function AddFileComponent(router, route, Http, httpService, sessionHandler, formBuilder, dialog, translate, commonService) {
        this.router = router;
        this.route = route;
        this.Http = Http;
        this.httpService = httpService;
        this.sessionHandler = sessionHandler;
        this.formBuilder = formBuilder;
        this.dialog = dialog;
        this.translate = translate;
        this.commonService = commonService;
        this.data = [];
        this.isSystemAdmin = false;
        this.isBUManager = false;
        this.isRegionalAdmin = false;
        this.isServiceOwner = false;
        this.isTradePartner = false;
        this.isSubUser = false;
        this.headers = new __WEBPACK_IMPORTED_MODULE_4__angular_http__["c" /* Headers */]();
        this.showError = false;
        this.Countries = [];
        this.tempCountries = [{
                "id": "",
                "name": "All",
                "code": "",
                "active": true,
                "createdAt": "2019-02-26T12:49:39.329Z"
            }];
        this.tempBusinessUnits = [{
                "id": "",
                "name": "All",
                "codeISAM": "",
                "active": true,
                "createdAt": "2018-04-06T20:05:02.397Z",
                "updatedAt": "2018-05-31T06:41:54.303Z"
            }];
        this.BusinessUnit = [];
        this.uploadAction = false;
        this.formDataFlag = false;
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            this.accessToken = this.userDetails['accessToken'];
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].BUManager)) {
                this.isBUManager = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].serviceOwner)) {
                this.isServiceOwner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].tradePartner)) {
                this.isTradePartner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].subuser)) {
                this.isSubUser = true;
            }
        }
        else {
            this.httpService.noUserError();
        }
        this.URL = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].URL + "/uploadCsv/dataUpload";
        this.uploader = new __WEBPACK_IMPORTED_MODULE_13_ng2_file_upload__["b" /* FileUploader */]({ url: this.URL, disableMultipart: true });
        this.getCountries();
    }
    AddFileComponent.prototype.getCountries = function () {
        var _this = this;
        this.httpService.getRequest('lookupDataOperationsApi/v1/countriesForAdmin').subscribe(function (res) { _this.saveCountries(res); }, function (err) { _this.httpService.onEnd(); });
    };
    AddFileComponent.prototype.saveCountries = function (res) {
        if (res && res.items) {
            //this.Countries = res.items;
            this.Countries = this.tempCountries.concat(res.items);
        }
        this.FileUploadForm.controls['countryId'].disable();
        this.FileUploadForm.controls['businessUnitId'].disable();
        this.httpService.onEnd();
    };
    AddFileComponent.prototype.getBusinessUnitByCountryId = function (countryId) {
        var _this = this;
        if (countryId) {
            this.httpService.getRequest('lookupDataOperationsApi/v1/buForSelectedCountry/' + countryId).subscribe(function (res) { _this.saveBusinessUnitByCountryId(res); }, function (err) { _this.httpService.onEnd(); });
        }
    };
    AddFileComponent.prototype.saveBusinessUnitByCountryId = function (res) {
        if (res && res.items) {
            //this.BusinessUnit = res.items;
            this.BusinessUnit = this.tempBusinessUnits.concat(res.items);
        }
        this.httpService.onEnd();
    };
    AddFileComponent.prototype.buildForm = function () {
        var _this = this;
        this.FileUploadForm = this.formBuilder.group({
            selectedRadioValue: this.formBuilder.control('Role_Maintenance', [__WEBPACK_IMPORTED_MODULE_8__angular_forms__["g" /* Validators */].required]),
            countryId: this.formBuilder.control('', [__WEBPACK_IMPORTED_MODULE_8__angular_forms__["g" /* Validators */].required]),
            businessUnitId: this.formBuilder.control('', [__WEBPACK_IMPORTED_MODULE_8__angular_forms__["g" /* Validators */].required]),
        });
        this.FileUploadForm.valueChanges.subscribe(function (data) {
            _this.FileUploadFormDetails = _this.FileUploadForm.getRawValue();
            _this.FileUploadFormDetails['includesHeader'] = true;
            _this.FileUploadFormDetails.validate = _this.FileUploadForm.valid;
        });
        this.FileUploadForm.get('selectedRadioValue').valueChanges.subscribe(function (data) {
            if (data != null) {
                if (data == 'Role_Maintenance') {
                    _this.uploadAction = false;
                    _this.FileUploadForm.controls['countryId'].disable();
                    _this.FileUploadForm.controls['businessUnitId'].disable();
                }
                else if (data == 'User_Migration') {
                    _this.uploadAction = true;
                    _this.FileUploadForm.controls['countryId'].enable();
                    _this.FileUploadForm.controls['businessUnitId'].enable();
                }
            }
        });
        this.FileUploadForm.get('countryId').valueChanges.subscribe(function (data) {
            _this.FileUploadForm.controls['businessUnitId'].setValue('');
            //this.BusinessUnit = [];
            _this.BusinessUnit = _this.tempBusinessUnits;
            if (data != null) {
                _this.getBusinessUnitByCountryId(data);
            }
        });
    };
    AddFileComponent.prototype.fileupload = function () {
        this.formData = new FormData();
        for (var i in this.uploader.queue) {
            if (!this.uploader.queue[i].isSuccess) {
                if (this.uploader.queue[i]._file.type == 'text/csv' || this.uploader.queue[i]._file.type == ''
                    || (this.uploader.queue[i]._file.type.indexOf("excel") != -1)) {
                    this.csvName = this.uploader.queue[i]._file.name;
                    if (this.uploader.queue[i]._file.type == '') {
                        if (this.csvName.indexOf(".")) {
                            var checkExtension = this.csvName.substring(this.csvName.indexOf(".") + 1, this.csvName.length);
                            if (checkExtension != 'csv') {
                                this.showError = true;
                                this.formDataFlag = false;
                                this.errorMsg = 'invalid_csv_format';
                            }
                        }
                    }
                    if (this.uploader.queue[i]._file.size / 1024 / 1024 < 5) {
                        this.showError = false;
                        this.formData.append('file', this.uploader.queue[i]._file);
                        this.formDataFlag = true;
                    }
                    else {
                        this.showError = true;
                        this.uploader.queue[i].isError = true;
                        this.formDataFlag = false;
                        this.errorMsg = 'file_too_large';
                    }
                }
                else {
                    this.showError = true;
                    this.formDataFlag = false;
                    this.errorMsg = 'invalid_csv_format';
                }
            }
        }
    };
    AddFileComponent.prototype.downloadSampleCSVFile = function () {
        var sampleMigrationData;
        var fileName = "User_migration_sample.csv";
        if (this.FileUploadFormDetails['selectedRadioValue'] == 'Role_Maintenance') {
            sampleMigrationData = [['LDAP ID', 'LDAP ROLE', 'Business Unit Name', 'Customer Number']];
            fileName = "Role_migration_sample.csv";
        }
        else {
            sampleMigrationData = [['LDAP ID (Optional)', 'First Name', 'Last Name', 'Email', 'Company Name', 'Company Phone', 'Company Address', 'Customer No', 'Language (Optional)', 'LDAP ROLE (Optional)']];
        }
        var csvContent = "data:text/csv;charset=utf-8,";
        sampleMigrationData.forEach(function (infoArray, index) {
            var dataString = infoArray.join(",");
            csvContent += index < sampleMigrationData.length ? dataString + "\n" : dataString;
        });
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", fileName);
        link.click();
    };
    AddFileComponent.prototype.saveUploadCSVData = function () {
        var _this = this;
        this.httpService.showLoader();
        this.Http
            .post(this.URL + '?action=' + this.FileUploadFormDetails['selectedRadioValue'] + '&includesHeader=' + this.FileUploadFormDetails['includesHeader'] + '&countryId=' + this.FileUploadFormDetails['countryId'] + '&businessUnitId=' + this.FileUploadFormDetails['businessUnitId'] + '&apiKey=' + __WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].apiKey + '&access-token=' + this.accessToken, this.formData, { headers: this.headers })
            .toPromise()
            .then(function (res) { return _this.setFormData(res.json()); })
            .catch(function (error) { return __WEBPACK_IMPORTED_MODULE_10_rxjs_Rx__["Observable"].throw(_this.httpService.handleError(error.json(), 'uploadCsv/dataUpload')); });
    };
    AddFileComponent.prototype.setFormData = function (res) {
        var _this = this;
        this.uploader = new __WEBPACK_IMPORTED_MODULE_13_ng2_file_upload__["b" /* FileUploader */]({ url: this.URL, disableMultipart: true });
        if (res) {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_11__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = "req_rcvd_to_be_notified_by_mail";
            this.dialogRef.afterClosed().subscribe(function (result) {
                _this.router.navigateByUrl('/app/file-upload/list');
            });
        }
        else if (res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_11__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = 'unable_to_upload';
            this.httpService.onEnd();
        }
    };
    AddFileComponent.prototype.ngOnInit = function () {
        this.buildForm();
    };
    AddFileComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            template: __webpack_require__(1260)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_3__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_3__angular_router__["b" /* ActivatedRoute */], __WEBPACK_IMPORTED_MODULE_4__angular_http__["b" /* Http */], __WEBPACK_IMPORTED_MODULE_5__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_2__shared_services_session_handler_service__["a" /* SessionHandler */],
            __WEBPACK_IMPORTED_MODULE_8__angular_forms__["h" /* FormBuilder */], __WEBPACK_IMPORTED_MODULE_6__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_12_ng2_translate__["d" /* TranslateService */], __WEBPACK_IMPORTED_MODULE_9__shared_services_common_service__["a" /* CommonService */]])
    ], AddFileComponent);
    return AddFileComponent;
}());



/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileUploadComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ng2_translate__ = __webpack_require__(17);
/**
 * Created by shubham on 13/6/18.
 */







var FileUploadComponent = /** @class */ (function () {
    function FileUploadComponent(router, sessionHandler, httpService, dialog, translate) {
        this.router = router;
        this.sessionHandler = sessionHandler;
        this.httpService = httpService;
        this.dialog = dialog;
        this.translate = translate;
        this.languageId = this.sessionHandler.getItem('languageId');
        if (!this.languageId) {
            this.languageId = "EN";
        }
        this.translate.use(this.languageId);
    }
    FileUploadComponent.prototype.ngOnInit = function () { };
    FileUploadComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'file-upload',
            template: __webpack_require__(1261)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_5__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_4__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_3__angular_material__["c" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_6_ng2_translate__["d" /* TranslateService */]])
    ], FileUploadComponent);
    return FileUploadComponent;
}());



/***/ }),

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CSVUploadModule", function() { return CSVUploadModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_http__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_common__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__swimlane_ngx_datatable__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__swimlane_ngx_datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__swimlane_ngx_datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fileUpload_routing_module__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fileUpload_component__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fileUploadList_fileUploadList_component__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__add_file_addFile_component__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ng2_file_upload__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ng2_translate__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config__ = __webpack_require__(12);
/**
 * Created by shubham on 13/6/18.
 */














var CSVUploadModule = /** @class */ (function () {
    function CSVUploadModule() {
    }
    CSVUploadModule = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
            imports: [
                __WEBPACK_IMPORTED_MODULE_3__angular_material__["a" /* MaterialModule */],
                __WEBPACK_IMPORTED_MODULE_3__angular_material__["e" /* MdTabsModule */],
                __WEBPACK_IMPORTED_MODULE_5__angular_common__["CommonModule"],
                __WEBPACK_IMPORTED_MODULE_4__angular_forms__["a" /* FormsModule */],
                __WEBPACK_IMPORTED_MODULE_6__swimlane_ngx_datatable__["NgxDatatableModule"],
                __WEBPACK_IMPORTED_MODULE_4__angular_forms__["b" /* ReactiveFormsModule */],
                __WEBPACK_IMPORTED_MODULE_11_ng2_file_upload__["a" /* FileUploadModule */],
                __WEBPACK_IMPORTED_MODULE_7__fileUpload_routing_module__["a" /* FileUploadRoutingModule */],
                __WEBPACK_IMPORTED_MODULE_12_ng2_translate__["b" /* TranslateModule */].forRoot({
                    provide: __WEBPACK_IMPORTED_MODULE_12_ng2_translate__["c" /* TranslateLoader */],
                    //useFactory: (http: Http) => new TranslateStaticLoader(http, '/assets/i18n', '.json'),
                    useFactory: function (http) { return new __WEBPACK_IMPORTED_MODULE_12_ng2_translate__["a" /* TranslateStaticLoader */](http, __WEBPACK_IMPORTED_MODULE_13__config__["a" /* APPCONFIG */].URL + __WEBPACK_IMPORTED_MODULE_13__config__["a" /* APPCONFIG */].translationUrl, '?v=' + __WEBPACK_IMPORTED_MODULE_13__config__["a" /* APPCONFIG */].translationVersion); },
                    deps: [__WEBPACK_IMPORTED_MODULE_2__angular_http__["b" /* Http */]]
                })
            ],
            declarations: [
                __WEBPACK_IMPORTED_MODULE_8__fileUpload_component__["a" /* FileUploadComponent */],
                __WEBPACK_IMPORTED_MODULE_9__fileUploadList_fileUploadList_component__["a" /* FileUploadListComponent */],
                __WEBPACK_IMPORTED_MODULE_10__add_file_addFile_component__["a" /* AddFileComponent */]
            ],
            exports: []
        })
    ], CSVUploadModule);
    return CSVUploadModule;
}());



/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileUploadListPage; });
/**
 * Created by shubham on 11/4/18.
 */
/**
 * An object used to get page information from the server
 */
var FileUploadListPage = /** @class */ (function () {
    function FileUploadListPage() {
        //The number of elements in the page
        this.size = 0;
        //The total number of elements
        this.totalElements = 0;
        //The total number of pages
        this.totalPages = 0;
        //The current page number
        this.pageNumber = 0;
    }
    return FileUploadListPage;
}());



/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileUploadListComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_services_common_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fileUploadList_datatable_fileUploadList_page__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fileUploadListDashboardResultService__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ng2_translate__ = __webpack_require__(17);
/**
 * Created by shubham on 13/6/18.
 */














var FileUploadListComponent = /** @class */ (function () {
    function FileUploadListComponent(router, httpService, sessionHandler, dialog, serverResultsService, commonService, translate) {
        this.router = router;
        this.httpService = httpService;
        this.sessionHandler = sessionHandler;
        this.dialog = dialog;
        this.serverResultsService = serverResultsService;
        this.commonService = commonService;
        this.translate = translate;
        this.page = new __WEBPACK_IMPORTED_MODULE_10__fileUploadList_datatable_fileUploadList_page__["a" /* FileUploadListPage */]();
        this.tableRows = [];
        this.filters = {};
        this.temp = [];
        this.showTable = true;
        this.isSystemAdmin = false;
        this.isBUManager = false;
        this.isRegionalAdmin = false;
        this.isServiceOwner = false;
        this.isTradePartner = false;
        this.isSubUser = false;
        this.dataTableMessage = { 'selectedMessage': '', 'totalMessage': '' };
        this.saveFileUploadList = function (res, filter) {
            if (res.errorStatus == 'Fail') {
                this.httpService.onEnd();
                this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
                this.dialogRef.componentInstance.msg = 'data_pull_fail';
            }
            else {
                if (res && Object.keys(res).length > 0) {
                    this.uploadList = res;
                    this.rows = [];
                    this.rows['offset'] = res.offset;
                    if (this.uploadList.list) {
                        var totalCount = 0;
                        if (parseInt(res.offset) == 0) {
                            localStorage.setItem('totalCount', res.totalCount);
                            totalCount = parseInt(res.totalCount);
                        }
                        else {
                            totalCount = parseInt(localStorage.getItem('totalCount'));
                        }
                        this.rows['totalCount'] = totalCount;
                        for (var data in this.uploadList.list) {
                            this.rows[data] = {};
                            this.rows[data]['id'] = this.uploadList.list[data]['id'];
                            this.rows[data]['type'] = this.uploadList.list[data]['type'];
                            if (this.uploadList.list[data]['countryName']) {
                                this.rows[data]['countryName'] = this.uploadList.list[data]['countryName'];
                            }
                            if (this.uploadList.list[data]['businessUnitName']) {
                                this.rows[data]['businessUnitName'] = this.uploadList.list[data]['businessUnitName'];
                            }
                            this.rows[data]['includesHeader'] = this.uploadList.list[data]['includesHeader'];
                            this.rows[data]['csvName'] = this.uploadList.list[data]['csvName'];
                            this.rows[data]['csvUrl'] = this.uploadList.list[data]['csvUrl'];
                            this.rows[data]['status'] = this.uploadList.list[data]['status'];
                            this.rows[data]['error'] = this.uploadList.list[data]['error'];
                            if (this.uploadList.list[data]['error'] == true) {
                                this.rows[data]['message'] = this.uploadList.list[data]['message'];
                            }
                            this.rows[data]['uploadBy'] = this.uploadList.list[data]['uploadBy'];
                            this.rows[data]['uploadedAt'] = this.uploadList.list[data]['uploadedAt'];
                        }
                        this.showTable = true;
                        this.temp = this.rows;
                    }
                    else {
                        this.showTable = false;
                    }
                    var finalRows = [];
                    for (var f in this.rows) {
                        if (f != 'offset' && f != 'totalCount' && this.rows[f]) {
                            finalRows.push(this.rows[f]);
                        }
                        if (f == 'offset') {
                            finalRows['offset'] = this.rows['offset'];
                        }
                        if (f == 'totalCount') {
                            finalRows['totalCount'] = this.rows['totalCount'];
                        }
                    }
                    this.rows = finalRows;
                    this.setPage({ offset: this.rows['offset'] / this.page.size }, finalRows, filter);
                    this.httpService.onEnd();
                }
            }
        };
        this.page.pageNumber = 0;
        this.page.size = 20;
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* APPCONFIG */].systemAdmin)) {
                this.isSystemAdmin = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* APPCONFIG */].BUManager)) {
                this.isBUManager = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* APPCONFIG */].regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* APPCONFIG */].serviceOwner)) {
                this.isServiceOwner = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* APPCONFIG */].tradePartner)) {
                this.isTradePartner = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* APPCONFIG */].subuser)) {
                this.isSubUser = true;
            }
        }
        else {
            this.httpService.noUserError();
        }
        this.filters['offSet'] = this.page.pageNumber * this.page.size;
        this.filters['limit'] = this.page.size;
        if (this.isSystemAdmin || this.isBUManager) {
            this.getFileUploadList(this.filters);
        }
        else {
            this.showTable = false;
        }
    }
    FileUploadListComponent.prototype.getFileUploadList = function (filter) {
        var _this = this;
        this.httpService.getRequest("dataUploadOperations/v1/userMigration/list?limit=" + filter.limit + "&offset=" + filter.offSet).subscribe(function (res) { _this.saveFileUploadList(res, filter); }, function (err) { _this.httpService.onEnd(); });
    };
    /**
     * Populate the table with new data based on the page number
     * @param page The page to select
     */
    FileUploadListComponent.prototype.setPage = function (pageInfo, rows, filter) {
        var _this = this;
        this.page.pageNumber = pageInfo.offset;
        if (rows.length != 0) {
            this.serverResultsService.getResults(this.page, rows).subscribe(function (pageData) {
                _this.page = pageData.page;
                _this.tableRows = pageData.data;
                if (!filter) {
                    if (Object.keys(_this.tableRows).length == 0 || !_this.tableRows[0]['status']) {
                        _this.filters['offSet'] = _this.page.pageNumber * _this.page.size;
                        _this.getFileUploadList(_this.filters);
                    }
                }
            });
        }
        else {
            this.tableRows = [];
            this.page.totalElements = rows.length;
        }
    };
    FileUploadListComponent.prototype.showErrorMsg = function (msg) {
        this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["j" /* CSVErrorDialogComponent */]);
        this.dialogRef.componentInstance.msg = msg;
    };
    FileUploadListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.translate.get('total').subscribe(function (res) {
            _this.dataTableMessage.totalMessage = res;
        });
        this.translate.get('selected').subscribe(function (res) {
            _this.dataTableMessage.selectedMessage = res;
        });
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"])(__WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__["DatatableComponent"]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__["DatatableComponent"])
    ], FileUploadListComponent.prototype, "table", void 0);
    FileUploadListComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'fileUploadList',
            template: __webpack_require__(1262)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_4__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_6__angular_material__["c" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_11__fileUploadListDashboardResultService__["a" /* FileUploadListDashboardResultService */], __WEBPACK_IMPORTED_MODULE_8__shared_services_common_service__["a" /* CommonService */], __WEBPACK_IMPORTED_MODULE_12_ng2_translate__["d" /* TranslateService */]])
    ], FileUploadListComponent);
    return FileUploadListComponent;
}());



/***/ }),

/***/ 289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileUploadListDashboardResultService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fileUploadList_datatable_fileUploadList_page_data__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fileUploadList_datatable_fileUploadList_dashboard__ = __webpack_require__(757);
/**
 * Created by shubham on 8/5/18.
 */





/**
 * A server used to mock a paged data result from a server
 */
var FileUploadListDashboardResultService = /** @class */ (function () {
    function FileUploadListDashboardResultService() {
        this.rows = {};
        this.adminDashboardData = {};
    }
    /**
     * A method that mocks a paged server response
     * @param page The selected page
     * @returns {any} An observable containing the employee data
     */
    FileUploadListDashboardResultService.prototype.getResults = function (page, listData) {
        var _this = this;
        this.listData = listData;
        return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(listData).map(function (data) { return _this.getPageData(page); });
    };
    /**
     * Package companyData into a PagedData object based on the selected Page
     * @param page The page data used to get the selected data from companyData
     * @returns {PagedData<icsList>} An array of the selected data and page
     */
    FileUploadListDashboardResultService.prototype.getPageData = function (page) {
        var pageData = new __WEBPACK_IMPORTED_MODULE_3__fileUploadList_datatable_fileUploadList_page_data__["a" /* FileUploadListPageData */]();
        var offset = this.listData.offset;
        var raw = [];
        for (var l in this.listData) {
            if (Object.keys(this.listData[l]).length > 0) {
                raw[offset + parseInt(l)] = this.listData[l];
            }
        }
        if (this.listData.totalCount) {
            page.totalElements = this.listData.totalCount;
        }
        page.totalPages = page.totalElements / page.size;
        var start = page.pageNumber * page.size;
        var end = Math.min((start + page.size), page.totalElements);
        for (var i = start; i < end; i++) {
            if (raw[i]) {
                var jsonObj = raw[i];
                if (jsonObj) {
                    var list = new __WEBPACK_IMPORTED_MODULE_4__fileUploadList_datatable_fileUploadList_dashboard__["a" /* FileUploadListDashboard */](jsonObj['id'], jsonObj['type'], jsonObj['countryName'], jsonObj['businessUnitName'], jsonObj['includesHeader'], jsonObj['csvName'], jsonObj['csvUrl'], jsonObj['status'], jsonObj['error'], jsonObj['message'], jsonObj['uploadBy'], jsonObj['uploadedAt']);
                    pageData.data.push(list);
                }
            }
        }
        pageData.page = page;
        return pageData;
    };
    FileUploadListDashboardResultService = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [])
    ], FileUploadListDashboardResultService);
    return FileUploadListDashboardResultService;
}());



/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ForgotPasswordComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dialog_dialog_component__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_services_common_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ng2_translate__ = __webpack_require__(17);
/**
 * Created by shubham on 17/5/18.
 */










var ForgotPasswordComponent = /** @class */ (function () {
    function ForgotPasswordComponent(router, route, httpService, sessionHandler, dialog, translate, formBuilder, commonService) {
        this.router = router;
        this.route = route;
        this.httpService = httpService;
        this.sessionHandler = sessionHandler;
        this.dialog = dialog;
        this.translate = translate;
        this.formBuilder = formBuilder;
        this.commonService = commonService;
        this.data = [];
    }
    ForgotPasswordComponent.prototype.buildForm = function () {
        var _this = this;
        this.ForgetPasswordForm = this.formBuilder.group({
            userId_WPASS: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].required]),
        });
        this.ForgetPasswordForm.valueChanges.subscribe(function (data) {
            _this.ForgetPasswordFormDetails = _this.ForgetPasswordForm.getRawValue();
        });
    };
    ForgotPasswordComponent.prototype.forgetPassword = function () {
        var _this = this;
        this.httpService.postRequest(this.ForgetPasswordFormDetails, 'userOperationsApi/v1/forgotPassword').subscribe(function (res) { _this.saveResponse(res); }, function (err) {
            _this.httpService.onEnd();
        });
    };
    ForgotPasswordComponent.prototype.saveResponse = function (res) {
        var _this = this;
        if (res) {
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_5__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = 'after_reset_password_notify';
            this.dialogRef.afterClosed().subscribe(function (result) {
                _this.router.navigateByUrl('/login');
            });
        }
        this.httpService.onEnd();
    };
    ForgotPasswordComponent.prototype.ngOnInit = function () {
        this.buildForm();
    };
    ForgotPasswordComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            template: __webpack_require__(1263)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_2__angular_router__["b" /* ActivatedRoute */], __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_8__shared_services_session_handler_service__["a" /* SessionHandler */],
            __WEBPACK_IMPORTED_MODULE_4__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_9_ng2_translate__["d" /* TranslateService */], __WEBPACK_IMPORTED_MODULE_6__angular_forms__["h" /* FormBuilder */], __WEBPACK_IMPORTED_MODULE_7__shared_services_common_service__["a" /* CommonService */]])
    ], ForgotPasswordComponent);
    return ForgotPasswordComponent;
}());



/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoginComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_layout_service__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ng2_translate__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_services_common_service__ = __webpack_require__(24);
/**
 * Created by shubham on 27/2/18.
 */











var LoginComponent = /** @class */ (function () {
    function LoginComponent(dialog, router, route, layoutService, httpService, sessionHandler, formBuilder, translate, commonService) {
        var _this = this;
        this.dialog = dialog;
        this.router = router;
        this.route = route;
        this.layoutService = layoutService;
        this.httpService = httpService;
        this.sessionHandler = sessionHandler;
        this.formBuilder = formBuilder;
        this.translate = translate;
        this.commonService = commonService;
        this.redirectUrl = "";
        this.PartnersFormDetails = [];
        //Get URL param value
        this.route.params.subscribe(function (params) {
            _this.urlId = params['id'];
            if (_this.urlId != undefined) {
                _this.urlId = _this.urlId.toUpperCase();
            }
        });
        this.redirectUrl = this.commonService.getLoginRedirectUrl();
        //this.redirectUrl = this.sessionHandler.getItem('lastUrl');
        console.log(this.redirectUrl);
        this.getLanguages();
    }
    LoginComponent.prototype.googleInit = function () {
        var that = this;
        gapi.load('auth2', function () {
            that.auth2 = gapi.auth2.init({
                client_id: __WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].google_client_id,
                cookiepolicy: 'single_host_origin',
                scope: 'profile email'
            });
            that.attachSignin(document.getElementById('googleBtn'));
        });
    };
    //Attach Click Handler for Google Login
    LoginComponent.prototype.attachSignin = function (element) {
        var that = this;
        this.auth2.attachClickHandler(element, {}, function (googleUser) {
            that.adminLogin(googleUser);
        }, function (error) {
            console.log(JSON.stringify(error, undefined, 2));
        });
    };
    //Google Login Post API
    LoginComponent.prototype.adminLogin = function (googleUser) {
        var _this = this;
        var profile = googleUser.getBasicProfile();
        this.userDetails = {
            token: googleUser.getAuthResponse().id_token,
            name: profile.getName(),
            image: profile.getImageUrl(),
            email: profile.getEmail(),
            languageId: this.PartnersFormDetails.languageId
        };
        if (this.userDetails.email) {
            this.httpService.postRequest(this.userDetails, 'userOperationsApi/v1/googleLogin').subscribe(function (res) { _this.saveGoogleResponse(res); }, function (err) { _this.httpService.onEnd(); });
        }
        else {
            this.layoutService.popToast("Invalid Email Domain.", __WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].toastrType.error);
        }
    };
    //Save Response of Google Login API
    LoginComponent.prototype.saveGoogleResponse = function (res) {
        if (res.errorStatus == 'Fail') {
            this.httpService.onEnd();
            alert('User is not authorized');
        }
        else {
            if (res) {
                this.sessionHandler.saveItem("loginData", JSON.stringify(res));
                if (res.languageId) {
                    this.setLanguage(res.languageId);
                }
                else {
                    this.setLanguage('EN');
                }
                var redirectUrl = void 0;
                this.sessionHandler.saveItem("userDetails", JSON.stringify(this.userDetails));
                if (res.roleCode.includes(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].systemAdmin)) {
                    redirectUrl = '#/app/profile';
                }
                else if (res.roleCode.includes(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].BUManager) || res.roleCode.includes(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].regionalAdmin)) {
                    redirectUrl = '#/app/admin-dashboard';
                }
                else if (res.roleCode.includes(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].applicationManager)) {
                    redirectUrl = '#/app/application-manager-dashboard';
                }
                else {
                    alert('No role assigned to user. Please contact your administrator.');
                    redirectUrl = '#/login';
                }
                if (this.redirectUrl != "" && this.redirectUrl != undefined && this.redirectUrl != null) {
                    redirectUrl = this.redirectUrl;
                }
                this.httpService.onEnd();
                window.location.href = redirectUrl;
            }
        }
    };
    //DigiAccess Login
    LoginComponent.prototype.digiAccessLogin = function () {
        var _this = this;
        if (this.PartnersFormDetails.userId_WPASS) {
            this.httpService.postRequest(this.PartnersFormDetails, 'userOperationsApi/v1/digiAccessLogin').subscribe(function (res) { _this.saveResponse(res); }, function (err) {
                _this.PartnersForm.reset();
                _this.getLanguages();
                _this.httpService.onEnd();
            });
        }
        else {
            this.layoutService.popToast("Invalid Email Domain.", __WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].toastrType.error);
        }
    };
    //Save Response of DigiAccess Login API
    LoginComponent.prototype.saveResponse = function (res) {
        var selectedLogin = res.userType;
        if (res.errorStatus == 'Fail') {
            this.httpService.onEnd();
            if (selectedLogin == 'PARTNER') {
                this.PartnersForm.reset();
                this.getLanguages();
            }
            alert('User is not authorized');
        }
        else {
            if (res) {
                this.sessionHandler.saveItem("loginData", JSON.stringify(res));
                if (res.languageId) {
                    this.setLanguage(res.languageId);
                }
                else {
                    this.setLanguage('EN');
                }
                var redirectUrl = void 0;
                if (selectedLogin == "EMPLOYEE") {
                    this.sessionHandler.saveItem("userDetails", JSON.stringify(this.PartnersFormDetails));
                    if (res.roleCode.includes(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].systemAdmin)) {
                        redirectUrl = '#/app/profile';
                    }
                    else if (res.roleCode.includes(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].BUManager) || res.roleCode.includes(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].regionalAdmin)) {
                        redirectUrl = '#/app/admin-dashboard';
                    }
                    else if (res.roleCode.includes(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].applicationManager)) {
                        redirectUrl = '#/app/application-manager-dashboard';
                    }
                    else {
                        alert('No role assigned to user. Please contact your administrator.');
                        redirectUrl = '#/login';
                    }
                    if (this.redirectUrl != "" && this.redirectUrl != undefined && this.redirectUrl != null) {
                        redirectUrl = this.redirectUrl;
                    }
                }
                else if (selectedLogin == "PARTNER") {
                    this.sessionHandler.saveItem("userDetails", JSON.stringify(this.PartnersFormDetails));
                    if (res.roleCode.includes(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].serviceOwner) || res.roleCode.includes(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].tradePartner)) {
                        redirectUrl = '#/app/partners-dashboard';
                        this.sessionHandler.saveItem("wpassLogin", true);
                    }
                    else if (res.roleCode.includes(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].subuser)) {
                        redirectUrl = '#/app/profile';
                    }
                    else {
                        alert('No role assigned to user. Please contact your administrator.');
                        redirectUrl = '#/login';
                    }
                }
                this.httpService.onEnd();
                window.location.href = redirectUrl;
            }
        }
    };
    //Get Languages Details
    LoginComponent.prototype.getLanguages = function () {
        var _this = this;
        this.httpService.getRequest('lookupDataOperationsApi/v1/language').subscribe(function (res) { _this.saveLanguageResponse(res); }, function (err) { _this.httpService.onEnd(); });
    };
    //Save Languages Response
    LoginComponent.prototype.saveLanguageResponse = function (res) {
        if (res && res.items) {
            this.languageDetails = res.items;
            var localStorageLanguageId = this.sessionHandler.getItem('languageId');
            for (var l in this.languageDetails) {
                if (this.urlId != undefined && this.urlId != null) {
                    if (this.languageDetails[l]['id'] == this.urlId) {
                        this.setLanguage(this.urlId);
                        this.PartnersForm.controls['languageId'].setValue(this.urlId);
                    }
                }
                else if (localStorageLanguageId != undefined && localStorageLanguageId != null) {
                    if (this.languageDetails[l]['id'] == localStorageLanguageId) {
                        this.setLanguage(localStorageLanguageId);
                        this.PartnersForm.controls['languageId'].setValue(localStorageLanguageId);
                    }
                }
                else {
                    if (this.languageDetails[l]['id'] == 'EN') {
                        this.defaultLanguageId = this.languageDetails[l]['id'];
                        this.setLanguage(this.defaultLanguageId);
                    }
                }
            }
        }
        this.httpService.onEnd();
    };
    LoginComponent.prototype.showPassword = function (input) {
        input.type = input.type === 'password' ? 'text' : 'password';
    };
    //Build Form
    LoginComponent.prototype.buildForm = function () {
        var _this = this;
        this.PartnersForm = this.formBuilder.group({
            languageId: this.formBuilder.control(this.urlId),
            userId_WPASS: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_7__angular_forms__["g" /* Validators */].required]),
            password: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_7__angular_forms__["g" /* Validators */].required])
        });
        this.PartnersForm.valueChanges.subscribe(function (data) {
            _this.PartnersFormDetails = _this.PartnersForm.getRawValue();
            if (_this.PartnersFormDetails.languageId != null) {
                _this.setLanguage(_this.PartnersFormDetails.languageId);
            }
        });
    };
    LoginComponent.prototype.setLanguage = function (languageId) {
        this.sessionHandler.saveItem("languageId", languageId);
        this.translate.setDefaultLang(languageId);
        this.translate.use(languageId);
    };
    //Initialize buildForm() function when Login Component loads
    LoginComponent.prototype.ngOnInit = function () {
        this.buildForm();
    };
    //Initialize googleInit() function after viewPartners initialize
    LoginComponent.prototype.ngAfterViewInit = function () {
        this.googleInit();
    };
    LoginComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'app-login',
            styles: [],
            template: __webpack_require__(1272),
            providers: []
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_6__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_8__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_8__angular_router__["b" /* ActivatedRoute */], __WEBPACK_IMPORTED_MODULE_4__layout_layout_service__["a" /* LayoutService */], __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__["a" /* HttpService */],
            __WEBPACK_IMPORTED_MODULE_2__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_7__angular_forms__["h" /* FormBuilder */], __WEBPACK_IMPORTED_MODULE_9_ng2_translate__["d" /* TranslateService */], __WEBPACK_IMPORTED_MODULE_10__shared_services_common_service__["a" /* CommonService */]])
    ], LoginComponent);
    return LoginComponent;
}());



/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageLayoutFullscreenComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);


// Children of AppModule instead of AppMainModule
var PageLayoutFullscreenComponent = /** @class */ (function () {
    function PageLayoutFullscreenComponent() {
    }
    PageLayoutFullscreenComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'my-page-layout-fullscreen',
            styles: [],
            template: __webpack_require__(1274)
        })
    ], PageLayoutFullscreenComponent);
    return PageLayoutFullscreenComponent;
}());



/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PartnersDashboardComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_services_common_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__partners_datatable_partners_page__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__partnersDashboardResultService__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ng2_translate__ = __webpack_require__(17);
/**
 * Created by shubham on 24/4/18.
 */














var PartnersDashboardComponent = /** @class */ (function () {
    function PartnersDashboardComponent(router, route, httpService, sessionHandler, formBuilder, dialog, serverResultsService, commonService, translate) {
        var _this = this;
        this.router = router;
        this.route = route;
        this.httpService = httpService;
        this.sessionHandler = sessionHandler;
        this.formBuilder = formBuilder;
        this.dialog = dialog;
        this.serverResultsService = serverResultsService;
        this.commonService = commonService;
        this.translate = translate;
        this.page = new __WEBPACK_IMPORTED_MODULE_9__partners_datatable_partners_page__["a" /* PartnersPage */]();
        this.tableRows = [];
        this.filters = {};
        this.partnersDashboardData = [];
        this.temp = [];
        this.showTable = true;
        this.isSystemAdmin = false;
        this.isBUManager = false;
        this.isRegionalAdmin = false;
        this.isServiceOwner = false;
        this.isTradePartner = false;
        this.isSubUser = false;
        this.selected = [];
        this.searchedFilters = { email: '', firstName: '', wpassId: '' };
        this.selectedStatusId = '';
        this.firstName = '';
        this.email = '';
        this.wpassId = '';
        this.isDisabled = false;
        this.showCheckbox = false;
        this.wpassLogin = false;
        this.type = '';
        this.dataTableMessage = { 'selectedMessage': '', 'totalMessage': '' };
        this.StatusData = [{
                "id": "",
                "code": "",
                "name": "All"
            }];
        //Close Sidebar Initially
        __WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].navCollapsed = true;
        this.page.pageNumber = 0;
        this.page.size = 20;
        this.partnersText = 'partners';
        this.wpassLogin = JSON.parse(this.sessionHandler.getItem('wpassLogin'));
        if (this.wpassLogin != null && this.wpassLogin == true) {
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["c" /* WelcomeDialogComponent */]);
            this.dialogRef.afterClosed().subscribe(function (result) {
                localStorage.removeItem('wpassLogin');
            });
        }
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].BUManager)) {
                this.isBUManager = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].serviceOwner)) {
                this.isServiceOwner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].tradePartner)) {
                this.isTradePartner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].subuser)) {
                this.isSubUser = true;
            }
        }
        else {
            this.httpService.noUserError();
        }
        //Get URL param value
        this.route.params.subscribe(function (params) {
            _this.urlId = +params['id'];
        });
        this.getStatusList();
        this.filters['offSet'] = this.page.pageNumber * this.page.size;
        this.filters['limit'] = this.page.size;
        this.callUsersListbyAdminOrPartner();
        //Call when approve/delete from ApproveRejectComponent/ActiveInactiveComponent to get the updated list.
        this.commonService.partnersDashboard.subscribe(function (value) {
            if (!isNaN(_this.urlId)) {
                _this.getUsersList(_this.filters, _this.selectedStatusId, _this.urlId, _this.email, _this.firstName, _this.wpassId);
            }
            else {
                _this.getUsersList(_this.filters, _this.selectedStatusId, '', _this.email, _this.firstName, _this.wpassId);
            }
        });
    }
    PartnersDashboardComponent.prototype.buildForm = function () {
        var _this = this;
        this.PartnersFiltersForm = this.formBuilder.group({
            firstName: this.formBuilder.control({ value: '', disabled: this.isDisabled }),
            email: this.formBuilder.control({ value: '', disabled: this.isDisabled }),
            wpassId: this.formBuilder.control(''),
        });
        this.PartnersFiltersForm.valueChanges.subscribe(function (data) {
            _this.firstName = _this.PartnersFiltersForm.get('firstName').value;
            _this.email = _this.PartnersFiltersForm.get('email').value;
            _this.wpassId = _this.PartnersFiltersForm.get('wpassId').value;
        });
    };
    PartnersDashboardComponent.prototype.disablefields = function (value) {
        if (value != '') {
            this.PartnersFiltersForm.controls['firstName'].setValue('');
            this.PartnersFiltersForm.controls['email'].setValue('');
            this.PartnersFiltersForm.controls['firstName'].disable();
            this.PartnersFiltersForm.controls['email'].disable();
        }
        else {
            this.PartnersFiltersForm.controls['firstName'].enable();
            this.PartnersFiltersForm.controls['email'].enable();
        }
    };
    PartnersDashboardComponent.prototype.resetSearch = function () {
        this.PartnersFiltersForm.controls['firstName'].enable();
        this.PartnersFiltersForm.controls['email'].enable();
        this.PartnersFiltersForm.reset();
        this.firstName = '';
        this.email = '';
        this.wpassId = '';
        this.selectedStatusId = "";
        this.callUsersListbyAdminOrPartner();
    };
    PartnersDashboardComponent.prototype.getStatusList = function () {
        var _this = this;
        this.httpService.getRequest("lookupDataOperationsApi/v1/registrationStatusFilter?includeDeleted=true").subscribe(function (res) { _this.saveStatusList(res); }, function (err) { _this.httpService.onEnd(); });
    };
    PartnersDashboardComponent.prototype.saveStatusList = function (res) {
        if (res && res.items) {
            for (var s in res.items) {
                this.StatusData.push(res.items[s]);
            }
        }
    };
    PartnersDashboardComponent.prototype.callUsersListbyAdminOrPartner = function () {
        this.selected = [];
        this.filters['offSet'] = 0;
        if (this.isServiceOwner || this.isTradePartner) {
            this.getUsersList(this.filters, this.selectedStatusId, '', this.email, this.firstName, this.wpassId);
        }
        else if (this.isRegionalAdmin || this.isBUManager) {
            if (this.urlId != NaN) {
                this.getUsersList(this.filters, this.selectedStatusId, this.urlId, this.email, this.firstName, this.wpassId);
            }
        }
    };
    PartnersDashboardComponent.prototype.getUsersList = function (filter, selectedStatus, id, email, firstName, wpassId) {
        var _this = this;
        this.searchedFilters.email = email;
        this.searchedFilters.firstName = firstName;
        this.searchedFilters.wpassId = wpassId;
        if (selectedStatus == 'PENDING') {
            this.showCheckbox = true;
        }
        else {
            this.showCheckbox = false;
        }
        this.httpService.getRequest("partnerOperationsApi/v1/companyUser/list?limit=" + filter.limit + "&offset=" + filter.offSet + "&ownerId=" + id + "&status=" + selectedStatus + "&email=" + email + "&firstName=" + firstName + "&wpassId=" + wpassId).subscribe(function (res) {
            if (id) {
                _this.saveUserList(res, filter, 'admin');
            }
            else {
                _this.saveUserList(res, filter, 'partners');
            }
        }, function (err) { _this.httpService.onEnd(); });
    };
    PartnersDashboardComponent.prototype.saveUserList = function (res, filter, type) {
        this.type = type;
        if (res.errorStatus == 'Fail') {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = 'data_pull_fail';
        }
        else {
            if (res && Object.keys(res).length > 0) {
                this.partnersDashboardData = res;
                this.rows = [];
                this.rows['offset'] = res.offset;
                this.count = res.count;
                this.totalCount = res.totalCount;
                if (this.partnersDashboardData['list']) {
                    var totalCount = 0;
                    if (parseInt(res.offset) == 0) {
                        localStorage.setItem('totalCount', res.totalCount);
                        totalCount = parseInt(res.totalCount);
                    }
                    else {
                        totalCount = parseInt(localStorage.getItem('totalCount'));
                    }
                    this.rows['totalCount'] = totalCount;
                    for (var data in this.partnersDashboardData['list']) {
                        if (this.isBUManager || this.isRegionalAdmin || this.isServiceOwner || this.isTradePartner) {
                            this.rows[data] = {};
                            this.rows[data]['id'] = this.partnersDashboardData['list'][data]['id'];
                            this.rows[data]['Name'] = this.partnersDashboardData['list'][data]['firstName'] + ' ' + this.partnersDashboardData['list'][data]['lastName'];
                            if (this.partnersDashboardData['list'][data]['roleName']) {
                                this.rows[data]['roleName'] = this.partnersDashboardData['list'][data]['roleName'];
                            }
                            this.rows[data]['email'] = this.partnersDashboardData['list'][data]['email'];
                            this.rows[data]['emailVerified'] = this.partnersDashboardData['list'][data]['emailVerified'];
                            if (this.partnersDashboardData['list'][data]['userId_WPASS']) {
                                this.rows[data]['userId_WPASS'] = this.partnersDashboardData['list'][data]['userId_WPASS'];
                            }
                            else {
                                this.rows[data]['userId_WPASS'] = null;
                            }
                            this.rows[data]['languageId'] = this.partnersDashboardData['list'][data]['languageId'];
                            this.rows[data]['languageName'] = this.partnersDashboardData['list'][data]['languageName'];
                            this.rows[data]['status'] = this.partnersDashboardData['list'][data]['status'];
                            this.rows[data]['ownerId'] = this.partnersDashboardData['list'][data]['ownerId'];
                            this.rows[data]['sessionUserManager'] = this.partnersDashboardData['list'][data]['sessionUserManager'];
                            this.rows[data]['createdAt'] = this.partnersDashboardData['list'][data]['createdAt'];
                            this.rows[data]['updatedAt'] = this.partnersDashboardData['list'][data]['updatedAt'];
                        }
                        else {
                            //For Other Service Partner's
                            this.rows[data] = {};
                        }
                    }
                    this.showTable = true;
                    this.temp = this.rows;
                }
                else {
                    this.showTable = false;
                }
                var finalRows = [];
                for (var f in this.rows) {
                    if (f != 'offset' && f != 'totalCount' && this.rows[f]) {
                        finalRows.push(this.rows[f]);
                    }
                    if (f == 'offset') {
                        finalRows['offset'] = this.rows['offset'];
                    }
                    if (f == 'totalCount') {
                        finalRows['totalCount'] = this.rows['totalCount'];
                    }
                }
                this.rows = finalRows;
                this.setPage({ offset: this.rows['offset'] / this.page.size }, finalRows, filter);
                this.httpService.onEnd();
            }
        }
    };
    /**
     * Populate the table with new data based on the page number
     * @param page The page to select
     */
    PartnersDashboardComponent.prototype.setPage = function (pageInfo, rows, filter) {
        var _this = this;
        this.page.pageNumber = pageInfo.offset;
        if (rows.length != 0) {
            this.serverResultsService.getResults(this.page, rows).subscribe(function (pageData) {
                _this.page = pageData.page;
                _this.tableRows = pageData.data;
                if (!filter) {
                    if (Object.keys(_this.tableRows).length == 0 || !_this.tableRows[0]['status']) {
                        _this.filters['offSet'] = _this.page.pageNumber * _this.page.size;
                        console.log('type:' + _this.type);
                        if (_this.type == 'admin') {
                            _this.getUsersList(_this.filters, _this.selectedStatusId, _this.urlId, _this.email, _this.firstName, _this.wpassId);
                        }
                        else if (_this.type == 'partners') {
                            _this.getUsersList(_this.filters, _this.selectedStatusId, '', _this.email, _this.firstName, _this.wpassId);
                        }
                    }
                }
            });
        }
        else {
            this.tableRows = [];
            this.page.totalElements = rows.length;
        }
    };
    PartnersDashboardComponent.prototype.onSelect = function (_a) {
        var selected = _a.selected;
        var _b;
        this.selected.splice(0, this.selected.length);
        (_b = this.selected).push.apply(_b, selected);
        this.selectedCount = this.selected.length;
    };
    PartnersDashboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.buildForm();
        this.translate.get('total').subscribe(function (res) {
            _this.dataTableMessage.totalMessage = res;
        });
        this.translate.get('selected').subscribe(function (res) {
            _this.dataTableMessage.selectedMessage = res;
        });
    };
    PartnersDashboardComponent.prototype.ngOnDestroy = function () {
        this.dialog.closeAll();
        localStorage.removeItem('wpassLogin');
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"])(__WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__["DatatableComponent"]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__["DatatableComponent"])
    ], PartnersDashboardComponent.prototype, "table", void 0);
    PartnersDashboardComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'partners-dashboard',
            template: __webpack_require__(1275)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_2__angular_router__["b" /* ActivatedRoute */], __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_4__shared_services_session_handler_service__["a" /* SessionHandler */],
            __WEBPACK_IMPORTED_MODULE_10__angular_forms__["h" /* FormBuilder */], __WEBPACK_IMPORTED_MODULE_6__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_12__partnersDashboardResultService__["a" /* PartnersDashboardResultService */],
            __WEBPACK_IMPORTED_MODULE_8__shared_services_common_service__["a" /* CommonService */], __WEBPACK_IMPORTED_MODULE_13_ng2_translate__["d" /* TranslateService */]])
    ], PartnersDashboardComponent);
    return PartnersDashboardComponent;
}());



/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PartnersPage; });
/**
 * Created by shubham on 11/4/18.
 */
/**
 * An object used to get page information from the server
 */
var PartnersPage = /** @class */ (function () {
    function PartnersPage() {
        //The number of elements in the page
        this.size = 0;
        //The total number of elements
        this.totalElements = 0;
        //The total number of pages
        this.totalPages = 0;
        //The current page number
        this.pageNumber = 0;
    }
    return PartnersPage;
}());



/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PartnersDashboardResultService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partners_dashboard_partners_datatable_partners_page_data__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partners_dashboard_partners_datatable_partnersDashboardList__ = __webpack_require__(780);
/**
 * Created by shubham on 24/4/18.
 */





/**
 * A server used to mock a paged data result from a server
 */
var PartnersDashboardResultService = /** @class */ (function () {
    function PartnersDashboardResultService() {
        this.rows = {};
        this.partnersDashboardData = {};
    }
    /**
     * A method that mocks a paged server response
     * @param page The selected page
     * @returns {any} An observable containing the employee data
     */
    PartnersDashboardResultService.prototype.getResults = function (page, listData) {
        var _this = this;
        this.listData = listData;
        return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(listData).map(function (data) { return _this.getPageData(page); });
    };
    /**
     * Package companyData into a PagedData object based on the selected Page
     * @param page The page data used to get the selected data from companyData
     * @returns {PagedData<icsList>} An array of the selected data and page
     */
    PartnersDashboardResultService.prototype.getPageData = function (page) {
        var pageData = new __WEBPACK_IMPORTED_MODULE_3__partners_dashboard_partners_datatable_partners_page_data__["a" /* PartnersPageData */]();
        var offset = this.listData.offset;
        var raw = [];
        for (var l in this.listData) {
            if (Object.keys(this.listData[l]).length > 0) {
                raw[offset + parseInt(l)] = this.listData[l];
            }
        }
        if (this.listData.totalCount) {
            page.totalElements = this.listData.totalCount;
        }
        page.totalPages = page.totalElements / page.size;
        var start = page.pageNumber * page.size;
        var end = Math.min((start + page.size), page.totalElements);
        for (var i = start; i < end; i++) {
            if (raw[i]) {
                var jsonObj = raw[i];
                if (jsonObj) {
                    var list = new __WEBPACK_IMPORTED_MODULE_4__partners_dashboard_partners_datatable_partnersDashboardList__["a" /* PartnersDashboardList */](jsonObj['id'], jsonObj['Name'], jsonObj['roleName'], jsonObj['email'], jsonObj['emailVerified'], jsonObj['userId_WPASS'], jsonObj['languageId'], jsonObj['languageName'], jsonObj['status'], jsonObj['ownerId'], jsonObj['sessionUserManager'], jsonObj['createdAt']);
                    pageData.data.push(list);
                }
            }
        }
        pageData.page = page;
        return pageData;
    };
    PartnersDashboardResultService = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [])
    ], PartnersDashboardResultService);
    return PartnersDashboardResultService;
}());



/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RegistrationComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_layout_service__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ng2_daterangepicker__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ng2_daterangepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_ng2_daterangepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialog_dialog_component__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ng2_translate__ = __webpack_require__(17);
/**
 * Created by shubham on 28/2/18.
 * Updated by shubham on 06/10/18.
 */













var RegistrationComponent = /** @class */ (function () {
    function RegistrationComponent(route, router, httpService, layoutService, dialog, formBuilder, daterangepickerOptions, sessionHandler, translate) {
        var _this = this;
        this.route = route;
        this.router = router;
        this.httpService = httpService;
        this.layoutService = layoutService;
        this.dialog = dialog;
        this.formBuilder = formBuilder;
        this.daterangepickerOptions = daterangepickerOptions;
        this.sessionHandler = sessionHandler;
        this.translate = translate;
        this.RegistrationDataById = [];
        this.CountryAndBusinessUnitDataById = [];
        this.Countries = [];
        this.BusinessUnit = [];
        this.isApplicationRemovable = true;
        this.Applications = [];
        this.emailPattern = __WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].emailPattern;
        //passwordPattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{5,}$/;
        this.passwordPattern = /^(?=.*?[A-Za-z])(?=.*?[0-9]).{5,}$/;
        this.phoneNumberPattern = /^[+]?([0-9]*[\.\s\-\(\)]|[0-9]+){3,7}$/;
        //phoneNumberPattern = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
        this.customerNumberLength = 0;
        this.urlIdFlag = false;
        this.appsUrlIdFlag = false;
        this.passwordErrorMsg = '';
        //Get URL param value
        this.route.params.subscribe(function (params) {
            _this.urlId = params['id'];
            _this.getLanguages();
            if (_this.urlId != undefined || _this.urlId != null) {
                _this.urlIdFlag = true;
                if (router.url.indexOf("apps") > -1) {
                    _this.appsUrlIdFlag = true;
                    _this.getCountryAndBusinessUnitById(_this.urlId);
                }
                else {
                    _this.getCountries();
                    _this.getBusinessUnit();
                    _this.getRegistrationDataById(_this.urlId);
                }
            }
            else {
                _this.urlIdFlag = false;
                _this.getCountries();
            }
        });
    }
    RegistrationComponent.prototype.getCountries = function () {
        var _this = this;
        this.httpService.getRequest('lookupDataOperationsApi/v1/country').subscribe(function (res) { _this.saveCountries(res); }, function (err) { _this.httpService.onEnd(); });
    };
    RegistrationComponent.prototype.validateName = function (event) {
        return __WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].validNameRegex.test(event.key);
    };
    RegistrationComponent.prototype.saveCountries = function (res) {
        if (res && res.items) {
            this.Countries = res.items;
        }
        this.httpService.onEnd();
    };
    RegistrationComponent.prototype.getBusinessUnit = function () {
        var _this = this;
        this.httpService.getRequest('lookupDataOperationsApi/v1/businessUnit').subscribe(function (res) { _this.saveBusinessUnits(res); }, function (err) { _this.httpService.onEnd(); });
    };
    RegistrationComponent.prototype.saveBusinessUnits = function (res) {
        if (res && res.items) {
            this.BusinessUnit = res.items;
        }
        this.httpService.onEnd();
    };
    RegistrationComponent.prototype.getLanguages = function () {
        var _this = this;
        this.httpService.getRequest('lookupDataOperationsApi/v1/language').subscribe(function (res) { _this.saveLanguageResponse(res); }, function (err) { _this.httpService.onEnd(); });
    };
    RegistrationComponent.prototype.saveLanguageResponse = function (res) {
        if (res && res.items) {
            this.LanguageData = res.items;
        }
        this.httpService.onEnd();
    };
    RegistrationComponent.prototype.getBusinessUnitByCountryId = function (countryId) {
        var _this = this;
        this.httpService.getRequest('lookupDataOperationsApi/v1/businessUnitForCountry/' + countryId).subscribe(function (res) { _this.saveBusinessUnitByCountryId(res); }, function (err) { _this.httpService.onEnd(); });
    };
    RegistrationComponent.prototype.saveBusinessUnitByCountryId = function (res) {
        if (res && res.items) {
            this.BusinessUnit = res.items;
        }
        this.httpService.onEnd();
    };
    RegistrationComponent.prototype.getApplicationsByCountryAndBusinessUnit = function (countryId, businessUnitId) {
        var _this = this;
        this.httpService.getRequest('applicationOperationApi/v1/getApplicationForbusinessUnit?countryId=' + countryId + '&businessUnitId=' + businessUnitId).subscribe(function (res) { _this.saveApplicationsByCountryAndBusinessUnit(res); }, function (err) { _this.httpService.onEnd(); });
    };
    RegistrationComponent.prototype.saveApplicationsByCountryAndBusinessUnit = function (res) {
        if (res && res.items) {
            this.Applications = res.items;
            this.createRoles(this.Applications);
        }
        this.httpService.onEnd();
    };
    RegistrationComponent.prototype.getCountryAndBusinessUnitById = function (urlId) {
        var _this = this;
        this.httpService.getRequest('/applicationOperationApi/v1/getbusinessUnitCountryForApplication?id=' + urlId).subscribe(function (res) { _this.saveCountryAndBusinessUnitById(res); }, function (err) { _this.httpService.onEnd(); });
    };
    RegistrationComponent.prototype.saveCountryAndBusinessUnitById = function (res) {
        this.CountryAndBusinessUnitDataById = res;
        if (this.CountryAndBusinessUnitDataById) {
            this.Countries = this.CountryAndBusinessUnitDataById['countryList'];
        }
        this.httpService.onEnd();
    };
    RegistrationComponent.prototype.getRegistrationDataById = function (urlId) {
        var _this = this;
        this.httpService.getRequest('/userRegistrationsApi/v1/migratedUserDetails/' + urlId).subscribe(function (res) { _this.saveRegistrationData(res); }, function (err) { _this.httpService.onEnd(); });
    };
    RegistrationComponent.prototype.saveRegistrationData = function (res) {
        if (res) {
            this.RegistrationDataById = res;
            this.RegistrationForm.controls['email'].disable();
            this.RegistrationForm.controls['countryId'].disable();
            this.RegistrationForm.controls['businessUnitId'].disable();
            this.RegistrationForm.controls['companyName'].disable();
            this.RegistrationForm.controls['customerNumber'].disable();
            $('#exampleInputNewPassword').focus();
            this.buildForm();
            // Now get all the applications
            if (!res.selectedApplications) {
                this.getApplicationsByCountryAndBusinessUnit(this.RegistrationDataById['countryId'], this.RegistrationDataById['businessUnitId']);
            }
            else {
                this.isApplicationRemovable = false;
                //Case where roles are already assigned to the migrated user 
                res.items = res.selectedApplications;
                this.saveApplicationsByCountryAndBusinessUnit(res);
            }
        }
    };
    RegistrationComponent.prototype.buildForm = function () {
        var _this = this;
        this.RegistrationForm = this.formBuilder.group({
            firstName: this.formBuilder.control(this.RegistrationDataById['firstName'] ? this.RegistrationDataById['firstName'] : null, [__WEBPACK_IMPORTED_MODULE_7__angular_forms__["g" /* Validators */].required]),
            lastName: this.formBuilder.control(this.RegistrationDataById['lastName'] ? this.RegistrationDataById['lastName'] : null, [__WEBPACK_IMPORTED_MODULE_7__angular_forms__["g" /* Validators */].required]),
            password: this.formBuilder.control('', [__WEBPACK_IMPORTED_MODULE_7__angular_forms__["g" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_7__angular_forms__["g" /* Validators */].minLength(8), __WEBPACK_IMPORTED_MODULE_7__angular_forms__["g" /* Validators */].maxLength(8), __WEBPACK_IMPORTED_MODULE_7__angular_forms__["g" /* Validators */].pattern(this.passwordPattern)]),
            confirmPassword: this.formBuilder.control('', [__WEBPACK_IMPORTED_MODULE_7__angular_forms__["g" /* Validators */].required]),
            email: this.formBuilder.control(this.RegistrationDataById['email'] ? this.RegistrationDataById['email'] : null, [__WEBPACK_IMPORTED_MODULE_7__angular_forms__["g" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_7__angular_forms__["g" /* Validators */].pattern(this.emailPattern)]),
            countryId: this.formBuilder.control(this.RegistrationDataById['countryId'] ? this.RegistrationDataById['countryId'] : null, [__WEBPACK_IMPORTED_MODULE_7__angular_forms__["g" /* Validators */].required]),
            businessUnitId: this.formBuilder.control(this.RegistrationDataById['businessUnitId'] ? this.RegistrationDataById['businessUnitId'] : null, [__WEBPACK_IMPORTED_MODULE_7__angular_forms__["g" /* Validators */].required]),
            companyName: this.formBuilder.control(this.RegistrationDataById['companyName'] ? this.RegistrationDataById['companyName'] : null, [__WEBPACK_IMPORTED_MODULE_7__angular_forms__["g" /* Validators */].required]),
            companyAddress: this.formBuilder.control(this.RegistrationDataById['companyAddress'] ? this.RegistrationDataById['companyAddress'] : null, [__WEBPACK_IMPORTED_MODULE_7__angular_forms__["g" /* Validators */].required]),
            customerNumber: this.formBuilder.control(this.RegistrationDataById['customerNumber'] ? this.RegistrationDataById['customerNumber'] : null),
            companyPhone: this.formBuilder.control(this.RegistrationDataById['companyPhone'] ? this.RegistrationDataById['companyPhone'] : null, [__WEBPACK_IMPORTED_MODULE_7__angular_forms__["g" /* Validators */].pattern(this.phoneNumberPattern)]),
            languageId: this.formBuilder.control(this.RegistrationDataById['languageId'] ? this.RegistrationDataById['languageId'] : null),
            applications: this.formBuilder.array([])
        }, { validator: this.checkPasswords });
        this.RegistrationForm.valueChanges.subscribe(function (data) {
            _this.RegistrationFormDetails = _this.RegistrationForm.getRawValue();
            if (_this.urlIdFlag) {
                _this.RegistrationFormDetails['migratedFrom'] = _this.RegistrationDataById['id'];
            }
            _this.RegistrationFormDetails.validate = _this.RegistrationForm.valid;
        });
        this.RegistrationForm.get('countryId').valueChanges.subscribe(function (data) {
            if (!_this.urlIdFlag || _this.appsUrlIdFlag) {
                _this.RegistrationForm.controls['businessUnitId'].setValue(null);
                _this.BusinessUnit = [];
                if (!_this.urlIdFlag && data != null) {
                    _this.getBusinessUnitByCountryId(data);
                }
                else if (_this.appsUrlIdFlag && data != null) {
                    for (var _i = 0, _a = _this.CountryAndBusinessUnitDataById['countryList']; _i < _a.length; _i++) {
                        var countryData = _a[_i];
                        if (countryData && countryData['id'] && data == countryData['id'] && countryData['businessUnitList']) {
                            _this.BusinessUnit = countryData['businessUnitList'];
                        }
                    }
                }
            }
        });
        this.RegistrationForm.get('businessUnitId').valueChanges.subscribe(function (data) {
            if (!_this.urlIdFlag || _this.appsUrlIdFlag) {
                var arrayControl = _this.RegistrationForm.controls['applications'];
                arrayControl.controls = [];
                _this.Applications = [];
                if (!_this.urlIdFlag && data != null) {
                    _this.getApplicationsByCountryAndBusinessUnit(_this.RegistrationForm.get('countryId').value, data);
                }
                else if (_this.appsUrlIdFlag && data != null) {
                    _this.Applications.push(_this.CountryAndBusinessUnitDataById);
                    _this.createRoles(_this.Applications);
                }
            }
        });
        this.RegistrationForm.get('customerNumber').valueChanges.subscribe(function (data) {
            if (data != null) {
                _this.customerNumberLength = data.toString().length;
            }
        });
        this.RegistrationForm.get('languageId').valueChanges.subscribe(function (data) {
            if (data != null) {
                _this.sessionHandler.saveItem("languageId", data);
                _this.translate.setDefaultLang(data);
                _this.translate.use(data);
            }
        });
        this.RegistrationForm.get('password').valueChanges.subscribe(function (data) {
            _this.validatePassword(data);
        });
    };
    RegistrationComponent.prototype.validatePassword = function (data) {
        var firstName = this.RegistrationForm.get('firstName').value || '';
        var lastName = this.RegistrationForm.get('lastName').value || '';
        if (data != null) {
            this.RegistrationForm.get('password').setErrors({ 'incorrect': true });
            var hasUpper = /[A-Z]/.test(data);
            var hasLower = /[a-z]/.test(data);
            var hasDigit = /[0-9]/.test(data);
            var minLength = data.length >= 8;
            var validSymbols = /^[a-zA-Z0-9!@#$%&*?]*$/.test(data);
            var containsFirstName = firstName && data.toLowerCase().includes(firstName.toLowerCase());
            var containsLastName = lastName && data.toLowerCase().includes(lastName.toLowerCase());
            console.log('containsFirstName:' + containsFirstName + ', containsLastName:' + containsLastName);
            if (!hasUpper || !hasLower) {
                this.passwordErrorMsg = "pass_one_upper_lower_char";
            }
            else if (!hasDigit) {
                this.passwordErrorMsg = "pass_one_number";
            }
            else if (!minLength) {
                this.passwordErrorMsg = "pass_least_8_chars";
            }
            else if (!validSymbols) {
                this.passwordErrorMsg = "pass_invalid_symbol"; //new
            }
            else if (containsFirstName) {
                this.passwordErrorMsg = "pass_contains_firstname"; //new
            }
            else if (containsLastName) {
                this.passwordErrorMsg = "pass_contains_lastname"; //new
            }
            else {
                this.passwordErrorMsg = "";
                this.RegistrationForm.get('password').setErrors(null);
                return true;
            }
        }
        return false;
    };
    RegistrationComponent.prototype.checkPasswords = function (group) {
        if (group.get('password').value === group.get('confirmPassword').value) {
            group.get('confirmPassword').setErrors(null);
            return null;
        }
        else {
            group.get('confirmPassword').setErrors({ 'incorrect': true });
            return { 'mismatch': true };
        }
    };
    RegistrationComponent.prototype.showPassword = function (input) {
        input.type = input.type === 'password' ? 'text' : 'password';
    };
    RegistrationComponent.prototype.createRoles = function (applicationsData) {
        for (var _i = 0, applicationsData_1 = applicationsData; _i < applicationsData_1.length; _i++) {
            var data = applicationsData_1[_i];
            this.onAddApplicationsProperty(data);
        }
    };
    RegistrationComponent.prototype.onAddApplicationsProperty = function (data) {
        var arrayControl = this.RegistrationForm.controls['applications'];
        var newGroup;
        if (data) {
            newGroup = this.formBuilder.group({
                applicationId: this.formBuilder.control(data.id ? data.id : null),
                applicationName: this.formBuilder.control({ value: data.applicationName ? data.applicationName : null, disabled: true }, [__WEBPACK_IMPORTED_MODULE_7__angular_forms__["g" /* Validators */].required]),
            });
        }
        else {
            newGroup = this.formBuilder.group({
                applicationId: this.formBuilder.control(null),
                applicationName: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_7__angular_forms__["g" /* Validators */].required]),
            });
        }
        arrayControl.push(newGroup);
    };
    /*ChangeValidator(group: FormGroup){
        if(group.get('customerNumberCheck').value){
            group.get('customerNumber').setValidators([Validators.required]);
        } else{
            group.get('customerNumber').setValidators(null);
        }
        return null;
    }*/
    RegistrationComponent.prototype.onDeleteRoleProperty = function (index) {
        var arrayControl = this.RegistrationForm.controls['applications'];
        arrayControl.removeAt(index);
    };
    RegistrationComponent.prototype.saveData = function () {
        var _this = this;
        if (!this.validatePassword(this.RegistrationForm.get('password').value)) {
            return;
        }
        if (this.RegistrationFormDetails) {
            this.httpService.postRequest(this.RegistrationFormDetails, 'userRegistrationsApi/v1/register/serviceOwner').subscribe(function (res) { _this.saveResponse(res); }, function (err) { _this.httpService.onEnd(); });
        }
        else {
            this.layoutService.popToast("Invalid Email Domain.", __WEBPACK_IMPORTED_MODULE_5__config__["a" /* APPCONFIG */].toastrType.error);
        }
    };
    RegistrationComponent.prototype.saveResponse = function (res) {
        var _this = this;
        if (res.errorStatus == 'Fail') {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_10__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = 'User is not authorized';
        }
        else {
            var email = res.email;
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_10__dialog_dialog_component__["e" /* RegistrationDialogComponent */]);
            if (this.urlIdFlag) {
                this.dialogRef.componentInstance.msg = "after_registration_notify";
            }
            else {
                this.dialogRef.componentInstance.msg = "registration_rqst_notify";
            }
            this.dialogRef.afterClosed().subscribe(function (result) {
                _this.router.navigateByUrl('/login');
            });
        }
    };
    RegistrationComponent.prototype.ngOnInit = function () {
        this.buildForm();
    };
    RegistrationComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            template: __webpack_require__(1278)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_8__angular_router__["b" /* ActivatedRoute */], __WEBPACK_IMPORTED_MODULE_8__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_4__layout_layout_service__["a" /* LayoutService */],
            __WEBPACK_IMPORTED_MODULE_6__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_7__angular_forms__["h" /* FormBuilder */], __WEBPACK_IMPORTED_MODULE_9_ng2_daterangepicker__["DaterangepickerConfig"],
            __WEBPACK_IMPORTED_MODULE_2__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_11_ng2_translate__["d" /* TranslateService */]])
    ], RegistrationComponent);
    return RegistrationComponent;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)))

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddAdminComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ng2_translate__ = __webpack_require__(17);
/**
 * Created by shubham on 8/5/18.
 */









var AddAdminComponent = /** @class */ (function () {
    function AddAdminComponent(sessionHandler, httpService, dialog, formBuilder, translate) {
        this.sessionHandler = sessionHandler;
        this.httpService = httpService;
        this.dialog = dialog;
        this.formBuilder = formBuilder;
        this.translate = translate;
        this.isSystemAdmin = false;
        this.isBUManager = false;
        this.isRegionalAdmin = false;
        this.isServiceOwner = false;
        this.isTradePartner = false;
        this.isSubUser = false;
        this.adminRoles = [];
        this.settings = {};
        this.languages = [];
        this.emailPattern = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].emailPattern;
        this.isDisabled = true;
        this.api1 = true;
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].BUManager)) {
                this.isBUManager = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].serviceOwner)) {
                this.isServiceOwner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].tradePartner)) {
                this.isTradePartner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].subuser)) {
                this.isSubUser = true;
            }
        }
        else {
            this.httpService.noUserError();
        }
        if (this.isSystemAdmin) {
            this.getAdminRoles();
            this.getLanguages();
        }
    }
    AddAdminComponent.prototype.validateName = function (event) {
        return __WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].validNameRegex.test(event.key);
    };
    AddAdminComponent.prototype.getAdminRoles = function () {
        var _this = this;
        this.httpService.getRequest('superUserOperationsApi/v1/adminRoles').subscribe(function (res) { _this.saveAdminRoles(res); }, function (err) { _this.httpService.onEnd(); });
    };
    AddAdminComponent.prototype.saveAdminRoles = function (res) {
        if (res && res.items) {
            this.adminRoles = res.items;
        }
        this.httpService.onEnd();
    };
    AddAdminComponent.prototype.getLanguages = function () {
        var _this = this;
        this.httpService.getRequest('lookupDataOperationsApi/v1/language').subscribe(function (res) { _this.saveLanguage(res); }, function (err) { _this.httpService.onEnd(); });
    };
    AddAdminComponent.prototype.saveLanguage = function (res) {
        if (res && res.items) {
            this.languages = res.items;
            for (var l in this.languages) {
                if (this.languages[l]['id'] == 'EN') {
                    this.defaultLanguageId = this.languages[l]['id'];
                }
            }
        }
        this.httpService.onEnd();
    };
    AddAdminComponent.prototype.buildForm = function () {
        var _this = this;
        this.AdminForm = this.formBuilder.group({
            firstName: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["g" /* Validators */].required]),
            lastName: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["g" /* Validators */].required]),
            email: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["g" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_4__angular_forms__["g" /* Validators */].pattern(this.emailPattern)]),
            languageId: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["g" /* Validators */].required]),
            roleData: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["g" /* Validators */].required]),
            userId_WPASS: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["g" /* Validators */].required]),
        });
        this.AdminForm.valueChanges.subscribe(function (data) {
            _this.AdminFormDetails = _this.AdminForm.getRawValue();
            _this.AdminFormDetails['roleId'] = [];
            for (var d in _this.AdminFormDetails.roleData) {
                _this.AdminFormDetails['roleId'].push(_this.AdminFormDetails.roleData[d]['id']);
            }
            _this.AdminFormDetails.validate = _this.AdminForm.valid;
        });
    };
    AddAdminComponent.prototype.buroleSelect = function (item) {
        if (this.selectedAdminItems.find(function (x) { return x.id == "5639445604728832"; })) {
            if (this.wpassId) {
                if (this.api1) {
                    /* this.dialogRef = this.dialog.open(DialogComponent);
                    this.dialogRef.componentInstance.msg = "This user id is not able to assign manager"; */
                }
            }
            else {
                if (this.selectedAdminItems.find(function (x) { return x.id == "5639445604728832"; })) {
                    var sliceFor = this.selectedAdminItems.findIndex(function (x) { return x.id == "5639445604728832"; });
                    this.selectedAdminItems.splice(sliceFor);
                    if (this.selectedAdminItems.length == 0) {
                        this.selectedAdminItems = [];
                    }
                    console.log(this.selectedAdminItems);
                }
            }
        }
        else {
            if (this.wpassId) { }
        }
    };
    AddAdminComponent.prototype.onBlurWpass = function () {
        if (this.selectedAdminItems) {
            console.log(this.selectedAdminItems);
            if (this.selectedAdminItems.find(function (x) { return x.id == "5639445604728832"; })) {
                if (this.wpassId) {
                    if (this.api1) {
                        /* this.dialogRef = this.dialog.open(DialogComponent);
                        this.dialogRef.componentInstance.msg = "This user id is not able to assign manager"; */
                        if (this.selectedAdminItems.find(function (x) { return x.id == "5639445604728832"; })) {
                            var sliceFor = this.selectedAdminItems.findIndex(function (x) { return x.id == "5639445604728832"; });
                            this.selectedAdminItems.splice(sliceFor);
                            if (this.selectedAdminItems.length == 0) {
                                this.selectedAdminItems = [];
                            }
                            console.log(this.selectedAdminItems);
                        }
                    }
                }
            }
            else if (this.wpassId) { }
        }
    };
    AddAdminComponent.prototype.noWpassId = function (item) {
        console.log(item);
    };
    AddAdminComponent.prototype.saveAdminData = function () {
        var _this = this;
        this.httpService.postRequest(this.AdminFormDetails, 'superUserOperationsApi/v1/admin').subscribe(function (res) { _this.saveAdminResponse(res); }, function (err) { _this.httpService.onEnd(); });
    };
    AddAdminComponent.prototype.saveAdminResponse = function (res) {
        if (res) {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = "Admin added successfully";
            this.dialogRef.afterClosed().subscribe(function (result) {
                window.location.href = '#/app/manage-admin/list';
            });
        }
        else if (res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = 'save_failed';
            this.httpService.onEnd();
        }
    };
    AddAdminComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.buildForm();
        var temp_settings = { singleSelection: false, text: "", labelKey: "name", selectAllText: "", unSelectAllText: "", classes: "myclass custom-class" };
        this.translate.get('Select Role').subscribe(function (res) {
            temp_settings.text = res;
            if (temp_settings.text && temp_settings.selectAllText && temp_settings.unSelectAllText) {
                _this.settings = temp_settings;
            }
        });
        this.translate.get('select_all').subscribe(function (res) {
            temp_settings.selectAllText = res;
            if (temp_settings.text && temp_settings.selectAllText && temp_settings.unSelectAllText) {
                _this.settings = temp_settings;
            }
        });
        this.translate.get('unselect_all').subscribe(function (res) {
            temp_settings.unSelectAllText = res;
            if (temp_settings.text && temp_settings.selectAllText && temp_settings.unSelectAllText) {
                _this.settings = temp_settings;
            }
        });
    };
    AddAdminComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'add-admin',
            template: __webpack_require__(1279)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_6__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_5__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_3__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_4__angular_forms__["h" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_8_ng2_translate__["d" /* TranslateService */]])
    ], AddAdminComponent);
    return AddAdminComponent;
}());



/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdminListPage; });
/**
 * Created by shubham on 11/4/18.
 */
/**
 * An object used to get page information from the server
 */
var AdminListPage = /** @class */ (function () {
    function AdminListPage() {
        //The number of elements in the page
        this.size = 0;
        //The total number of elements
        this.totalElements = 0;
        //The total number of pages
        this.totalPages = 0;
        //The current page number
        this.pageNumber = 0;
    }
    return AdminListPage;
}());



/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdminListComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_services_common_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__adminList_datatable_adminList_page__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__adminListDashboardResultService__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ng2_translate__ = __webpack_require__(17);
/**
 * Created by shubham on 8/5/18.
 */














var AdminListComponent = /** @class */ (function () {
    function AdminListComponent(router, httpService, sessionHandler, dialog, formBuilder, serverResultsService, commonService, translate) {
        var _this = this;
        this.router = router;
        this.httpService = httpService;
        this.sessionHandler = sessionHandler;
        this.dialog = dialog;
        this.formBuilder = formBuilder;
        this.serverResultsService = serverResultsService;
        this.commonService = commonService;
        this.translate = translate;
        this.page = new __WEBPACK_IMPORTED_MODULE_10__adminList_datatable_adminList_page__["a" /* AdminListPage */]();
        this.tableRows = [];
        this.filters = {};
        this.adminListData = [];
        this.temp = [];
        this.showTable = true;
        this.isSystemAdmin = false;
        this.isBUManager = false;
        this.isRegionalAdmin = false;
        this.isServiceOwner = false;
        this.isTradePartner = false;
        this.isSubUser = false;
        this.selected = [];
        this.firstName = '';
        this.email = '';
        this.wpassId = '';
        this.isDisabled = false;
        this.dataTableMessage = { 'selectedMessage': '', 'totalMessage': '' };
        this.getUserList = function () {
            this.showTable = false;
        };
        this.saveUserList = function (res, filter) {
            if (res.errorStatus == 'Fail') {
                this.httpService.onEnd();
                this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
                this.dialogRef.componentInstance.msg = 'data_pull_fail';
            }
            else {
                if (res && Object.keys(res).length > 0) {
                    this.adminListData = res;
                    this.rows = [];
                    this.rows['offset'] = res.offset;
                    if (this.adminListData.list) {
                        var totalCount = 0;
                        if (parseInt(res.offset) == 0) {
                            localStorage.setItem('totalCount', res.totalCount);
                            totalCount = parseInt(res.totalCount);
                        }
                        else {
                            totalCount = parseInt(localStorage.getItem('totalCount'));
                        }
                        this.rows['totalCount'] = totalCount;
                        for (var data in this.adminListData.list) {
                            if (this.isSystemAdmin) {
                                this.rows[data] = {};
                                this.rows[data]['id'] = this.adminListData.list[data]['id'];
                                this.rows[data]['Name'] = this.adminListData.list[data]['firstName'] + ' ' + this.adminListData.list[data]['lastName'];
                                this.rows[data]['roleName'] = this.adminListData.list[data]['roleName'];
                                this.rows[data]['email'] = this.adminListData.list[data]['email'];
                                this.rows[data]['emailVerified'] = this.adminListData.list[data]['emailVerified'];
                                if (this.adminListData.list[data]['userId_WPASS']) {
                                    this.rows[data]['userId_WPASS'] = this.adminListData.list[data]['userId_WPASS'];
                                }
                                else {
                                    this.rows[data]['userId_WPASS'] = null;
                                }
                                if (this.adminListData.list[data]['pendingSubUserCount']) {
                                    this.rows[data]['pendingSubUserCount'] = this.adminListData.list[data]['pendingSubUserCount'];
                                }
                                else {
                                    this.rows[data]['pendingSubUserCount'] = 0;
                                }
                                this.rows[data]['languageId'] = this.adminListData.list[data]['languageId'];
                                this.rows[data]['languageName'] = 'Language';
                                if (this.adminListData.list[data]['active'] == true) {
                                    this.rows[data]['status'] = 'Active';
                                }
                                else {
                                    this.rows[data]['status'] = 'Inactive';
                                }
                                this.rows[data]['active'] = this.adminListData.list[data]['active'];
                                this.rows[data]['createdAt'] = this.adminListData.list[data]['createdAt'];
                                this.rows[data]['updatedAt'] = this.adminListData.list[data]['updatedAt'];
                            }
                            else {
                                //For Other Service Partner's
                                this.rows[data] = {};
                            }
                        }
                        this.showTable = true;
                        this.temp = this.rows;
                    }
                    else {
                        this.showTable = false;
                    }
                    var finalRows = [];
                    for (var f in this.rows) {
                        if (f != 'offset' && f != 'totalCount' && this.rows[f]) {
                            finalRows.push(this.rows[f]);
                        }
                        if (f == 'offset') {
                            finalRows['offset'] = this.rows['offset'];
                        }
                        if (f == 'totalCount') {
                            finalRows['totalCount'] = this.rows['totalCount'];
                        }
                    }
                    this.rows = finalRows;
                    this.setPage({ offset: this.rows['offset'] / this.page.size }, finalRows, filter);
                    this.httpService.onEnd();
                }
            }
        };
        this.adminListText = 'adminList';
        //Assign Active or Inactive status
        this.StatusData = [
            {
                "id": true,
                "code": "ACTIVE",
                "name": "Active"
            }, {
                "id": false,
                "code": "INACTIVE",
                "name": "Inactive"
            }
        ];
        this.selectedStatusId = true;
        this.page.pageNumber = 0;
        this.page.size = 20;
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].systemAdmin)) {
                this.isSystemAdmin = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].BUManager)) {
                this.isBUManager = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].serviceOwner)) {
                this.isServiceOwner = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].tradePartner)) {
                this.isTradePartner = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].subuser)) {
                this.isSubUser = true;
            }
        }
        else {
            this.httpService.noUserError();
        }
        this.filters['offSet'] = this.page.pageNumber * this.page.size;
        this.filters['limit'] = this.page.size;
        if (this.isSystemAdmin) {
            this.getAdminRoles();
        }
        else {
            this.getUserList();
        }
        //Call when approve/delete from ApproveRejectComponent/ActiveInactiveComponent to get the updated list.
        this.commonService.adminList.subscribe(function (value) {
            _this.getUsersList(_this.filters, _this.selectedStatusId, _this.defaulAdminId, _this.email, _this.firstName, _this.wpassId);
        });
    }
    AdminListComponent.prototype.getAdminRoles = function () {
        var _this = this;
        this.httpService.getRequest('superUserOperationsApi/v1/adminRoles').subscribe(function (res) { _this.saveAdminRoles(res); }, function (err) { _this.httpService.onEnd(); });
    };
    AdminListComponent.prototype.saveAdminRoles = function (res) {
        if (res && res.items) {
            this.adminRoles = res.items;
            for (var a in this.adminRoles) {
                if (this.adminRoles[a]['code'] == __WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].BUManager) {
                    this.defaulAdminId = this.adminRoles[a]['id'];
                }
            }
            if (!this.defaulAdminId) {
                this.defaulAdminId = this.adminRoles[0]['id'];
            }
            this.getUsersList(this.filters, this.selectedStatusId, this.defaulAdminId, this.email, this.firstName, this.wpassId);
        }
        else {
            this.httpService.onEnd();
        }
    };
    AdminListComponent.prototype.buildForm = function () {
        var _this = this;
        this.FiltersForm = this.formBuilder.group({
            firstName: this.formBuilder.control({ value: '', disabled: this.isDisabled }),
            email: this.formBuilder.control({ value: '', disabled: this.isDisabled }),
            wpassId: this.formBuilder.control(''),
        });
        this.FiltersForm.valueChanges.subscribe(function (data) {
            _this.firstName = _this.FiltersForm.get('firstName').value;
            _this.email = _this.FiltersForm.get('email').value;
            _this.wpassId = _this.FiltersForm.get('wpassId').value;
        });
    };
    AdminListComponent.prototype.disablefields = function (value) {
        if (value != '') {
            this.FiltersForm.controls['firstName'].setValue('');
            this.FiltersForm.controls['email'].setValue('');
            this.FiltersForm.controls['firstName'].disable();
            this.FiltersForm.controls['email'].disable();
        }
        else {
            this.FiltersForm.controls['firstName'].enable();
            this.FiltersForm.controls['email'].enable();
        }
    };
    AdminListComponent.prototype.search = function () {
        this.filters['offSet'] = 0;
        this.getUsersList(this.filters, this.selectedStatusId, this.defaulAdminId, this.email, this.firstName, this.wpassId);
    };
    AdminListComponent.prototype.resetSearch = function () {
        this.FiltersForm.controls['firstName'].enable();
        this.FiltersForm.controls['email'].enable();
        this.FiltersForm.reset();
        this.firstName = '';
        this.email = '';
        this.wpassId = '';
        this.search();
    };
    AdminListComponent.prototype.getUsersList = function (filter, selectedStatus, defaulAdminId, email, firstName, wpassId) {
        var _this = this;
        this.httpService.getRequest("superUserOperationsApi/v1/admin/list?limit=" + filter.limit + "&offset=" + filter.offSet + "&role=" + defaulAdminId + "&active=" + selectedStatus + "&email=" + email + "&firstName=" + firstName + "&wpassId=" + wpassId).subscribe(function (res) { _this.saveUserList(res, filter); }, function (err) { _this.httpService.onEnd(); });
    };
    /**
     * Populate the table with new data based on the page number
     * @param page The page to select
     */
    AdminListComponent.prototype.setPage = function (pageInfo, rows, filter) {
        var _this = this;
        this.page.pageNumber = pageInfo.offset;
        if (rows.length != 0) {
            this.serverResultsService.getResults(this.page, rows).subscribe(function (pageData) {
                _this.page = pageData.page;
                _this.tableRows = pageData.data;
                if (!filter) {
                    if (Object.keys(_this.tableRows).length == 0 || !_this.tableRows[0]['status']) {
                        _this.filters['offSet'] = _this.page.pageNumber * _this.page.size;
                        _this.getUsersList(_this.filters, _this.selectedStatusId, _this.defaulAdminId, _this.email, _this.firstName, _this.wpassId);
                    }
                }
            });
        }
        else {
            this.tableRows = [];
            this.page.totalElements = rows.length;
        }
    };
    AdminListComponent.prototype.onSelect = function (_a) {
        var selected = _a.selected;
        var _b;
        this.selected.splice(0, this.selected.length);
        (_b = this.selected).push.apply(_b, selected);
    };
    AdminListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.buildForm();
        this.translate.get('total').subscribe(function (res) {
            _this.dataTableMessage.totalMessage = res;
        });
        this.translate.get('selected').subscribe(function (res) {
            _this.dataTableMessage.selectedMessage = res;
        });
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"])(__WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__["DatatableComponent"]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__["DatatableComponent"])
    ], AdminListComponent.prototype, "table", void 0);
    AdminListComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'adminList',
            template: __webpack_require__(1280)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_4__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_6__angular_material__["c" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_9__angular_forms__["h" /* FormBuilder */], __WEBPACK_IMPORTED_MODULE_12__adminListDashboardResultService__["a" /* AdminListDashboardResultService */], __WEBPACK_IMPORTED_MODULE_8__shared_services_common_service__["a" /* CommonService */],
            __WEBPACK_IMPORTED_MODULE_13_ng2_translate__["d" /* TranslateService */]])
    ], AdminListComponent);
    return AdminListComponent;
}());



/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdminListDashboardResultService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__adminList_datatable_adminList_page_data__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__adminList_datatable_adminList_dashboard__ = __webpack_require__(784);
/**
 * Created by shubham on 8/5/18.
 */





/**
 * A server used to mock a paged data result from a server
 */
var AdminListDashboardResultService = /** @class */ (function () {
    function AdminListDashboardResultService() {
        this.rows = {};
        this.adminDashboardData = {};
    }
    /**
     * A method that mocks a paged server response
     * @param page The selected page
     * @returns {any} An observable containing the employee data
     */
    AdminListDashboardResultService.prototype.getResults = function (page, listData) {
        var _this = this;
        this.listData = listData;
        return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(listData).map(function (data) { return _this.getPageData(page); });
    };
    /**
     * Package companyData into a PagedData object based on the selected Page
     * @param page The page data used to get the selected data from companyData
     * @returns {PagedData<icsList>} An array of the selected data and page
     */
    AdminListDashboardResultService.prototype.getPageData = function (page) {
        var pageData = new __WEBPACK_IMPORTED_MODULE_3__adminList_datatable_adminList_page_data__["a" /* AdminListPageData */]();
        var offset = this.listData.offset;
        var raw = [];
        for (var l in this.listData) {
            if (Object.keys(this.listData[l]).length > 0) {
                raw[offset + parseInt(l)] = this.listData[l];
            }
        }
        if (this.listData.totalCount) {
            page.totalElements = this.listData.totalCount;
        }
        page.totalPages = page.totalElements / page.size;
        var start = page.pageNumber * page.size;
        var end = Math.min((start + page.size), page.totalElements);
        for (var i = start; i < end; i++) {
            if (raw[i]) {
                var jsonObj = raw[i];
                if (jsonObj) {
                    var list = new __WEBPACK_IMPORTED_MODULE_4__adminList_datatable_adminList_dashboard__["a" /* AdminListDashboard */](jsonObj['id'], jsonObj['Name'], jsonObj['roleName'], jsonObj['email'], jsonObj['emailVerified'], jsonObj['pendingSubUserCount'], jsonObj['userId_WPASS'], jsonObj['languageId'], jsonObj['languageName'], jsonObj['active'], jsonObj['status'], jsonObj['createdAt']);
                    pageData.data.push(list);
                }
            }
        }
        pageData.page = page;
        return pageData;
    };
    AdminListDashboardResultService = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [])
    ], AdminListDashboardResultService);
    return AdminListDashboardResultService;
}());



/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdminManagementComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ng2_translate__ = __webpack_require__(17);
/**
 * Created by shubham on 8/5/18.
 */







var AdminManagementComponent = /** @class */ (function () {
    function AdminManagementComponent(router, sessionHandler, httpService, dialog, translate) {
        this.router = router;
        this.sessionHandler = sessionHandler;
        this.httpService = httpService;
        this.dialog = dialog;
        this.translate = translate;
        this.languageId = this.sessionHandler.getItem('languageId');
        if (!this.languageId) {
            this.languageId = "EN";
        }
        this.translate.use(this.languageId);
    }
    AdminManagementComponent.prototype.ngOnInit = function () { };
    AdminManagementComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'manage-admin',
            template: __webpack_require__(1281)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_5__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_4__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_3__angular_material__["c" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_6_ng2_translate__["d" /* TranslateService */]])
    ], AdminManagementComponent);
    return AdminManagementComponent;
}());



/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AdminManagementModule", function() { return AdminManagementModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_http__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_common__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__swimlane_ngx_datatable__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__swimlane_ngx_datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__swimlane_ngx_datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angular2_multiselect_dropdown_angular2_multiselect_dropdown__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__activate_deactivate_request_activate_deactivate_request_module__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__adminManagement_routing_module__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__adminManagement_component__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__adminList_adminList_component__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__addAdmin_addAdmin_component__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__viewAdmin_viewAdmin_component__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_ng2_translate__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__config__ = __webpack_require__(12);
/**
 * Created by shubham on 8/5/18.
 */
















var AdminManagementModule = /** @class */ (function () {
    function AdminManagementModule() {
    }
    AdminManagementModule = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
            imports: [
                __WEBPACK_IMPORTED_MODULE_3__angular_material__["a" /* MaterialModule */],
                __WEBPACK_IMPORTED_MODULE_3__angular_material__["e" /* MdTabsModule */],
                __WEBPACK_IMPORTED_MODULE_5__angular_common__["CommonModule"],
                __WEBPACK_IMPORTED_MODULE_4__angular_forms__["a" /* FormsModule */],
                __WEBPACK_IMPORTED_MODULE_6__swimlane_ngx_datatable__["NgxDatatableModule"],
                __WEBPACK_IMPORTED_MODULE_4__angular_forms__["b" /* ReactiveFormsModule */],
                __WEBPACK_IMPORTED_MODULE_7_angular2_multiselect_dropdown_angular2_multiselect_dropdown__["a" /* AngularMultiSelectModule */],
                __WEBPACK_IMPORTED_MODULE_8__activate_deactivate_request_activate_deactivate_request_module__["a" /* ActivateDeactivateModule */],
                __WEBPACK_IMPORTED_MODULE_9__adminManagement_routing_module__["a" /* AdminManagementRoutingModule */],
                __WEBPACK_IMPORTED_MODULE_14_ng2_translate__["b" /* TranslateModule */].forRoot({
                    provide: __WEBPACK_IMPORTED_MODULE_14_ng2_translate__["c" /* TranslateLoader */],
                    //useFactory: (http: Http) => new TranslateStaticLoader(http, '/assets/i18n', '.json'),
                    useFactory: function (http) { return new __WEBPACK_IMPORTED_MODULE_14_ng2_translate__["a" /* TranslateStaticLoader */](http, __WEBPACK_IMPORTED_MODULE_15__config__["a" /* APPCONFIG */].URL + __WEBPACK_IMPORTED_MODULE_15__config__["a" /* APPCONFIG */].translationUrl, '?v=' + __WEBPACK_IMPORTED_MODULE_15__config__["a" /* APPCONFIG */].translationVersion); },
                    deps: [__WEBPACK_IMPORTED_MODULE_2__angular_http__["b" /* Http */]]
                })
            ],
            declarations: [
                __WEBPACK_IMPORTED_MODULE_10__adminManagement_component__["a" /* AdminManagementComponent */],
                __WEBPACK_IMPORTED_MODULE_11__adminList_adminList_component__["a" /* AdminListComponent */],
                __WEBPACK_IMPORTED_MODULE_12__addAdmin_addAdmin_component__["a" /* AddAdminComponent */],
                __WEBPACK_IMPORTED_MODULE_13__viewAdmin_viewAdmin_component__["a" /* ViewAdminComponent */]
            ],
            exports: []
        })
    ], AdminManagementModule);
    return AdminManagementModule;
}());



/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewAdminComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dialog_dialog_component__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ng2_translate__ = __webpack_require__(17);
/**
 * Created by shubham on 8/5/18.
 */










var ViewAdminComponent = /** @class */ (function () {
    function ViewAdminComponent(router, route, sessionHandler, httpService, dialog, formBuilder, translate) {
        var _this = this;
        this.router = router;
        this.route = route;
        this.sessionHandler = sessionHandler;
        this.httpService = httpService;
        this.dialog = dialog;
        this.formBuilder = formBuilder;
        this.translate = translate;
        this.adminDetails = [];
        this.isSystemAdmin = false;
        this.isBUManager = false;
        this.isRegionalAdmin = false;
        this.isServiceOwner = false;
        this.isTradePartner = false;
        this.isSubUser = false;
        this.isDisabled = true;
        this.adminRoles = [];
        this.selectedItems = [];
        this.settings = {};
        this.api1 = true;
        this.route.params.subscribe(function (params) {
            _this.id = +params['id'];
        });
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].BUManager)) {
                this.isBUManager = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].serviceOwner)) {
                this.isServiceOwner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].tradePartner)) {
                this.isTradePartner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].subuser)) {
                this.isSubUser = true;
            }
        }
        else {
            this.httpService.noUserError();
        }
        if (this.isSystemAdmin) {
            this.getAdminDataById(this.id);
            this.getAdminRoles();
        }
        else {
            //TODO
        }
    }
    ViewAdminComponent.prototype.getAdminRoles = function () {
        var _this = this;
        this.httpService.getRequest('superUserOperationsApi/v1/adminRoles').subscribe(function (res) { _this.saveAdminRoles(res); }, function (err) { _this.httpService.onEnd(); });
    };
    ViewAdminComponent.prototype.saveAdminRoles = function (res) {
        if (res && res.items) {
            this.adminRoles = res.items;
        }
        this.httpService.onEnd();
    };
    ViewAdminComponent.prototype.getAdminDataById = function (id) {
        var _this = this;
        this.httpService.getRequest('superUserOperationsApi/v1/admin/' + id).subscribe(function (res) { _this.saveRequestData(res); }, function (err) { _this.httpService.onEnd(); });
    };
    ViewAdminComponent.prototype.saveRequestData = function (res) {
        if (res) {
            this.adminDetails = res;
            if (this.adminDetails['roleId'] && this.adminDetails['roleName']) {
                for (var l in this.adminDetails['roleId']) {
                    this.selectedItems.push({ id: this.adminDetails['roleId'][l], name: this.adminDetails['roleName'][l] });
                }
            }
            this.AdminEditFormDetails = this.adminDetails;
            this.buildForm();
            this.httpService.onEnd();
        }
        else if (res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_8__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = 'data_load_failed';
            this.httpService.onEnd();
        }
    };
    ViewAdminComponent.prototype.buildForm = function () {
        var _this = this;
        this.AdminEditForm = this.formBuilder.group({
            roleData: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_5__angular_forms__["g" /* Validators */].required]),
        });
        this.AdminEditForm.valueChanges.subscribe(function (data) {
            _this.AdminEditFormDetails = _this.AdminEditForm.getRawValue();
            _this.AdminEditFormDetails['id'] = _this.adminDetails['id'];
            _this.AdminEditFormDetails['roleId'] = [];
            for (var d in _this.AdminEditFormDetails.roleData) {
                _this.AdminEditFormDetails['roleId'].push(_this.AdminEditFormDetails.roleData[d]['id']);
            }
            _this.AdminEditFormDetails.validate = _this.AdminEditForm.valid;
        });
    };
    ViewAdminComponent.prototype.saveAdminRole = function () {
        var _this = this;
        this.httpService.postRequest(this.AdminEditFormDetails, 'superUserOperationsApi/v1/updateAdminRole').subscribe(function (res) { _this.saveAdminEditResponse(res); }, function (err) { _this.httpService.onEnd(); });
    };
    ViewAdminComponent.prototype.saveAdminEditResponse = function (res) {
        if (res) {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_8__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = "Role Updated Successfully";
            this.dialogRef.afterClosed().subscribe(function (result) {
                window.location.href = '#/app/manage-admin/list';
            });
        }
        else if (res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_8__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = 'save_failed';
            this.httpService.onEnd();
        }
    };
    ViewAdminComponent.prototype.buroleSelect = function (item) {
        console.log(item);
        if (this.selectedItems.find(function (x) { return x.id == "5639445604728832"; })) {
            if (this.api1) {
                /* this.dialogRef = this.dialog.open(DialogComponent);
                this.dialogRef.componentInstance.msg = "This user id is not able to assign manager"; */
            }
        }
        else {
            /* if(this.selectedAdminItems.find(x=> x.id == "5639445604728832")){
               var sliceFor =  this.selectedAdminItems.findIndex(x=> x.id == "5639445604728832");
                this.selectedAdminItems.splice(sliceFor);
            } */
        }
    };
    ViewAdminComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.buildForm();
        var temp_settings = { singleSelection: false, text: "", labelKey: "name", selectAllText: "", unSelectAllText: "", classes: "myclass custom-class" };
        this.translate.get('Select Role').subscribe(function (res) {
            temp_settings.text = res;
            if (temp_settings.text && temp_settings.selectAllText && temp_settings.unSelectAllText) {
                _this.settings = temp_settings;
            }
        });
        this.translate.get('select_all').subscribe(function (res) {
            temp_settings.selectAllText = res;
            if (temp_settings.text && temp_settings.selectAllText && temp_settings.unSelectAllText) {
                _this.settings = temp_settings;
            }
        });
        this.translate.get('unselect_all').subscribe(function (res) {
            temp_settings.unSelectAllText = res;
            if (temp_settings.text && temp_settings.selectAllText && temp_settings.unSelectAllText) {
                _this.settings = temp_settings;
            }
        });
    };
    ViewAdminComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'view-admin',
            template: __webpack_require__(1282)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_2__angular_router__["b" /* ActivatedRoute */], __WEBPACK_IMPORTED_MODULE_7__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_6__shared_services_http_service__["a" /* HttpService */],
            __WEBPACK_IMPORTED_MODULE_4__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_5__angular_forms__["h" /* FormBuilder */], __WEBPACK_IMPORTED_MODULE_9_ng2_translate__["d" /* TranslateService */]])
    ], ViewAdminComponent);
    return ViewAdminComponent;
}());



/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddApplicationComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ng2_translate__ = __webpack_require__(17);
/**
 * Created by shubham on 19/9/18.
 */










var AddApplicationComponent = /** @class */ (function () {
    function AddApplicationComponent(router, route, sessionHandler, httpService, dialog, formBuilder, translate) {
        var _this = this;
        this.router = router;
        this.route = route;
        this.sessionHandler = sessionHandler;
        this.httpService = httpService;
        this.dialog = dialog;
        this.formBuilder = formBuilder;
        this.translate = translate;
        this.isSystemAdmin = false;
        this.isBUManager = false;
        this.isRegionalAdmin = false;
        this.isServiceOwner = false;
        this.isTradePartner = false;
        this.isSubUser = false;
        this.isApplicationManager = false;
        this.admins = [];
        this.countries = [];
        this.businessUnits = [];
        this.ApplicationFormDetailsById = [];
        this.managers = [];
        this.settings = {};
        this.selectedItems = [];
        this.managersMessage = "";
        this.managersFlag = false;
        this.idFlag = false;
        this.activeFlag = false;
        this.isAssigned = false;
        this.allowMultipleRolesFlag = false;
        this.skipManagerApprovalFlag = false;
        this.skipManagerApprovalMessage = "";
        this.selectedCountryId = "";
        this.countryWiseDefaults = [];
        this.forSpecificCountry = false;
        this.selectedContries = [];
        this.route.params.subscribe(function (params) {
            _this.id = params['id'];
        });
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].BUManager)) {
                this.isBUManager = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].serviceOwner)) {
                this.isServiceOwner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].tradePartner)) {
                this.isTradePartner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].subuser)) {
                this.isSubUser = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].applicationManager)) {
                this.isApplicationManager = true;
            }
        }
        else {
            this.httpService.noUserError();
        }
        if (this.isSystemAdmin) {
            if (this.id != null && this.id != undefined) {
                this.getApplicationDataById(this.id);
                this.idFlag = true;
            }
            else {
                this.activeFlag = true;
                this.idFlag = false;
            }
            this.getApplicationManagers();
        }
        this.getCountries();
    }
    AddApplicationComponent.prototype.getApplicationManagers = function () {
        var _this = this;
        this.httpService.getRequest('applicationOperationApi/v1/getApplicationManagerList').subscribe(function (res) {
            _this.saveApplicationManagers(res);
        }, function (err) {
            _this.httpService.onEnd();
        });
    };
    AddApplicationComponent.prototype.saveApplicationManagers = function (res) {
        if (res && res.items) {
            this.managers = res.items;
        }
        this.httpService.onEnd();
    };
    AddApplicationComponent.prototype.getApplicationDataById = function (id) {
        var _this = this;
        this.httpService.getRequest('applicationOperationApi/v1/application/' + id).subscribe(function (res) {
            _this.saveApplicationDataById(res);
        }, function (err) {
            _this.httpService.onEnd();
        });
    };
    AddApplicationComponent.prototype.saveApplicationDataById = function (res) {
        if (res) {
            console.log(res);
            /**************************/
            // var applicationRoles=[];
            // for(let i in res.applicationRoles) {
            //     for(let j in res.applicationRoles[i].roles) {
            //         res.applicationRoles[i].roles[j].country=res.applicationRoles[i].country;
            //         applicationRoles.push(res.applicationRoles[i].roles[j]);
            //     }
            // }
            // delete res.applicationRoles;
            // res.applicationRoles=applicationRoles;
            /**************************/
            this.ApplicationFormDetailsById = res;
            this.forSpecificCountry = res.countrySpecificRoles;
            if (this.ApplicationFormDetailsById['active']) {
                this.activeFlag = true;
            }
            if (this.ApplicationFormDetailsById['managerIds'] && this.ApplicationFormDetailsById['managerNames']) {
                for (var l in this.ApplicationFormDetailsById['managerIds']) {
                    this.selectedItems.push({
                        id: this.ApplicationFormDetailsById['managerIds'][l],
                        name: this.ApplicationFormDetailsById['managerNames'][l]
                    });
                }
            }
            this.buildForm();
            if (this.ApplicationFormDetailsById['applicationRoles'] != null) {
                if (this.ApplicationFormDetailsById['assigned'] || this.ApplicationFormDetailsById['assigned'] != undefined) {
                    this.isAssigned = true;
                }
                else {
                    this.isAssigned = false;
                }
                // ***÷*****************************
                this.createRoles(this.ApplicationFormDetailsById['applicationRoles'], this.isAssigned);
            }
            this.httpService.onEnd();
        }
        else if (res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = 'data_load_failed';
            this.httpService.onEnd();
        }
    };
    AddApplicationComponent.prototype.buildForm = function () {
        var _this = this;
        this.ApplicationForm = this.formBuilder.group({
            applicationName: this.formBuilder.control(this.ApplicationFormDetailsById['applicationName'] ? this.ApplicationFormDetailsById['applicationName'] : null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["g" /* Validators */].required]),
            ldapApplicationId: this.formBuilder.control(this.ApplicationFormDetailsById['ldapApplicationId'] ? this.ApplicationFormDetailsById['ldapApplicationId'] : null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["g" /* Validators */].required]),
            managerData: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["g" /* Validators */].required]),
            url: this.formBuilder.control(this.ApplicationFormDetailsById['url'] ? this.ApplicationFormDetailsById['url'] : null),
            applicationRoles: this.formBuilder.array([]),
            multipleRole: this.formBuilder.control(this.ApplicationFormDetailsById['multipleRole'] ? this.ApplicationFormDetailsById['multipleRole'] : false),
            customerNumberRequired: this.formBuilder.control(this.ApplicationFormDetailsById['customerNumberRequired'] ? this.ApplicationFormDetailsById['customerNumberRequired'] : false),
            skipManagerApproval: this.formBuilder.control(this.ApplicationFormDetailsById['skipManagerApproval'] ? this.ApplicationFormDetailsById['skipManagerApproval'] : false),
            countries: this.formBuilder.array([])
        });
        this.ApplicationForm.valueChanges.subscribe(function (data) {
            _this.ApplicationFormDetails = _this.ApplicationForm.getRawValue();
            if (_this.ApplicationFormDetailsById['id']) {
                _this.ApplicationFormDetails['id'] = _this.ApplicationFormDetailsById['id'];
            }
            _this.ApplicationFormDetails['managerIds'] = [];
            for (var d in _this.ApplicationFormDetails.managerData) {
                _this.ApplicationFormDetails['managerIds'].push(_this.ApplicationFormDetails.managerData[d]['id']);
            }
            if (_this.ApplicationFormDetails['skipManagerApproval']) {
                _this.skipManagerApprovalFlag = true;
            }
            else {
                _this.skipManagerApprovalFlag = false;
            }
            if (_this.ApplicationFormDetails['multipleRole']) {
                _this.allowMultipleRolesFlag = true;
                if (_this.skipManagerApprovalFlag) {
                    _this.skipManagerApprovalMessage = "min_one_default_role";
                }
                else {
                    _this.skipManagerApprovalMessage = "";
                }
            }
            else {
                _this.skipManagerApprovalMessage = "only_one_default_role";
                _this.allowMultipleRolesFlag = false;
            }
            if (_this.ApplicationFormDetails['applicationRoles'].length > 0) {
                for (var _i = 0, _a = _this.ApplicationFormDetails['applicationRoles']; _i < _a.length; _i++) {
                    var appRolesObject = _a[_i];
                    if (appRolesObject['defaultRole']) {
                        _this.skipManagerApprovalMessage = "";
                        break;
                    }
                    else {
                        if (_this.allowMultipleRolesFlag) {
                            _this.skipManagerApprovalMessage = "min_one_default_role";
                        }
                        else {
                            _this.skipManagerApprovalMessage = "only_one_default_role";
                        }
                    }
                }
            }
            // ************************************
            if (_this.ApplicationFormDetails['countries']) {
                setTimeout(function () {
                    if (_this.forSpecificCountry && _this.selectedContries.length == 0) {
                        _this.skipManagerApprovalMessage = "Select at least one country.";
                    }
                    if (_this.forSpecificCountry && _this.selectedContries.length > 0 && _this.skipManagerApprovalFlag) {
                        for (var i = 0; i < _this.ApplicationFormDetails.countries.length; i++) {
                            for (var j = 0; j < _this.ApplicationFormDetails.countries[i].countryName.length; j++) {
                                if (_this.ApplicationFormDetails.countries[i].countryName[j]['defaultRole']) {
                                    _this.skipManagerApprovalMessage = "";
                                    break;
                                }
                                else {
                                    if (_this.allowMultipleRolesFlag) {
                                        _this.skipManagerApprovalMessage = "min_one_default_role";
                                    }
                                    else {
                                        _this.skipManagerApprovalMessage = "only_one_default_role";
                                    }
                                }
                            }
                            if (_this.skipManagerApprovalMessage != "") {
                                break;
                            }
                        }
                    }
                });
            }
            //    ***************************************** 
            _this.ApplicationFormDetails.validate = _this.ApplicationForm.valid;
        });
        this.ApplicationForm.get('managerData').valueChanges.subscribe(function (data) {
            if (data != null && data.length < 2) {
                _this.managersMessage = "atleast_two_mgrs";
                _this.managersFlag = false;
            }
            else if (data.length >= 2) {
                _this.managersMessage = "";
                _this.managersFlag = true;
            }
        });
        this.ApplicationForm.get('multipleRole').valueChanges.subscribe(function (data) {
            console.log(data);
            if (data != null && !data && _this.allowMultipleRolesFlag) {
                _this.createDefaultRoles();
            }
        });
        this.ApplicationForm.get('skipManagerApproval').valueChanges.subscribe(function (data) {
            if (data != null && !data) {
                _this.createDefaultRoles();
            }
        });
    };
    // ********************************
    AddApplicationComponent.prototype.setApplicationRoleSpecific = function () {
        var _this = this;
        console.log(this.selectedContries);
        var formdata = this.ApplicationForm.getRawValue();
        console.log(formdata);
        if (this.forSpecificCountry) {
            formdata.countries.forEach(function (element, index) {
                _this.ApplicationFormDetails['applicationRoles'].push({
                    country: _this.selectedContries[index].id,
                    roles: element.countryName
                    // country:this.selectedContries[index],
                    // roles:element.countryName
                });
            });
        }
        else {
            this.ApplicationFormDetails.applicationRoles = [];
            this.ApplicationFormDetails['applicationRoles'].push({
                country: "all",
                roles: formdata.applicationRoles
            });
        }
    };
    AddApplicationComponent.prototype.createRoles = function (rolesData, isAssigned) {
        if (!this.forSpecificCountry) {
            for (var roleDataIndex in rolesData) {
                rolesData[roleDataIndex]['isAssigned'] = isAssigned;
                this.onAddRoleProperty(rolesData[roleDataIndex]);
                // this.onAddRoleProperty(rolesData[0].roles[roleDataIndex]);
            }
        }
        else {
            // rolesData.forEach((element,index) => {
            //     console.log(element)
            //     this.onAddCountriestoForm(element);  
            // });
            this.onAddCountriestoForm(rolesData, isAssigned);
        }
    };
    AddApplicationComponent.prototype.onAddCountriestoForm = function (data, isAssigned) {
        var _this = this;
        var contries = [];
        for (var i = 0; i < data.length; i++) {
            if (contries.length == 0) {
                contries.push({ "countryId": data[i].country, "countryName": data[i].countryName, "roles": [{ "id": data[i].id, "name": data[i].name, "ldapRoleId": data[i].ldapRoleId, "defaultRole": data[i].defaultRole, "isAssignFlag": isAssigned }] });
            }
            else {
                var valueArr = contries.map(function (item) { return item.countryId; });
                if (!valueArr.includes(data[i].country)) {
                    contries.push({ "countryId": data[i].country, "countryName": data[i].countryName, "roles": [{ "id": data[i].id, "name": data[i].name, "ldapRoleId": data[i].ldapRoleId, "defaultRole": data[i].defaultRole, "isAssignFlag": isAssigned }] });
                }
                else {
                    for (var j = 0; j < contries.length; j++) {
                        if (data[i].country == contries[j].countryId) {
                            contries[j].roles.push({ "id": data[i].id, "name": data[i].name, "ldapRoleId": data[i].ldapRoleId, "defaultRole": data[i].defaultRole, "isAssignFlag": isAssigned });
                        }
                    }
                }
            }
        }
        for (var k = 0; k < contries.length; k++) {
            var fg = this.formBuilder.group({
                'countryName': this.formBuilder.array([]),
            });
            this.ApplicationForm.get('countries').push(fg);
            this.selectedContries.push({ 'id': contries[k].countryId, "name": contries[k].countryName, "isAssignFlag": isAssigned });
            contries[k]['roles'].forEach(function (element, index) {
                var newGroup = _this.formBuilder.group({
                    id: _this.formBuilder.control(element.id ? element.id : null),
                    name: _this.formBuilder.control(element.name ? element.name : null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["g" /* Validators */].required]),
                    ldapRoleId: _this.formBuilder.control(element.ldapRoleId ? element.ldapRoleId : null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["g" /* Validators */].required]),
                    defaultRole: _this.formBuilder.control(element.defaultRole ? element.defaultRole : false),
                    isAssignFlag: _this.formBuilder.control(element.isAssignFlag ? element.isAssignFlag : false)
                });
                _this.ApplicationForm.controls['countries']
                    .controls[_this.selectedContries.length - 1].controls['countryName'].push(newGroup);
            });
        }
        // data.roles.forEach((element,index) => {
        //     console.log(element)
        //     let newGroup = this.formBuilder.group({
        //         id: this.formBuilder.control(element.id ? element.id : null),
        //         name: this.formBuilder.control(element.name ? element.name : null, [Validators.required]),
        //         ldapRoleId: this.formBuilder.control(element.ldapRoleId ? element.ldapRoleId : null, [Validators.required]),
        //         defaultRole: this.formBuilder.control(element.defaultRole ? element.defaultRole : false),
        //         isAssignFlag: this.formBuilder.control(element.isAssigned ? element.isAssigned : false)
        //     });
        //     (<FormArray>(<FormGroup>(<FormArray>this.ApplicationForm.controls['countries'])
        //     .controls[this.selectedContries.length-1]).controls['countryName']).push(newGroup);
        // });
    };
    // **********************************
    AddApplicationComponent.prototype.onAddRoleProperty = function (data) {
        var arrayControl = this.ApplicationForm.controls['applicationRoles'];
        var newGroup;
        if (data) {
            newGroup = this.formBuilder.group({
                id: this.formBuilder.control(data.id ? data.id : null),
                name: this.formBuilder.control(data.name ? data.name : null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["g" /* Validators */].required]),
                ldapRoleId: this.formBuilder.control(data.ldapRoleId ? data.ldapRoleId : null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["g" /* Validators */].required]),
                defaultRole: this.formBuilder.control(data.defaultRole ? data.defaultRole : false),
                isAssignFlag: this.formBuilder.control(data.isAssigned ? data.isAssigned : false)
            });
        }
        else {
            newGroup = this.formBuilder.group({
                id: this.formBuilder.control(null),
                name: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["g" /* Validators */].required]),
                ldapRoleId: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["g" /* Validators */].required]),
                defaultRole: this.formBuilder.control(false),
                isAssignFlag: this.formBuilder.control(false)
            });
        }
        arrayControl.push(newGroup);
    };
    AddApplicationComponent.prototype.onlyOneDefault = function (index, value) {
        if (this.skipManagerApprovalFlag && !this.allowMultipleRolesFlag) {
            this.createDefaultRoles();
        }
    };
    AddApplicationComponent.prototype.createDefaultRoles = function () {
        if (!this.forSpecificCountry) {
            var arrayControl = this.ApplicationForm.controls['applicationRoles'];
            for (var index1 in arrayControl.controls) {
                var groupControl = arrayControl.controls[index1];
                groupControl.controls['defaultRole'].setValue(false);
                groupControl.controls['defaultRole'].updateValueAndValidity();
            }
        }
        else {
            var arrayControl = this.ApplicationForm.controls['countries'];
            for (var index2 in arrayControl.controls) {
                this.createDefaultRolesCountSpecific(index2);
            }
            this.calculateErrorForRDefault();
        }
    };
    AddApplicationComponent.prototype.onDeleteRoleProperty = function (index) {
        var arrayControl = this.ApplicationForm.controls['applicationRoles'];
        arrayControl.removeAt(index);
    };
    AddApplicationComponent.prototype.saveApplicationData = function () {
        var _this = this;
        this.setApplicationRoleSpecific();
        /**************************/
        var requestData = JSON.parse(JSON.stringify(this.ApplicationFormDetails));
        delete requestData.countries;
        var applicationRoles = [];
        for (var i in requestData.applicationRoles) {
            for (var j in requestData.applicationRoles[i].roles) {
                requestData.applicationRoles[i].roles[j].country = requestData.applicationRoles[i].country;
                applicationRoles.push(requestData.applicationRoles[i].roles[j]);
            }
        }
        delete requestData.applicationRoles;
        requestData.applicationRoles = applicationRoles;
        if (!requestData.skipManagerApproval) {
            requestData.applicationRoles.forEach(function (element) {
                element.defaultRole = false;
            });
        }
        /**************************/
        this.httpService.postRequest(requestData, 'applicationOperationApi/v1/createApplication').subscribe(function (res) {
            _this.saveApplicationResponse(res);
        }, function (err) {
            _this.httpService.onEnd();
        });
    };
    AddApplicationComponent.prototype.saveApplicationResponse = function (res) {
        if (res) {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
            if (this.id != null && this.id != undefined) {
                this.dialogRef.componentInstance.msg = "Application updated successfully.";
            }
            else {
                this.dialogRef.componentInstance.msg = "Application added successfully.";
            }
            this.dialogRef.afterClosed().subscribe(function (result) {
                window.location.href = '#/app/application-management/list';
            });
        }
        else if (res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = 'save_failed';
            this.httpService.onEnd();
        }
    };
    AddApplicationComponent.prototype.copyToClipboard = function () {
        var textArea = document.createElement("textarea");
        textArea.style.position = 'fixed';
        textArea.style.top = '-999px';
        textArea.style.left = '-999px';
        textArea.style.width = '2em';
        textArea.style.height = '2em';
        textArea.style.padding = '0';
        textArea.style.border = 'none';
        textArea.style.outline = 'none';
        textArea.style.boxShadow = 'none';
        textArea.style.background = 'transparent';
        textArea.value = window.location.origin + "/#/registration/apps/" + this.id;
        document.body.appendChild(textArea);
        textArea.select();
        try {
            document.execCommand('copy');
        }
        catch (err) {
            console.log('unable to copy');
        }
        document.body.removeChild(textArea);
    };
    AddApplicationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.buildForm();
        if (this.id == null || this.id == undefined) {
            this.onAddRoleProperty();
        }
        var temp_settings = { singleSelection: false, text: "", labelKey: "name", selectAllText: "", unSelectAllText: "", classes: "myclass custom-class" };
        this.translate.get('Assign Manager').subscribe(function (res) {
            temp_settings.text = res;
            if (temp_settings.text && temp_settings.selectAllText && temp_settings.unSelectAllText) {
                _this.settings = temp_settings;
            }
        });
        this.translate.get('select_all').subscribe(function (res) {
            temp_settings.selectAllText = res;
            if (temp_settings.text && temp_settings.selectAllText && temp_settings.unSelectAllText) {
                _this.settings = temp_settings;
            }
        });
        this.translate.get('unselect_all').subscribe(function (res) {
            temp_settings.unSelectAllText = res;
            if (temp_settings.text && temp_settings.selectAllText && temp_settings.unSelectAllText) {
                _this.settings = temp_settings;
            }
        });
    };
    AddApplicationComponent.prototype.getCountries = function () {
        var _this = this;
        this.httpService.getRequest('lookupDataOperationsApi/v1/countriesForAdmin').subscribe(function (res) {
            _this.saveCountries(res);
        }, function (err) { _this.httpService.onEnd(); });
    };
    AddApplicationComponent.prototype.saveCountries = function (res) {
        if (res && res.items) {
            this.countries = res.items;
        }
    };
    AddApplicationComponent.prototype.countSpecificFun = function (event) {
        var arrayControl = this.ApplicationForm.controls['applicationRoles'];
        if (!event.checked) {
            this.forSpecificCountry = false;
            while (this.ApplicationForm.controls['countries'].controls.length !== 0) {
                this.ApplicationForm.controls['countries'].removeAt(0);
            }
            this.selectedContries = [];
            this.onAddRoleProperty();
        }
        else if (event.checked) {
            this.forSpecificCountry = true;
            while (this.ApplicationForm.controls['applicationRoles'].controls.length !== 0) {
                this.ApplicationForm.controls['applicationRoles'].removeAt(0);
            }
        }
    };
    AddApplicationComponent.prototype.onCountryChange = function (contId) {
        var _this = this;
        var valueArr = this.selectedContries.map(function (item) { return item.name; });
        var contry = contId.source.selected._element.nativeElement.innerText.trim();
        var id = contId.value;
        var country = contId.source.selected._element.nativeElement.innerText.trim();
        var fg = this.formBuilder.group({
            'countryName': this.formBuilder.array([]),
        });
        if (valueArr.includes(contry) == false) {
            this.selectedContries.push({ "id": id, "name": contry, "isAssignFlag": false });
            this.ApplicationForm.get('countries').push(fg);
            this.rolesAddForSelectedCountries(this.selectedContries.length - 1);
        }
        this.calculateErrorForRDefault();
        setTimeout(function () {
            _this.countrySelect.writeValue(null);
        }, 1000);
    };
    AddApplicationComponent.prototype.rolesAddForSelectedCountries = function (index) {
        var newGroup = this.formBuilder.group({
            id: this.formBuilder.control(null),
            name: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["g" /* Validators */].required]),
            ldapRoleId: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["g" /* Validators */].required]),
            defaultRole: this.formBuilder.control(false),
            isAssignFlag: this.formBuilder.control(false)
        });
        this.ApplicationForm.controls['countries']
            .controls[index].controls['countryName'].push(newGroup);
    };
    AddApplicationComponent.prototype.deleteCountry = function (index) {
        var arrayControl = this.ApplicationForm.controls['countries'];
        arrayControl.removeAt(index);
        this.selectedContries.splice(index, 1);
        this.countryWiseDefaults.splice(index, 1);
    };
    AddApplicationComponent.prototype.onDeleteRolePropertySelected = function (cIndex, index) {
        var arrayControl = this.ApplicationForm.controls['countries']
            .controls[cIndex].controls['countryName'];
        arrayControl.controls[index].get('defaultRole').value ? this.countryWiseDefaults[cIndex] = false : null;
        arrayControl.removeAt(index);
    };
    AddApplicationComponent.prototype.createDefaultRolesCountSpecific = function (countIndex, index) {
        var arrayControl = this.ApplicationForm.controls['countries']
            .controls[countIndex].controls['countryName'];
        for (var index1 in arrayControl.controls) {
            var groupControl = arrayControl.controls[index1];
            groupControl.controls['defaultRole'].setValue(false);
            groupControl.controls['defaultRole'].updateValueAndValidity();
        }
    };
    AddApplicationComponent.prototype.onlyOneDefaultSpecific = function (countIndex, index) {
        if (!this.allowMultipleRolesFlag) {
            var arrayControl = this.ApplicationForm.controls['countries']
                .controls[countIndex].controls['countryName'];
            for (var index1 in arrayControl.controls) {
                if (index1 != index) {
                    var groupControl = arrayControl.controls[index1];
                    groupControl.controls['defaultRole'].setValue(false);
                }
            }
        }
        this.calculateErrorForRDefault();
    };
    AddApplicationComponent.prototype.calculateErrorForRDefault = function () {
        var _this = this;
        this.countryWiseDefaults = [];
        setTimeout(function () {
            var data = _this.ApplicationForm.get('countries').value;
            var defaultFlag = false;
            for (var i = 0; i < data.length; i++) {
                defaultFlag = false;
                for (var j = 0; j < data[i].countryName.length; j++) {
                    if (data[i].countryName[j].defaultRole) {
                        defaultFlag = true;
                    }
                }
                if (defaultFlag) {
                    _this.countryWiseDefaults.push(true);
                }
                else {
                    _this.countryWiseDefaults.push(false);
                }
            }
            console.log(_this.countryWiseDefaults);
        });
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"])('countrySelect'),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", Object)
    ], AddApplicationComponent.prototype, "countrySelect", void 0);
    AddApplicationComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'add-application',
            template: __webpack_require__(1283)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_8__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_8__angular_router__["b" /* ActivatedRoute */], __WEBPACK_IMPORTED_MODULE_6__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_5__shared_services_http_service__["a" /* HttpService */],
            __WEBPACK_IMPORTED_MODULE_3__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_4__angular_forms__["h" /* FormBuilder */], __WEBPACK_IMPORTED_MODULE_9_ng2_translate__["d" /* TranslateService */]])
    ], AddApplicationComponent);
    return AddApplicationComponent;
}());



/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApplicationListPage; });
/**
 * Created by prakash on 22/9/18.
 */
/**
 * An object used to get page information from the server
 */
var ApplicationListPage = /** @class */ (function () {
    function ApplicationListPage() {
        //The number of elements in the page
        this.size = 0;
        //The total number of elements
        this.totalElements = 0;
        //The total number of pages
        this.totalPages = 0;
        //The current page number
        this.pageNumber = 0;
    }
    return ApplicationListPage;
}());



/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApplicationListComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_services_common_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__applicationList_datatable_applicationList_page__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__applicationListDashboardResultService__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ng2_translate__ = __webpack_require__(17);
/**
 * Created by shubham on 8/5/18.
 */














var ApplicationListComponent = /** @class */ (function () {
    function ApplicationListComponent(router, httpService, sessionHandler, dialog, formBuilder, serverResultsService, commonService, translate) {
        var _this = this;
        this.router = router;
        this.httpService = httpService;
        this.sessionHandler = sessionHandler;
        this.dialog = dialog;
        this.formBuilder = formBuilder;
        this.serverResultsService = serverResultsService;
        this.commonService = commonService;
        this.translate = translate;
        this.page = new __WEBPACK_IMPORTED_MODULE_10__applicationList_datatable_applicationList_page__["a" /* ApplicationListPage */]();
        this.tableRows = [];
        this.filters = {};
        this.applicationListData = [];
        this.temp = [];
        this.showTable = true;
        this.isSystemAdmin = false;
        this.isBUManager = false;
        this.isRegionalAdmin = false;
        this.isServiceOwner = false;
        this.isTradePartner = false;
        this.isSubUser = false;
        this.selected = [];
        this.applicationName = '';
        this.wpassId = '';
        this.isDisabled = false;
        this.dataTableMessage = { 'selectedMessage': '', 'totalMessage': '' };
        this.getUserList = function () {
            this.showTable = false;
        };
        this.saveUserList = function (res, filter) {
            if (res.errorStatus == 'Fail') {
                this.httpService.onEnd();
                this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
                this.dialogRef.componentInstance.msg = 'data_pull_fail';
            }
            else {
                if (res && Object.keys(res).length > 0) {
                    this.applicationListData = res;
                    this.rows = [];
                    this.rows['offset'] = res.offset;
                    if (this.applicationListData.list) {
                        var totalCount = 0;
                        if (parseInt(res.offset) == 0) {
                            localStorage.setItem('totalCount', res.totalCount);
                            totalCount = parseInt(res.totalCount);
                        }
                        else {
                            totalCount = parseInt(localStorage.getItem('totalCount'));
                        }
                        this.rows['totalCount'] = totalCount;
                        for (var data in this.applicationListData.list) {
                            if (this.isSystemAdmin) {
                                this.rows[data] = {};
                                this.rows[data]['id'] = this.applicationListData.list[data]['id'];
                                this.rows[data]['applicationName'] = this.applicationListData.list[data]['applicationName'];
                                this.rows[data]['ldapApplicationId'] = this.applicationListData.list[data]['ldapApplicationId'];
                                this.rows[data]['managerNames'] = this.applicationListData.list[data]['managerNames'];
                                this.rows[data]['customerNumberRequired'] = this.applicationListData.list[data]['customerNumberRequired'];
                                this.rows[data]['skipManagerApproval'] = this.applicationListData.list[data]['skipManagerApproval'];
                                this.rows[data]['multipleRole'] = this.applicationListData.list[data]['multipleRole'];
                                if (this.applicationListData.list[data]['active'] == true) {
                                    this.rows[data]['status'] = 'Active';
                                }
                                else {
                                    this.rows[data]['status'] = 'Inactive';
                                }
                                this.rows[data]['active'] = this.applicationListData.list[data]['active'];
                                this.rows[data]['createdAt'] = this.applicationListData.list[data]['createdAt'];
                            }
                            else {
                                //For Other Service Partner's
                                this.rows[data] = {};
                            }
                        }
                        this.showTable = true;
                        this.temp = this.rows;
                    }
                    else {
                        this.showTable = false;
                    }
                    var finalRows = [];
                    for (var f in this.rows) {
                        if (f != 'offset' && f != 'totalCount' && this.rows[f]) {
                            finalRows.push(this.rows[f]);
                        }
                        if (f == 'offset') {
                            finalRows['offset'] = this.rows['offset'];
                        }
                        if (f == 'totalCount') {
                            finalRows['totalCount'] = this.rows['totalCount'];
                        }
                    }
                    this.rows = finalRows;
                    this.setPage({ offset: this.rows['offset'] / this.page.size }, finalRows, filter);
                    this.httpService.onEnd();
                }
            }
        };
        this.applicationListText = 'applicationList';
        //Assign Active or Inactive status
        this.StatusData = [
            {
                "id": true,
                "code": "ACTIVE",
                "name": "Active"
            }, {
                "id": false,
                "code": "INACTIVE",
                "name": "Inactive"
            }
        ];
        this.selectedStatusId = true;
        this.page.pageNumber = 0;
        this.page.size = 20;
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].systemAdmin)) {
                this.isSystemAdmin = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].BUManager)) {
                this.isBUManager = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].serviceOwner)) {
                this.isServiceOwner = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].tradePartner)) {
                this.isTradePartner = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].subuser)) {
                this.isSubUser = true;
            }
        }
        else {
            this.httpService.noUserError();
        }
        this.filters['offSet'] = this.page.pageNumber * this.page.size;
        this.filters['limit'] = this.page.size;
        if (this.isSystemAdmin) {
            this.getAdminRoles();
        }
        else {
            this.getUserList();
        }
        //Call when approve/delete from ApproveRejectComponent/ActiveInactiveComponent to get the updated list.
        this.commonService.applicationList.subscribe(function (value) {
            _this.getApplicationList(_this.filters, _this.selectedStatusId, _this.defaulAdminId, _this.applicationName);
        });
    }
    ApplicationListComponent.prototype.getAdminRoles = function () {
        var _this = this;
        this.httpService.getRequest('superUserOperationsApi/v1/adminRoles').subscribe(function (res) { _this.saveAdminRoles(res); }, function (err) { _this.httpService.onEnd(); });
    };
    ApplicationListComponent.prototype.saveAdminRoles = function (res) {
        if (res && res.items) {
            this.adminRoles = res.items;
            for (var a in this.adminRoles) {
                if (this.adminRoles[a]['code'] == __WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].BUManager) {
                    this.defaulAdminId = this.adminRoles[a]['id'];
                }
            }
            if (!this.defaulAdminId) {
                this.defaulAdminId = this.adminRoles[0]['id'];
            }
            this.getApplicationList(this.filters, this.selectedStatusId, this.defaulAdminId, this.applicationName);
        }
        else {
            this.httpService.onEnd();
        }
    };
    ApplicationListComponent.prototype.buildForm = function () {
        var _this = this;
        this.FiltersForm = this.formBuilder.group({
            applicationName: this.formBuilder.control({ value: '', disabled: this.isDisabled }),
            wpassId: this.formBuilder.control(''),
        });
        this.FiltersForm.valueChanges.subscribe(function (data) {
            _this.applicationName = _this.FiltersForm.get('applicationName').value;
        });
    };
    ApplicationListComponent.prototype.disablefields = function (value) {
        if (value != '') {
            this.FiltersForm.controls['applicationName'].setValue('');
            this.FiltersForm.controls['applicationName'].disable();
        }
        else {
            this.FiltersForm.controls['applicationName'].enable();
        }
    };
    ApplicationListComponent.prototype.search = function () {
        this.filters['offSet'] = 0;
        this.getApplicationList(this.filters, this.selectedStatusId, this.defaulAdminId, this.applicationName);
    };
    ApplicationListComponent.prototype.resetSearch = function () {
        this.FiltersForm.controls['applicationName'].enable();
        this.FiltersForm.reset();
        this.applicationName = '';
        this.search();
    };
    ApplicationListComponent.prototype.getApplicationList = function (filter, selectedStatus, defaulAdminId, applicationName) {
        var _this = this;
        this.httpService.getRequest("applicationOperationApi/v1/applicationList?limit=" + filter.limit + "&offset=" + filter.offSet + "&role=" + defaulAdminId + "&active=" + selectedStatus + "&applicationName=" + applicationName).subscribe(function (res) { _this.saveUserList(res, filter); }, function (err) { _this.httpService.onEnd(); });
    };
    /**
     * Populate the table with new data based on the page number
     * @param page The page to select
     */
    ApplicationListComponent.prototype.setPage = function (pageInfo, rows, filter) {
        var _this = this;
        this.page.pageNumber = pageInfo.offset;
        if (rows.length != 0) {
            this.serverResultsService.getResults(this.page, rows).subscribe(function (pageData) {
                _this.page = pageData.page;
                _this.tableRows = pageData.data;
                if (!filter) {
                    if (Object.keys(_this.tableRows).length == 0 || !_this.tableRows[0]['status']) {
                        _this.filters['offSet'] = _this.page.pageNumber * _this.page.size;
                        _this.getApplicationList(_this.filters, _this.selectedStatusId, _this.defaulAdminId, _this.applicationName);
                    }
                }
            });
        }
        else {
            this.tableRows = [];
            this.page.totalElements = rows.length;
        }
    };
    ApplicationListComponent.prototype.onSelect = function (_a) {
        var selected = _a.selected;
        var _b;
        this.selected.splice(0, this.selected.length);
        (_b = this.selected).push.apply(_b, selected);
    };
    ApplicationListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.buildForm();
        this.translate.get('total').subscribe(function (res) {
            _this.dataTableMessage.totalMessage = res;
        });
        this.translate.get('selected').subscribe(function (res) {
            _this.dataTableMessage.selectedMessage = res;
        });
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"])(__WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__["DatatableComponent"]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__["DatatableComponent"])
    ], ApplicationListComponent.prototype, "table", void 0);
    ApplicationListComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'applicationList',
            template: __webpack_require__(1284)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_4__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_6__angular_material__["c" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_9__angular_forms__["h" /* FormBuilder */], __WEBPACK_IMPORTED_MODULE_12__applicationListDashboardResultService__["a" /* ApplicationListDashboardResultService */],
            __WEBPACK_IMPORTED_MODULE_8__shared_services_common_service__["a" /* CommonService */], __WEBPACK_IMPORTED_MODULE_13_ng2_translate__["d" /* TranslateService */]])
    ], ApplicationListComponent);
    return ApplicationListComponent;
}());



/***/ }),

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApplicationListDashboardResultService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applicationList_datatable_applicationList_page_data__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__applicationList_datatable_applicationList_dashboard__ = __webpack_require__(787);
/**
 * Created by prakash on 22/9/18.
 */





/**
 * A server used to mock a paged data result from a server
 */
var ApplicationListDashboardResultService = /** @class */ (function () {
    function ApplicationListDashboardResultService() {
        this.rows = {};
        this.applicationDashboardData = {};
    }
    /**
     * A method that mocks a paged server response
     * @param page The selected page
     * @returns {any} An observable containing the employee data
     */
    ApplicationListDashboardResultService.prototype.getResults = function (page, listData) {
        var _this = this;
        this.listData = listData;
        return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(listData).map(function (data) { return _this.getPageData(page); });
    };
    /**
     * Package companyData into a PagedData object based on the selected Page
     * @param page The page data used to get the selected data from companyData
     * @returns {PagedData<icsList>} An array of the selected data and page
     */
    ApplicationListDashboardResultService.prototype.getPageData = function (page) {
        var pageData = new __WEBPACK_IMPORTED_MODULE_3__applicationList_datatable_applicationList_page_data__["a" /* ApplicationListPageData */]();
        var offset = this.listData.offset;
        var raw = [];
        for (var l in this.listData) {
            if (Object.keys(this.listData[l]).length > 0) {
                raw[offset + parseInt(l)] = this.listData[l];
            }
        }
        if (this.listData.totalCount) {
            page.totalElements = this.listData.totalCount;
        }
        page.totalPages = page.totalElements / page.size;
        var start = page.pageNumber * page.size;
        var end = Math.min((start + page.size), page.totalElements);
        for (var i = start; i < end; i++) {
            if (raw[i]) {
                var jsonObj = raw[i];
                if (jsonObj) {
                    var list = new __WEBPACK_IMPORTED_MODULE_4__applicationList_datatable_applicationList_dashboard__["a" /* ApplicationListDashboard */](jsonObj['id'], jsonObj['applicationName'], jsonObj['ldapApplicationId'], jsonObj['managerNames'], jsonObj['customerNumberRequired'], jsonObj['skipManagerApproval'], jsonObj['multipleRole'], jsonObj['status'], jsonObj['active'], jsonObj['createdAt']);
                    pageData.data.push(list);
                }
            }
        }
        pageData.page = page;
        return pageData;
    };
    ApplicationListDashboardResultService = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [])
    ], ApplicationListDashboardResultService);
    return ApplicationListDashboardResultService;
}());



/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApplicationManagementComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ng2_translate__ = __webpack_require__(17);
/**
 * Created by shubham on 19/9/18.
 */







var ApplicationManagementComponent = /** @class */ (function () {
    function ApplicationManagementComponent(router, sessionHandler, httpService, dialog, translate) {
        this.router = router;
        this.sessionHandler = sessionHandler;
        this.httpService = httpService;
        this.dialog = dialog;
        this.translate = translate;
        this.languageId = this.sessionHandler.getItem('languageId');
        if (!this.languageId) {
            this.languageId = "EN";
        }
        this.translate.use(this.languageId);
    }
    ApplicationManagementComponent.prototype.ngOnInit = function () { };
    ApplicationManagementComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'application-management',
            template: __webpack_require__(1285)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_5__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_4__shared_services_http_service__["a" /* HttpService */],
            __WEBPACK_IMPORTED_MODULE_3__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_6_ng2_translate__["d" /* TranslateService */]])
    ], ApplicationManagementComponent);
    return ApplicationManagementComponent;
}());



/***/ }),

/***/ 309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApplicationManagementModule", function() { return ApplicationManagementModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_http__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_common__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__swimlane_ngx_datatable__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__swimlane_ngx_datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__swimlane_ngx_datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__applicationManagement_routing_module__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__applicationManagement_component__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__addApplication_addApplication_component__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__applicationList_applicationList_component__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ng2_translate__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angular2_multiselect_dropdown_angular2_multiselect_dropdown__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__activate_deactivate_request_activate_deactivate_request_module__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config__ = __webpack_require__(12);
/**
 * Created by shubham on 19/9/18.
 */















var ApplicationManagementModule = /** @class */ (function () {
    function ApplicationManagementModule() {
    }
    ApplicationManagementModule = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
            imports: [
                __WEBPACK_IMPORTED_MODULE_3__angular_material__["a" /* MaterialModule */],
                __WEBPACK_IMPORTED_MODULE_3__angular_material__["e" /* MdTabsModule */],
                __WEBPACK_IMPORTED_MODULE_5__angular_common__["CommonModule"],
                __WEBPACK_IMPORTED_MODULE_4__angular_forms__["a" /* FormsModule */],
                __WEBPACK_IMPORTED_MODULE_6__swimlane_ngx_datatable__["NgxDatatableModule"],
                __WEBPACK_IMPORTED_MODULE_4__angular_forms__["b" /* ReactiveFormsModule */],
                __WEBPACK_IMPORTED_MODULE_12_angular2_multiselect_dropdown_angular2_multiselect_dropdown__["a" /* AngularMultiSelectModule */],
                __WEBPACK_IMPORTED_MODULE_13__activate_deactivate_request_activate_deactivate_request_module__["a" /* ActivateDeactivateModule */],
                __WEBPACK_IMPORTED_MODULE_7__applicationManagement_routing_module__["a" /* ApplicationManagementRoutingModule */],
                __WEBPACK_IMPORTED_MODULE_11_ng2_translate__["b" /* TranslateModule */].forRoot({
                    provide: __WEBPACK_IMPORTED_MODULE_11_ng2_translate__["c" /* TranslateLoader */],
                    //useFactory: (http: Http) => new TranslateStaticLoader(http, '/assets/i18n', '.json'),
                    useFactory: function (http) { return new __WEBPACK_IMPORTED_MODULE_11_ng2_translate__["a" /* TranslateStaticLoader */](http, __WEBPACK_IMPORTED_MODULE_14__config__["a" /* APPCONFIG */].URL + __WEBPACK_IMPORTED_MODULE_14__config__["a" /* APPCONFIG */].translationUrl, '?v=' + __WEBPACK_IMPORTED_MODULE_14__config__["a" /* APPCONFIG */].translationVersion); },
                    deps: [__WEBPACK_IMPORTED_MODULE_2__angular_http__["b" /* Http */]]
                })
            ],
            declarations: [
                __WEBPACK_IMPORTED_MODULE_8__applicationManagement_component__["a" /* ApplicationManagementComponent */],
                __WEBPACK_IMPORTED_MODULE_9__addApplication_addApplication_component__["a" /* AddApplicationComponent */],
                __WEBPACK_IMPORTED_MODULE_10__applicationList_applicationList_component__["a" /* ApplicationListComponent */]
            ],
            exports: []
        })
    ], ApplicationManagementModule);
    return ApplicationManagementModule;
}());



/***/ }),

/***/ 310:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddManagerComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ng2_translate__ = __webpack_require__(17);
/**
 * Created by shubham on 10/5/18.
 */









var AddManagerComponent = /** @class */ (function () {
    function AddManagerComponent(sessionHandler, httpService, dialog, formBuilder, translate) {
        this.sessionHandler = sessionHandler;
        this.httpService = httpService;
        this.dialog = dialog;
        this.formBuilder = formBuilder;
        this.translate = translate;
        this.isSystemAdmin = false;
        this.isBUManager = false;
        this.isRegionalAdmin = false;
        this.isServiceOwner = false;
        this.isTradePartner = false;
        this.isSubUser = false;
        this.admins = [];
        this.countries = [];
        this.applications = [];
        this.businessUnits = [];
        this.selectedItems = [];
        this.manager_settings = {};
        this.application_settings = {};
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].BUManager)) {
                this.isBUManager = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].serviceOwner)) {
                this.isServiceOwner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].tradePartner)) {
                this.isTradePartner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].subuser)) {
                this.isSubUser = true;
            }
        }
        else {
            this.httpService.noUserError();
        }
        if (this.isSystemAdmin) {
            this.getCountries();
            this.getBusinessUnit();
            this.getAdmins();
            this.getApplications();
        }
    }
    AddManagerComponent.prototype.getCountries = function () {
        var _this = this;
        this.httpService.getRequest('lookupDataOperationsApi/v1/country').subscribe(function (res) { _this.saveCountries(res); }, function (err) { _this.httpService.onEnd(); });
    };
    AddManagerComponent.prototype.saveCountries = function (res) {
        if (res && res.items) {
            this.countries = res.items;
        }
        this.httpService.onEnd();
    };
    AddManagerComponent.prototype.getBusinessUnit = function () {
        var _this = this;
        this.httpService.getRequest('lookupDataOperationsApi/v1/businessUnit').subscribe(function (res) { _this.saveBusinessUnit(res); }, function (err) { _this.httpService.onEnd(); });
    };
    AddManagerComponent.prototype.saveBusinessUnit = function (res) {
        if (res && res.items) {
            this.businessUnits = res.items;
        }
        this.httpService.onEnd();
    };
    AddManagerComponent.prototype.getAdmins = function () {
        var _this = this;
        this.httpService.getRequest('superUserOperationsApi/v1/getCountryAdminList').subscribe(function (res) { _this.saveAdmins(res); }, function (err) { _this.httpService.onEnd(); });
    };
    AddManagerComponent.prototype.saveAdmins = function (res) {
        if (res && res.items) {
            this.admins = res.items;
        }
        this.httpService.onEnd();
    };
    AddManagerComponent.prototype.getApplications = function () {
        var _this = this;
        this.httpService.getRequest('applicationOperationApi/v1/getApplicationDropDownList').subscribe(function (res) { _this.saveApplications(res); }, function (err) { _this.httpService.onEnd(); });
    };
    AddManagerComponent.prototype.saveApplications = function (res) {
        if (res && res.items) {
            this.applications = res.items;
        }
        this.httpService.onEnd();
    };
    AddManagerComponent.prototype.buildForm = function () {
        var _this = this;
        this.AddManagerForm = this.formBuilder.group({
            countryId: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["g" /* Validators */].required]),
            businessUnitId: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["g" /* Validators */].required]),
            /*managerId: this.formBuilder.control(null, [Validators.required]),*/
            managerData: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["g" /* Validators */].required]),
            applicationData: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["g" /* Validators */].required]),
        });
        this.AddManagerForm.valueChanges.subscribe(function (data) {
            _this.AddManagerFormDetails = _this.AddManagerForm.getRawValue();
            _this.AddManagerFormDetails['managerIds'] = [];
            for (var d in _this.AddManagerFormDetails.managerData) {
                _this.AddManagerFormDetails['managerIds'].push(_this.AddManagerFormDetails.managerData[d]['id']);
            }
            _this.AddManagerFormDetails['applicationId'] = [];
            for (var d in _this.AddManagerFormDetails.applicationData) {
                _this.AddManagerFormDetails['applicationId'].push(_this.AddManagerFormDetails.applicationData[d]['id']);
            }
            _this.AddManagerFormDetails.validate = _this.AddManagerForm.valid;
        });
    };
    AddManagerComponent.prototype.addManager = function () {
        var _this = this;
        this.httpService.postRequest(this.AddManagerFormDetails, 'superUserOperationsApi/v1/addCountryBusinessUnitManagerMapping').subscribe(function (res) { _this.saveAddManagerResponse(res); }, function (err) { _this.httpService.onEnd(); });
    };
    AddManagerComponent.prototype.saveAddManagerResponse = function (res) {
        if (res) {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = "mngr_assigned_notify";
            this.dialogRef.afterClosed().subscribe(function (result) {
                window.location.href = '#/app/manager-assignment/list';
            });
        }
        else if (res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = 'save_failed';
            this.httpService.onEnd();
        }
    };
    ;
    AddManagerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.buildForm();
        var app_settings = { singleSelection: false, text: "", labelKey: "name", selectAllText: "", unSelectAllText: "", classes: "myclass custom-class" };
        var mgr_settings = { singleSelection: false, text: "", labelKey: "name", selectAllText: "", unSelectAllText: "", classes: "myclass custom-class" };
        this.translate.get('Select Applications').subscribe(function (res) {
            app_settings.text = res;
            if (app_settings.text && app_settings.selectAllText && app_settings.unSelectAllText) {
                _this.application_settings = app_settings;
            }
        });
        this.translate.get('Assign Manager').subscribe(function (res) {
            mgr_settings.text = res;
            if (mgr_settings.text && mgr_settings.selectAllText && mgr_settings.unSelectAllText) {
                _this.manager_settings = mgr_settings;
            }
        });
        this.translate.get('select_all').subscribe(function (res) {
            app_settings.selectAllText = res;
            mgr_settings.selectAllText = res;
            if (mgr_settings.text && mgr_settings.selectAllText && mgr_settings.unSelectAllText) {
                _this.manager_settings = mgr_settings;
            }
            if (app_settings.text && app_settings.selectAllText && app_settings.unSelectAllText) {
                _this.application_settings = app_settings;
            }
        });
        this.translate.get('unselect_all').subscribe(function (res) {
            app_settings.unSelectAllText = res;
            mgr_settings.unSelectAllText = res;
            if (mgr_settings.text && mgr_settings.selectAllText && mgr_settings.unSelectAllText) {
                _this.manager_settings = mgr_settings;
            }
            if (app_settings.text && app_settings.selectAllText && app_settings.unSelectAllText) {
                _this.application_settings = app_settings;
            }
        });
    };
    AddManagerComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'add-manager',
            template: __webpack_require__(1286)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_6__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_5__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_3__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_4__angular_forms__["h" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_8_ng2_translate__["d" /* TranslateService */]])
    ], AddManagerComponent);
    return AddManagerComponent;
}());



/***/ }),

/***/ 311:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ManagerAssignmentComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ng2_translate__ = __webpack_require__(17);
/**
 * Created by shubham on 10/5/18.
 */







var ManagerAssignmentComponent = /** @class */ (function () {
    function ManagerAssignmentComponent(router, sessionHandler, httpService, dialog, translate) {
        this.router = router;
        this.sessionHandler = sessionHandler;
        this.httpService = httpService;
        this.dialog = dialog;
        this.translate = translate;
        this.languageId = this.sessionHandler.getItem('languageId');
        if (!this.languageId) {
            this.languageId = "EN";
        }
        this.translate.use(this.languageId);
    }
    ManagerAssignmentComponent.prototype.ngOnInit = function () { };
    ManagerAssignmentComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'manager-assignment',
            template: __webpack_require__(1287)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_5__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_4__shared_services_http_service__["a" /* HttpService */],
            __WEBPACK_IMPORTED_MODULE_3__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_6_ng2_translate__["d" /* TranslateService */]])
    ], ManagerAssignmentComponent);
    return ManagerAssignmentComponent;
}());



/***/ }),

/***/ 312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ManagerAssignmentModule", function() { return ManagerAssignmentModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_http__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_common__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__swimlane_ngx_datatable__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__swimlane_ngx_datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__swimlane_ngx_datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__activate_deactivate_request_activate_deactivate_request_module__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__managerAssignment_routing_module__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__managerAssignment_component__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__managerList_managerList_component__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__addManager_addManager_component__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__viewManager_viewManager_component__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ng2_translate__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_angular2_multiselect_dropdown_angular2_multiselect_dropdown__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__config__ = __webpack_require__(12);
/**
 * Created by shubham on 10/5/18.
 */
















var ManagerAssignmentModule = /** @class */ (function () {
    function ManagerAssignmentModule() {
    }
    ManagerAssignmentModule = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
            imports: [
                __WEBPACK_IMPORTED_MODULE_3__angular_material__["a" /* MaterialModule */],
                __WEBPACK_IMPORTED_MODULE_3__angular_material__["e" /* MdTabsModule */],
                __WEBPACK_IMPORTED_MODULE_5__angular_common__["CommonModule"],
                __WEBPACK_IMPORTED_MODULE_4__angular_forms__["a" /* FormsModule */],
                __WEBPACK_IMPORTED_MODULE_6__swimlane_ngx_datatable__["NgxDatatableModule"],
                __WEBPACK_IMPORTED_MODULE_14_angular2_multiselect_dropdown_angular2_multiselect_dropdown__["a" /* AngularMultiSelectModule */],
                __WEBPACK_IMPORTED_MODULE_4__angular_forms__["b" /* ReactiveFormsModule */],
                __WEBPACK_IMPORTED_MODULE_7__activate_deactivate_request_activate_deactivate_request_module__["a" /* ActivateDeactivateModule */],
                __WEBPACK_IMPORTED_MODULE_8__managerAssignment_routing_module__["a" /* ManagerAssignmentRoutingModule */],
                __WEBPACK_IMPORTED_MODULE_13_ng2_translate__["b" /* TranslateModule */].forRoot({
                    provide: __WEBPACK_IMPORTED_MODULE_13_ng2_translate__["c" /* TranslateLoader */],
                    //useFactory: (http: Http) => new TranslateStaticLoader(http, '/assets/i18n', '.json'),
                    useFactory: function (http) { return new __WEBPACK_IMPORTED_MODULE_13_ng2_translate__["a" /* TranslateStaticLoader */](http, __WEBPACK_IMPORTED_MODULE_15__config__["a" /* APPCONFIG */].URL + __WEBPACK_IMPORTED_MODULE_15__config__["a" /* APPCONFIG */].translationUrl, '?v=' + __WEBPACK_IMPORTED_MODULE_15__config__["a" /* APPCONFIG */].translationVersion); },
                    deps: [__WEBPACK_IMPORTED_MODULE_2__angular_http__["b" /* Http */]]
                })
            ],
            declarations: [
                __WEBPACK_IMPORTED_MODULE_9__managerAssignment_component__["a" /* ManagerAssignmentComponent */],
                __WEBPACK_IMPORTED_MODULE_10__managerList_managerList_component__["a" /* ManagerListComponent */],
                __WEBPACK_IMPORTED_MODULE_11__addManager_addManager_component__["a" /* AddManagerComponent */],
                __WEBPACK_IMPORTED_MODULE_12__viewManager_viewManager_component__["a" /* ViewManagerComponent */]
            ],
            exports: []
        })
    ], ManagerAssignmentModule);
    return ManagerAssignmentModule;
}());



/***/ }),

/***/ 313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ManagerListPage; });
/**
 * Created by shubham on 10/5/18.
 */
/**
 * An object used to get page information from the server
 */
var ManagerListPage = /** @class */ (function () {
    function ManagerListPage() {
        //The number of elements in the page
        this.size = 0;
        //The total number of elements
        this.totalElements = 0;
        //The total number of pages
        this.totalPages = 0;
        //The current page number
        this.pageNumber = 0;
    }
    return ManagerListPage;
}());



/***/ }),

/***/ 314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ManagerListComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_services_common_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__managerList_datatable_managerList_page__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__managerListDashboardResultService__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ng2_translate__ = __webpack_require__(17);
/**
 * Created by shubham on 10/5/18.
 */














var ManagerListComponent = /** @class */ (function () {
    function ManagerListComponent(router, httpService, sessionHandler, dialog, formBuilder, serverResultsService, commonService, translate) {
        var _this = this;
        this.router = router;
        this.httpService = httpService;
        this.sessionHandler = sessionHandler;
        this.dialog = dialog;
        this.formBuilder = formBuilder;
        this.serverResultsService = serverResultsService;
        this.commonService = commonService;
        this.translate = translate;
        this.page = new __WEBPACK_IMPORTED_MODULE_10__managerList_datatable_managerList_page__["a" /* ManagerListPage */]();
        this.tableRows = [];
        this.filters = {};
        this.managerListData = [];
        this.temp = [];
        this.showTable = true;
        this.isSystemAdmin = false;
        this.isBUManager = false;
        this.isRegionalAdmin = false;
        this.isServiceOwner = false;
        this.isTradePartner = false;
        this.isSubUser = false;
        this.selected = [];
        this.countries = [];
        this.businessUnits = [];
        this.applicationList = [];
        this.wpassId = '';
        this.countryId = '';
        this.businessUnitId = '';
        this.selectedApplicationId = '';
        this.applicationName = '';
        this.dataTableMessage = { 'selectedMessage': '', 'totalMessage': '' };
        this.tempCountries = [{
                "id": "",
                "name": "All",
                "code": "",
                "active": true,
                "createdAt": "2019-02-26T12:49:39.329Z"
            }];
        this.tempBusinessUnits = [{
                "id": "",
                "name": "All",
                "codeISAM": "",
                "active": true,
                "createdAt": "2018-04-06T20:05:02.397Z",
                "updatedAt": "2018-05-31T06:41:54.303Z"
            }];
        this.getUserList = function () {
            this.showTable = false;
        };
        this.saveUserList = function (res, filter) {
            if (res.errorStatus == 'Fail') {
                this.httpService.onEnd();
                this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
                this.dialogRef.componentInstance.msg = 'data_pull_fail';
            }
            else {
                if (res && Object.keys(res).length > 0) {
                    this.managerListData = res;
                    this.rows = [];
                    this.rows['offset'] = res.offset;
                    if (this.managerListData.list) {
                        var totalCount = 0;
                        if (parseInt(res.offset) == 0) {
                            localStorage.setItem('totalCount', res.totalCount);
                            totalCount = parseInt(res.totalCount);
                        }
                        else {
                            totalCount = parseInt(localStorage.getItem('totalCount'));
                        }
                        this.rows['totalCount'] = totalCount;
                        for (var data in this.managerListData.list) {
                            if (this.isSystemAdmin) {
                                this.rows[data] = {};
                                this.rows[data]['buAssociationId'] = this.managerListData.list[data]['buAssociationId'];
                                this.rows[data]['Name'] = this.managerListData.list[data]['firstName'];
                                /*this.rows[data]['Name'] = this.managerListData.list[data]['firstName'] +' '+this.managerListData.list[data]['lastName'];*/
                                this.rows[data]['email'] = this.managerListData.list[data]['email'];
                                this.rows[data]['emailVerified'] = this.managerListData.list[data]['emailVerified'];
                                if (this.managerListData.list[data]['userId_WPASS']) {
                                    this.rows[data]['userId_WPASS'] = this.managerListData.list[data]['userId_WPASS'];
                                }
                                else {
                                    this.rows[data]['userId_WPASS'] = null;
                                }
                                if (this.managerListData.list[data]['pendingSubUserCount']) {
                                    this.rows[data]['pendingSubUserCount'] = this.managerListData.list[data]['pendingSubUserCount'];
                                }
                                if (this.managerListData.list[data]['applicationName']) {
                                    this.rows[data]['applicationName'] = this.managerListData.list[data]['applicationName'];
                                }
                                this.rows[data]['countryId'] = this.managerListData.list[data]['countryId'];
                                this.rows[data]['countryName'] = this.managerListData.list[data]['countryName'];
                                this.rows[data]['businessUnitId'] = this.managerListData.list[data]['businessUnitId'];
                                this.rows[data]['businessUnitName'] = this.managerListData.list[data]['businessUnitName'];
                                this.rows[data]['status'] = this.managerListData.list[data]['status'];
                                this.rows[data]['active'] = this.managerListData.list[data]['active'];
                                this.rows[data]['createdAt'] = this.managerListData.list[data]['createdAt'];
                                this.rows[data]['updatedAt'] = this.managerListData.list[data]['updatedAt'];
                            }
                            else {
                                //For Other Service Partner's
                                this.rows[data] = {};
                            }
                        }
                        this.showTable = true;
                        this.temp = this.rows;
                    }
                    else {
                        this.showTable = false;
                    }
                    var finalRows = [];
                    for (var f in this.rows) {
                        if (f != 'offset' && f != 'totalCount' && this.rows[f]) {
                            finalRows.push(this.rows[f]);
                        }
                        if (f == 'offset') {
                            finalRows['offset'] = this.rows['offset'];
                        }
                        if (f == 'totalCount') {
                            finalRows['totalCount'] = this.rows['totalCount'];
                        }
                    }
                    this.rows = finalRows;
                    this.setPage({ offset: this.rows['offset'] / this.page.size }, finalRows, filter);
                    this.httpService.onEnd();
                }
            }
        };
        this.managerListText = 'managerList';
        //Assign Active or Inactive status
        this.StatusData = [
            {
                "id": true,
                "code": "ACTIVE",
                "name": "Active"
            }, {
                "id": false,
                "code": "INACTIVE",
                "name": "Inactive"
            }
        ];
        this.selectedStatusId = true;
        this.CountryOrBusinessUnitData = [
            {
                "id": 1,
                "name": "Country"
            }, {
                "id": 2,
                "name": "Business Unit"
            }
        ];
        this.page.pageNumber = 0;
        this.page.size = 20;
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].systemAdmin)) {
                this.isSystemAdmin = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].BUManager)) {
                this.isBUManager = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].serviceOwner)) {
                this.isServiceOwner = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].tradePartner)) {
                this.isTradePartner = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].subuser)) {
                this.isSubUser = true;
            }
        }
        else {
            this.httpService.noUserError();
        }
        this.filters['offSet'] = this.page.pageNumber * this.page.size;
        this.filters['limit'] = this.page.size;
        if (this.isSystemAdmin) {
            this.getCountries();
            this.getBusinessUnit();
            this.getApplications();
            this.getUsersList(this.filters, this.selectedStatusId, this.wpassId, this.countryId, this.businessUnitId, this.selectedApplicationId);
        }
        else {
            this.getUserList();
        }
        //Call when approve/delete from ApproveRejectComponent/ActiveInactiveComponent to get the updated list.
        this.commonService.managerList.subscribe(function (value) {
            _this.getUsersList(_this.filters, _this.selectedStatusId, _this.wpassId, _this.countryId, _this.businessUnitId, _this.selectedApplicationId);
        });
    }
    ManagerListComponent.prototype.buildForm = function () {
        var _this = this;
        this.ManagerFiltersForm = this.formBuilder.group({
            selectedStatusId: this.formBuilder.control(true),
            wpassId: this.formBuilder.control(''),
            countryId: this.formBuilder.control(''),
            businessUnitId: this.formBuilder.control(''),
            selectedApplicationId: this.formBuilder.control('')
        });
        this.ManagerFiltersForm.valueChanges.subscribe(function (data) {
            _this.selectedStatusId = _this.ManagerFiltersForm.get('selectedStatusId').value;
            _this.wpassId = _this.ManagerFiltersForm.get('wpassId').value;
            _this.countryId = _this.ManagerFiltersForm.get('countryId').value;
            _this.businessUnitId = _this.ManagerFiltersForm.get('businessUnitId').value;
            _this.selectedApplicationId = _this.ManagerFiltersForm.get('selectedApplicationId').value;
        });
    };
    ManagerListComponent.prototype.getCountries = function () {
        var _this = this;
        this.httpService.getRequest('lookupDataOperationsApi/v1/country').subscribe(function (res) { _this.saveCountries(res); }, function (err) { _this.httpService.onEnd(); });
    };
    ManagerListComponent.prototype.saveCountries = function (res) {
        if (res && res.items) {
            this.countries = this.tempCountries.concat(res.items);
        }
    };
    ManagerListComponent.prototype.getBusinessUnit = function () {
        var _this = this;
        this.httpService.getRequest('lookupDataOperationsApi/v1/businessUnit').subscribe(function (res) { _this.saveBusinessUnit(res); }, function (err) { _this.httpService.onEnd(); });
    };
    ManagerListComponent.prototype.saveBusinessUnit = function (res) {
        if (res && res.items) {
            this.businessUnits = this.tempBusinessUnits.concat(res.items);
        }
    };
    ManagerListComponent.prototype.getApplications = function () {
        var _this = this;
        this.httpService.getRequest("applicationOperationApi/v1/applicationsForDropdown").subscribe(function (res) { _this.saveApplicationsName(res); }, function (err) { _this.httpService.onEnd(); });
    };
    ManagerListComponent.prototype.saveApplicationsName = function (res) {
        if (res && res.items) {
            var tempApp = [{ "id": "", "code": "", "name": "all" }];
            this.applicationList = tempApp.concat(res.items);
        }
    };
    ManagerListComponent.prototype.disablefields = function (value, uniqueKey) {
        if (value != '') {
            if (uniqueKey == 'wpassId') {
                this.ManagerFiltersForm.controls['selectedApplicationId'].setValue('');
                this.ManagerFiltersForm.controls['selectedApplicationId'].disable();
            }
            else {
                this.ManagerFiltersForm.controls['wpassId'].setValue('');
                this.ManagerFiltersForm.controls['wpassId'].disable();
            }
            this.ManagerFiltersForm.controls['businessUnitId'].setValue('');
            this.ManagerFiltersForm.controls['countryId'].setValue('');
            this.ManagerFiltersForm.controls['businessUnitId'].disable();
            this.ManagerFiltersForm.controls['countryId'].disable();
        }
        else {
            if (uniqueKey == 'wpassId') {
                this.ManagerFiltersForm.controls['selectedApplicationId'].enable();
            }
            else {
                this.ManagerFiltersForm.controls['wpassId'].enable();
            }
            this.ManagerFiltersForm.controls['businessUnitId'].enable();
            this.ManagerFiltersForm.controls['countryId'].enable();
        }
    };
    ManagerListComponent.prototype.search = function () {
        this.filters['offSet'] = 0;
        this.getUsersList(this.filters, this.selectedStatusId, this.wpassId, this.countryId, this.businessUnitId, this.selectedApplicationId);
    };
    ManagerListComponent.prototype.resetSearch = function () {
        this.ManagerFiltersForm.controls['businessUnitId'].enable();
        this.ManagerFiltersForm.controls['countryId'].enable();
        this.ManagerFiltersForm.reset();
        this.selectedStatusId = true;
        this.countryId = '';
        this.businessUnitId = '';
        this.wpassId = '';
        this.selectedApplicationId = '';
        this.buildForm();
        this.search();
    };
    ManagerListComponent.prototype.downloadBuMappingCsv = function () {
        var loginDataArray = JSON.parse(this.sessionHandler.getItem("loginData"));
        var accessToken;
        if (loginDataArray) {
            accessToken = loginDataArray['accessToken'];
        }
        window.open(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].URL + '/export?access-token=' + accessToken + '&action=bu_manager_mapping', '_blank');
    };
    ManagerListComponent.prototype.getUsersList = function (filter, selectedStatus, wpassId, countryId, businessUnitId, selectedApplicationId) {
        var _this = this;
        this.httpService.getRequest("superUserOperationsApi/v1/countryBusinessUnitManagerMapping/list?limit=" + filter.limit + "&offset=" + filter.offSet + "&active=" + selectedStatus + "&countryId=" + countryId + "&businessUnitId=" + businessUnitId + "&wpassId=" + wpassId + "&selectedApplicationId=" + selectedApplicationId).subscribe(function (res) { _this.saveUserList(res, filter); }, function (err) { _this.httpService.onEnd(); });
    };
    /**
     * Populate the table with new data based on the page number
     * @param page The page to select
     */
    ManagerListComponent.prototype.setPage = function (pageInfo, rows, filter) {
        var _this = this;
        this.page.pageNumber = pageInfo.offset;
        if (rows.length != 0) {
            this.serverResultsService.getResults(this.page, rows).subscribe(function (pageData) {
                _this.page = pageData.page;
                _this.tableRows = pageData.data;
                if (!filter) {
                    if (Object.keys(_this.tableRows).length == 0 || !_this.tableRows[0]['status']) {
                        _this.filters['offSet'] = _this.page.pageNumber * _this.page.size;
                        _this.getUsersList(_this.filters, _this.selectedStatusId, _this.wpassId, _this.countryId, _this.businessUnitId, _this.selectedApplicationId);
                    }
                }
            });
        }
        else {
            this.tableRows = [];
            this.page.totalElements = rows.length;
        }
    };
    ManagerListComponent.prototype.onSelect = function (_a) {
        var selected = _a.selected;
        var _b;
        this.selected.splice(0, this.selected.length);
        (_b = this.selected).push.apply(_b, selected);
    };
    ManagerListComponent.prototype.showApplications = function (apps) {
        this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["k" /* ShowApplicationsDialogComponent */]);
        this.dialogRef.componentInstance.apps = apps;
    };
    ManagerListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.buildForm();
        this.translate.get('total').subscribe(function (res) {
            _this.dataTableMessage.totalMessage = res;
        });
        this.translate.get('selected').subscribe(function (res) {
            _this.dataTableMessage.selectedMessage = res;
        });
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"])(__WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__["DatatableComponent"]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__["DatatableComponent"])
    ], ManagerListComponent.prototype, "table", void 0);
    ManagerListComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'managerList',
            template: __webpack_require__(1288)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_4__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_6__angular_material__["c" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_9__angular_forms__["h" /* FormBuilder */], __WEBPACK_IMPORTED_MODULE_12__managerListDashboardResultService__["a" /* ManagerListDashboardResultService */],
            __WEBPACK_IMPORTED_MODULE_8__shared_services_common_service__["a" /* CommonService */], __WEBPACK_IMPORTED_MODULE_13_ng2_translate__["d" /* TranslateService */]])
    ], ManagerListComponent);
    return ManagerListComponent;
}());



/***/ }),

/***/ 315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ManagerListDashboardResultService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__managerList_datatable_managerList_dashboard__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__managerList_datatable_managerList_page_data__ = __webpack_require__(794);
/**
 * Created by shubham on 10/5/18.
 */





/**
 * A server used to mock a paged data result from a server
 */
var ManagerListDashboardResultService = /** @class */ (function () {
    function ManagerListDashboardResultService() {
        this.rows = {};
        this.adminDashboardData = {};
    }
    /**
     * A method that mocks a paged server response
     * @param page The selected page
     * @returns {any} An observable containing the employee data
     */
    ManagerListDashboardResultService.prototype.getResults = function (page, listData) {
        var _this = this;
        this.listData = listData;
        return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(listData).map(function (data) { return _this.getPageData(page); });
    };
    /**
     * Package companyData into a PagedData object based on the selected Page
     * @param page The page data used to get the selected data from companyData
     * @returns {PagedData<icsList>} An array of the selected data and page
     */
    ManagerListDashboardResultService.prototype.getPageData = function (page) {
        var pageData = new __WEBPACK_IMPORTED_MODULE_4__managerList_datatable_managerList_page_data__["a" /* ManagerListPageData */]();
        var offset = this.listData.offset;
        var raw = [];
        for (var l in this.listData) {
            if (Object.keys(this.listData[l]).length > 0) {
                raw[offset + parseInt(l)] = this.listData[l];
            }
        }
        if (this.listData.totalCount) {
            page.totalElements = this.listData.totalCount;
        }
        page.totalPages = page.totalElements / page.size;
        var start = page.pageNumber * page.size;
        var end = Math.min((start + page.size), page.totalElements);
        for (var i = start; i < end; i++) {
            if (raw[i]) {
                var jsonObj = raw[i];
                if (jsonObj) {
                    var list = new __WEBPACK_IMPORTED_MODULE_3__managerList_datatable_managerList_dashboard__["a" /* ManagerListDashboard */](jsonObj['buAssociationId'], jsonObj['Name'], jsonObj['email'], jsonObj['emailVerified'], jsonObj['userId_WPASS'], jsonObj['pendingSubUserCount'], jsonObj['applicationName'], jsonObj['countryId'], jsonObj['countryName'], jsonObj['businessUnitId'], jsonObj['businessUnitName'], jsonObj['active'], jsonObj['status'], jsonObj['createdAt']);
                    pageData.data.push(list);
                }
            }
        }
        pageData.page = page;
        return pageData;
    };
    ManagerListDashboardResultService = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [])
    ], ManagerListDashboardResultService);
    return ManagerListDashboardResultService;
}());



/***/ }),

/***/ 316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewManagerComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dialog_dialog_component__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ng2_translate__ = __webpack_require__(17);
/**
 * Created by shubham on 10/5/18.
 */











var ViewManagerComponent = /** @class */ (function () {
    function ViewManagerComponent(router, route, sessionHandler, httpService, dialog, formBuilder, translate) {
        var _this = this;
        this.router = router;
        this.route = route;
        this.sessionHandler = sessionHandler;
        this.httpService = httpService;
        this.dialog = dialog;
        this.formBuilder = formBuilder;
        this.translate = translate;
        this.managerDetails = [];
        this.isSystemAdmin = false;
        this.isBUManager = false;
        this.isRegionalAdmin = false;
        this.isServiceOwner = false;
        this.isTradePartner = false;
        this.isSubUser = false;
        this.isDisabled = true;
        this.admins = [];
        this.manager_settings = {};
        this.application_settings = {};
        this.selectedManagerItems = [];
        this.selectedManagerItemsCopy = [];
        this.selectedApplicationItems = [];
        this.selectedApplicationItemsCopy = [];
        this.applications = [];
        this.tempRemoved = [];
        this.tempReplaced = [];
        this.tempReplacedCopy = [];
        this.tempFlag = false;
        this.route.params.subscribe(function (params) {
            _this.id = params['buAssociationId'];
        });
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].systemAdmin)) {
                this.isSystemAdmin = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].BUManager)) {
                this.isBUManager = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].serviceOwner)) {
                this.isServiceOwner = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].tradePartner)) {
                this.isTradePartner = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].subuser)) {
                this.isSubUser = true;
            }
        }
        else {
            this.httpService.noUserError();
        }
        if (this.isSystemAdmin) {
            this.getManagerDataById(this.id);
            this.getAdmins();
            this.getApplications();
        }
    }
    ViewManagerComponent.prototype.getManagerDataById = function (id) {
        var _this = this;
        this.httpService.getRequest('superUserOperationsApi/v1/countryBusinessUnitManagerMapping/' + id).subscribe(function (res) { _this.saveManagerData(res); }, function (err) { _this.httpService.onEnd(); });
    };
    ViewManagerComponent.prototype.saveManagerData = function (res) {
        if (res) {
            this.managerDetails = res;
            if (this.managerDetails['managerIds'] && this.managerDetails['managerNames']) {
                for (var l in this.managerDetails['managerIds']) {
                    this.selectedManagerItems.push({ id: this.managerDetails['managerIds'][l], name: this.managerDetails['managerNames'][l] });
                    this.selectedManagerItemsCopy.push({ id: this.managerDetails['managerIds'][l], name: this.managerDetails['managerNames'][l] });
                }
            }
            if (this.managerDetails['applicationId'] && this.managerDetails['applicationName']) {
                for (var l in this.managerDetails['applicationId']) {
                    this.selectedApplicationItems.push({ id: this.managerDetails['applicationId'][l], name: this.managerDetails['applicationName'][l] });
                    this.selectedApplicationItemsCopy.push({ id: this.managerDetails['applicationId'][l], name: this.managerDetails['applicationName'][l] });
                }
            }
            this.ManagerEditFormDetails = this.managerDetails;
            this.buildForm();
            this.httpService.onEnd();
        }
        else if (res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_8__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = 'data_load_failed';
            this.httpService.onEnd();
        }
    };
    ViewManagerComponent.prototype.getAdmins = function () {
        var _this = this;
        this.httpService.getRequest('superUserOperationsApi/v1/getCountryAdminList').subscribe(function (res) { _this.saveAdmins(res); }, function (err) { _this.httpService.onEnd(); });
    };
    ViewManagerComponent.prototype.saveAdmins = function (res) {
        if (res && res.items) {
            this.admins = res.items;
        }
        this.httpService.onEnd();
    };
    ViewManagerComponent.prototype.getApplications = function () {
        var _this = this;
        this.httpService.getRequest('applicationOperationApi/v1/getApplicationDropDownList').subscribe(function (res) { _this.saveApplications(res); }, function (err) { _this.httpService.onEnd(); });
    };
    ViewManagerComponent.prototype.saveApplications = function (res) {
        if (res && res.items) {
            this.applications = res.items;
        }
        this.httpService.onEnd();
    };
    ViewManagerComponent.prototype.buildForm = function () {
        var _this = this;
        this.ManagerEditForm = this.formBuilder.group({
            /*managerId: this.formBuilder.control(this.managerDetails['managerId'], [Validators.required]),*/
            managerData: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_5__angular_forms__["g" /* Validators */].required]),
            applicationData: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_5__angular_forms__["g" /* Validators */].required]),
            buManagerReplacementsData: this.formBuilder.control(null)
        });
        this.ManagerEditForm.valueChanges.subscribe(function (data) {
            _this.ManagerEditFormDetails = _this.ManagerEditForm.getRawValue();
            _this.ManagerEditFormDetails['buAssociationId'] = _this.managerDetails['buAssociationId'];
            _this.ManagerEditFormDetails['managerIds'] = [];
            for (var d in _this.ManagerEditFormDetails.managerData) {
                _this.ManagerEditFormDetails['managerIds'].push(_this.ManagerEditFormDetails.managerData[d]['id']);
            }
            _this.ManagerEditFormDetails['applicationId'] = [];
            for (var d in _this.ManagerEditFormDetails.applicationData) {
                _this.ManagerEditFormDetails['applicationId'].push(_this.ManagerEditFormDetails.applicationData[d]['id']);
            }
            _this.ManagerEditFormDetails['buManagerReplacements'] = [];
            console.log(_this.ManagerEditFormDetails);
            for (var d in _this.ManagerEditFormDetails.buManagerReplacementsData) {
                _this.ManagerEditFormDetails['buManagerReplacements'].push({ currentId: _this.ManagerEditFormDetails.buManagerReplacementsData[d]['currentId'],
                    newId: _this.ManagerEditFormDetails.buManagerReplacementsData[d]['newId'] });
            }
            _this.ManagerEditFormDetails.validate = _this.ManagerEditForm.valid;
        });
    };
    ViewManagerComponent.prototype.updateManagerDetails = function () {
        var _this = this;
        console.log(this.tempReplaced);
        console.log(this.ManagerEditFormDetails);
        this.httpService.postRequest(this.ManagerEditFormDetails, '/superUserOperationsApi/v1/updateCountryBusinessUnitManagerMapping').subscribe(function (res) { _this.saveUpdateManagerResponse(res); }, function (err) { _this.httpService.onEnd(); });
    };
    ViewManagerComponent.prototype.saveUpdateManagerResponse = function (res) {
        if (res) {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_8__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = "Updated Successfully";
            this.dialogRef.afterClosed().subscribe(function (result) {
                window.location.href = '#/app/manager-assignment/list';
            });
        }
        else if (res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_8__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = 'save_failed';
            this.httpService.onEnd();
        }
    };
    ViewManagerComponent.prototype.onDeSelectAll = function (items) {
        this.selectedApplicationItems = Object.assign([], this.selectedApplicationItemsCopy);
        this.ManagerEditForm.controls['applicationData'].setValue(this.selectedApplicationItems);
    };
    ViewManagerComponent.prototype.OnItemDeSelect = function (item) {
        if (this.selectedApplicationItemsCopy.find(function (s) { return s.id === item.id; })) {
            this.selectedApplicationItems.push({ id: item.id, name: item.name });
            this.ManagerEditForm.controls['applicationData'].setValue(this.selectedApplicationItems);
        }
    };
    ViewManagerComponent.prototype.OnManagerDeSelect = function (item) {
        var _this = this;
        this.removedAdmin = item;
        if (this.selectedManagerItemsCopy.find(function (x) { return x.id == item.id; })) {
            console.log(this.selectedManagerItemsCopy.find(function (x) { return x.id == item.id; }).name);
            if (this.tempReplaced.find(function (x) { return x.currentId == item.id; })) { }
            else {
                this.tempReplaced.push({ currentId: this.selectedManagerItemsCopy.find(function (x) { return x.id == item.id; }).id });
            }
            console.log(this.tempReplaced.find(function (x) { return x.currentId == item.id; }));
            var currentId = this.tempReplaced.find(function (x) { return x.currentId == item.id; }).currentId;
            console.log(this.selectedManagerItemsCopy.find(function (x) { return x.id == currentId; }).name);
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_8__dialog_dialog_component__["d" /* BuAssignmentDialogComponent */]);
            this.dialogRef.componentInstance.admins = this.admins;
            this.dialogRef.componentInstance.managerName = this.selectedManagerItemsCopy.find(function (x) { return x.id == currentId; }).name;
            this.dialogRef.afterClosed().subscribe(function (data) {
                console.log(data);
                if (data) {
                    _this.replacementAdmin = data;
                    if (_this.tempReplaced.find(function (x) { return x.currentId == _this.removedAdmin.id; })) {
                        console.log(_this.tempReplaced);
                        if (_this.selectedManagerItemsCopy.find(function (x) { return x.id == _this.replacementAdmin.id; })) {
                            if (_this.tempReplaced.find(function (x) { return x.currentId == _this.replacementAdmin.id; })) {
                                _this.selectedManagerItems.push({ id: _this.replacementAdmin.id, name: _this.replacementAdmin.name });
                                _this.ManagerEditForm.controls['managerData'].setValue(_this.selectedManagerItems);
                            }
                        }
                        else {
                            if (_this.tempReplaced.find(function (x) { return x.newId == _this.replacementAdmin.id; })) { }
                            else {
                                _this.selectedManagerItems.push({ id: _this.replacementAdmin.id, name: _this.replacementAdmin.name });
                                _this.ManagerEditForm.controls['managerData'].setValue(_this.selectedManagerItems);
                            }
                        }
                    }
                    _this.tempReplaced.find(function (x) { return x.currentId == _this.removedAdmin.id; }).newId = _this.replacementAdmin.id;
                    console.log(_this.tempReplaced);
                    console.log(_this.selectedManagerItems);
                    _this.ManagerEditForm.controls['buManagerReplacementsData'].setValue(_this.tempReplaced);
                }
                else {
                    _this.selectedManagerItems.push(_this.removedAdmin);
                    _this.ManagerEditForm.controls['managerData'].setValue(_this.selectedManagerItems);
                }
            });
        }
        else if (this.tempReplaced.find(function (x) { return x.newId == _this.removedAdmin.id; })) {
            console.log(this.tempReplaced.find(function (x) { return x.newId == _this.removedAdmin.id; }));
            var selectionId = this.tempReplaced.find(function (x) { return x.newId == _this.removedAdmin.id; }).currentId;
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_8__dialog_dialog_component__["d" /* BuAssignmentDialogComponent */]);
            this.dialogRef.componentInstance.admins = this.admins;
            console.log(this.selectedManagerItemsCopy.find(function (x) { return x.id == selectionId; }).name);
            this.dialogRef.componentInstance.managerName = this.selectedManagerItemsCopy.find(function (x) { return x.id == selectionId; }).name;
            this.dialogRef.afterClosed().subscribe(function (data) {
                console.log(data);
                if (data) {
                    _this.replacementAdmin = data;
                    if (_this.tempReplaced.find(function (x) { return x.currentId == selectionId; })) {
                        console.log(_this.tempReplaced);
                        if (_this.selectedManagerItemsCopy.find(function (x) { return x.id == _this.replacementAdmin.id; })) {
                            if (_this.tempReplaced.find(function (x) { return x.currentId == _this.replacementAdmin.id; })) {
                                _this.selectedManagerItems.push({ id: _this.replacementAdmin.id, name: _this.replacementAdmin.name });
                                _this.ManagerEditForm.controls['managerData'].setValue(_this.selectedManagerItems);
                            }
                        }
                        else {
                            if (_this.tempReplaced.find(function (x) { return x.newId == _this.replacementAdmin.id; })) { }
                            else {
                                _this.selectedManagerItems.push({ id: _this.replacementAdmin.id, name: _this.replacementAdmin.name });
                                _this.ManagerEditForm.controls['managerData'].setValue(_this.selectedManagerItems);
                            }
                        }
                    }
                    _this.tempReplaced.find(function (x) { return x.currentId == selectionId; }).newId = _this.replacementAdmin.id;
                    console.log(_this.tempReplaced);
                    _this.ManagerEditForm.controls['buManagerReplacementsData'].setValue(_this.tempReplaced);
                }
                else {
                    _this.selectedManagerItems.push(_this.removedAdmin);
                }
            });
            this.ManagerEditForm.controls['managerData'].setValue(this.selectedManagerItems);
        }
        console.log(this.tempReplaced);
    };
    ViewManagerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.buildForm();
        var app_settings = { singleSelection: false, text: "", labelKey: "name", selectAllText: "", unSelectAllText: "", classes: "myclass custom-class" };
        var mgr_settings = { singleSelection: false, text: "", labelKey: "name", selectAllText: "", unSelectAllText: "", classes: "myclass custom-class" };
        this.translate.get('Select Applications').subscribe(function (res) {
            app_settings.text = res;
            if (app_settings.text && app_settings.selectAllText && app_settings.unSelectAllText) {
                _this.application_settings = app_settings;
            }
        });
        this.translate.get('Assign Manager').subscribe(function (res) {
            mgr_settings.text = res;
            if (mgr_settings.text && mgr_settings.selectAllText && mgr_settings.unSelectAllText) {
                _this.manager_settings = mgr_settings;
            }
        });
        this.translate.get('select_all').subscribe(function (res) {
            app_settings.selectAllText = res;
            mgr_settings.selectAllText = res;
            if (mgr_settings.text && mgr_settings.selectAllText && mgr_settings.unSelectAllText) {
                _this.manager_settings = mgr_settings;
            }
            if (app_settings.text && app_settings.selectAllText && app_settings.unSelectAllText) {
                _this.application_settings = app_settings;
            }
        });
        this.translate.get('unselect_all').subscribe(function (res) {
            app_settings.unSelectAllText = res;
            mgr_settings.unSelectAllText = res;
            if (mgr_settings.text && mgr_settings.selectAllText && mgr_settings.unSelectAllText) {
                _this.manager_settings = mgr_settings;
            }
            if (app_settings.text && app_settings.selectAllText && app_settings.unSelectAllText) {
                _this.application_settings = app_settings;
            }
        });
    };
    ViewManagerComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'view-manager',
            template: __webpack_require__(1289)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_2__angular_router__["b" /* ActivatedRoute */], __WEBPACK_IMPORTED_MODULE_7__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_6__shared_services_http_service__["a" /* HttpService */],
            __WEBPACK_IMPORTED_MODULE_4__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_5__angular_forms__["h" /* FormBuilder */], __WEBPACK_IMPORTED_MODULE_9_ng2_translate__["d" /* TranslateService */]])
    ], ViewManagerComponent);
    return ViewManagerComponent;
}());



/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WPASSComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dialog_dialog_component__ = __webpack_require__(11);
/**
 * Created by shubham on 4/5/18.
 */










var WPASSComponent = /** @class */ (function () {
    function WPASSComponent(router, sessionHandler, httpService, dialog, formBuilder) {
        this.router = router;
        this.sessionHandler = sessionHandler;
        this.httpService = httpService;
        this.dialog = dialog;
        this.formBuilder = formBuilder;
        this.WPASSResponse = [];
        this.urlPattern = /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;
        this.passwordPattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/;
        this.isChecked = false;
        this.isDisabled = true;
        //Close Sidebar Initially
        __WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].navCollapsed = true;
        this.getWPASSDetails();
    }
    WPASSComponent.prototype.getWPASSDetails = function () {
        var _this = this;
        this.httpService.getRequest('superUserOperationsApi/v1/applicationDetailsWPASS').subscribe(function (res) { _this.saveWPASSDetails(res, 'getAPI'); }, function (err) { _this.httpService.onEnd(); });
    };
    WPASSComponent.prototype.saveUserData = function () {
        var _this = this;
        this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_8__dialog_dialog_component__["i" /* ActiveInactiveDialogComponent */]);
        this.dialogRef.componentInstance.isConfirm = true;
        this.dialogRef.componentInstance.msg = 'You are updating very sensitive information.';
        this.dialogRef.componentInstance.systemSetting = 'update_confirmation';
        this.dialogRef.afterClosed().subscribe(function (result) {
            if (result) {
                _this.httpService.postRequest(_this.WPASSFormDetails, 'superUserOperationsApi/v1/applicationDetailsWPASS').subscribe(function (res) { _this.saveWPASSDetails(res, 'postAPI'); }, function (err) { _this.httpService.onEnd(); });
            }
        });
    };
    WPASSComponent.prototype.saveWPASSDetails = function (res, apiStatus) {
        if (res) {
            if (apiStatus == 'postAPI') {
                this.httpService.onEnd();
                this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_8__dialog_dialog_component__["a" /* DialogComponent */]);
                this.dialogRef.componentInstance.msg = "WPASS information updated successfully.";
            }
            this.WPASSResponse = res;
            this.WPASSFormDetails = this.WPASSResponse;
            this.buildForm();
        }
        this.httpService.onEnd();
    };
    WPASSComponent.prototype.toggle = function () {
        this.isChecked = !this.isChecked;
        if (this.isChecked == true) {
            this.isDisabled = false;
        }
        else {
            this.isDisabled = true;
            this.WPASSForm.get('wpassAppUserPassword').setValue('');
            this.WPASSForm.get('wpassAppUserConfirmPassword').setValue('');
        }
        this.buildForm();
    };
    WPASSComponent.prototype.buildForm = function () {
        var _this = this;
        this.WPASSForm = this.formBuilder.group({
            wpassUrl: this.formBuilder.control(this.WPASSResponse['wpassUrl'], [__WEBPACK_IMPORTED_MODULE_5__angular_forms__["g" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["g" /* Validators */].pattern(this.urlPattern)]),
            wpassAppUserId: this.formBuilder.control(this.WPASSResponse['wpassAppUserId'], [__WEBPACK_IMPORTED_MODULE_5__angular_forms__["g" /* Validators */].required]),
            wpassAppUserPassword: this.formBuilder.control({ value: '', disabled: this.isDisabled }, [__WEBPACK_IMPORTED_MODULE_5__angular_forms__["g" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["g" /* Validators */].minLength(8), __WEBPACK_IMPORTED_MODULE_5__angular_forms__["g" /* Validators */].maxLength(8), __WEBPACK_IMPORTED_MODULE_5__angular_forms__["g" /* Validators */].pattern(this.passwordPattern)]),
            wpassAppUserConfirmPassword: this.formBuilder.control({ value: '', disabled: this.isDisabled }, [__WEBPACK_IMPORTED_MODULE_5__angular_forms__["g" /* Validators */].required]),
        }, { validator: this.checkPasswords });
        this.WPASSForm.valueChanges.subscribe(function (data) {
            _this.WPASSFormDetails = _this.WPASSForm.getRawValue();
            _this.WPASSFormDetails['id'] = _this.WPASSResponse['id'];
            _this.WPASSFormDetails.validate = _this.WPASSForm.valid;
        });
    };
    WPASSComponent.prototype.checkPasswords = function (group) {
        if (group.get('wpassAppUserPassword').value === group.get('wpassAppUserConfirmPassword').value) {
            group.get('wpassAppUserConfirmPassword').setErrors(null);
            return null;
        }
        else {
            group.get('wpassAppUserConfirmPassword').setErrors({ 'incorrect': true });
            return { 'mismatch': true };
        }
    };
    WPASSComponent.prototype.ngOnInit = function () {
        this.buildForm();
    };
    WPASSComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'wpass-details',
            template: __webpack_require__(1290)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_7__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_6__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_4__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_5__angular_forms__["h" /* FormBuilder */]])
    ], WPASSComponent);
    return WPASSComponent;
}());



/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TranslationEmailComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_forms__ = __webpack_require__(14);

// Imports





//import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
//import { ChangeEvent } from '@ckeditor/ckeditor5-angular/ckeditor.component';
// Component Decorator
var TranslationEmailComponent = /** @class */ (function () {
    function TranslationEmailComponent(httpService, formBuilder, sessionHandler) {
        this.httpService = httpService;
        this.formBuilder = formBuilder;
        this.sessionHandler = sessionHandler;
        //public Editor = ClassicEditor;
        this.emailBody = "";
        this.isSystemAdmin = false;
        this.isApplicationManager = false;
        this.isBUManager = false;
        this.isRegionalAdmin = false;
        this.isServiceOwner = false;
        this.isTradePartner = false;
        this.isSubUser = false;
        this.updatedSubject = {};
        __WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].navCollapsed = true;
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].applicationManager)) {
                this.isApplicationManager = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].BUManager)) {
                this.isBUManager = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].serviceOwner)) {
                this.isServiceOwner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].tradePartner)) {
                this.isTradePartner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].subuser)) {
                this.isSubUser = true;
            }
        }
        else {
            this.httpService.noUserError();
        }
        if (this.isSystemAdmin) {
            this.getlanguages();
            this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
            this.profileData = this.userDetails;
            if (this.profileData.languageId) {
                this.setLanguage(this.profileData.languageId);
            }
            this.getSubjectList();
        }
    }
    TranslationEmailComponent.prototype.setLanguage = function (languageId) {
        this.responseLanguageId = languageId;
        this.buildForm();
    };
    TranslationEmailComponent.prototype.buildForm = function () {
        this.ProfileForm = this.formBuilder.group({
            languageId: this.formBuilder.control(this.responseLanguageId, [__WEBPACK_IMPORTED_MODULE_5__angular_forms__["g" /* Validators */].required])
        });
    };
    TranslationEmailComponent.prototype.getlanguages = function () {
        var _this = this;
        this.httpService.getRequest('lookupDataOperationsApi/v1/language').subscribe(function (res) { _this.savelanguageResponse(res); }, function (err) { _this.httpService.onEnd(); });
    };
    //Save languages Response
    TranslationEmailComponent.prototype.savelanguageResponse = function (res) {
        if (res && res.items) {
            this.LanguageData = res.items;
        }
    };
    TranslationEmailComponent.prototype.onLanguageChange = function (languageId) {
        this.j = undefined;
        this.responseLanguageId = languageId;
        this.getSubjectList();
        this.j = undefined;
    };
    TranslationEmailComponent.prototype.selectEmail = function (data, i) {
        console.log(i);
        console.log(data);
        if (this.j != i) {
            if (this.j != undefined) {
                document.getElementById(this.j).setAttribute("class", "style2, mdl-tabs__tab");
            }
            document.getElementById(i).setAttribute("class", "style1");
        }
        this.j = i;
        this.emailSubject = data.text;
        this.getEmailBodyList(data);
    };
    TranslationEmailComponent.prototype.getSubjectList = function () {
        var _this = this;
        var st = this.j;
        this.httpService.getRequest("superUserOperationsApi/v1/multilingualEmailSubject/list/" + this.responseLanguageId).subscribe(function (res) {
            console.log(res);
            _this.SubjectData = res;
            _this.SubjectItems = _this.SubjectData.items;
        }, function (err) {
            _this.httpService.onEnd();
        });
        if (st) {
            setTimeout(function () {
                for (var i in _this.SubjectItems) {
                    if (st == _this.SubjectItems[i].id) {
                        document.getElementById(_this.SubjectItems[i].id).setAttribute("class", "style1");
                    }
                }
                _this.httpService.onEnd();
            }, 3000);
        }
        else {
            setTimeout(function () {
                if (_this.SubjectItems) {
                    _this.selectEmail(_this.SubjectItems[0], _this.SubjectItems[0].id);
                }
            }, 3000);
        }
        /* if(st){
            for(let i in this.SubjectItems){
                if(st == this.SubjectItems[i].id){
                 document.getElementById(this.SubjectItems[i].id).setAttribute("class", "style1");
                }
            }
        } */
    };
    TranslationEmailComponent.prototype.getEmailBodyList = function (key) {
        var _this = this;
        this.emailSubjectid = key.id;
        this.httpService.getRequest("superUserOperationsApi/v1/multilingualEmail/" + this.responseLanguageId + "?key=" + key.key).subscribe(function (res) {
            console.log(res);
            _this.emailBodyData = res;
            _this.emailBody = _this.emailBodyData.html;
            _this.emailBodyid = _this.emailBodyData.id;
            _this.httpService.onEnd();
        }, function (err) {
            _this.httpService.onEnd();
        });
    };
    TranslationEmailComponent.prototype.updateSubject = function () {
        var _this = this;
        console.log(this.emailSubject);
        var body = {
            id: this.emailSubjectid,
            text: this.emailSubject
        };
        this.httpService.postRequest(body, 'superUserOperationsApi/v1/multilingualEmailSubject').subscribe(function (res) {
            console.log(res);
            _this.getSubjectList();
            _this.updatedSubject = res;
        }, function (err) { _this.httpService.onEnd(); });
    };
    TranslationEmailComponent.prototype.updateBody = function () {
        var _this = this;
        console.log(this.emailBody);
        var body = {
            id: this.emailBodyid,
            html: this.emailBody
        };
        this.httpService.postRequest(body, 'superUserOperationsApi/v1/multilingualEmail').subscribe(function (res) {
            console.log(res);
            _this.httpService.onEnd();
        }, function (err) { _this.httpService.onEnd(); });
    };
    TranslationEmailComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            template: __webpack_require__(1291),
            styles: [__webpack_require__(132)],
        })
        // Component Class
        ,
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_5__angular_forms__["h" /* FormBuilder */], __WEBPACK_IMPORTED_MODULE_4__shared_services_session_handler_service__["a" /* SessionHandler */]])
    ], TranslationEmailComponent);
    return TranslationEmailComponent;
}());



/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TranslationMessagesComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dialog_dialog_component__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__swimlane_ngx_datatable__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__swimlane_ngx_datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__swimlane_ngx_datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__translation_messages_translation_messages_page__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__translation_messages_translationResultService__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(12);

// Imports









// Component Decorator
var TranslationMessagesComponent = /** @class */ (function () {
    function TranslationMessagesComponent(httpService, formBuilder, sessionHandler, serverResultsService) {
        this.httpService = httpService;
        this.formBuilder = formBuilder;
        this.sessionHandler = sessionHandler;
        this.serverResultsService = serverResultsService;
        this.page = new __WEBPACK_IMPORTED_MODULE_5__translation_messages_translation_messages_page__["a" /* TranslationMessagePage */]();
        this.tableRows = [];
        this.filters = {};
        this.selected = [];
        this.selectedStatusId = '';
        this.language2 = [];
        this.isSystemAdmin = false;
        this.isApplicationManager = false;
        this.isBUManager = false;
        this.isRegionalAdmin = false;
        this.isServiceOwner = false;
        this.isTradePartner = false;
        this.isSubUser = false;
        this.saveTranslationList = function (res, filter) {
            if (res.errorStatus == 'Fail') {
                this.httpService.onEnd();
                this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_3__dialog_dialog_component__["a" /* DialogComponent */]);
                this.dialogRef.componentInstance.msg = 'data_pull_fail';
            }
            else {
                if (res && Object.keys(res).length > 0) {
                    this.translationData = res;
                    this.rows = [];
                    this.rows['offset'] = res.offset;
                    this.count = res.count;
                    this.totalCount = res.totalCount;
                    if (this.translationData.list) {
                        var totalCount = 0;
                        if (parseInt(res.offset) == 0) {
                            localStorage.setItem('totalCount', res.totalCount);
                            totalCount = parseInt(res.totalCount);
                        }
                        else {
                            totalCount = parseInt(localStorage.getItem('totalCount'));
                        }
                        this.rows['totalCount'] = totalCount;
                        for (var data in this.translationData.list) {
                            this.rows[data] = {};
                            this.rows[data]['id'] = this.translationData.list[data]['id'];
                            this.rows[data]['key'] = this.translationData.list[data]['key'];
                            this.rows[data]['english'] = this.translationData.list[data]['englishText'];
                            this.rows[data]['selectLanguage'] = this.translationData.list[data]['text'];
                            this.rows[data]['actionFlag'] = true;
                            this.language2[data] = this.translationData.list[data]['text'];
                        }
                        this.showTable = true;
                        this.temp = this.rows;
                    }
                    else {
                        this.showTable = false;
                    }
                    var finalRows = [];
                    for (var f in this.rows) {
                        if (f != 'offset' && f != 'totalCount' && this.rows[f]) {
                            finalRows.push(this.rows[f]);
                        }
                        if (f == 'offset') {
                            finalRows['offset'] = this.rows['offset'];
                        }
                        if (f == 'totalCount') {
                            finalRows['totalCount'] = this.rows['totalCount'];
                        }
                    }
                    this.rows = finalRows;
                    this.setPage({ offset: this.rows['offset'] / this.page.size }, finalRows, filter);
                    this.httpService.onEnd();
                }
            }
        };
        __WEBPACK_IMPORTED_MODULE_9__config__["a" /* APPCONFIG */].navCollapsed = true;
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* APPCONFIG */].systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* APPCONFIG */].applicationManager)) {
                this.isApplicationManager = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* APPCONFIG */].BUManager)) {
                this.isBUManager = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* APPCONFIG */].regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* APPCONFIG */].serviceOwner)) {
                this.isServiceOwner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* APPCONFIG */].tradePartner)) {
                this.isTradePartner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* APPCONFIG */].subuser)) {
                this.isSubUser = true;
            }
        }
        else {
            this.httpService.noUserError();
        }
        this.getlanguages();
        this.page.pageNumber = 0;
        this.page.size = 20;
        this.filters['offSet'] = this.page.pageNumber * this.page.size;
        this.filters['limit'] = this.page.size;
        if (this.isSystemAdmin) {
            this.profileData = this.userDetails;
            if (this.profileData.languageId) {
                this.setLanguage(this.profileData.languageId);
            }
        }
    }
    TranslationMessagesComponent.prototype.setLanguage = function (languageId) {
        this.responseLanguageId = languageId;
        this.buildForm();
        this.getTranslationData(this.filters);
    };
    TranslationMessagesComponent.prototype.buildForm = function () {
        this.ProfileForm = this.formBuilder.group({
            languageId: this.formBuilder.control(this.responseLanguageId, [__WEBPACK_IMPORTED_MODULE_7__angular_forms__["g" /* Validators */].required])
        });
    };
    TranslationMessagesComponent.prototype.search = function () {
        this.selected = [];
        this.filters['offSet'] = 0;
        this.getTranslationData(this.filters);
    };
    TranslationMessagesComponent.prototype.resetSearch = function () {
        this.searchText = "";
        this.resetDateFlag = true;
        if (this.profileData.languageId) {
            this.setLanguage(this.profileData.languageId);
        }
        this.search();
    };
    TranslationMessagesComponent.prototype.updateBtn = function (rowdata, editedText) {
        var _this = this;
        console.log(rowdata);
        console.log(editedText);
        var data = {};
        data['id'] = rowdata['id'];
        data['text'] = editedText;
        this.httpService.postRequest(data, 'superUserOperationsApi/v1/multilingualText').subscribe(function (res) {
            console.log(res);
            _this.getTranslationData(_this.filters);
        }, function (err) { _this.httpService.onEnd(); });
    };
    TranslationMessagesComponent.prototype.getlanguages = function () {
        var _this = this;
        this.httpService.getRequest('lookupDataOperationsApi/v1/language').subscribe(function (res) { _this.savelanguageResponse(res); }, function (err) { _this.httpService.onEnd(); });
    };
    //Save languages Response
    TranslationMessagesComponent.prototype.savelanguageResponse = function (res) {
        if (res && res.items) {
            this.LanguageData = res.items;
        }
        this.httpService.onEnd();
    };
    TranslationMessagesComponent.prototype.onLanguageChange = function (languageId) {
        console.log(languageId);
        this.responseLanguageId = languageId;
        this.getTranslationData(this.filters);
    };
    TranslationMessagesComponent.prototype.getTranslationData = function (filter) {
        var _this = this;
        if (this.searchText == undefined) {
            this.searchText = "";
        }
        this.httpService.getRequest("superUserOperationsApi/v1/multilingualText/list/" + this.responseLanguageId + "?limit=" + filter.limit + "&offset=" + filter.offSet + "&search=" + this.searchText).subscribe(function (res) {
            console.log(res);
            _this.saveTranslationList(res, filter);
        }, function (err) {
            _this.httpService.onEnd();
        });
    };
    TranslationMessagesComponent.prototype.setPage = function (pageInfo, rows, filter) {
        var _this = this;
        this.page.pageNumber = pageInfo.offset;
        if (rows.length != 0) {
            this.serverResultsService.getResults(this.page, rows).subscribe(function (pageData) {
                _this.page = pageData.page;
                _this.tableRows = pageData.data;
                if (!filter) {
                    if (Object.keys(_this.tableRows).length == 0 || !_this.tableRows[0]['status']) {
                        _this.filters['offSet'] = _this.page.pageNumber * _this.page.size;
                        _this.getTranslationData(_this.filters);
                    }
                }
            });
        }
        else {
            this.tableRows = [];
            this.page.totalElements = rows.length;
        }
    };
    TranslationMessagesComponent.prototype.onSelect = function (_a) {
        var selected = _a.selected;
        var _b;
        this.selected.splice(0, this.selected.length);
        (_b = this.selected).push.apply(_b, selected);
        this.selectedCount = this.selected.length;
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"])(__WEBPACK_IMPORTED_MODULE_4__swimlane_ngx_datatable__["DatatableComponent"]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", __WEBPACK_IMPORTED_MODULE_4__swimlane_ngx_datatable__["DatatableComponent"])
    ], TranslationMessagesComponent.prototype, "table", void 0);
    TranslationMessagesComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            template: __webpack_require__(1292),
            styles: [__webpack_require__(132)],
            providers: [__WEBPACK_IMPORTED_MODULE_6__translation_messages_translationResultService__["a" /* TranslationMessagesResultService */]]
        })
        // Component Class
        ,
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_7__angular_forms__["h" /* FormBuilder */], __WEBPACK_IMPORTED_MODULE_8__shared_services_session_handler_service__["a" /* SessionHandler */],
            __WEBPACK_IMPORTED_MODULE_6__translation_messages_translationResultService__["a" /* TranslationMessagesResultService */]])
    ], TranslationMessagesComponent);
    return TranslationMessagesComponent;
}());



/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TranslationMessagePage; });
var TranslationMessagePage = /** @class */ (function () {
    function TranslationMessagePage() {
        //The number of elements in the page
        this.size = 0;
        //The total number of elements
        this.totalElements = 0;
        //The total number of pages
        this.totalPages = 0;
        //The current page number
        this.pageNumber = 0;
    }
    return TranslationMessagePage;
}());



/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UnlockAccountComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dialog_dialog_component__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_services_common_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ng2_translate__ = __webpack_require__(17);
/**
 * Created by shubham on 15/02/19.
 */










var UnlockAccountComponent = /** @class */ (function () {
    function UnlockAccountComponent(router, route, httpService, sessionHandler, dialog, translate, formBuilder, commonService) {
        this.router = router;
        this.route = route;
        this.httpService = httpService;
        this.sessionHandler = sessionHandler;
        this.dialog = dialog;
        this.translate = translate;
        this.formBuilder = formBuilder;
        this.commonService = commonService;
        this.data = [];
    }
    UnlockAccountComponent.prototype.buildForm = function () {
        var _this = this;
        this.UnlockAccountForm = this.formBuilder.group({
            userId_WPASS: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].required]),
        });
        this.UnlockAccountForm.valueChanges.subscribe(function (data) {
            _this.UnlockAccountFormDetails = _this.UnlockAccountForm.getRawValue();
        });
    };
    UnlockAccountComponent.prototype.unlockAccount = function () {
        var _this = this;
        this.httpService.postRequest(this.UnlockAccountFormDetails, 'userOperationsApi/v1/unlockWpassUser').subscribe(function (res) { _this.saveResponse(res); }, function (err) {
            _this.httpService.onEnd();
        });
    };
    UnlockAccountComponent.prototype.saveResponse = function (res) {
        var _this = this;
        if (res) {
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_5__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = 'account_unlock_succesfully';
            this.dialogRef.afterClosed().subscribe(function (result) {
                _this.router.navigateByUrl('/login');
            });
        }
        this.httpService.onEnd();
    };
    UnlockAccountComponent.prototype.ngOnInit = function () {
        this.buildForm();
    };
    UnlockAccountComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            template: __webpack_require__(1293)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_2__angular_router__["b" /* ActivatedRoute */], __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_8__shared_services_session_handler_service__["a" /* SessionHandler */],
            __WEBPACK_IMPORTED_MODULE_4__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_9_ng2_translate__["d" /* TranslateService */], __WEBPACK_IMPORTED_MODULE_6__angular_forms__["h" /* FormBuilder */], __WEBPACK_IMPORTED_MODULE_7__shared_services_common_service__["a" /* CommonService */]])
    ], UnlockAccountComponent);
    return UnlockAccountComponent;
}());



/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserActivityPage; });
var UserActivityPage = /** @class */ (function () {
    function UserActivityPage() {
        //The number of elements in the page
        this.size = 0;
        //The total number of elements
        this.totalElements = 0;
        //The total number of pages
        this.totalPages = 0;
        //The current page number
        this.pageNumber = 0;
    }
    return UserActivityPage;
}());



/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserActivityResultService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_activity_page_data__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_activity_dashboardList__ = __webpack_require__(798);





/**
 * A server used to mock a paged data result from a server
 */
var UserActivityResultService = /** @class */ (function () {
    function UserActivityResultService() {
        this.rows = {};
        this.applicationsDashboardData = {};
    }
    /**
     * A method that mocks a paged server response
     * @param page The selected page
     * @returns {any} An observable containing the employee data
     */
    UserActivityResultService.prototype.getResults = function (page, listData) {
        var _this = this;
        this.listData = listData;
        return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(listData).map(function (data) { return _this.getPageData(page); });
    };
    /**
     * Package companyData into a PagedData object based on the selected Page
     * @param page The page data used to get the selected data from companyData
     * @returns {PagedData<icsList>} An array of the selected data and page
     */
    UserActivityResultService.prototype.getPageData = function (page) {
        var pageData = new __WEBPACK_IMPORTED_MODULE_3__user_activity_page_data__["a" /* UserActivityPageData */]();
        var offset = this.listData.offset;
        var raw = [];
        for (var l in this.listData) {
            if (Object.keys(this.listData[l]).length > 0) {
                raw[offset + parseInt(l)] = this.listData[l];
            }
        }
        if (this.listData.totalCount) {
            page.totalElements = this.listData.totalCount;
        }
        page.totalPages = page.totalElements / page.size;
        var start = page.pageNumber * page.size;
        var end = Math.min((start + page.size), page.totalElements);
        for (var i = start; i < end; i++) {
            if (raw[i]) {
                var jsonObj = raw[i];
                if (jsonObj) {
                    var list = new __WEBPACK_IMPORTED_MODULE_4__user_activity_dashboardList__["a" /* UserActivityDashboardList */](jsonObj['username'], jsonObj['createdAt'], jsonObj['description'], jsonObj['email'], jsonObj['wpassId']);
                    pageData.data.push(list);
                }
            }
        }
        pageData.page = page;
        return pageData;
    };
    UserActivityResultService = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [])
    ], UserActivityResultService);
    return UserActivityResultService;
}());



/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return userActivityLogs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dialog_dialog_component__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_activity_datatable_user_activity_page__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__swimlane_ngx_datatable__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__swimlane_ngx_datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__swimlane_ngx_datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_activity_datatable_userActivityResultService__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_services_common_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__angular_common__ = __webpack_require__(32);











var userActivityLogs = /** @class */ (function () {
    function userActivityLogs(serverResultsService, sessionHandler, httpService, datePipe, commonService) {
        var _this = this;
        this.serverResultsService = serverResultsService;
        this.sessionHandler = sessionHandler;
        this.httpService = httpService;
        this.datePipe = datePipe;
        this.commonService = commonService;
        this.page = new __WEBPACK_IMPORTED_MODULE_3__user_activity_datatable_user_activity_page__["a" /* UserActivityPage */]();
        this.filters = {};
        this.tableRows = [];
        this.isSystemAdmin = false;
        this.isApplicationManager = false;
        this.isBUManager = false;
        this.isRegionalAdmin = false;
        this.isServiceOwner = false;
        this.isTradePartner = false;
        this.isSubUser = false;
        this.showTable = true;
        this.todaySelected = new Date;
        this.Wpass = [];
        this.autocompleteLoader = "";
        this.searchWpass = "";
        this.today = new Date();
        this.model = { date: { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() } };
        this.response = {};
        this.selected = [];
        this.selectedStatusId = '';
        this.myDatePickerOptions = {
            // other options...
            dateFormat: 'yyyy-mm-dd',
        };
        this.saveApplicationsList = function (res, filter) {
            if (res.errorStatus == 'Fail') {
                this.httpService.onEnd();
                this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_2__dialog_dialog_component__["a" /* DialogComponent */]);
                this.dialogRef.componentInstance.msg = 'data_pull_fail';
            }
            else {
                if (res && Object.keys(res).length > 0) {
                    this.applicationsDashboardData = res;
                    this.rows = [];
                    this.rows['offset'] = res.offset;
                    this.count = res.count;
                    this.totalCount = res.totalCount;
                    if (this.applicationsDashboardData.list) {
                        var totalCount = 0;
                        if (parseInt(res.offset) == 0) {
                            localStorage.setItem('totalCount', res.totalCount);
                            totalCount = parseInt(res.totalCount);
                        }
                        else {
                            totalCount = parseInt(localStorage.getItem('totalCount'));
                        }
                        this.rows['totalCount'] = totalCount;
                        for (var data in this.applicationsDashboardData.list) {
                            this.rows[data] = {};
                            this.rows[data]['name'] = this.applicationsDashboardData.list[data]['name'];
                            this.rows[data]['username'] = this.applicationsDashboardData.list[data]['username'];
                            this.rows[data]['description'] = this.applicationsDashboardData.list[data]['description'];
                            this.rows[data]['email'] = this.applicationsDashboardData.list[data]['email'];
                            this.rows[data]['wpassId'] = this.applicationsDashboardData.list[data]['wpassId'];
                            this.rows[data]['createdAt'] = this.applicationsDashboardData.list[data]['createdAt'];
                            /* this.rows[data]['createdAt'] = this.datePipe.transform(this.applicationsDashboardData.list[data]['createdAt'], 'dd-MM-yyyy hh:mm:ss a'); */
                        }
                        this.showTable = true;
                        this.temp = this.rows;
                    }
                    else {
                        this.showTable = false;
                    }
                    var finalRows = [];
                    for (var f in this.rows) {
                        if (f != 'offset' && f != 'totalCount' && this.rows[f]) {
                            finalRows.push(this.rows[f]);
                        }
                        if (f == 'offset') {
                            finalRows['offset'] = this.rows['offset'];
                        }
                        if (f == 'totalCount') {
                            finalRows['totalCount'] = this.rows['totalCount'];
                        }
                    }
                    this.rows = finalRows;
                    this.setPage({ offset: this.rows['offset'] / this.page.size }, finalRows, filter);
                    this.httpService.onEnd();
                }
            }
        };
        this.selectedDate = this.datePipe.transform(this.todaySelected, 'yyyy-MM-dd');
        //Close Sidebar Initially
        __WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].navCollapsed = true;
        this.page.pageNumber = 0;
        this.page.size = 20;
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].applicationManager)) {
                this.isApplicationManager = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].BUManager)) {
                this.isBUManager = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].serviceOwner)) {
                this.isServiceOwner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].tradePartner)) {
                this.isTradePartner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].subuser)) {
                this.isSubUser = true;
            }
        }
        else {
            this.httpService.noUserError();
        }
        this.filters['offSet'] = this.page.pageNumber * this.page.size;
        this.filters['limit'] = this.page.size;
        if (this.isSystemAdmin) {
            this.getApplicationsList(this.filters);
        }
        else {
            this.showTable = false;
        }
        //Call when approve/delete from ApproveRejectComponent/ActiveInactiveComponent to get the updated list.
        this.commonService.applicationDashboard.subscribe(function (value) {
            _this.getApplicationsList(_this.filters);
        });
    }
    userActivityLogs.prototype.autocompleteSearch = function (term, filter) {
        var _this = this;
        if (filter == "wpass") {
            this.Wpass = [];
            this.searchWpass = term;
        }
        if (term == "")
            return;
        var url = "/lookupDataOperationsApi/v1/partialSearch?type=" + filter + "&searchStr=" + term;
        this.autocompleteLoader = filter;
        this.httpService.getRequestForAutocomplete(url).subscribe(function (res) {
            if (res && res['items']) {
                var name_1 = res['items'];
                var filterArray = [];
                for (var index in name_1) {
                    filterArray.push(name_1[index]['name']);
                }
                if (filter == "wpass") {
                    _this.Wpass = filterArray;
                }
            }
            _this.autocompleteLoader = "";
            _this.httpService.onEnd();
        }, function (err) {
            _this.autocompleteLoader = "";
            _this.httpService.onEnd();
        });
    };
    userActivityLogs.prototype.onSelectAutocomplete = function (value, textFlag) {
        if (textFlag == "wpass") {
            this.searchWpass = value;
        }
    };
    userActivityLogs.prototype.search = function () {
        this.selected = [];
        this.selectedDate = "";
        this.filters['offSet'] = 0;
        if (this.model) {
            if (this.model.formatted) {
                this.selectedDate = this.model.formatted;
            }
            else {
                var date1 = this.model.date.year + "-" + this.model.date.month + "-" + this.model.date.day;
                this.selectedDate = this.datePipe.transform(date1, 'yyyy-MM-dd');
            }
        }
        if (this.searchWpass == undefined) {
            this.searchWpass = "";
        }
        else if (this.searchWpass != "" && this.Wpass.length > 0) {
            if (this.checkAutocompleteWord(this.Wpass, this.searchWpass)) {
                this.searchWpass = "";
            }
        }
        this.getApplicationsList(this.filters);
    };
    userActivityLogs.prototype.checkAutocompleteWord = function (objArray, searchValue) {
        if (objArray.includes(searchValue)) {
            return false;
        }
        else {
            return true;
        }
    };
    userActivityLogs.prototype.resetSearch = function () {
        this.searchWpass = '';
        this.Wpass = [];
        this.searchValue = "";
        this.selectedDate = "";
        this.model = { date: { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() } };
        this.search();
    };
    userActivityLogs.prototype.onSelect = function (_a) {
        var selected = _a.selected;
        var _b;
        this.selected.splice(0, this.selected.length);
        (_b = this.selected).push.apply(_b, selected);
        this.selectedCount = this.selected.length;
    };
    userActivityLogs.prototype.getApplicationsList = function (filter) {
        var _this = this;
        this.showCheckbox = true;
        this.httpService.getRequest("/userActivityLogsOperationApi/v1/userActivityLogList?limit=" + filter.limit + "&offset=" + filter.offSet + "&wpassId=" + this.searchWpass + "&date=" + this.selectedDate).subscribe(function (res) {
            _this.saveApplicationsList(res, filter);
        }, function (err) {
            _this.httpService.onEnd();
        });
    };
    userActivityLogs.prototype.setPage = function (pageInfo, rows, filter) {
        var _this = this;
        this.page.pageNumber = pageInfo.offset;
        if (rows.length != 0) {
            this.serverResultsService.getResults(this.page, rows).subscribe(function (pageData) {
                _this.page = pageData.page;
                _this.tableRows = pageData.data;
                if (!filter) {
                    if (Object.keys(_this.tableRows).length == 0 || !_this.tableRows[0]['status']) {
                        _this.filters['offSet'] = _this.page.pageNumber * _this.page.size;
                        _this.getApplicationsList(_this.filters);
                    }
                }
            });
        }
        else {
            this.tableRows = [];
            this.page.totalElements = rows.length;
        }
    };
    userActivityLogs.prototype.ngOnInit = function () { };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"])(__WEBPACK_IMPORTED_MODULE_4__swimlane_ngx_datatable__["DatatableComponent"]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", __WEBPACK_IMPORTED_MODULE_4__swimlane_ngx_datatable__["DatatableComponent"])
    ], userActivityLogs.prototype, "table", void 0);
    userActivityLogs = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            template: __webpack_require__(1294),
            styles: [__webpack_require__(1242), __webpack_require__(132)],
            providers: [__WEBPACK_IMPORTED_MODULE_10__angular_common__["DatePipe"]]
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_5__user_activity_datatable_userActivityResultService__["a" /* UserActivityResultService */], __WEBPACK_IMPORTED_MODULE_8__shared_services_session_handler_service__["a" /* SessionHandler */],
            __WEBPACK_IMPORTED_MODULE_6__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_10__angular_common__["DatePipe"], __WEBPACK_IMPORTED_MODULE_9__shared_services_common_service__["a" /* CommonService */]])
    ], userActivityLogs);
    return userActivityLogs;
}());



/***/ }),

/***/ 325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddBusinessUnitForUserComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__ = __webpack_require__(11);
/**
 * Created by shubham on 20/11/18.
 */








var AddBusinessUnitForUserComponent = /** @class */ (function () {
    function AddBusinessUnitForUserComponent(sessionHandler, httpService, dialog, formBuilder) {
        this.sessionHandler = sessionHandler;
        this.httpService = httpService;
        this.dialog = dialog;
        this.formBuilder = formBuilder;
        this.isSystemAdmin = false;
        this.isBUManager = false;
        this.isRegionalAdmin = false;
        this.isServiceOwner = false;
        this.isTradePartner = false;
        this.isSubUser = false;
        this.settings = {};
        this.country = [];
        this.businessUnits = [];
        this.applications = [];
        this.isDisabled = true;
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].BUManager)) {
                this.isBUManager = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].serviceOwner)) {
                this.isServiceOwner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].tradePartner)) {
                this.isTradePartner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].subuser)) {
                this.isSubUser = true;
            }
        }
        else {
            this.httpService.noUserError();
        }
        if (this.isServiceOwner) {
            this.getBusinessUnitAndCountry();
        }
    }
    AddBusinessUnitForUserComponent.prototype.getBusinessUnitAndCountry = function () {
        var _this = this;
        this.httpService.getRequest('applicationOperationApi/v1/initNewApplicationRequest').subscribe(function (res) { _this.saveBusinessUnitAndCountry(res); }, function (err) { _this.httpService.onEnd(); });
    };
    AddBusinessUnitForUserComponent.prototype.saveBusinessUnitAndCountry = function (res) {
        if (res) {
            this.country['id'] = res.countryId;
            this.country['name'] = res.countryName;
            if (res.availableBusinessUnits) {
                this.businessUnits = res.availableBusinessUnits;
            }
            if (res.defaultBusinessUnit) {
                this.selectedBusinessUnit = res.defaultBusinessUnit.id;
            }
        }
        this.buildForm();
        this.httpService.onEnd();
    };
    AddBusinessUnitForUserComponent.prototype.buildForm = function () {
        var _this = this;
        this.AddBusinessUnitForm = this.formBuilder.group({
            country: this.formBuilder.control({ value: this.country['name'], disabled: true }),
            businessUnitId: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["g" /* Validators */].required]),
            applicationData: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["g" /* Validators */].required]),
            customerNumber: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["g" /* Validators */].required])
        });
        this.AddBusinessUnitForm.valueChanges.subscribe(function (data) {
            _this.AddBusinessUnitFormDetails = _this.AddBusinessUnitForm.getRawValue();
            _this.AddBusinessUnitFormDetails['applicationId'] = [];
            for (var d in _this.AddBusinessUnitFormDetails.applicationData) {
                _this.AddBusinessUnitFormDetails['applicationId'].push(_this.AddBusinessUnitFormDetails.applicationData[d]['id']);
            }
            _this.AddBusinessUnitFormDetails.validate = _this.AddBusinessUnitForm.valid;
        });
        this.AddBusinessUnitForm.get('businessUnitId').valueChanges.subscribe(function (data) {
            var arrayControl = _this.AddBusinessUnitForm.controls['applicationData'];
            arrayControl.controls = [];
            _this.applications = [];
            if (data != null) {
                _this.getApplicationsByBusinessUnit(data);
            }
        });
        this.AddBusinessUnitForm.get('applicationData').valueChanges.subscribe(function (data) {
            if (data != null) {
                for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                    var app = data_1[_i];
                    if (app.customerNumberRequired && app.customerNumberRequired != null) {
                        _this.AddBusinessUnitForm.get('customerNumber').setValidators(null);
                        _this.AddBusinessUnitForm.get('customerNumber').updateValueAndValidity();
                        break;
                    }
                }
            }
        });
    };
    AddBusinessUnitForUserComponent.prototype.getApplicationsByBusinessUnit = function (businessUnitId) {
        var _this = this;
        this.httpService.getRequest('applicationOperationApi/v1/getUnsubscribedApplicationsForPartner/' + businessUnitId).subscribe(function (res) { _this.saveApplicationsByBusinessUnit(res); }, function (err) { _this.httpService.onEnd(); });
    };
    AddBusinessUnitForUserComponent.prototype.saveApplicationsByBusinessUnit = function (res) {
        if (res && res.availableApplications) {
            if (res.availableApplications) {
                this.applications = res.availableApplications;
            }
            if (res.customerNumber) {
                this.AddBusinessUnitForm.get('customerNumber').setValue(res.customerNumber);
            }
        }
        this.httpService.onEnd();
    };
    AddBusinessUnitForUserComponent.prototype.saveBusinessUnitData = function () {
        var _this = this;
        this.httpService.postRequest(this.AddBusinessUnitFormDetails, 'applicationOperationApi/v1/subscribeApplications').subscribe(function (res) { _this.saveBusinessUnitDataResponse(res); }, function (err) { _this.httpService.onEnd(); });
    };
    AddBusinessUnitForUserComponent.prototype.saveBusinessUnitDataResponse = function (res) {
        if (res) {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = "app_add_success";
            this.dialogRef.afterClosed().subscribe(function (result) {
                window.location.href = '#/app/request-application/list';
            });
        }
        else if (res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = 'save_failed';
            this.httpService.onEnd();
        }
    };
    AddBusinessUnitForUserComponent.prototype.ngOnInit = function () {
        this.buildForm();
        this.settings = {
            singleSelection: false,
            text: "Select Applications",
            labelKey: "name",
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            classes: "myclass custom-class"
        };
    };
    AddBusinessUnitForUserComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'add-business-user',
            template: __webpack_require__(1295)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_6__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_5__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_3__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_4__angular_forms__["h" /* FormBuilder */]])
    ], AddBusinessUnitForUserComponent);
    return AddBusinessUnitForUserComponent;
}());



/***/ }),

/***/ 326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BusinessUnitListForUserComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_services_common_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__businessUnitList_datatable_businessUnitList_page__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__businessUnitForUserDashboardResultService__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ng2_translate__ = __webpack_require__(17);
/**
 * Created by shubham on 24/11/18.
 */














var BusinessUnitListForUserComponent = /** @class */ (function () {
    function BusinessUnitListForUserComponent(router, httpService, sessionHandler, dialog, formBuilder, serverResultsService, commonService, translate) {
        this.router = router;
        this.httpService = httpService;
        this.sessionHandler = sessionHandler;
        this.dialog = dialog;
        this.formBuilder = formBuilder;
        this.serverResultsService = serverResultsService;
        this.commonService = commonService;
        this.translate = translate;
        this.page = new __WEBPACK_IMPORTED_MODULE_10__businessUnitList_datatable_businessUnitList_page__["a" /* BusinessUnitListPage */]();
        this.tableRows = [];
        this.filters = {};
        this.businessUnitListData = [];
        this.temp = [];
        this.showTable = true;
        this.isSystemAdmin = false;
        this.isBUManager = false;
        this.isRegionalAdmin = false;
        this.isServiceOwner = false;
        this.isTradePartner = false;
        this.isSubUser = false;
        this.selected = [];
        this.ApplicationData = [];
        this.selectedApplicationId = '';
        this.businessUnitWithApplicationAndRoles = [];
        this.businessUnitWithAppRolesProfile = [];
        this.getUserList = function () {
            this.showTable = false;
        };
        this.saveUserList = function (res, filter) {
            if (res.errorStatus == 'Fail') {
                this.httpService.onEnd();
                this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
                this.dialogRef.componentInstance.msg = 'data_pull_fail';
            }
            else {
                if (res && Object.keys(res).length > 0) {
                    this.businessUnitListData = res;
                    this.rows = [];
                    this.rows['offset'] = res.offset;
                    if (this.businessUnitListData.list) {
                        var totalCount = 0;
                        if (parseInt(res.offset) == 0) {
                            localStorage.setItem('totalCount', res.totalCount);
                            totalCount = parseInt(res.totalCount);
                        }
                        else {
                            totalCount = parseInt(localStorage.getItem('totalCount'));
                        }
                        this.rows['totalCount'] = totalCount;
                        for (var data in this.businessUnitListData.list) {
                            if (this.isServiceOwner) {
                                this.rows[data] = {};
                                this.rows[data]['countryId'] = this.businessUnitListData.list[data]['countryId'];
                                this.rows[data]['countryName'] = this.businessUnitListData.list[data]['countryName'];
                                this.rows[data]['businessUnitId'] = this.businessUnitListData.list[data]['businessUnitId'];
                                this.rows[data]['businessUnitName'] = this.businessUnitListData.list[data]['businessUnitName'];
                                this.rows[data]['emailVerified'] = this.businessUnitListData.list[data]['emailVerified'];
                                this.rows[data]['customerNumber'] = this.businessUnitListData.list[data]['customerNumber'];
                                if (this.businessUnitListData.list[data]['selectedApplicationNames']) {
                                    this.rows[data]['selectedApplicationNames'] = this.businessUnitListData.list[data]['selectedApplicationNames'];
                                }
                                this.rows[data]['status'] = this.businessUnitListData.list[data]['status'];
                                this.rows[data]['active'] = this.businessUnitListData.list[data]['active'];
                            }
                            else {
                                //For Other Service Partner's
                                this.rows[data] = {};
                            }
                        }
                        this.showTable = true;
                        this.temp = this.rows;
                    }
                    else {
                        this.showTable = false;
                    }
                    var finalRows = [];
                    for (var f in this.rows) {
                        if (f != 'offset' && f != 'totalCount' && this.rows[f]) {
                            finalRows.push(this.rows[f]);
                        }
                        if (f == 'offset') {
                            finalRows['offset'] = this.rows['offset'];
                        }
                        if (f == 'totalCount') {
                            finalRows['totalCount'] = this.rows['totalCount'];
                        }
                    }
                    this.rows = finalRows;
                    this.setPage({ offset: this.rows['offset'] / this.page.size }, finalRows, filter);
                    this.httpService.onEnd();
                }
            }
        };
        this.businessUnitForUserListText = 'businessUnitForUserList';
        this.page.pageNumber = 0;
        this.page.size = 20;
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].systemAdmin)) {
                this.isSystemAdmin = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].BUManager)) {
                this.isBUManager = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].serviceOwner)) {
                this.isServiceOwner = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].tradePartner)) {
                this.isTradePartner = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].subuser)) {
                this.isSubUser = true;
            }
        }
        else {
            this.httpService.noUserError();
        }
        this.filters['offSet'] = this.page.pageNumber * this.page.size;
        this.filters['limit'] = this.page.size;
        if (this.isServiceOwner) {
            //this.getApplications();
            //this.getUsersList(this.filters, this.selectedApplicationId);
            this.getPartnersProfileData();
        }
        else {
            //this.getUserList();
        }
    }
    BusinessUnitListForUserComponent.prototype.getPartnersProfileData = function () {
        var _this = this;
        this.httpService.getRequest('partnerOperationsApi/v1/partnerDetails').subscribe(function (res) { _this.savePartnersProfileData(res); }, function (err) { _this.httpService.onEnd(); });
    };
    BusinessUnitListForUserComponent.prototype.savePartnersProfileData = function (res) {
        if (res) {
            this.profileData = res;
            if (this.profileData) {
                if (this.profileData.businessUnitWithApplicationAndRoles) {
                    this.businessUnitWithApplicationAndRoles = this.profileData.businessUnitWithApplicationAndRoles;
                    for (var businessUnit in this.businessUnitWithApplicationAndRoles) {
                        for (var appAndRoles in this.businessUnitWithApplicationAndRoles[businessUnit]['applications']) {
                            var temp = [];
                            temp['businessUnitName'] = this.businessUnitWithApplicationAndRoles[businessUnit]['businessUnitName'];
                            temp['customerNumber'] = this.businessUnitWithApplicationAndRoles[businessUnit]['customerNumber'];
                            temp['applicationName'] = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles]['applicationName'];
                            temp['selectedRoleNames'] = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles]['selectedRoleNames'];
                            temp['url'] = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles]['url'];
                            var actionObject = {};
                            if (this.businessUnitWithApplicationAndRoles[businessUnit]['statusCode'] != 'APPROVED') {
                                actionObject = this.businessUnitWithApplicationAndRoles[businessUnit];
                            }
                            else {
                                actionObject = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles];
                            }
                            temp['statusCode'] = actionObject['statusCode'];
                            temp['status'] = actionObject['status'];
                            temp['message'] = actionObject['message'];
                            this.businessUnitWithAppRolesProfile.push(temp);
                        }
                    }
                }
            }
            this.httpService.onEnd();
        }
        else if (res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = 'data_load_failed';
            this.httpService.onEnd();
        }
    };
    BusinessUnitListForUserComponent.prototype.getApplications = function () {
        var _this = this;
        this.httpService.getRequest('applicationOperationApi/v1/applicationsForPartner').subscribe(function (res) { _this.saveApplications(res); }, function (err) { _this.httpService.onEnd(); });
    };
    BusinessUnitListForUserComponent.prototype.saveApplications = function (res) {
        if (res && res.items) {
            for (var s in res.items) {
                this.ApplicationData.push(res.items[s]);
            }
        }
    };
    BusinessUnitListForUserComponent.prototype.search = function () {
        this.filters['offSet'] = 0;
        this.getUsersList(this.filters, this.selectedApplicationId);
    };
    BusinessUnitListForUserComponent.prototype.resetSearch = function () {
        this.selectedApplicationId = "";
        this.search();
    };
    BusinessUnitListForUserComponent.prototype.getUsersList = function (filter, applicationId) {
        var _this = this;
        this.httpService.getRequest("partnerOperationsApi/v1/businessUnitListForPartner?limit=" + filter.limit + "&offset=" + filter.offSet + "&applicationId=" + applicationId).subscribe(function (res) { _this.saveUserList(res, filter); }, function (err) { _this.httpService.onEnd(); });
    };
    /**
     * Populate the table with new data based on the page number
     * @param page The page to select
     */
    BusinessUnitListForUserComponent.prototype.setPage = function (pageInfo, rows, filter) {
        var _this = this;
        this.page.pageNumber = pageInfo.offset;
        if (rows.length != 0) {
            this.serverResultsService.getResults(this.page, rows).subscribe(function (pageData) {
                _this.page = pageData.page;
                _this.tableRows = pageData.data;
                if (!filter) {
                    if (Object.keys(_this.tableRows).length == 0 || !_this.tableRows[0]['status']) {
                        _this.filters['offSet'] = _this.page.pageNumber * _this.page.size;
                        _this.getUsersList(_this.filters, _this.selectedApplicationId);
                    }
                }
            });
        }
        else {
            this.tableRows = [];
            this.page.totalElements = rows.length;
        }
    };
    BusinessUnitListForUserComponent.prototype.onSelect = function (_a) {
        var selected = _a.selected;
        var _b;
        this.selected.splice(0, this.selected.length);
        (_b = this.selected).push.apply(_b, selected);
    };
    BusinessUnitListForUserComponent.prototype.ngOnInit = function () {
        var _this = this;
        var temp = [{ id: "", code: "", name: "All" }];
        this.translate.get('all').subscribe(function (res) {
            temp[0].name = res;
            _this.ApplicationData = temp;
        });
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"])(__WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__["DatatableComponent"]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", __WEBPACK_IMPORTED_MODULE_5__swimlane_ngx_datatable__["DatatableComponent"])
    ], BusinessUnitListForUserComponent.prototype, "table", void 0);
    BusinessUnitListForUserComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'businessUnitList',
            template: __webpack_require__(1296)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_4__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_6__angular_material__["c" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_9__angular_forms__["h" /* FormBuilder */], __WEBPACK_IMPORTED_MODULE_12__businessUnitForUserDashboardResultService__["a" /* BusinessUnitListForUserDashboardResultService */],
            __WEBPACK_IMPORTED_MODULE_8__shared_services_common_service__["a" /* CommonService */], __WEBPACK_IMPORTED_MODULE_13_ng2_translate__["d" /* TranslateService */]])
    ], BusinessUnitListForUserComponent);
    return BusinessUnitListForUserComponent;
}());



/***/ }),

/***/ 327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BusinessUnitListForUserDashboardResultService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__businessUnitList_datatable_businessUnitList_page_data__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__businessUnitList_datatable_businessUnitList_dashboard__ = __webpack_require__(800);
/**
 * Created by shubham on 20/11/18.
 */





/**
 * A server used to mock a paged data result from a server
 */
var BusinessUnitListForUserDashboardResultService = /** @class */ (function () {
    function BusinessUnitListForUserDashboardResultService() {
        this.rows = {};
        this.adminDashboardData = {};
    }
    /**
     * A method that mocks a paged server response
     * @param page The selected page
     * @returns {any} An observable containing the employee data
     */
    BusinessUnitListForUserDashboardResultService.prototype.getResults = function (page, listData) {
        var _this = this;
        this.listData = listData;
        return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(listData).map(function (data) { return _this.getPageData(page); });
    };
    /**
     * Package companyData into a PagedData object based on the selected Page
     * @param page The page data used to get the selected data from companyData
     * @returns {PagedData<icsList>} An array of the selected data and page
     */
    BusinessUnitListForUserDashboardResultService.prototype.getPageData = function (page) {
        var pageData = new __WEBPACK_IMPORTED_MODULE_3__businessUnitList_datatable_businessUnitList_page_data__["a" /* BusinessUnitListPageData */]();
        var offset = this.listData.offset;
        var raw = [];
        for (var l in this.listData) {
            if (Object.keys(this.listData[l]).length > 0) {
                raw[offset + parseInt(l)] = this.listData[l];
            }
        }
        if (this.listData.totalCount) {
            page.totalElements = this.listData.totalCount;
        }
        page.totalPages = page.totalElements / page.size;
        var start = page.pageNumber * page.size;
        var end = Math.min((start + page.size), page.totalElements);
        for (var i = start; i < end; i++) {
            if (raw[i]) {
                var jsonObj = raw[i];
                if (jsonObj) {
                    var list = new __WEBPACK_IMPORTED_MODULE_4__businessUnitList_datatable_businessUnitList_dashboard__["a" /* BusinessUnitListDashboard */](jsonObj['countryId'], jsonObj['countryName'], jsonObj['businessUnitId'], jsonObj['businessUnitName'], jsonObj['emailVerified'], jsonObj['customerNumber'], jsonObj['selectedApplicationNames'], jsonObj['status'], jsonObj['active']);
                    pageData.data.push(list);
                }
            }
        }
        pageData.page = page;
        return pageData;
    };
    BusinessUnitListForUserDashboardResultService = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [])
    ], BusinessUnitListForUserDashboardResultService);
    return BusinessUnitListForUserDashboardResultService;
}());



/***/ }),

/***/ 328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BusinessUnitListPage; });
/**
 * Created by shubham on 20/11/18.
 */
/**
 * An object used to get page information from the server
 */
var BusinessUnitListPage = /** @class */ (function () {
    function BusinessUnitListPage() {
        //The number of elements in the page
        this.size = 0;
        //The total number of elements
        this.totalElements = 0;
        //The total number of pages
        this.totalPages = 0;
        //The current page number
        this.pageNumber = 0;
    }
    return BusinessUnitListPage;
}());



/***/ }),

/***/ 329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RequestBusinessUnitComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_services_common_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ng2_translate__ = __webpack_require__(17);
/**
 * Created by shubham on 19/11/18.
 */








var RequestBusinessUnitComponent = /** @class */ (function () {
    function RequestBusinessUnitComponent(router, route, httpService, sessionHandler, dialog, translate, commonService) {
        this.router = router;
        this.route = route;
        this.httpService = httpService;
        this.sessionHandler = sessionHandler;
        this.dialog = dialog;
        this.translate = translate;
        this.commonService = commonService;
        this.data = [];
        this.languageId = this.sessionHandler.getItem('languageId');
        if (!this.languageId) {
            this.languageId = "EN";
        }
        this.translate.use(this.languageId);
    }
    RequestBusinessUnitComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            template: __webpack_require__(1297)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_2__angular_router__["b" /* ActivatedRoute */], __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_6__shared_services_session_handler_service__["a" /* SessionHandler */],
            __WEBPACK_IMPORTED_MODULE_4__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_7_ng2_translate__["d" /* TranslateService */], __WEBPACK_IMPORTED_MODULE_5__shared_services_common_service__["a" /* CommonService */]])
    ], RequestBusinessUnitComponent);
    return RequestBusinessUnitComponent;
}());



/***/ }),

/***/ 330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RequestBusinessUnitModule", function() { return RequestBusinessUnitModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_http__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angular2_multiselect_dropdown_angular2_multiselect_dropdown__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_common__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__swimlane_ngx_datatable__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__swimlane_ngx_datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__swimlane_ngx_datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__request_business_unit_routing_module__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__request_business_unit_component__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__add_business_unit_add_business_unit_component__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__business_unit_list_business_unit_list_component__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__view_business_unit_view_business_unit_component__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ng2_translate__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config__ = __webpack_require__(12);
/**
 * Created by shubham on 20/11/18.
 */















var RequestBusinessUnitModule = /** @class */ (function () {
    function RequestBusinessUnitModule() {
    }
    RequestBusinessUnitModule = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
            imports: [
                __WEBPACK_IMPORTED_MODULE_3__angular_material__["a" /* MaterialModule */],
                __WEBPACK_IMPORTED_MODULE_3__angular_material__["e" /* MdTabsModule */],
                __WEBPACK_IMPORTED_MODULE_6__angular_common__["CommonModule"],
                __WEBPACK_IMPORTED_MODULE_7__swimlane_ngx_datatable__["NgxDatatableModule"],
                __WEBPACK_IMPORTED_MODULE_5__angular_forms__["a" /* FormsModule */],
                __WEBPACK_IMPORTED_MODULE_5__angular_forms__["b" /* ReactiveFormsModule */],
                __WEBPACK_IMPORTED_MODULE_4_angular2_multiselect_dropdown_angular2_multiselect_dropdown__["a" /* AngularMultiSelectModule */],
                __WEBPACK_IMPORTED_MODULE_8__request_business_unit_routing_module__["a" /* RequestBusinessUnitRoutingModule */],
                __WEBPACK_IMPORTED_MODULE_13_ng2_translate__["b" /* TranslateModule */].forRoot({
                    provide: __WEBPACK_IMPORTED_MODULE_13_ng2_translate__["c" /* TranslateLoader */],
                    //useFactory: (http: Http) => new TranslateStaticLoader(http, '/assets/i18n', '.json'),
                    useFactory: function (http) { return new __WEBPACK_IMPORTED_MODULE_13_ng2_translate__["a" /* TranslateStaticLoader */](http, __WEBPACK_IMPORTED_MODULE_14__config__["a" /* APPCONFIG */].URL + __WEBPACK_IMPORTED_MODULE_14__config__["a" /* APPCONFIG */].translationUrl, '?v=' + __WEBPACK_IMPORTED_MODULE_14__config__["a" /* APPCONFIG */].translationVersion); },
                    deps: [__WEBPACK_IMPORTED_MODULE_2__angular_http__["b" /* Http */]]
                })
            ],
            declarations: [
                __WEBPACK_IMPORTED_MODULE_9__request_business_unit_component__["a" /* RequestBusinessUnitComponent */],
                __WEBPACK_IMPORTED_MODULE_10__add_business_unit_add_business_unit_component__["a" /* AddBusinessUnitForUserComponent */],
                __WEBPACK_IMPORTED_MODULE_11__business_unit_list_business_unit_list_component__["a" /* BusinessUnitListForUserComponent */],
                __WEBPACK_IMPORTED_MODULE_12__view_business_unit_view_business_unit_component__["a" /* ViewBusinessUnitForUserComponent */]
            ],
            exports: []
        })
    ], RequestBusinessUnitModule);
    return RequestBusinessUnitModule;
}());



/***/ }),

/***/ 331:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewBusinessUnitForUserComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dialog_dialog_component__ = __webpack_require__(11);
/**
 * Created by shubham on 25/11/18.
 */









var ViewBusinessUnitForUserComponent = /** @class */ (function () {
    function ViewBusinessUnitForUserComponent(router, route, sessionHandler, httpService, dialog, formBuilder) {
        var _this = this;
        this.router = router;
        this.route = route;
        this.sessionHandler = sessionHandler;
        this.httpService = httpService;
        this.dialog = dialog;
        this.formBuilder = formBuilder;
        this.businessUnitDetails = [];
        this.applications = [];
        this.isSystemAdmin = false;
        this.isBUManager = false;
        this.isRegionalAdmin = false;
        this.isServiceOwner = false;
        this.isTradePartner = false;
        this.isSubUser = false;
        this.isDisabled = true;
        this.admins = [];
        this.settings = {};
        this.selectedItems = [];
        this.applicationData = [];
        this.route.params.subscribe(function (params) {
            _this.id = params['id'];
        });
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].systemAdmin)) {
                this.isSystemAdmin = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].BUManager)) {
                this.isBUManager = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].serviceOwner)) {
                this.isServiceOwner = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].tradePartner)) {
                this.isTradePartner = true;
            }
            else if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].subuser)) {
                this.isSubUser = true;
            }
        }
        else {
            this.httpService.noUserError();
        }
        if (this.isServiceOwner) {
            this.getBusinessUnitDetailsById(this.id);
        }
    }
    ViewBusinessUnitForUserComponent.prototype.getBusinessUnitDetailsById = function (id) {
        var _this = this;
        this.httpService.getRequest('partnerOperationsApi/v1/businessUnitDetailsForPartner/' + id).subscribe(function (res) { _this.saveBusinessUnitDetails(res); }, function (err) { _this.httpService.onEnd(); });
    };
    ViewBusinessUnitForUserComponent.prototype.saveBusinessUnitDetails = function (res) {
        if (res) {
            this.businessUnitDetails = res;
            if (this.businessUnitDetails['applications']) {
                this.applications = this.businessUnitDetails['applications'];
                for (var appIndex in this.applications) {
                    if (!this.applications[appIndex]['message']) {
                        this.applications[appIndex]['message'] = "";
                    }
                }
            }
            this.httpService.onEnd();
        }
        else if (res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_8__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = 'data_load_failed';
            this.httpService.onEnd();
        }
    };
    ViewBusinessUnitForUserComponent.prototype.requestNewApplication = function (businessUnitId) {
        var _this = this;
        this.httpService.getRequest('applicationOperationApi/v1/getUnsubscribedApplicationsForPartner/' + businessUnitId).subscribe(function (res) { _this.requestNewApplicationResponse(res, businessUnitId); }, function (err) { _this.httpService.onEnd(); });
    };
    ViewBusinessUnitForUserComponent.prototype.requestNewApplicationResponse = function (res, businessUnitId) {
        var _this = this;
        if (res && res.items) {
            this.applicationData = res.items;
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_8__dialog_dialog_component__["b" /* SelectApplicationsDialogComponent */]);
            this.dialogRef.componentInstance.applications = this.applicationData;
            this.dialogRef.componentInstance.businessUnitId = businessUnitId;
            this.dialogRef.afterClosed().subscribe(function (result) {
                if (result) {
                    _this.saveApplications(result);
                }
            });
        }
        this.httpService.onEnd();
    };
    ViewBusinessUnitForUserComponent.prototype.saveApplications = function (result) {
        var _this = this;
        this.httpService.postRequest(result, 'applicationOperationApi/v1/subscribeApplications').subscribe(function (res) { _this.saveBusinessUnitDetails(res); }, function (err) { _this.httpService.onEnd(); });
    };
    ViewBusinessUnitForUserComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'view-business-unit-for-user',
            template: __webpack_require__(1298)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_2__angular_router__["b" /* ActivatedRoute */], __WEBPACK_IMPORTED_MODULE_7__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_6__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_4__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_5__angular_forms__["h" /* FormBuilder */]])
    ], ViewBusinessUnitForUserComponent);
    return ViewBusinessUnitForUserComponent;
}());



/***/ }),

/***/ 332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddEditUserComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_services_session_handler_service__ = __webpack_require__(16);
/**
 * Created by shubham on 24/4/18.
 */









var AddEditUserComponent = /** @class */ (function () {
    function AddEditUserComponent(router, sessionHandler, route, httpService, formBuilder, dialog) {
        this.router = router;
        this.sessionHandler = sessionHandler;
        this.route = route;
        this.httpService = httpService;
        this.formBuilder = formBuilder;
        this.dialog = dialog;
        this.data = [];
        this.emailPattern = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].emailPattern;
        //passwordPattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/;
        this.passwordPattern = /^(?=.*?[A-Za-z])(?=.*?[0-9]).{5,}$/;
        this.settings = {};
        this.LanguageDetails = [];
        this.passwordErrorMsg = '';
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        this.getLanguages();
    }
    AddEditUserComponent.prototype.getLanguages = function () {
        var _this = this;
        this.httpService.getRequest('lookupDataOperationsApi/v1/language').subscribe(function (res) { _this.saveLanguageResponse(res); }, function (err) { _this.httpService.onEnd(); });
    };
    AddEditUserComponent.prototype.validateName = function (event) {
        return __WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].validNameRegex.test(event.key);
    };
    AddEditUserComponent.prototype.saveLanguageResponse = function (res) {
        if (res) {
            if (res.items) {
                this.LanguageDetails = res.items;
            }
        }
        this.httpService.onEnd();
    };
    AddEditUserComponent.prototype.buildForm = function () {
        var _this = this;
        this.UserForm = this.formBuilder.group({
            firstName: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].required]),
            lastName: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].required]),
            password: this.formBuilder.control('', [__WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].minLength(8), __WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].maxLength(8), __WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].pattern(this.passwordPattern)]),
            confirmPassword: this.formBuilder.control('', [__WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].required]),
            email: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].pattern(this.emailPattern)]),
            languageId: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_6__angular_forms__["g" /* Validators */].required]),
        }, { validator: this.checkPasswords });
        this.UserForm.valueChanges.subscribe(function (data) {
            _this.UserFormDetails = _this.UserForm.getRawValue();
            _this.UserFormDetails.validate = _this.UserForm.valid;
        });
        this.UserForm.get('password').valueChanges.subscribe(function (data) {
            _this.validatePassword(data);
        });
    };
    AddEditUserComponent.prototype.validatePassword = function (data) {
        var firstName = this.UserForm.get('firstName').value || '';
        var lastName = this.UserForm.get('lastName').value || '';
        if (data != null) {
            this.UserForm.get('password').setErrors({ 'incorrect': true });
            var hasUpper = /[A-Z]/.test(data);
            var hasLower = /[a-z]/.test(data);
            var hasDigit = /[0-9]/.test(data);
            var minLength = data.length >= 8;
            var validSymbols = /^[a-zA-Z0-9!@#$%&*?]*$/.test(data);
            var containsFirstName = firstName && data.toLowerCase().includes(firstName.toLowerCase());
            var containsLastName = lastName && data.toLowerCase().includes(lastName.toLowerCase());
            if (!hasUpper || !hasLower) {
                this.passwordErrorMsg = "pass_one_upper_lower_char";
            }
            else if (!hasDigit) {
                this.passwordErrorMsg = "pass_one_number";
            }
            else if (!minLength) {
                this.passwordErrorMsg = "pass_least_8_chars";
            }
            else if (data.toLowerCase().includes(this.userDetails.userId_WPASS.toLowerCase())) {
                this.passwordErrorMsg = "pass_no_userId";
            }
            else if (!validSymbols) {
                this.passwordErrorMsg = "pass_invalid_symbol"; //new
            }
            else if (containsFirstName) {
                this.passwordErrorMsg = "pass_contains_firstname"; //new
            }
            else if (containsLastName) {
                this.passwordErrorMsg = "pass_contains_lastname"; //new
            }
            else {
                this.passwordErrorMsg = "";
                this.UserForm.get('password').setErrors(null);
                return true;
            }
        }
        return false;
    };
    AddEditUserComponent.prototype.showPassword = function (input) {
        input.type = input.type === 'password' ? 'text' : 'password';
    };
    AddEditUserComponent.prototype.checkPasswords = function (group) {
        if (group.get('password').value === group.get('confirmPassword').value) {
            group.get('confirmPassword').setErrors(null);
            return null;
        }
        else {
            group.get('confirmPassword').setErrors({ 'incorrect': true });
            return { 'mismatch': true };
        }
    };
    AddEditUserComponent.prototype.saveUserData = function () {
        var _this = this;
        if (!this.validatePassword(this.UserForm.get('password').value)) {
            return;
        }
        this.httpService.postRequest(this.UserFormDetails, 'partnerOperationsApi/v1/createCompanyUser').subscribe(function (res) { _this.saveResponse(res); }, function (err) { _this.httpService.onEnd(); });
    };
    AddEditUserComponent.prototype.saveResponse = function (res) {
        var _this = this;
        if (res.errorStatus == 'Fail') {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = 'user_creation_failed';
        }
        else {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = "registration_rqst_notify";
            //this.dialogRef.componentInstance.msg = "User Created Successfully";
            this.dialogRef.afterClosed().subscribe(function (result) {
                _this.router.navigateByUrl('/app/partners-dashboard');
            });
        }
    };
    AddEditUserComponent.prototype.ngOnInit = function () {
        this.buildForm();
    };
    AddEditUserComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            template: __webpack_require__(1299)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_3__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_8__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_3__angular_router__["b" /* ActivatedRoute */], __WEBPACK_IMPORTED_MODULE_4__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_6__angular_forms__["h" /* FormBuilder */], __WEBPACK_IMPORTED_MODULE_5__angular_material__["c" /* MdDialog */]])
    ], AddEditUserComponent);
    return AddEditUserComponent;
}());



/***/ }),

/***/ 333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_services_common_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ng2_translate__ = __webpack_require__(17);
/**
 * Created by shubham on 24/4/18.
 */








var UserComponent = /** @class */ (function () {
    function UserComponent(router, route, httpService, sessionHandler, dialog, translate, commonService) {
        var _this = this;
        this.router = router;
        this.route = route;
        this.httpService = httpService;
        this.sessionHandler = sessionHandler;
        this.dialog = dialog;
        this.translate = translate;
        this.commonService = commonService;
        this.data = [];
        this.languageId = this.sessionHandler.getItem('languageId');
        if (!this.languageId) {
            this.languageId = "EN";
        }
        this.translate.use(this.languageId);
        this.commonService.userData.subscribe(function (value) {
            _this.data = value;
        });
    }
    UserComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            template: __webpack_require__(1300)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_2__angular_router__["b" /* ActivatedRoute */], __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_6__shared_services_session_handler_service__["a" /* SessionHandler */],
            __WEBPACK_IMPORTED_MODULE_4__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_7_ng2_translate__["d" /* TranslateService */], __WEBPACK_IMPORTED_MODULE_5__shared_services_common_service__["a" /* CommonService */]])
    ], UserComponent);
    return UserComponent;
}());



/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserModule", function() { return UserModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_http__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angular2_multiselect_dropdown_angular2_multiselect_dropdown__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_common__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user_routing_module__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__user_component__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__add_edit_user_add_edit_user_component__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ng2_translate__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(12);
/**
 * Created by shubham on 16/4/18.
 */












var UserModule = /** @class */ (function () {
    function UserModule() {
    }
    UserModule = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
            imports: [
                __WEBPACK_IMPORTED_MODULE_3__angular_material__["a" /* MaterialModule */],
                __WEBPACK_IMPORTED_MODULE_3__angular_material__["e" /* MdTabsModule */],
                __WEBPACK_IMPORTED_MODULE_6__angular_common__["CommonModule"],
                __WEBPACK_IMPORTED_MODULE_5__angular_forms__["a" /* FormsModule */],
                __WEBPACK_IMPORTED_MODULE_5__angular_forms__["b" /* ReactiveFormsModule */],
                __WEBPACK_IMPORTED_MODULE_4_angular2_multiselect_dropdown_angular2_multiselect_dropdown__["a" /* AngularMultiSelectModule */],
                __WEBPACK_IMPORTED_MODULE_7__user_routing_module__["a" /* UserRoutingModule */],
                __WEBPACK_IMPORTED_MODULE_10_ng2_translate__["b" /* TranslateModule */].forRoot({
                    provide: __WEBPACK_IMPORTED_MODULE_10_ng2_translate__["c" /* TranslateLoader */],
                    //useFactory: (http: Http) => new TranslateStaticLoader(http, '/assets/i18n', '.json'),
                    useFactory: function (http) { return new __WEBPACK_IMPORTED_MODULE_10_ng2_translate__["a" /* TranslateStaticLoader */](http, __WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].URL + __WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].translationUrl, '?v=' + __WEBPACK_IMPORTED_MODULE_11__config__["a" /* APPCONFIG */].translationVersion); },
                    deps: [__WEBPACK_IMPORTED_MODULE_2__angular_http__["b" /* Http */]]
                })
            ],
            declarations: [
                __WEBPACK_IMPORTED_MODULE_8__user_component__["a" /* UserComponent */],
                __WEBPACK_IMPORTED_MODULE_9__add_edit_user_add_edit_user_component__["a" /* AddEditUserComponent */]
            ],
            exports: []
        })
    ], UserModule);
    return UserModule;
}());



/***/ }),

/***/ 335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewRequestModule", function() { return ViewRequestModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_http__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_common__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_request_routing_module__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__approve_reject_request_approve_reject_request_module__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__view_request_component__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__viewPartners_viewPartners_component__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__viewSubUsers_viewSubUsers_component__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__viewApplicationRequest_viewApplicationRequest_component__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angular2_multiselect_dropdown_angular2_multiselect_dropdown__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ng2_translate__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config__ = __webpack_require__(12);
/**
 * Created by shubham on 16/4/18.
 */















var ViewRequestModule = /** @class */ (function () {
    function ViewRequestModule() {
    }
    ViewRequestModule = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
            imports: [
                __WEBPACK_IMPORTED_MODULE_2__angular_material__["a" /* MaterialModule */],
                __WEBPACK_IMPORTED_MODULE_2__angular_material__["e" /* MdTabsModule */],
                __WEBPACK_IMPORTED_MODULE_5__angular_common__["CommonModule"],
                __WEBPACK_IMPORTED_MODULE_4__angular_forms__["a" /* FormsModule */],
                __WEBPACK_IMPORTED_MODULE_4__angular_forms__["b" /* ReactiveFormsModule */],
                __WEBPACK_IMPORTED_MODULE_6__view_request_routing_module__["a" /* RequestRoutingModule */],
                __WEBPACK_IMPORTED_MODULE_12_angular2_multiselect_dropdown_angular2_multiselect_dropdown__["a" /* AngularMultiSelectModule */],
                __WEBPACK_IMPORTED_MODULE_7__approve_reject_request_approve_reject_request_module__["a" /* ApproveRejectRequestModule */],
                __WEBPACK_IMPORTED_MODULE_13_ng2_translate__["b" /* TranslateModule */].forRoot({
                    provide: __WEBPACK_IMPORTED_MODULE_13_ng2_translate__["c" /* TranslateLoader */],
                    //useFactory: (http: Http) => new TranslateStaticLoader(http, '/assets/i18n', '.json'),
                    useFactory: function (http) { return new __WEBPACK_IMPORTED_MODULE_13_ng2_translate__["a" /* TranslateStaticLoader */](http, __WEBPACK_IMPORTED_MODULE_14__config__["a" /* APPCONFIG */].URL + __WEBPACK_IMPORTED_MODULE_14__config__["a" /* APPCONFIG */].translationUrl, '?v=' + __WEBPACK_IMPORTED_MODULE_14__config__["a" /* APPCONFIG */].translationVersion); },
                    deps: [__WEBPACK_IMPORTED_MODULE_3__angular_http__["b" /* Http */]]
                })
            ],
            declarations: [
                __WEBPACK_IMPORTED_MODULE_8__view_request_component__["b" /* ViewRequestComponent */],
                __WEBPACK_IMPORTED_MODULE_9__viewPartners_viewPartners_component__["a" /* ViewPartnersRequestComponent */],
                __WEBPACK_IMPORTED_MODULE_10__viewSubUsers_viewSubUsers_component__["a" /* ViewSubUsersRequestComponent */],
                __WEBPACK_IMPORTED_MODULE_11__viewApplicationRequest_viewApplicationRequest_component__["a" /* ViewApplicationRequestComponent */]
            ],
            exports: []
        })
    ], ViewRequestModule);
    return ViewRequestModule;
}());



/***/ }),

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewApplicationRequestComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dialog_dialog_component__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_services_common_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ng2_translate__ = __webpack_require__(17);
/**
 * Created by shubham on 11/10/18.
 */












var ViewApplicationRequestComponent = /** @class */ (function () {
    function ViewApplicationRequestComponent(route, httpService, formBuilder, dialog, commonService, sessionHandler, translate) {
        var _this = this;
        this.route = route;
        this.httpService = httpService;
        this.formBuilder = formBuilder;
        this.dialog = dialog;
        this.commonService = commonService;
        this.sessionHandler = sessionHandler;
        this.translate = translate;
        this.isApproved = false;
        this.isReject = false;
        this.roles = [];
        this.settings = {};
        this.selectedItems = [];
        this.showApproveButton = false;
        this.settingSingleField = {
            singleSelection: true,
            text: "Select Role",
            labelKey: "name",
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            classes: "myclass custom-class",
            disabled: false
        };
        this.settingMultipleField = {
            singleSelection: false,
            text: "Select Role",
            labelKey: "name",
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            classes: "myclass custom-class",
            disabled: false
        };
        this.applicationText = 'applicationManagerView';
        //Get URL param value
        this.route.params.subscribe(function (params) {
            _this.urlId = params['id'];
            if (_this.urlId != undefined || _this.urlId != null) {
                _this.getApplicationRequestDataById(_this.urlId);
            }
        });
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* APPCONFIG */].systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* APPCONFIG */].applicationManager)) {
                this.isApplicationManager = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* APPCONFIG */].BUManager)) {
                this.isBUManager = true;
            }
        }
        else {
            this.httpService.noUserError();
        }
    }
    ViewApplicationRequestComponent.prototype.getApplicationRequestDataById = function (urlId) {
        var _this = this;
        this.httpService.getRequest("applicationOperationApi/v1/applicationRequestsById/" + this.urlId).subscribe(function (res) { _this.saveApplicationRequestDataById(res); }, function (err) { _this.httpService.onEnd(); });
    };
    ViewApplicationRequestComponent.prototype.saveApplicationRequestDataById = function (res) {
        if (res) {
            this.ApplicationsRequestData = res;
            this.commonService.changeViewData(this.ApplicationsRequestData, 'appView');
            if (this.ApplicationsRequestData) {
                if (this.ApplicationsRequestData.multipleRole) {
                    this.settings = this.settingMultipleField;
                }
                else {
                    this.settings = this.settingSingleField;
                }
                if (this.ApplicationsRequestData.applicationRoles) {
                    this.roles = this.ApplicationsRequestData.applicationRoles;
                }
                if (this.ApplicationsRequestData.selectedRoles) {
                    for (var l in this.ApplicationsRequestData.selectedRoles) {
                        this.selectedItems.push({ id: this.ApplicationsRequestData.selectedRoles[l]['id'], name: this.ApplicationsRequestData.selectedRoles[l]['name'] });
                    }
                }
            }
        }
        this.httpService.onEnd();
    };
    ViewApplicationRequestComponent.prototype.buildForm = function () {
        var _this = this;
        this.ApplicationsRequestForm = this.formBuilder.group({
            selectedRoles: this.formBuilder.control(null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["g" /* Validators */].required])
        });
        this.ApplicationsRequestForm.valueChanges.subscribe(function (data) {
            _this.ApplicationsRequestFormDetails = _this.ApplicationsRequestForm.getRawValue();
            if (_this.urlId) {
                _this.ApplicationsRequestFormDetails['id'] = _this.urlId;
            }
            if (_this.ApplicationsRequestFormDetails['selectedRoles'].length > 0) {
                _this.showApproveButton = false;
            }
            else {
                _this.showApproveButton = true;
            }
            _this.ApplicationsRequestFormDetails.validate = _this.ApplicationsRequestForm.valid;
        });
    };
    ViewApplicationRequestComponent.prototype.saveApplicationData = function () {
        var _this = this;
        if (this.ApplicationsRequestFormDetails['selectedRoles'].length <= 0) {
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_5__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.isConfirm = true;
            this.dialogRef.componentInstance.msg = "app_revoke_confirm";
            this.dialogRef.afterClosed().subscribe(function (result) {
                if (result) {
                    _this.saveApplicationDataApi();
                }
            });
        }
        else {
            this.saveApplicationDataApi();
        }
    };
    ViewApplicationRequestComponent.prototype.saveApplicationDataApi = function () {
        var _this = this;
        this.httpService.postRequest(this.ApplicationsRequestFormDetails, 'applicationOperationApi/v1/updateUserApplicationRoles').subscribe(function (res) {
            _this.saveApplicationResponse(res);
        }, function (err) { _this.httpService.onEnd(); });
    };
    ViewApplicationRequestComponent.prototype.saveApplicationResponse = function (res) {
        if (res) {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_5__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = "Request submitted successfully.";
            this.dialogRef.afterClosed().subscribe(function (result) {
                window.location.href = '#/app/application-manager-dashboard';
            });
        }
        else if (res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_5__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = 'save_failed';
            this.httpService.onEnd();
        }
    };
    ViewApplicationRequestComponent.prototype.appAction = function (status) {
        var _this = this;
        this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_5__dialog_dialog_component__["h" /* ApplicationRejectActionDialogComponent */]);
        var actionStatus = "";
        if (status == 'APPROVED') {
            actionStatus = 'APPROVE';
            this.dialogRef.componentInstance.msg = 'rqst_approve_confirm';
            this.dialogRef.componentInstance.isApproved = true;
        }
        else if (status == 'REJECTED') {
            actionStatus = 'REJECT';
            this.dialogRef.componentInstance.msg = 'rqst_rjct_confirm';
            this.dialogRef.componentInstance.isRejected = true;
        }
        this.dialogRef.afterClosed().subscribe(function (result) {
            if (result) {
                var data = {};
                data['id'] = _this.urlId;
                data['status'] = status;
                if (status == "REJECTED") {
                    data['message'] = result;
                }
                else {
                    data['selectedRoles'] = _this.ApplicationsRequestFormDetails['selectedRoles'];
                }
                var today = new Date();
                var dd = ('0' + today.getDate()).slice(-2);
                var mm = ('0' + (today.getMonth() + 1)).slice(-2);
                var yyyy = today.getFullYear();
                data['approvalDate'] = yyyy + '' + mm + '' + dd;
                _this.httpService.postRequest(data, 'applicationOperationApi/v1/approveApplicationRequest').subscribe(function (res) {
                    _this.saveResponse(res, status);
                }, function (err) {
                    _this.httpService.onEnd();
                });
            }
        });
    };
    ViewApplicationRequestComponent.prototype.saveResponse = function (res, status) {
        this.httpService.onEnd();
        var statusTxt;
        if (res) {
            if (status == 'APPROVED') {
                statusTxt = 'Approval process initiated. It will take time. User will be notified on mail.';
            }
            else {
                statusTxt = 'Rejected Successfully';
            }
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_5__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = statusTxt;
            this.dialogRef.afterClosed().subscribe(function (result) {
                window.location.href = '#/app/application-manager-dashboard';
            });
        }
    };
    ViewApplicationRequestComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.buildForm();
        this.translate.get('Select Role').subscribe(function (res) {
            _this.settingSingleField.text = res;
            _this.settingMultipleField.text = res;
        });
        this.translate.get('select_all').subscribe(function (res) {
            _this.settingSingleField.selectAllText = res;
            _this.settingMultipleField.selectAllText = res;
        });
        this.translate.get('unselect_all').subscribe(function (res) {
            _this.settingSingleField.unSelectAllText = res;
            _this.settingMultipleField.unSelectAllText = res;
        });
    };
    ViewApplicationRequestComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'application-request',
            template: __webpack_require__(1303),
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["b" /* ActivatedRoute */], __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_4__angular_forms__["h" /* FormBuilder */], __WEBPACK_IMPORTED_MODULE_6__angular_material__["c" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_7__shared_services_common_service__["a" /* CommonService */], __WEBPACK_IMPORTED_MODULE_8__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_10_ng2_translate__["d" /* TranslateService */]])
    ], ViewApplicationRequestComponent);
    return ViewApplicationRequestComponent;
}());



/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewPartnersRequestComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_error_handler_service__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_services_common_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dialog_dialog_component__ = __webpack_require__(11);
/**
 * Created by shubham on 16/4/18.
 */









var ViewPartnersRequestComponent = /** @class */ (function () {
    function ViewPartnersRequestComponent(router, route, httpService, dialog, commonService, sessionHandler) {
        var _this = this;
        this.router = router;
        this.route = route;
        this.httpService = httpService;
        this.dialog = dialog;
        this.commonService = commonService;
        this.sessionHandler = sessionHandler;
        this.formData = {};
        this.businessUnitsFlag = false;
        this.wPassIdFlag = false;
        this.companyPhoneFlag = false;
        this.ownerFlag = false;
        this.businessUnitWithApplicationAndRoles = [];
        this.businessUnitWithAppRoles = [];
        this.updatingBuAppId = '';
        this.emailUpdating = false;
        this.allCustomerNumberChecked = false;
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        this.route.params.subscribe(function (params) {
            _this.id = +params['id'];
        });
        if (this.userDetails) {
            this.getRequestDataWithId();
        }
        else {
            this.httpService.noUserError();
        }
        this.commonService.partnersView.subscribe(function (value) {
            _this.getRequestDataWithId();
        });
    }
    ViewPartnersRequestComponent.prototype.getRequestDataWithId = function () {
        var _this = this;
        this.httpService.getRequest('userRegistrationsApi/v1/user?userId=' + this.id + "&allRoles=false&applicationStatus=approve").subscribe(function (res) { _this.saveRequestData(res); }, function (err) { _this.httpService.onEnd(); });
    };
    ViewPartnersRequestComponent.prototype.saveRequestData = function (res) {
        if (res) {
            this.formData = res;
            console.log(this.formData);
            this.commonService.changeViewData(this.formData, 'partnersView');
            if (this.formData) {
                if (this.formData.businessUnits) {
                    this.businessUnitsFlag = true;
                }
                if (this.formData.userId_WPASS) {
                    this.wPassIdFlag = true;
                }
                if (this.formData.companyPhone) {
                    this.companyPhoneFlag = true;
                }
                if (this.formData.ownerWpassId) {
                    this.ownerFlag = true;
                }
                if (this.formData.businessUnitWithApplicationAndRoles) {
                    this.businessUnitWithAppRoles = [];
                    this.businessUnitWithApplicationAndRoles = this.formData.businessUnitWithApplicationAndRoles;
                    for (var businessUnit in this.businessUnitWithApplicationAndRoles) {
                        for (var appAndRoles in this.businessUnitWithApplicationAndRoles[businessUnit]['applications']) {
                            var temp = [];
                            temp['buAppId'] = this.businessUnitWithApplicationAndRoles[businessUnit]['businessUnitId'] + '-' + this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles]['applicationId'];
                            temp['businessUnitName'] = this.businessUnitWithApplicationAndRoles[businessUnit]['businessUnitName'];
                            temp['customerNumber'] = this.businessUnitWithApplicationAndRoles[businessUnit]['customerNumber'];
                            temp['applicationName'] = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles]['applicationName'];
                            temp['selectedRoleNames'] = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles]['selectedRoleNames'];
                            temp['url'] = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles]['url'];
                            var actionObject = {};
                            if (this.businessUnitWithApplicationAndRoles[businessUnit]['statusCode'] != 'APPROVED') {
                                actionObject = this.businessUnitWithApplicationAndRoles[businessUnit];
                            }
                            else {
                                actionObject = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles];
                            }
                            temp['statusCode'] = actionObject['statusCode'];
                            temp['status'] = actionObject['status'];
                            temp['message'] = actionObject['message'];
                            this.businessUnitWithAppRoles.push(temp);
                        }
                    }
                }
            }
            this.httpService.onEnd();
        }
        else if (res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_8__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = 'data_load_failed';
            this.httpService.onEnd();
        }
    };
    ViewPartnersRequestComponent.prototype.showApplicationsWithRoles = function (apps) {
        this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_8__dialog_dialog_component__["k" /* ShowApplicationsDialogComponent */]);
        for (var appIndex in apps) {
            if (!apps[appIndex]['message']) {
                apps[appIndex]['message'] = "";
            }
        }
        this.dialogRef.componentInstance.apps = apps;
        this.dialogRef.componentInstance.profileFlag = true;
    };
    ViewPartnersRequestComponent.prototype.initUpdateCustomerNumber = function (buAppId) {
        this.updatingBuAppId = buAppId;
    };
    ViewPartnersRequestComponent.prototype.updateCustomerNumber = function (buAppId) {
        var _this = this;
        var newCustomerNumber = $('#cn-' + buAppId).val();
        buAppId = buAppId.split('-')[0];
        console.log('newCustomerNumber:' + newCustomerNumber + ', buAppId:' + buAppId);
        if (!newCustomerNumber) {
            this.updatingBuAppId = '';
            return;
        }
        this.httpService.postRequest({ customerNumber: newCustomerNumber, businessUnitId: buAppId, customerNumberMandatory: this.allCustomerNumberChecked, id: this.id }, 'userRegistrationsApi/v1/updateCustomerNumber').subscribe(function (res) {
            _this.httpService.onEnd();
            window.location.reload();
        }, function (err) { _this.httpService.onEnd(); });
    };
    ViewPartnersRequestComponent.prototype.cancelUpdateCustomerNumber = function (buAppId) {
        this.updatingBuAppId = '';
    };
    ViewPartnersRequestComponent.prototype.customerNumberUpdating = function (buAppId) {
        return this.updatingBuAppId == buAppId;
    };
    ViewPartnersRequestComponent.prototype.updateEmail = function () {
        var _this = this;
        var newEmail = $('#newEmail').val();
        console.log('newEmail:' + newEmail);
        if (!newEmail) {
            this.emailUpdating = false;
            return;
        }
        this.httpService.postRequest({ email: newEmail, id: this.id }, 'userRegistrationsApi/v1/updateEmail').subscribe(function (res) {
            _this.httpService.onEnd();
            window.location.reload();
        }, function (err) { _this.httpService.onEnd(); });
    };
    ViewPartnersRequestComponent.prototype.initUpdateEmail = function () {
        this.emailUpdating = true;
    };
    ViewPartnersRequestComponent.prototype.cancelUpdateEmail = function () {
        this.emailUpdating = false;
    };
    ViewPartnersRequestComponent.prototype.isEmailUpdating = function () {
        return this.emailUpdating;
    };
    ViewPartnersRequestComponent.prototype.toggleAllCustomerNumberCheck = function () {
        this.allCustomerNumberChecked = !this.allCustomerNumberChecked;
    };
    ViewPartnersRequestComponent.prototype.ngOnInit = function () { };
    ViewPartnersRequestComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'partners-request-view',
            template: __webpack_require__(1304),
            providers: [__WEBPACK_IMPORTED_MODULE_4__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_3__shared_services_error_handler_service__["a" /* ErrorHandler */]]
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_2__angular_router__["b" /* ActivatedRoute */], __WEBPACK_IMPORTED_MODULE_4__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_7__angular_material__["c" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_6__shared_services_common_service__["a" /* CommonService */], __WEBPACK_IMPORTED_MODULE_5__shared_services_session_handler_service__["a" /* SessionHandler */]])
    ], ViewPartnersRequestComponent);
    return ViewPartnersRequestComponent;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)))

/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewSubUsersRequestComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_error_handler_service__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_services_common_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dialog_dialog_component__ = __webpack_require__(11);
/**
 * Created by shubham on 26/4/18.
 */









var ViewSubUsersRequestComponent = /** @class */ (function () {
    function ViewSubUsersRequestComponent(router, route, httpService, dialog, commonService, sessionHandler) {
        var _this = this;
        this.router = router;
        this.route = route;
        this.httpService = httpService;
        this.dialog = dialog;
        this.commonService = commonService;
        this.sessionHandler = sessionHandler;
        this.formData = {};
        this.businessUnitsFlag = false;
        this.wPassIdFlag = false;
        this.businessUnitWithApplicationAndRoles = [];
        this.businessUnitWithAppRolesSubPartner = [];
        this.ownerFlag = false;
        this.emailUpdating = false;
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        this.route.params.subscribe(function (params) {
            _this.id = +params['id'];
        });
        if (this.userDetails) {
            this.getRequestDataWithId();
        }
        else {
            this.httpService.noUserError();
        }
        this.commonService.subUsersView.subscribe(function (value) {
            _this.getRequestDataWithId();
        });
    }
    ViewSubUsersRequestComponent.prototype.getRequestDataWithId = function () {
        var _this = this;
        this.httpService.getRequest('partnerOperationsApi/v1/companyUser/' + this.id).subscribe(function (res) { _this.saveRequestData(res); }, function (err) { _this.httpService.onEnd(); });
    };
    ViewSubUsersRequestComponent.prototype.saveRequestData = function (res) {
        if (res) {
            this.formData = res;
            this.commonService.changeViewData(this.formData, 'subUsersView');
            if (this.formData) {
                if (this.formData.userId_WPASS) {
                    this.wPassIdFlag = true;
                }
                if (this.formData.ownerWpassId) {
                    this.ownerFlag = true;
                }
                /*if(this.formData.businessUnitWithApplicationAndRoles){
                    this.businessUnitWithApplicationAndRoles = this.formData.businessUnitWithApplicationAndRoles;

                    for(let appIndex in this.businessUnitWithApplicationAndRoles){
                        if(!this.businessUnitWithApplicationAndRoles[appIndex]['message']){
                            this.businessUnitWithApplicationAndRoles[appIndex]['message'] = "";
                        }
                    }
                }*/
                if (this.formData.businessUnitWithApplicationAndRoles) {
                    this.businessUnitWithApplicationAndRoles = this.formData.businessUnitWithApplicationAndRoles;
                    for (var businessUnit in this.businessUnitWithApplicationAndRoles) {
                        for (var appAndRoles in this.businessUnitWithApplicationAndRoles[businessUnit]['applications']) {
                            var temp = [];
                            temp['businessUnitName'] = this.businessUnitWithApplicationAndRoles[businessUnit]['businessUnitName'];
                            temp['customerNumber'] = this.businessUnitWithApplicationAndRoles[businessUnit]['customerNumber'];
                            temp['applicationName'] = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles]['applicationName'];
                            temp['selectedRoleNames'] = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles]['selectedRoleNames'];
                            temp['url'] = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles]['url'];
                            var actionObject = {};
                            if (this.businessUnitWithApplicationAndRoles[businessUnit]['statusCode'] != 'APPROVED') {
                                actionObject = this.businessUnitWithApplicationAndRoles[businessUnit];
                            }
                            else {
                                actionObject = this.businessUnitWithApplicationAndRoles[businessUnit]['applications'][appAndRoles];
                            }
                            temp['statusCode'] = actionObject['statusCode'];
                            temp['status'] = actionObject['status'];
                            temp['message'] = actionObject['message'];
                            this.businessUnitWithAppRolesSubPartner.push(temp);
                        }
                    }
                }
            }
            this.httpService.onEnd();
        }
        else if (res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_8__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = 'data_load_failed';
            this.httpService.onEnd();
        }
    };
    ViewSubUsersRequestComponent.prototype.updateEmail = function () {
        var _this = this;
        var newEmail = $('#newEmail').val();
        console.log('newEmail:' + newEmail);
        if (!newEmail) {
            this.emailUpdating = false;
            return;
        }
        this.httpService.postRequest({ email: newEmail, id: this.id }, 'userRegistrationsApi/v1/updateEmail').subscribe(function (res) {
            _this.httpService.onEnd();
            window.location.reload();
        }, function (err) { _this.httpService.onEnd(); });
    };
    ViewSubUsersRequestComponent.prototype.initUpdateEmail = function () {
        this.emailUpdating = true;
    };
    ViewSubUsersRequestComponent.prototype.cancelUpdateEmail = function () {
        this.emailUpdating = false;
    };
    ViewSubUsersRequestComponent.prototype.isEmailUpdating = function () {
        return this.emailUpdating;
    };
    ViewSubUsersRequestComponent.prototype.showApplicationsWithRoles = function (apps) {
        this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_8__dialog_dialog_component__["k" /* ShowApplicationsDialogComponent */]);
        for (var appIndex in apps) {
            if (!apps[appIndex]['message']) {
                apps[appIndex]['message'] = "";
            }
        }
        this.dialogRef.componentInstance.apps = apps;
        this.dialogRef.componentInstance.profileFlag = true;
    };
    ViewSubUsersRequestComponent.prototype.ngOnInit = function () { };
    ViewSubUsersRequestComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'subusers-request-view',
            template: __webpack_require__(1305),
            providers: [__WEBPACK_IMPORTED_MODULE_4__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_3__shared_services_error_handler_service__["a" /* ErrorHandler */]]
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_2__angular_router__["b" /* ActivatedRoute */], __WEBPACK_IMPORTED_MODULE_4__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_7__angular_material__["c" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_6__shared_services_common_service__["a" /* CommonService */], __WEBPACK_IMPORTED_MODULE_5__shared_services_session_handler_service__["a" /* SessionHandler */]])
    ], ViewSubUsersRequestComponent);
    return ViewSubUsersRequestComponent;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)))

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayoutService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angular2_toaster__ = __webpack_require__(343);





var LayoutService = /** @class */ (function () {
    function LayoutService(toasterService) {
        this.toasterService = toasterService;
        this.toasterConfig = new __WEBPACK_IMPORTED_MODULE_4_angular2_toaster__["b" /* ToasterConfig */]({
            timeout: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].toasterDefaultTimeOut,
            positionClass: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].toasterDefaultPositionClass
        });
        this.preloaderStateSource = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
        this.preloaderState$ = this.preloaderStateSource.asObservable();
        this.searchOverlaySource = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
        this.searchOverlayState$ = this.searchOverlaySource.asObservable();
    }
    LayoutService.prototype.popToastWithTimeOut = function (title, type, timeout) {
        var toast = { type: type, body: title, timeout: timeout };
        this.toasterService.pop(toast);
    };
    LayoutService.prototype.popToast = function (title, type) {
        var toast = { type: type, body: title };
        this.toasterService.pop(toast);
    };
    LayoutService.prototype.updatePreloaderState = function (state) {
        // console.log('preloader state: ' + state)
        this.preloaderStateSource.next(state);
    };
    LayoutService.prototype.updateSearchOverlayState = function (state) {
        // console.log('overlay state: ' + state)
        this.searchOverlaySource.next(state);
    };
    LayoutService = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_4_angular2_toaster__["c" /* ToasterService */]])
    ], LayoutService);
    return LayoutService;
}());



/***/ }),

/***/ 723:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createTranslateLoader */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_http__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser_animations__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_hammerjs__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_hammerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_hammerjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_routing_module__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_component__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__layout_layout_component__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__layout_preloader_directive__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__layout_header_header_component__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__layout_sidenav_sidenav_component__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__layout_sidenav_toggle_offcanvas_nav_directive__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__layout_sidenav_auto_close_mobile_nav_directive__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__layout_sidenav_sidenav_menu_sidenav_menu_component__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__layout_sidenav_sidenav_menu_accordion_nav_directive__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__layout_sidenav_sidenav_menu_append_submenu_icon_directive__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__layout_sidenav_sidenav_menu_highlight_active_items_directive__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__layout_customizer_customizer_component__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__layout_customizer_toggle_quickview_directive__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_ng2_daterangepicker__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_ng2_daterangepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_ng2_daterangepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__layout_footer_footer_component__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__layout_search_overlay_search_overlay_component__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__layout_search_overlay_search_overlay_directive__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__layout_search_overlay_open_search_overlay_directive__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__loader_loader_component__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__loader_loader_service__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__shared_services_common_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__login_login_component__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__registration_registration_component__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__forgot_password_forgotPassword_component__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__unlock_account_UnlockAccountComponent__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__system_level_setting_wpass_wpass_component__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__admin_dashboard_admin_dashboard_component__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__partners_dashboard_partners_dashboard_component__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__applications_manager_dashboard_applications_manager_dashboard_component__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__profile_profile_component__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__page_layouts_fullscreen_fullscreen_component__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__dialog_dialog_component__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__viewRequest_view_request_component__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__swimlane_ngx_datatable__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__swimlane_ngx_datatable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__swimlane_ngx_datatable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__approve_reject_request_approve_reject_request_module__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__multi_approve_reject_multi_approve_reject_request_module__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__activate_deactivate_request_activate_deactivate_request_module__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__layout_layout_module__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__shared_shared_module__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_angular2_toaster__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_angular2_multiselect_dropdown_angular2_multiselect_dropdown__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__viewRequest_view_request_module__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__system_level_setting_adminManagement_adminManagement_module__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__system_level_setting_managerAssignment_managerAssignment_module__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__user_user_module__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__user_operations_request_business_unit_request_business_unit_module__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__file_upload_fileUpload_module__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_mydatepicker__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__angularclass_hmr__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__angularclass_hmr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__angularclass_hmr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__shared_services_error_handler_service__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__adminDashboardResultService__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__partnersDashboardResultService__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__applicationsManagerDashboardResultService__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__system_level_setting_adminManagement_adminListDashboardResultService__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__system_level_setting_applicationManagement_applicationListDashboardResultService__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__system_level_setting_businessUnitManagement_businessUnitDashboardResultService__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__system_level_setting_managerAssignment_managerListDashboardResultService__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__file_upload_fileUploadListDashboardResultService__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__user_operations_request_business_unit_businessUnitForUserDashboardResultService__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__shared_directive_blockCutCopyPaste_directive__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_ng2_input_autocomplete__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_ng2_translate__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__system_level_setting_applicationManagement_applicationManagement_module__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__app_user_activity_logs_user_activity_logs_component__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__app_translation_messages_translation_messages_component__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__app_user_activity_logs_user_activity_datatable_userActivityResultService__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__app_translation_email_translation_email_component__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_ng2_ckeditor__ = __webpack_require__(1238);











// Layout


// Header

// Sidenav







// Customizer


//date range picker

// Footer

// Search Overaly






// Pages





















// Sub modules















// hmr

//Services












//Directive

// multilingual








//import { CKEditorModule } from 'ckeditor4-angular';

function createTranslateLoader(http) {
    //return new TranslateStaticLoader(http, './assets/i18n', '.json');
    return new __WEBPACK_IMPORTED_MODULE_72_ng2_translate__["a" /* TranslateStaticLoader */](http, __WEBPACK_IMPORTED_MODULE_78__config__["a" /* APPCONFIG */].URL + __WEBPACK_IMPORTED_MODULE_78__config__["a" /* APPCONFIG */].translationUrl, '?v=' + __WEBPACK_IMPORTED_MODULE_78__config__["a" /* APPCONFIG */].translationVersion);
}
var AppModule = /** @class */ (function () {
    function AppModule(appRef) {
        this.appRef = appRef;
        // console.log = function(){};
        // console.error = function(){};
        // window.alert = function(){}
    }
    AppModule.prototype.hmrOnInit = function (store) {
        console.log('HMR store', store);
    };
    AppModule.prototype.hmrOnDestroy = function (store) {
        var cmpLocation = this.appRef.components.map(function (cmp) { return cmp.location.nativeElement; });
        // recreate elements
        store.disposeOldHosts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_57__angularclass_hmr__["createNewHosts"])(cmpLocation);
        // remove styles
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_57__angularclass_hmr__["removeNgStyles"])();
    };
    AppModule.prototype.hmrAfterDestroy = function (store) {
        // display new elements
        store.disposeOldHosts();
        delete store.disposeOldHosts;
    };
    AppModule = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
            imports: [
                __WEBPACK_IMPORTED_MODULE_48_angular2_toaster__["a" /* ToasterModule */],
                __WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__["BrowserModule"],
                __WEBPACK_IMPORTED_MODULE_3__angular_http__["a" /* HttpModule */],
                __WEBPACK_IMPORTED_MODULE_4__angular_forms__["a" /* FormsModule */],
                __WEBPACK_IMPORTED_MODULE_4__angular_forms__["b" /* ReactiveFormsModule */],
                __WEBPACK_IMPORTED_MODULE_5__angular_material__["a" /* MaterialModule */],
                __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser_animations__["a" /* BrowserAnimationsModule */],
                __WEBPACK_IMPORTED_MODULE_8__app_routing_module__["a" /* AppRoutingModule */],
                __WEBPACK_IMPORTED_MODULE_43__approve_reject_request_approve_reject_request_module__["a" /* ApproveRejectRequestModule */],
                __WEBPACK_IMPORTED_MODULE_44__multi_approve_reject_multi_approve_reject_request_module__["a" /* MultiApproveRejectRequestModule */],
                __WEBPACK_IMPORTED_MODULE_45__activate_deactivate_request_activate_deactivate_request_module__["a" /* ActivateDeactivateModule */],
                __WEBPACK_IMPORTED_MODULE_49_angular2_multiselect_dropdown_angular2_multiselect_dropdown__["a" /* AngularMultiSelectModule */],
                __WEBPACK_IMPORTED_MODULE_71_ng2_input_autocomplete__["a" /* AutocompleteModule */].forRoot(),
                __WEBPACK_IMPORTED_MODULE_5__angular_material__["b" /* MdInputModule */],
                // Sub modules
                __WEBPACK_IMPORTED_MODULE_46__layout_layout_module__["a" /* LayoutModule */],
                __WEBPACK_IMPORTED_MODULE_47__shared_shared_module__["a" /* SharedModule */],
                __WEBPACK_IMPORTED_MODULE_42__swimlane_ngx_datatable__["NgxDatatableModule"],
                __WEBPACK_IMPORTED_MODULE_22_ng2_daterangepicker__["Daterangepicker"],
                __WEBPACK_IMPORTED_MODULE_50__viewRequest_view_request_module__["ViewRequestModule"],
                __WEBPACK_IMPORTED_MODULE_51__system_level_setting_adminManagement_adminManagement_module__["AdminManagementModule"],
                __WEBPACK_IMPORTED_MODULE_52__system_level_setting_managerAssignment_managerAssignment_module__["ManagerAssignmentModule"],
                __WEBPACK_IMPORTED_MODULE_73__system_level_setting_applicationManagement_applicationManagement_module__["ApplicationManagementModule"],
                __WEBPACK_IMPORTED_MODULE_53__user_user_module__["UserModule"],
                __WEBPACK_IMPORTED_MODULE_54__user_operations_request_business_unit_request_business_unit_module__["RequestBusinessUnitModule"],
                __WEBPACK_IMPORTED_MODULE_56_mydatepicker__["MyDatePickerModule"],
                __WEBPACK_IMPORTED_MODULE_55__file_upload_fileUpload_module__["CSVUploadModule"],
                __WEBPACK_IMPORTED_MODULE_79_ng2_ckeditor__["a" /* CKEditorModule */],
                __WEBPACK_IMPORTED_MODULE_72_ng2_translate__["b" /* TranslateModule */].forRoot({
                    provide: __WEBPACK_IMPORTED_MODULE_72_ng2_translate__["c" /* TranslateLoader */],
                    useFactory: (createTranslateLoader),
                    deps: [__WEBPACK_IMPORTED_MODULE_3__angular_http__["b" /* Http */]]
                })
            ],
            declarations: [
                __WEBPACK_IMPORTED_MODULE_9__app_component__["a" /* AppComponent */],
                // Layout
                __WEBPACK_IMPORTED_MODULE_10__layout_layout_component__["a" /* LayoutComponent */],
                __WEBPACK_IMPORTED_MODULE_11__layout_preloader_directive__["a" /* PreloaderDirective */],
                // Header
                __WEBPACK_IMPORTED_MODULE_12__layout_header_header_component__["a" /* AppHeaderComponent */],
                // Sidenav
                __WEBPACK_IMPORTED_MODULE_13__layout_sidenav_sidenav_component__["a" /* AppSidenavComponent */],
                __WEBPACK_IMPORTED_MODULE_14__layout_sidenav_toggle_offcanvas_nav_directive__["a" /* ToggleOffcanvasNavDirective */],
                __WEBPACK_IMPORTED_MODULE_15__layout_sidenav_auto_close_mobile_nav_directive__["a" /* AutoCloseMobileNavDirective */],
                __WEBPACK_IMPORTED_MODULE_16__layout_sidenav_sidenav_menu_sidenav_menu_component__["a" /* AppSidenavMenuComponent */],
                __WEBPACK_IMPORTED_MODULE_17__layout_sidenav_sidenav_menu_accordion_nav_directive__["a" /* AccordionNavDirective */],
                __WEBPACK_IMPORTED_MODULE_18__layout_sidenav_sidenav_menu_append_submenu_icon_directive__["a" /* AppendSubmenuIconDirective */],
                __WEBPACK_IMPORTED_MODULE_19__layout_sidenav_sidenav_menu_highlight_active_items_directive__["a" /* HighlightActiveItemsDirective */],
                // Customizer
                __WEBPACK_IMPORTED_MODULE_20__layout_customizer_customizer_component__["a" /* AppCustomizerComponent */],
                __WEBPACK_IMPORTED_MODULE_21__layout_customizer_toggle_quickview_directive__["a" /* ToggleQuickviewDirective */],
                // Footer
                __WEBPACK_IMPORTED_MODULE_23__layout_footer_footer_component__["a" /* AppFooterComponent */],
                // Search overlay
                __WEBPACK_IMPORTED_MODULE_24__layout_search_overlay_search_overlay_component__["a" /* AppSearchOverlayComponent */],
                __WEBPACK_IMPORTED_MODULE_25__layout_search_overlay_search_overlay_directive__["a" /* SearchOverlayDirective */],
                __WEBPACK_IMPORTED_MODULE_26__layout_search_overlay_open_search_overlay_directive__["a" /* OpenSearchOverlaylDirective */],
                // Dashboard
                __WEBPACK_IMPORTED_MODULE_35__admin_dashboard_admin_dashboard_component__["a" /* AdminDashboardComponent */],
                __WEBPACK_IMPORTED_MODULE_74__app_user_activity_logs_user_activity_logs_component__["a" /* userActivityLogs */],
                __WEBPACK_IMPORTED_MODULE_75__app_translation_messages_translation_messages_component__["a" /* TranslationMessagesComponent */],
                __WEBPACK_IMPORTED_MODULE_77__app_translation_email_translation_email_component__["a" /* TranslationEmailComponent */],
                __WEBPACK_IMPORTED_MODULE_36__partners_dashboard_partners_dashboard_component__["a" /* PartnersDashboardComponent */],
                __WEBPACK_IMPORTED_MODULE_37__applications_manager_dashboard_applications_manager_dashboard_component__["a" /* ApplicationsManagerDashboardComponent */],
                // Profile
                __WEBPACK_IMPORTED_MODULE_38__profile_profile_component__["a" /* ProfileComponent */],
                // Pages
                __WEBPACK_IMPORTED_MODULE_30__login_login_component__["a" /* LoginComponent */],
                __WEBPACK_IMPORTED_MODULE_31__registration_registration_component__["a" /* RegistrationComponent */],
                __WEBPACK_IMPORTED_MODULE_32__forgot_password_forgotPassword_component__["a" /* ForgotPasswordComponent */],
                __WEBPACK_IMPORTED_MODULE_33__unlock_account_UnlockAccountComponent__["a" /* UnlockAccountComponent */],
                __WEBPACK_IMPORTED_MODULE_34__system_level_setting_wpass_wpass_component__["a" /* WPASSComponent */],
                __WEBPACK_IMPORTED_MODULE_39__page_layouts_fullscreen_fullscreen_component__["a" /* PageLayoutFullscreenComponent */],
                __WEBPACK_IMPORTED_MODULE_27__loader_loader_component__["a" /* LoaderComponent */],
                __WEBPACK_IMPORTED_MODULE_40__dialog_dialog_component__["a" /* DialogComponent */],
                __WEBPACK_IMPORTED_MODULE_40__dialog_dialog_component__["b" /* SelectApplicationsDialogComponent */],
                __WEBPACK_IMPORTED_MODULE_40__dialog_dialog_component__["c" /* WelcomeDialogComponent */],
                __WEBPACK_IMPORTED_MODULE_40__dialog_dialog_component__["d" /* BuAssignmentDialogComponent */],
                __WEBPACK_IMPORTED_MODULE_40__dialog_dialog_component__["e" /* RegistrationDialogComponent */],
                __WEBPACK_IMPORTED_MODULE_40__dialog_dialog_component__["f" /* DashboardActionDialogComponent */],
                __WEBPACK_IMPORTED_MODULE_40__dialog_dialog_component__["g" /* ApplicationDashboardActionDialogComponent */],
                __WEBPACK_IMPORTED_MODULE_40__dialog_dialog_component__["h" /* ApplicationRejectActionDialogComponent */],
                __WEBPACK_IMPORTED_MODULE_40__dialog_dialog_component__["i" /* ActiveInactiveDialogComponent */],
                __WEBPACK_IMPORTED_MODULE_38__profile_profile_component__["b" /* EmailPasswordActionDialogComponent */],
                __WEBPACK_IMPORTED_MODULE_41__viewRequest_view_request_component__["a" /* EmailActionDialogComponent */],
                __WEBPACK_IMPORTED_MODULE_40__dialog_dialog_component__["j" /* CSVErrorDialogComponent */],
                __WEBPACK_IMPORTED_MODULE_40__dialog_dialog_component__["k" /* ShowApplicationsDialogComponent */],
                //Directives
                __WEBPACK_IMPORTED_MODULE_70__shared_directive_blockCutCopyPaste_directive__["a" /* BlockCutCopyPasteDirective */],
            ],
            providers: [__WEBPACK_IMPORTED_MODULE_28__loader_loader_service__["a" /* LoaderService */], __WEBPACK_IMPORTED_MODULE_58__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_59__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_60__shared_services_error_handler_service__["a" /* ErrorHandler */], __WEBPACK_IMPORTED_MODULE_29__shared_services_common_service__["a" /* CommonService */], __WEBPACK_IMPORTED_MODULE_61__adminDashboardResultService__["a" /* AdminDashboardResultService */], __WEBPACK_IMPORTED_MODULE_62__partnersDashboardResultService__["a" /* PartnersDashboardResultService */], __WEBPACK_IMPORTED_MODULE_63__applicationsManagerDashboardResultService__["a" /* ApplicationsManagerDashboardResultService */],
                __WEBPACK_IMPORTED_MODULE_76__app_user_activity_logs_user_activity_datatable_userActivityResultService__["a" /* UserActivityResultService */], __WEBPACK_IMPORTED_MODULE_64__system_level_setting_adminManagement_adminListDashboardResultService__["a" /* AdminListDashboardResultService */], __WEBPACK_IMPORTED_MODULE_65__system_level_setting_applicationManagement_applicationListDashboardResultService__["a" /* ApplicationListDashboardResultService */], __WEBPACK_IMPORTED_MODULE_66__system_level_setting_businessUnitManagement_businessUnitDashboardResultService__["a" /* BusinessUnitListDashboardResultService */], __WEBPACK_IMPORTED_MODULE_67__system_level_setting_managerAssignment_managerListDashboardResultService__["a" /* ManagerListDashboardResultService */], __WEBPACK_IMPORTED_MODULE_68__file_upload_fileUploadListDashboardResultService__["a" /* FileUploadListDashboardResultService */], __WEBPACK_IMPORTED_MODULE_69__user_operations_request_business_unit_businessUnitForUserDashboardResultService__["a" /* BusinessUnitListForUserDashboardResultService */]],
            entryComponents: [__WEBPACK_IMPORTED_MODULE_40__dialog_dialog_component__["a" /* DialogComponent */], __WEBPACK_IMPORTED_MODULE_40__dialog_dialog_component__["b" /* SelectApplicationsDialogComponent */], __WEBPACK_IMPORTED_MODULE_40__dialog_dialog_component__["k" /* ShowApplicationsDialogComponent */], __WEBPACK_IMPORTED_MODULE_40__dialog_dialog_component__["c" /* WelcomeDialogComponent */], __WEBPACK_IMPORTED_MODULE_40__dialog_dialog_component__["d" /* BuAssignmentDialogComponent */], __WEBPACK_IMPORTED_MODULE_40__dialog_dialog_component__["f" /* DashboardActionDialogComponent */], __WEBPACK_IMPORTED_MODULE_40__dialog_dialog_component__["g" /* ApplicationDashboardActionDialogComponent */], __WEBPACK_IMPORTED_MODULE_40__dialog_dialog_component__["h" /* ApplicationRejectActionDialogComponent */], __WEBPACK_IMPORTED_MODULE_40__dialog_dialog_component__["e" /* RegistrationDialogComponent */], __WEBPACK_IMPORTED_MODULE_40__dialog_dialog_component__["i" /* ActiveInactiveDialogComponent */], __WEBPACK_IMPORTED_MODULE_38__profile_profile_component__["b" /* EmailPasswordActionDialogComponent */], __WEBPACK_IMPORTED_MODULE_41__viewRequest_view_request_component__["a" /* EmailActionDialogComponent */], __WEBPACK_IMPORTED_MODULE_40__dialog_dialog_component__["j" /* CSVErrorDialogComponent */]],
            bootstrap: [__WEBPACK_IMPORTED_MODULE_9__app_component__["a" /* AppComponent */]]
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ApplicationRef"]])
    ], AppModule);
    return AppModule;
}());



/***/ }),

/***/ 743:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BusinessUnitListDashboardResultService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__businessUnitList_datatable_businessUnitList_page_data__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__businessUnitList_datatable_businessUnitList_dashboard__ = __webpack_require__(790);
/**
 * Created by shubham on 23/5/18.
 */





/**
 * A server used to mock a paged data result from a server
 */
var BusinessUnitListDashboardResultService = /** @class */ (function () {
    function BusinessUnitListDashboardResultService() {
        this.rows = {};
        this.adminDashboardData = {};
    }
    /**
     * A method that mocks a paged server response
     * @param page The selected page
     * @returns {any} An observable containing the employee data
     */
    BusinessUnitListDashboardResultService.prototype.getResults = function (page, listData) {
        var _this = this;
        this.listData = listData;
        return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(listData).map(function (data) { return _this.getPageData(page); });
    };
    /**
     * Package companyData into a PagedData object based on the selected Page
     * @param page The page data used to get the selected data from companyData
     * @returns {PagedData<icsList>} An array of the selected data and page
     */
    BusinessUnitListDashboardResultService.prototype.getPageData = function (page) {
        var pageData = new __WEBPACK_IMPORTED_MODULE_3__businessUnitList_datatable_businessUnitList_page_data__["a" /* BusinessUnitListPageData */]();
        var offset = this.listData.offset;
        var raw = [];
        for (var l in this.listData) {
            if (Object.keys(this.listData[l]).length > 0) {
                raw[offset + parseInt(l)] = this.listData[l];
            }
        }
        if (this.listData.totalCount) {
            page.totalElements = this.listData.totalCount;
        }
        page.totalPages = page.totalElements / page.size;
        var start = page.pageNumber * page.size;
        var end = Math.min((start + page.size), page.totalElements);
        for (var i = start; i < end; i++) {
            if (raw[i]) {
                var jsonObj = raw[i];
                if (jsonObj) {
                    var list = new __WEBPACK_IMPORTED_MODULE_4__businessUnitList_datatable_businessUnitList_dashboard__["a" /* BusinessUnitListDashboard */](jsonObj['id'], jsonObj['Name'], jsonObj['code'], jsonObj['active'], jsonObj['status'], jsonObj['createdAt']);
                    pageData.data.push(list);
                }
            }
        }
        pageData.page = page;
        return pageData;
    };
    BusinessUnitListDashboardResultService = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [])
    ], BusinessUnitListDashboardResultService);
    return BusinessUnitListDashboardResultService;
}());



/***/ }),

/***/ 744:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BusinessUnitListPage; });
/**
 * Created by shubham on 11/4/18.
 */
/**
 * An object used to get page information from the server
 */
var BusinessUnitListPage = /** @class */ (function () {
    function BusinessUnitListPage() {
        //The number of elements in the page
        this.size = 0;
        //The total number of elements
        this.totalElements = 0;
        //The total number of pages
        this.totalPages = 0;
        //The current page number
        this.pageNumber = 0;
    }
    return BusinessUnitListPage;
}());



/***/ }),

/***/ 748:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActivateDeactivateComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_services_common_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dialog_dialog_component__ = __webpack_require__(11);
/**
 * Created by shubham on 22/5/18.
 */








var ActivateDeactivateComponent = /** @class */ (function () {
    function ActivateDeactivateComponent(router, route, httpService, dialog, commonService) {
        this.router = router;
        this.route = route;
        this.httpService = httpService;
        this.dialog = dialog;
        this.commonService = commonService;
    }
    ActivateDeactivateComponent.prototype.performAction = function (status) {
        var _this = this;
        this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_6__dialog_dialog_component__["i" /* ActiveInactiveDialogComponent */]);
        var actionStatus;
        if (status == 'delete') {
            actionStatus = 'DELETE';
            this.dialogRef.componentInstance.msg = 'user_deactivate_confirm';
        }
        else if (status == 'active') {
            actionStatus = 'Activate';
            this.dialogRef.componentInstance.msg = 'user_activate_confirm';
        }
        else {
            actionStatus = 'Deactivate';
            this.dialogRef.componentInstance.msg = 'user_deactivate_confirm';
        }
        this.dialogRef.componentInstance.activeDeactive = true;
        this.dialogRef.componentInstance.dashboard = this.dashboard;
        this.dialogRef.componentInstance.isConfirm = true;
        if (this.dashboard == 'admin') {
            this.dialogRef.componentInstance.note = 'sub_user_del_info';
        }
        this.dialogRef.afterClosed().subscribe(function (result) {
            if (result) {
                var data = {};
                if (_this.dashboard == 'managerList') {
                    data['buAssociationId'] = _this.childData.buAssociationId;
                }
                else {
                    data['id'] = _this.childData.id;
                }
                if (_this.childData) {
                    if (_this.childData.applicationName) {
                        data['Name'] = _this.childData.applicationName;
                    }
                    if (_this.childData.Name) {
                        data['Name'] = _this.childData.Name;
                    }
                    else if (_this.childData.firstName && _this.childData.lastName) {
                        data['Name'] = _this.childData.firstName + ' ' + _this.childData.lastName;
                    }
                    if (_this.childData.email) {
                        data['email'] = _this.childData.email;
                    }
                }
                if (status == 'delete') {
                    data['status'] = 'DELETE';
                }
                else if (status == 'active') {
                    data['active'] = true;
                }
                else {
                    data['active'] = false;
                }
                var today = new Date();
                var dd = ('0' + today.getDate()).slice(-2);
                var mm = ('0' + (today.getMonth() + 1)).slice(-2);
                var yyyy = today.getFullYear();
                data['deletionDate'] = yyyy + '' + mm + '' + dd;
                if (_this.dashboard == 'admin') {
                    _this.httpService.postRequest(data, 'userRegistrationsApi/v1/deletePartner/' + _this.childData.id).subscribe(function (res) {
                        _this.saveResponse(res, status);
                    }, function (err) { _this.httpService.onEnd(); });
                }
                else if (_this.dashboard == 'partners') {
                    _this.httpService.postRequest(data, 'partnerOperationsApi/v1/deleteCompanyUser/' + data['id']).subscribe(function (res) {
                        _this.saveResponse(res, status);
                    }, function (err) { _this.httpService.onEnd(); });
                }
                else if (_this.dashboard == 'adminList') {
                    _this.httpService.postRequest(data, 'superUserOperationsApi/v1/adminActiveState').subscribe(function (res) {
                        _this.saveResponse(res, status);
                    }, function (err) { _this.httpService.onEnd(); });
                }
                else if (_this.dashboard == 'managerList') {
                    _this.httpService.postRequest(data, 'superUserOperationsApi/v1/countryBusinessUnitManagerActiveState?active=' + data['active']).subscribe(function (res) {
                        _this.saveResponse(res, status);
                    }, function (err) { _this.httpService.onEnd(); });
                }
                else if (_this.dashboard == 'applicationList') {
                    _this.httpService.getRequest('applicationOperationApi/v1/deleteApplication/' + data['id']).subscribe(function (res) {
                        _this.saveResponse(res, status);
                    }, function (err) { _this.httpService.onEnd(); });
                }
            }
            _this.dialogRef = null;
        });
    };
    ActivateDeactivateComponent.prototype.saveResponse = function (res, status) {
        this.httpService.onEnd();
        var statusTxt;
        if (res) {
            if (status == 'delete') {
                statusTxt = 'del_rqst_submission_notify';
            }
            else {
                statusTxt = 'Updated Successfully';
            }
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_6__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = statusTxt;
            if (this.dashboard == 'admin') {
                this.commonService.changeAdminDashboardData();
            }
            else if (this.dashboard == 'partners') {
                this.commonService.changePartnersDashboardData();
            }
            else if (this.dashboard == 'adminList') {
                this.commonService.changeAdminListDashboardData();
            }
            else if (this.dashboard == 'managerList') {
                this.commonService.changeManagerListDashboardData();
            }
            else if (this.dashboard == 'applicationList') {
                this.commonService.changeApplicationListDashboardData();
            }
        }
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", Object)
    ], ActivateDeactivateComponent.prototype, "childData", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", Object)
    ], ActivateDeactivateComponent.prototype, "dashboard", void 0);
    ActivateDeactivateComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'activate-deactivate',
            template: __webpack_require__(1244)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_2__angular_router__["b" /* ActivatedRoute */], __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__["a" /* HttpService */],
            __WEBPACK_IMPORTED_MODULE_4__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_5__shared_services_common_service__["a" /* CommonService */]])
    ], ActivateDeactivateComponent);
    return ActivateDeactivateComponent;
}());



/***/ }),

/***/ 749:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdminDashboardList; });
/**
 * Created by shubham on 11/4/18.
 */
/**
 * A model for an individual corporate employee
 */
var AdminDashboardList = /** @class */ (function () {
    function AdminDashboardList(id, Name, roleName, email, emailVerified, businessUnits, userId_WPASS, pendingSubUserCount, languageId, languageName, countryId, countryName, companyName, companyAddress, companyPhone, personalArea, costCenter, location, actionFlag, contractorType, status, appStatus, createdAt) {
        this.id = id;
        this.Name = Name;
        this.roleName = roleName;
        this.email = email;
        this.emailVerified = emailVerified;
        this.businessUnits = businessUnits;
        this.userId_WPASS = userId_WPASS;
        this.pendingSubUserCount = pendingSubUserCount;
        this.languageId = languageId;
        this.languageName = languageName;
        this.countryId = countryId;
        this.countryName = countryName;
        this.companyName = companyName;
        this.companyAddress = companyAddress;
        this.companyPhone = companyPhone;
        this.personalArea = personalArea;
        this.costCenter = costCenter;
        this.location = location;
        this.contractorType = contractorType;
        this.actionFlag = actionFlag;
        this.status = status;
        this.appStatus = appStatus;
        this.createdAt = createdAt;
    }
    return AdminDashboardList;
}());



/***/ }),

/***/ 750:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdminPageData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__admin_page__ = __webpack_require__(278);
/**
 * Created by shubham on 11/4/18.
 */

/**
 * An array of data with an associated page object used for paging
 */
var AdminPageData = /** @class */ (function () {
    function AdminPageData() {
        this.data = new Array();
        this.page = new __WEBPACK_IMPORTED_MODULE_0__admin_page__["a" /* AdminPage */]();
    }
    return AdminPageData;
}());



/***/ }),

/***/ 751:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppRoutingModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_layout_component__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__login_login_component__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__registration_registration_component__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forgot_password_forgotPassword_component__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__unlock_account_UnlockAccountComponent__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__page_layouts_fullscreen_fullscreen_component__ = __webpack_require__(292);






// Page Layouts

var AppRoutes = [
    { path: '', redirectTo: '/login', pathMatch: 'full' },
    { path: 'login', component: __WEBPACK_IMPORTED_MODULE_2__login_login_component__["a" /* LoginComponent */] },
    { path: 'login/:id', component: __WEBPACK_IMPORTED_MODULE_2__login_login_component__["a" /* LoginComponent */] },
    { path: 'registration', component: __WEBPACK_IMPORTED_MODULE_3__registration_registration_component__["a" /* RegistrationComponent */] },
    { path: 'registration/:id', component: __WEBPACK_IMPORTED_MODULE_3__registration_registration_component__["a" /* RegistrationComponent */] },
    { path: 'registration/apps/:id', component: __WEBPACK_IMPORTED_MODULE_3__registration_registration_component__["a" /* RegistrationComponent */] },
    { path: 'forgot-password', component: __WEBPACK_IMPORTED_MODULE_4__forgot_password_forgotPassword_component__["a" /* ForgotPasswordComponent */] },
    { path: 'unlock-account', component: __WEBPACK_IMPORTED_MODULE_5__unlock_account_UnlockAccountComponent__["a" /* UnlockAccountComponent */] },
    { path: 'app', component: __WEBPACK_IMPORTED_MODULE_1__layout_layout_component__["a" /* LayoutComponent */] },
    { path: 'extra', loadChildren: function() { return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1609))  .then( function(module) { return module['ExtraPagesModule']; } ); } },
    { path: 'fullscreen', component: __WEBPACK_IMPORTED_MODULE_6__page_layouts_fullscreen_fullscreen_component__["a" /* PageLayoutFullscreenComponent */] },
    { path: '**', redirectTo: 'login', pathMatch: 'full' },
];
var AppRoutingModule = __WEBPACK_IMPORTED_MODULE_0__angular_router__["g" /* RouterModule */].forRoot(AppRoutes, { useHash: true });


/***/ }),

/***/ 752:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_layout_service__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_services_error_handler_service__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ng2_translate__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styles_font_awesome_scss__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styles_font_awesome_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_styles_font_awesome_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_styles_material2_theme_scss__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_styles_material2_theme_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_styles_material2_theme_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styles_bootstrap_scss__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styles_bootstrap_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_styles_bootstrap_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_styles_layout_scss__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_styles_layout_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_styles_layout_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_styles_theme_scss__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_styles_theme_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_styles_theme_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_styles_ui_scss__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_styles_ui_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_styles_ui_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_styles_app_scss__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_styles_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_styles_app_scss__);










// 3rd



// custom




var AppComponent = /** @class */ (function () {
    function AppComponent(router, layoutService, sessionHandler, dialog, translate) {
        this.router = router;
        this.layoutService = layoutService;
        this.sessionHandler = sessionHandler;
        this.dialog = dialog;
        this.translate = translate;
        this.languageId = this.sessionHandler.getItem('languageId');
        if (!this.languageId) {
            this.languageId = "EN";
        }
        this.translate.use(this.languageId);
    }
    AppComponent.prototype.ngOnInit = function () {
        this.AppConfig = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */];
        // Scroll to top on route change
        this.router.events.subscribe(function (evt) {
            if (!(evt instanceof __WEBPACK_IMPORTED_MODULE_2__angular_router__["c" /* NavigationEnd */])) {
                return;
            }
            document.body.scrollTop = 0;
        });
    };
    AppComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'app-root',
            template: __webpack_require__(1246),
            providers: [__WEBPACK_IMPORTED_MODULE_4__layout_layout_service__["a" /* LayoutService */], __WEBPACK_IMPORTED_MODULE_6__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_7__shared_services_error_handler_service__["a" /* ErrorHandler */], __WEBPACK_IMPORTED_MODULE_8__shared_services_session_handler_service__["a" /* SessionHandler */]],
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_4__layout_layout_service__["a" /* LayoutService */], __WEBPACK_IMPORTED_MODULE_8__shared_services_session_handler_service__["a" /* SessionHandler */],
            __WEBPACK_IMPORTED_MODULE_5__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_9_ng2_translate__["d" /* TranslateService */]])
    ], AppComponent);
    return AppComponent;
}());



/***/ }),

/***/ 753:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApplicationsDashboardList; });
/**
 * Created by shubham on 11/4/18.
 */
/**
 * A model for an individual corporate employee
 */
/**
 * Created by shubham on 11/4/18.
 */
/**
 * A model for an individual corporate employee
 */
var ApplicationsDashboardList = /** @class */ (function () {
    function ApplicationsDashboardList(id, applicationId, applicationName, userId_WPASS, businessUnitId, businessUnitName, countryId, countryName, approverId, approverName, multipleRole, reason, status, statusCode, updatedAt) {
        this.id = id;
        this.applicationId = applicationId;
        this.applicationName = applicationName;
        this.userId_WPASS = userId_WPASS;
        this.businessUnitId = businessUnitId;
        this.businessUnitName = businessUnitName;
        this.countryId = countryId;
        this.countryName = countryName;
        this.approverId = approverId;
        this.approverName = approverName;
        this.multipleRole = multipleRole;
        this.reason = reason;
        this.status = status;
        this.statusCode = statusCode;
        this.updatedAt = updatedAt;
    }
    return ApplicationsDashboardList;
}());



/***/ }),

/***/ 754:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApplicationsPageData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__applications_page__ = __webpack_require__(280);
/**
 * Created by shubham on 11/4/18.
 */

/**
 * An array of data with an associated page object used for paging
 */
var ApplicationsPageData = /** @class */ (function () {
    function ApplicationsPageData() {
        this.data = new Array();
        this.page = new __WEBPACK_IMPORTED_MODULE_0__applications_page__["a" /* ApplicationsPage */]();
    }
    return ApplicationsPageData;
}());



/***/ }),

/***/ 755:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApproveRejectComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_services_common_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dialog_dialog_component__ = __webpack_require__(11);
/**
 * Created by shubham on 27/4/18.
 */








var ApproveRejectComponent = /** @class */ (function () {
    function ApproveRejectComponent(router, route, httpService, dialog, commonService) {
        this.router = router;
        this.route = route;
        this.httpService = httpService;
        this.dialog = dialog;
        this.commonService = commonService;
    }
    ApproveRejectComponent.prototype.performAction = function (status) {
        var _this = this;
        this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_6__dialog_dialog_component__["f" /* DashboardActionDialogComponent */]);
        var actionStatus;
        if (status == 'approved') {
            actionStatus = 'APPROVE';
            this.dialogRef.componentInstance.msg = 'rqst_approve_confirm';
            this.dialogRef.componentInstance.isApproved = true;
        }
        else if (status == 'rejected') {
            actionStatus = 'REJECT';
            this.dialogRef.componentInstance.isReject = true;
            this.dialogRef.componentInstance.msg = 'rqst_rjct_confirm';
        }
        this.dialogRef.componentInstance.multiApproveRejectFlag = false;
        this.dialogRef.componentInstance.dashboard = this.dashboard;
        this.dialogRef.componentInstance.row = this.childData;
        this.dialogRef.afterClosed().subscribe(function (result) {
            if (result) {
                var data = {};
                data['id'] = _this.childData.id;
                if (_this.childData.Name) {
                    data['Name'] = _this.childData.Name;
                }
                else {
                    data['Name'] = _this.childData.firstName + ' ' + _this.childData.lastName;
                }
                if (_this.childData.email) {
                    data['email'] = _this.childData.email;
                }
                if (_this.childData.userId_WPASS) {
                    data['userId_WPASS'] = _this.childData.userId_WPASS;
                }
                if (_this.childData && _this.childData.businessUnitId) {
                    data['businessUnitId'] = _this.childData.businessUnitId;
                }
                if (status == 'approved') {
                    data['status'] = 'BU_APPROVE';
                    if (_this.dashboard == 'admin' || _this.dashboard == 'partnersView') {
                        //data['roleId'] = result.roleId;
                        data['customerNumber'] = result.customerNumber;
                        data['partnerType'] = result.selectedPartnerType;
                    }
                }
                else if (status == 'rejected') {
                    data['message'] = result;
                    data['status'] = 'BU_REJECT';
                }
                var today = new Date();
                var dd = ('0' + today.getDate()).slice(-2);
                var mm = ('0' + (today.getMonth() + 1)).slice(-2);
                var yyyy = today.getFullYear();
                data['approvalDate'] = yyyy + '' + mm + '' + dd;
                console.log(data);
                if (_this.dashboard == 'admin' || _this.dashboard == 'partnersView') {
                    if (data['userId_WPASS'] && data['userId_WPASS'] != "") {
                        _this.httpService.postRequest(data, 'partnerOperationsApi/v1/approveRejectNewBusinessUnitForPartner').subscribe(function (res) {
                            _this.saveResponse(res, status, true);
                        }, function (err) {
                            _this.httpService.onEnd();
                        });
                    }
                    else {
                        _this.httpService.postRequest(data, 'userRegistrationsApi/v1/approveBusinessUnit').subscribe(function (res) {
                            _this.saveResponse(res, status, false);
                        }, function (err) {
                            _this.httpService.onEnd();
                        });
                    }
                }
                else if (_this.dashboard == 'partners' || _this.dashboard == 'subUsersView') {
                    _this.httpService.postRequest(data, 'partnerOperationsApi/v1/approveCompanyUserCreationRequest').subscribe(function (res) {
                        _this.saveResponse(res, status, false);
                    }, function (err) {
                        _this.httpService.onEnd();
                    });
                }
            }
            _this.dialogRef = null;
        });
    };
    ApproveRejectComponent.prototype.saveResponse = function (res, status, wpassIdCreated) {
        this.httpService.onEnd();
        var statusTxt;
        console.log(wpassIdCreated);
        if (res) {
            if (status == 'approved') {
                if (wpassIdCreated) {
                    statusTxt = 'after_new_bu_approval_notify';
                }
                else {
                    statusTxt = 'after_user_creation_approval_notify';
                }
            }
            else {
                statusTxt = 'Rejected Successfully';
            }
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_6__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = statusTxt;
            if (this.dashboard == 'admin') {
                this.commonService.changeAdminDashboardData();
            }
            else if (this.dashboard == 'partnersView') {
                this.commonService.changePartnerViewData();
            }
            else if (this.dashboard == 'partners') {
                this.commonService.changePartnersDashboardData();
            }
            else if (this.dashboard == 'subUsersView') {
                this.commonService.changeSubUserViewData();
            }
        }
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", Object)
    ], ApproveRejectComponent.prototype, "childData", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", Object)
    ], ApproveRejectComponent.prototype, "dashboard", void 0);
    ApproveRejectComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'approve-reject',
            template: __webpack_require__(1248)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_2__angular_router__["b" /* ActivatedRoute */], __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__["a" /* HttpService */],
            __WEBPACK_IMPORTED_MODULE_4__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_5__shared_services_common_service__["a" /* CommonService */]])
    ], ApproveRejectComponent);
    return ApproveRejectComponent;
}());



/***/ }),

/***/ 756:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FileUploadRoutes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileUploadRoutingModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fileUpload_component__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fileUploadList_fileUploadList_component__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__add_file_addFile_component__ = __webpack_require__(284);
/**
 * Created by shubham on 13/6/18.
 */




var FileUploadRoutes = [
    {
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_1__fileUpload_component__["a" /* FileUploadComponent */],
        children: [
            { path: '', redirectTo: '/app/profile', pathMatch: 'full' },
            { path: 'list', component: __WEBPACK_IMPORTED_MODULE_2__fileUploadList_fileUploadList_component__["a" /* FileUploadListComponent */] },
            { path: 'add', component: __WEBPACK_IMPORTED_MODULE_3__add_file_addFile_component__["a" /* AddFileComponent */] },
        ]
    }
];
var FileUploadRoutingModule = __WEBPACK_IMPORTED_MODULE_0__angular_router__["g" /* RouterModule */].forChild(FileUploadRoutes);


/***/ }),

/***/ 757:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileUploadListDashboard; });
/**
 * Created by shubham on 11/4/18.
 */
/**
 * A model for an individual corporate employee
 */
var FileUploadListDashboard = /** @class */ (function () {
    function FileUploadListDashboard(id, type, countryName, businessUnitName, includesHeader, csvName, csvUrl, status, error, message, uploadBy, uploadedAt) {
        this.id = id;
        this.type = type;
        this.countryName = countryName;
        this.businessUnitName = businessUnitName;
        this.includesHeader = includesHeader;
        this.csvName = csvName;
        this.csvUrl = csvUrl;
        this.status = status;
        this.error = error;
        this.message = message;
        this.uploadBy = uploadBy;
        this.uploadedAt = uploadedAt;
    }
    return FileUploadListDashboard;
}());



/***/ }),

/***/ 758:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileUploadListPageData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fileUploadList_page__ = __webpack_require__(287);
/**
 * Created by shubham on 11/4/18.
 */

/**
 * An array of data with an associated page object used for paging
 */
var FileUploadListPageData = /** @class */ (function () {
    function FileUploadListPageData() {
        this.data = new Array();
        this.page = new __WEBPACK_IMPORTED_MODULE_0__fileUploadList_page__["a" /* FileUploadListPage */]();
    }
    return FileUploadListPageData;
}());



/***/ }),

/***/ 759:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppCustomizerComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(12);



var AppCustomizerComponent = /** @class */ (function () {
    function AppCustomizerComponent() {
    }
    AppCustomizerComponent.prototype.ngOnInit = function () {
        this.AppConfig = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */];
    };
    AppCustomizerComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'my-app-customizer',
            styles: [],
            template: __webpack_require__(1264),
        })
    ], AppCustomizerComponent);
    return AppCustomizerComponent;
}());



/***/ }),

/***/ 760:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToggleQuickviewDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);


var ToggleQuickviewDirective = /** @class */ (function () {
    function ToggleQuickviewDirective(el) {
        this.el = el;
    }
    ToggleQuickviewDirective.prototype.ngAfterViewInit = function () {
        var $el = $(this.el.nativeElement);
        var $body = $('#body');
        var target = this.myToggleQuickview;
        var qvClass = 'quickview-open';
        if (target) {
            qvClass = qvClass + '-' + target;
        }
        $el.on('click', function (e) {
            $body.toggleClass(qvClass);
            e.preventDefault();
        });
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", String)
    ], ToggleQuickviewDirective.prototype, "myToggleQuickview", void 0);
    ToggleQuickviewDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[myToggleQuickview]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"]])
    ], ToggleQuickviewDirective);
    return ToggleQuickviewDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)))

/***/ }),

/***/ 761:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppFooterComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(12);



var AppFooterComponent = /** @class */ (function () {
    function AppFooterComponent() {
    }
    AppFooterComponent.prototype.ngOnInit = function () {
        this.AppConfig = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */];
    };
    AppFooterComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'my-app-footer',
            styles: [],
            template: __webpack_require__(1265)
        })
    ], AppFooterComponent);
    return AppFooterComponent;
}());



/***/ }),

/***/ 762:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppHeaderComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_services_error_handler_service__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_services_common_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__layout_layout_service__ = __webpack_require__(72);









var AppHeaderComponent = /** @class */ (function () {
    function AppHeaderComponent(router, httpService, errorHandler, layoutService, sessionHandler, commonService) {
        this.router = router;
        this.httpService = httpService;
        this.errorHandler = errorHandler;
        this.layoutService = layoutService;
        this.sessionHandler = sessionHandler;
        this.commonService = commonService;
        this.userDetails = { image: '' };
        try {
            if (this.sessionHandler.getItem("userDetails") != null) {
                this.userDetails = JSON.parse(this.sessionHandler.getItem("userDetails"));
                if (!this.userDetails)
                    throw "Invalid user details.";
            }
            else {
                this.router.navigate(['/login']);
            }
        }
        catch (err) {
            this.router.navigate(['/login']);
        }
    }
    AppHeaderComponent.prototype.logout = function () {
        //this.commonService.setLoginRedirectUrl(window.location.hash);
        this.sessionHandler.removeItem('loginData');
        this.sessionHandler.removeItem('timestamp');
        this.sessionHandler.removeItem('userDetails');
        this.router.navigate(['/login']);
    };
    AppHeaderComponent.prototype.saveResponse = function (res) {
        if (res.errorStatus == 'Fail') {
            this.httpService.onEnd();
            alert('Not able to Logout Please Try Again');
        }
        else {
            this.httpService.onEnd();
            //this.commonService.setLoginRedirectUrl('');
            this.sessionHandler.clearAllItems();
            this.router.navigate(['/login']);
        }
    };
    AppHeaderComponent.prototype.toggleCollapsedNav = function () {
        this.AppConfig.navCollapsed = !this.AppConfig.navCollapsed;
    };
    AppHeaderComponent.prototype.ngOnInit = function () {
        this.AppConfig = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */];
    };
    AppHeaderComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'my-app-header',
            styles: [],
            template: __webpack_require__(1266)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_3__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_6__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_4__shared_services_error_handler_service__["a" /* ErrorHandler */],
            __WEBPACK_IMPORTED_MODULE_8__layout_layout_service__["a" /* LayoutService */], __WEBPACK_IMPORTED_MODULE_5__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_7__shared_services_common_service__["a" /* CommonService */]])
    ], AppHeaderComponent);
    return AppHeaderComponent;
}());



/***/ }),

/***/ 763:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayoutRoutingModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_component__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__system_level_setting_wpass_wpass_component__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__admin_dashboard_admin_dashboard_component__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partners_dashboard_partners_dashboard_component__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__applications_manager_dashboard_applications_manager_dashboard_component__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__profile_profile_component__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user_activity_logs_user_activity_logs_component__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__translation_messages_translation_messages_component__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__translation_email_translation_email_component__ = __webpack_require__(318);










var routes = [
    {
        path: 'app',
        component: __WEBPACK_IMPORTED_MODULE_1__layout_component__["a" /* LayoutComponent */],
        children: [
            { path: '', redirectTo: '/app/admin-dashboard', pathMatch: 'full' },
            { path: 'wpass', component: __WEBPACK_IMPORTED_MODULE_2__system_level_setting_wpass_wpass_component__["a" /* WPASSComponent */] },
            { path: 'admin-dashboard', component: __WEBPACK_IMPORTED_MODULE_3__admin_dashboard_admin_dashboard_component__["a" /* AdminDashboardComponent */] },
            { path: 'translation-messages', component: __WEBPACK_IMPORTED_MODULE_8__translation_messages_translation_messages_component__["a" /* TranslationMessagesComponent */] },
            { path: 'translation-email', component: __WEBPACK_IMPORTED_MODULE_9__translation_email_translation_email_component__["a" /* TranslationEmailComponent */] },
            { path: 'user-activity-logs', component: __WEBPACK_IMPORTED_MODULE_7__user_activity_logs_user_activity_logs_component__["a" /* userActivityLogs */] },
            { path: 'partners-dashboard', component: __WEBPACK_IMPORTED_MODULE_4__partners_dashboard_partners_dashboard_component__["a" /* PartnersDashboardComponent */] },
            { path: 'partners-dashboard/:id', component: __WEBPACK_IMPORTED_MODULE_4__partners_dashboard_partners_dashboard_component__["a" /* PartnersDashboardComponent */] },
            { path: 'application-manager-dashboard', component: __WEBPACK_IMPORTED_MODULE_5__applications_manager_dashboard_applications_manager_dashboard_component__["a" /* ApplicationsManagerDashboardComponent */] },
            { path: 'profile', component: __WEBPACK_IMPORTED_MODULE_6__profile_profile_component__["a" /* ProfileComponent */] },
            { path: 'user', loadChildren: function() { return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 334))  .then( function(module) { return module['UserModule']; } ); } },
            { path: 'request-application', loadChildren: function() { return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 330))  .then( function(module) { return module['RequestBusinessUnitModule']; } ); } },
            { path: 'chart', loadChildren: function() { return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1607))  .then( function(module) { return module['ChartsModule']; } ); } },
            { path: 'ecommerce', loadChildren: function() { return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1608))  .then( function(module) { return module['ECommerceModule']; } ); } },
            { path: 'form', loadChildren: function() { return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1610))  .then( function(module) { return module['MyFormsModule']; } ); } },
            { path: 'page', loadChildren: function() { return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1612))  .then( function(module) { return module['PagesModule']; } ); } },
            { path: 'pglayout', loadChildren: function() { return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1611))  .then( function(module) { return module['PageLayoutsModule']; } ); } },
            { path: 'table', loadChildren: function() { return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1614))  .then( function(module) { return module['MyTablesModule']; } ); } },
            { path: 'ui', loadChildren: function() { return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1615))  .then( function(module) { return module['UIModule']; } ); } },
            { path: 'file-upload', loadChildren: function() { return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 286))  .then( function(module) { return module['CSVUploadModule']; } ); } },
            { path: 'manage-admin', loadChildren: function() { return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 302))  .then( function(module) { return module['AdminManagementModule']; } ); } },
            { path: 'manage-business-unit', loadChildren: function() { return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1613))  .then( function(module) { return module['BusinessUnitManagementModule']; } ); } },
            { path: 'manager-assignment', loadChildren: function() { return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 312))  .then( function(module) { return module['ManagerAssignmentModule']; } ); } },
            { path: 'application-management', loadChildren: function() { return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 309))  .then( function(module) { return module['ApplicationManagementModule']; } ); } },
            { path: 'view-request', loadChildren: function() { return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 335))  .then( function(module) { return module['ViewRequestModule']; } ); } },
        ]
    }
];
var LayoutRoutingModule = __WEBPACK_IMPORTED_MODULE_0__angular_router__["g" /* RouterModule */].forChild(routes);


/***/ }),

/***/ 764:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayoutModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_routing_module__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_shared_module__ = __webpack_require__(274);




var LayoutModule = /** @class */ (function () {
    function LayoutModule() {
    }
    LayoutModule = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
            imports: [
                __WEBPACK_IMPORTED_MODULE_2__layout_routing_module__["a" /* LayoutRoutingModule */],
                __WEBPACK_IMPORTED_MODULE_3__shared_shared_module__["a" /* SharedModule */],
            ],
            declarations: []
        })
    ], LayoutModule);
    return LayoutModule;
}());



/***/ }),

/***/ 765:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PreloaderDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_service__ = __webpack_require__(72);




var PreloaderDirective = /** @class */ (function () {
    function PreloaderDirective(el, router, layoutService) {
        var _this = this;
        this.el = el;
        this.router = router;
        this.layoutService = layoutService;
        router.events.subscribe(function (event) {
            _this.navigationInterceptor(event);
        });
        this.subscription = layoutService.preloaderState$.subscribe(function (state) {
            _this.updatePreloader(state);
        });
    }
    PreloaderDirective.prototype.ngAfterViewInit = function () {
        this.$el = $(this.el.nativeElement);
    };
    PreloaderDirective.prototype.active = function () {
        if (this.$el) {
            this.$el.removeClass('hide').addClass('active');
        }
    };
    PreloaderDirective.prototype.hide = function () {
        if (this.$el) {
            this.$el.addClass('hide').removeClass('active');
        }
    };
    // Shows and hides the loading spinner during RouterEvent changes
    PreloaderDirective.prototype.navigationInterceptor = function (event) {
        if (event instanceof __WEBPACK_IMPORTED_MODULE_2__angular_router__["d" /* NavigationStart */]) {
            this.active();
        }
        if (event instanceof __WEBPACK_IMPORTED_MODULE_2__angular_router__["c" /* NavigationEnd */]) {
            this.hide();
        }
        // Set loading state to false in both of the below events to hide the spinner in case a request fails
        if (event instanceof __WEBPACK_IMPORTED_MODULE_2__angular_router__["e" /* NavigationCancel */]) {
            this.hide();
        }
        if (event instanceof __WEBPACK_IMPORTED_MODULE_2__angular_router__["f" /* NavigationError */]) {
            this.hide();
        }
    };
    // 
    PreloaderDirective.prototype.updatePreloader = function (state) {
        // console.log('change state')
        if (state == 'active') {
            this.active();
        }
        if (state == 'hide') {
            this.hide();
        }
    };
    PreloaderDirective.prototype.ngOnDestroy = function () {
        // prevent memory leak when component destroyed
        this.subscription.unsubscribe();
    };
    PreloaderDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({
            selector: '[myPreloader]',
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_3__layout_service__["a" /* LayoutService */]])
    ], PreloaderDirective);
    return PreloaderDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)))

/***/ }),

/***/ 766:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OpenSearchOverlaylDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_service__ = __webpack_require__(72);



var OpenSearchOverlaylDirective = /** @class */ (function () {
    function OpenSearchOverlaylDirective(el, layoutService) {
        this.el = el;
        this.layoutService = layoutService;
    }
    OpenSearchOverlaylDirective.prototype.ngAfterViewInit = function () {
        var _this = this;
        var $el = $(this.el.nativeElement);
        var $body = $('#body');
        $el.on('click', function (e) {
            _this.openOverlay();
        });
    };
    OpenSearchOverlaylDirective.prototype.openOverlay = function () {
        this.layoutService.updateSearchOverlayState('open');
    };
    OpenSearchOverlaylDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[myOpenSearchOverlay]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__layout_service__["a" /* LayoutService */]])
    ], OpenSearchOverlaylDirective);
    return OpenSearchOverlaylDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)))

/***/ }),

/***/ 767:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppSearchOverlayComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);


var AppSearchOverlayComponent = /** @class */ (function () {
    function AppSearchOverlayComponent() {
    }
    AppSearchOverlayComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'my-app-search-overlay',
            styles: [],
            template: __webpack_require__(1268)
        })
    ], AppSearchOverlayComponent);
    return AppSearchOverlayComponent;
}());



/***/ }),

/***/ 768:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchOverlayDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_service__ = __webpack_require__(72);



var SearchOverlayDirective = /** @class */ (function () {
    function SearchOverlayDirective(el, layoutService) {
        var _this = this;
        this.el = el;
        this.layoutService = layoutService;
        this.subscription = layoutService.searchOverlayState$.subscribe(function (state) {
            _this.updateSearchOverlay(state);
        });
    }
    SearchOverlayDirective.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.$el = $(this.el.nativeElement);
        this.$body = $('#body');
        this.$searchInput = this.$el.find('#overlay-search-input');
        this.$closeOverlayBtn = this.$el.find('#overlay-close');
        this.$el.on('keyup', function (e) {
            if (e.keyCode == 27) { // when ESC is pressed
                _this.closeOverlay();
            }
        });
        this.$closeOverlayBtn.on('click', function (e) {
            _this.closeOverlay();
            e.preventDefault();
        });
    };
    SearchOverlayDirective.prototype.openOverlay = function () {
        var _this = this;
        this.$body.addClass('overlay-active');
        // [delay] should >= `visibility` transition duration in CSS, see _overlay.scss
        // otherwise auto-focus won't work since element is not there yet
        if (this.$searchInput) {
            setTimeout(function () {
                _this.$searchInput.focus();
            }, 301);
        }
    };
    SearchOverlayDirective.prototype.closeOverlay = function () {
        this.$body.removeClass('overlay-active');
        if (this.$searchInput) {
            this.$searchInput.val(function () {
                return this.defaultValue;
            });
        }
    };
    SearchOverlayDirective.prototype.updateSearchOverlay = function (state) {
        if (state == 'open') {
            this.openOverlay();
        }
    };
    SearchOverlayDirective.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    SearchOverlayDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[mySearchOverlay]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__layout_service__["a" /* LayoutService */]])
    ], SearchOverlayDirective);
    return SearchOverlayDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)))

/***/ }),

/***/ 769:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AutoCloseMobileNavDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(12);




// Mobile only: automatically close sidebar on route change.
var AutoCloseMobileNavDirective = /** @class */ (function () {
    function AutoCloseMobileNavDirective(el, router) {
        this.el = el;
        this.router = router;
    }
    AutoCloseMobileNavDirective.prototype.ngOnInit = function () {
        var $body = $('#body');
        if (__WEBPACK_IMPORTED_MODULE_3__config__["a" /* APPCONFIG */].AutoCloseMobileNav) {
            this.router.events.subscribe(function (event) {
                if (event instanceof __WEBPACK_IMPORTED_MODULE_2__angular_router__["c" /* NavigationEnd */]) {
                    setTimeout(function () {
                        // console.log('NavigationEnd:', event);
                        $body.removeClass('sidebar-mobile-open');
                    }, 0);
                }
            });
        }
    };
    AutoCloseMobileNavDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[myAutoCloseMobileNav]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */]])
    ], AutoCloseMobileNavDirective);
    return AutoCloseMobileNavDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)))

/***/ }),

/***/ 770:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccordionNavDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);


var AccordionNavDirective = /** @class */ (function () {
    function AccordionNavDirective(el) {
        this.el = el;
    }
    AccordionNavDirective.prototype.ngAfterViewInit = function () {
        // on click, open it's own ul, close sibling li opened ul & sub ul
        // on click, close it's own ul & sub ul
        var $nav = $(this.el.nativeElement);
        var slideTime = 250;
        var $lists = $nav.find('ul').parent('li');
        $lists.append('<i class="material-icons icon-has-ul">arrow_drop_down</i>');
        var $As = $lists.children('a');
        // Disable a link that has ul
        $As.on('click', function (event) {
            event.preventDefault();
        });
        // Accordion nav
        $nav.on('click', function (e) {
            var target = e.target;
            var $parentLi = $(target).closest('li'); // closest, insead of parent, so it still works when click on i icons
            if (!$parentLi.length)
                return; // return if doesn't click on li
            var $subUl = $parentLi.children('ul');
            // let depth = $subUl.parents().length; // but some li has no sub ul, so...
            var depth = $parentLi.parents().length + 1;
            // filter out all elements (except target) at current depth or greater
            var allAtDepth = $nav.find('ul').filter(function () {
                if ($(this).parents().length >= depth && this !== $subUl.get(0)) {
                    return true;
                }
            });
            allAtDepth.slideUp(slideTime).closest('li').removeClass('open');
            // Toggle target 
            if ($parentLi.has('ul').length) {
                $parentLi.toggleClass('open');
            }
            $subUl.stop().slideToggle(slideTime);
        });
    };
    AccordionNavDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[myAccordionNav]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"]])
    ], AccordionNavDirective);
    return AccordionNavDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)))

/***/ }),

/***/ 771:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppendSubmenuIconDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);


var AppendSubmenuIconDirective = /** @class */ (function () {
    function AppendSubmenuIconDirective(el) {
        this.el = el;
    }
    AppendSubmenuIconDirective.prototype.ngAfterViewInit = function () {
        var $el = $(this.el.nativeElement);
        $el.find('.prepend-icon').prepend('<i class="material-icons">keyboard_arrow_right</i>');
    };
    AppendSubmenuIconDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[myAppendSubmenuIcon]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"]])
    ], AppendSubmenuIconDirective);
    return AppendSubmenuIconDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)))

/***/ }),

/***/ 772:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HighlightActiveItemsDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_router__ = __webpack_require__(9);




var HighlightActiveItemsDirective = /** @class */ (function () {
    function HighlightActiveItemsDirective(el, location, router) {
        this.el = el;
        this.location = location;
        this.router = router;
    }
    HighlightActiveItemsDirective.prototype.ngAfterViewInit = function () {
        var $el = $(this.el.nativeElement);
        var $links = $el.find('a');
        function highlightActive(links) {
            var path = location.hash;
            // console.log(path);
            links.each(function (i, link) {
                var $link = $(link);
                var $li = $link.parent('li');
                var href = $link.attr('href');
                // console.log(href);
                if ($li.hasClass('active')) {
                    $li.removeClass('active');
                }
                if (path.indexOf(href) === 0) {
                    $li.addClass('active');
                }
            });
        }
        highlightActive($links);
        this.router.events.subscribe(function (evt) {
            if (!(evt instanceof __WEBPACK_IMPORTED_MODULE_3__angular_router__["c" /* NavigationEnd */])) {
                return;
            }
            highlightActive($links);
        });
    };
    HighlightActiveItemsDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[myHighlightActiveItems]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_2__angular_common__["Location"], __WEBPACK_IMPORTED_MODULE_3__angular_router__["a" /* Router */]])
    ], HighlightActiveItemsDirective);
    return HighlightActiveItemsDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)))

/***/ }),

/***/ 773:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppSidenavMenuComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_services_common_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_layout_service__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(12);








var AppSidenavMenuComponent = /** @class */ (function () {
    function AppSidenavMenuComponent(router, layoutService, httpService, sessionHandler, commonService) {
        this.router = router;
        this.layoutService = layoutService;
        this.httpService = httpService;
        this.sessionHandler = sessionHandler;
        this.commonService = commonService;
        this.isSystemAdmin = false;
        this.isBUManager = false;
        this.isApplicationManager = false;
        this.isRegionalAdmin = false;
        this.isServiceOwner = false;
        this.isTradePartner = false;
        this.isSubUser = false;
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].BUManager)) {
                this.isBUManager = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].applicationManager)) {
                this.isApplicationManager = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].serviceOwner)) {
                this.isServiceOwner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].tradePartner)) {
                this.isTradePartner = true;
            }
            if (this.userDetails.roleCode.includes(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* APPCONFIG */].subuser)) {
                this.isSubUser = true;
            }
        }
        else {
            this.httpService.noUserError();
        }
    }
    AppSidenavMenuComponent.prototype.logout = function () {
        //this.commonService.setLoginRedirectUrl(window.location.hash);
        this.sessionHandler.removeItem('loginData');
        this.sessionHandler.removeItem('timestamp');
        this.sessionHandler.removeItem('userDetails');
        this.router.navigate(['/login']);
    };
    AppSidenavMenuComponent.prototype.saveResponse = function (res) {
        this.httpService.onEnd();
        //this.commonService.setLoginRedirectUrl('');
        this.sessionHandler.clearAllItems();
        this.router.navigate(['/login']);
    };
    AppSidenavMenuComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'my-app-sidenav-menu',
            styles: [],
            template: __webpack_require__(1269)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_5__layout_layout_service__["a" /* LayoutService */], __WEBPACK_IMPORTED_MODULE_6__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_3__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_4__shared_services_common_service__["a" /* CommonService */]])
    ], AppSidenavMenuComponent);
    return AppSidenavMenuComponent;
}());



/***/ }),

/***/ 774:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppSidenavComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_services_error_handler_service__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_services_session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_services_common_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__layout_layout_service__ = __webpack_require__(72);









var AppSidenavComponent = /** @class */ (function () {
    function AppSidenavComponent(router, httpService, errorHandler, layoutService, sessionHandler, commonService) {
        this.router = router;
        this.httpService = httpService;
        this.errorHandler = errorHandler;
        this.layoutService = layoutService;
        this.sessionHandler = sessionHandler;
        this.commonService = commonService;
    }
    AppSidenavComponent.prototype.ngOnInit = function () {
        this.AppConfig = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */];
    };
    AppSidenavComponent.prototype.toggleCollapsedNav = function () {
        this.AppConfig.navCollapsed = !this.AppConfig.navCollapsed;
    };
    AppSidenavComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'my-app-sidenav',
            styles: [],
            template: __webpack_require__(1270)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_3__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_6__shared_services_http_service__["a" /* HttpService */], __WEBPACK_IMPORTED_MODULE_4__shared_services_error_handler_service__["a" /* ErrorHandler */],
            __WEBPACK_IMPORTED_MODULE_8__layout_layout_service__["a" /* LayoutService */], __WEBPACK_IMPORTED_MODULE_5__shared_services_session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_7__shared_services_common_service__["a" /* CommonService */]])
    ], AppSidenavComponent);
    return AppSidenavComponent;
}());



/***/ }),

/***/ 775:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToggleOffcanvasNavDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);


// off-canvas sidebar for mobile, and this is the trigger
var ToggleOffcanvasNavDirective = /** @class */ (function () {
    function ToggleOffcanvasNavDirective(el) {
        this.el = el;
    }
    ToggleOffcanvasNavDirective.prototype.ngAfterViewInit = function () {
        var $navToggler = $(this.el.nativeElement);
        var $body = $('#body');
        $navToggler.on('click', function (e) {
            // _sidebar.scss, _page-container.scss
            $body.toggleClass('sidebar-mobile-open');
            e.preventDefault();
        });
    };
    ToggleOffcanvasNavDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[myToggleOffcanvasNav]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"]])
    ], ToggleOffcanvasNavDirective);
    return ToggleOffcanvasNavDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)))

/***/ }),

/***/ 776:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoaderComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__loader_service__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_router__ = __webpack_require__(9);
/**
 * Created by shubham on 27/2/18.
 */




var LoaderComponent = /** @class */ (function () {
    function LoaderComponent(router, loaderService, chRef) {
        this.router = router;
        this.loaderService = loaderService;
        this.chRef = chRef;
        this.show = false;
        this.isLogin = false;
    }
    LoaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.router.events.subscribe(function (evt) {
            if ((evt instanceof __WEBPACK_IMPORTED_MODULE_3__angular_router__["c" /* NavigationEnd */])) {
                if (evt['url'] == '/login') {
                    _this.isLogin = true;
                }
                else {
                    _this.isLogin = false;
                }
            }
        });
        this.subscription = this.loaderService.loaderState
            .subscribe(function (state) {
            _this.show = state.show;
            if (_this.isLogin) {
                _this.chRef.detectChanges();
            }
        });
    };
    LoaderComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    LoaderComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'angular-loader',
            template: __webpack_require__(1271),
            styles: [__webpack_require__(1243)]
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_3__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_2__loader_service__["a" /* LoaderService */], __WEBPACK_IMPORTED_MODULE_1__angular_core__["ChangeDetectorRef"]])
    ], LoaderComponent);
    return LoaderComponent;
}());



/***/ }),

/***/ 777:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MultiApproveRejectRequestModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_http__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_forms__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_common__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__multi_approve_reject_multi_approve_reject_component__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ng2_translate__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(12);
/**
 * Created by shubham on 29/4/18.
 */









var MultiApproveRejectRequestModule = /** @class */ (function () {
    function MultiApproveRejectRequestModule() {
    }
    MultiApproveRejectRequestModule = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
            imports: [
                __WEBPACK_IMPORTED_MODULE_2__angular_material__["a" /* MaterialModule */],
                __WEBPACK_IMPORTED_MODULE_2__angular_material__["e" /* MdTabsModule */],
                __WEBPACK_IMPORTED_MODULE_5__angular_common__["CommonModule"],
                __WEBPACK_IMPORTED_MODULE_4__angular_forms__["a" /* FormsModule */],
                __WEBPACK_IMPORTED_MODULE_4__angular_forms__["b" /* ReactiveFormsModule */],
                __WEBPACK_IMPORTED_MODULE_7_ng2_translate__["b" /* TranslateModule */].forRoot({
                    provide: __WEBPACK_IMPORTED_MODULE_7_ng2_translate__["c" /* TranslateLoader */],
                    //useFactory: (http: Http) => new TranslateStaticLoader(http, '/assets/i18n', '.json'),
                    useFactory: function (http) { return new __WEBPACK_IMPORTED_MODULE_7_ng2_translate__["a" /* TranslateStaticLoader */](http, __WEBPACK_IMPORTED_MODULE_8__config__["a" /* APPCONFIG */].URL + __WEBPACK_IMPORTED_MODULE_8__config__["a" /* APPCONFIG */].translationUrl, '?v=' + __WEBPACK_IMPORTED_MODULE_8__config__["a" /* APPCONFIG */].translationVersion); },
                    deps: [__WEBPACK_IMPORTED_MODULE_3__angular_http__["b" /* Http */]]
                })
            ],
            declarations: [
                __WEBPACK_IMPORTED_MODULE_6__multi_approve_reject_multi_approve_reject_component__["a" /* MultiApproveRejectComponent */]
            ],
            exports: [
                __WEBPACK_IMPORTED_MODULE_6__multi_approve_reject_multi_approve_reject_component__["a" /* MultiApproveRejectComponent */],
            ]
        })
    ], MultiApproveRejectRequestModule);
    return MultiApproveRejectRequestModule;
}());



/***/ }),

/***/ 778:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MultiApproveRejectComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_material__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_services_common_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dialog_dialog_component__ = __webpack_require__(11);
/**
 * Created by shubham on 27/4/18.
 */









var MultiApproveRejectComponent = /** @class */ (function () {
    function MultiApproveRejectComponent(router, route, httpService, dialog, commonService) {
        this.router = router;
        this.route = route;
        this.httpService = httpService;
        this.dialog = dialog;
        this.commonService = commonService;
        this.settingSingleField = {
            singleSelection: true,
            text: "Select Role",
            labelKey: "name",
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            classes: "myclass custom-class",
            disabled: false
        };
        this.settingMultipleField = {
            singleSelection: false,
            text: "Select Role",
            labelKey: "name",
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            classes: "myclass custom-class",
            disabled: false
        };
    }
    MultiApproveRejectComponent.prototype.checkStatus = function (status) {
        if (this.dashboard == "applicationManagerView") {
            var applicationId = 0;
            for (var data in this.childData) {
                if (this.childData[data]['applicationId']) {
                    applicationId = this.childData[data]['applicationId'];
                    break;
                }
            }
            if (status == 'approved') {
                this.getApplicationRoles(applicationId, status);
            }
            else {
                this.performAction(status, applicationId, '');
            }
        }
        else {
            this.performAction(status, '', '');
        }
    };
    MultiApproveRejectComponent.prototype.getApplicationRoles = function (applicationId, status) {
        var _this = this;
        this.httpService.getRequest('applicationOperationApi/v1/applicationRoles/' + applicationId).subscribe(function (res) { _this.saveApplicationRoles(res, applicationId, status); }, function (err) { _this.httpService.onEnd(); });
    };
    MultiApproveRejectComponent.prototype.saveApplicationRoles = function (res, applicationId, status) {
        this.httpService.onEnd();
        if (res && res.applicationRoles) {
            this.performAction(status, applicationId, res);
        }
    };
    MultiApproveRejectComponent.prototype.performAction = function (status, applicationId, res) {
        var _this = this;
        if (this.dashboard == "applicationManagerView") {
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_6__dialog_dialog_component__["g" /* ApplicationDashboardActionDialogComponent */]);
            this.dialogRef.componentInstance.row = this.childData;
            this.dialogRef.componentInstance.roles = res.applicationRoles;
            if (res.multipleRole) {
                this.dialogRef.componentInstance.settings = this.settingMultipleField;
            }
            else {
                this.dialogRef.componentInstance.settings = this.settingSingleField;
            }
        }
        else {
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_6__dialog_dialog_component__["f" /* DashboardActionDialogComponent */]);
            this.dialogRef.componentInstance.row = '';
        }
        var actionStatus;
        if (status == 'approved') {
            actionStatus = 'APPROVE';
            this.dialogRef.componentInstance.isApproved = true;
        }
        else if (status == 'rejected') {
            actionStatus = 'REJECT';
            this.dialogRef.componentInstance.isReject = true;
        }
        this.dialogRef.componentInstance.multiApproveRejectFlag = true;
        this.dialogRef.componentInstance.actionStatus = actionStatus;
        this.dialogRef.componentInstance.dashboard = this.dashboard;
        if (this.selectedCount < this.count) {
            this.dialogRef.componentInstance.condition1Flag = true;
        }
        else if (this.selectedCount >= this.count && this.selectedCount < this.totalCount) {
            this.dialogRef.componentInstance.condition2Flag = true;
        }
        else if (this.selectedCount == this.totalCount) {
            this.dialogRef.componentInstance.condition3Flag = true;
        }
        this.dialogRef.afterClosed().subscribe(function (result) {
            if (result) {
                var data_1 = {};
                if (_this.childData) {
                    if (_this.dashboard == "applicationManagerView") {
                        data_1['applicationId'] = applicationId;
                        data_1['userApplicationIds'] = [];
                    }
                    else {
                        data_1['userIds'] = [];
                    }
                    if (result.selectedRadioValue == "Approve All") {
                        data_1['allSelected'] = true;
                    }
                    else {
                        data_1['allSelected'] = false;
                        for (var c in _this.childData) {
                            if (_this.childData[c]['id']) {
                                if (_this.dashboard == "applicationManagerView") {
                                    data_1['userApplicationIds'].push(_this.childData[c]['id']);
                                }
                                else {
                                    data_1['userIds'].push(_this.childData[c]['id']);
                                }
                            }
                        }
                    }
                    if (status == 'approved') {
                        if (_this.dashboard == 'admin' || _this.dashboard == 'partners') {
                            data_1['status'] = 'BU_APPROVE';
                            // data['roleIds'] = result.roleId;
                        }
                        else {
                            data_1['status'] = 'APPROVED';
                            data_1['selectedRoles'] = result.selectedRoles;
                        }
                    }
                    else if (status == 'rejected') {
                        if (_this.dashboard == 'admin' || _this.dashboard == 'partners') {
                            data_1['status'] = 'BU_REJECT';
                        }
                        else {
                            data_1['status'] = 'REJECTED';
                        }
                        data_1['message'] = result.reason;
                    }
                    data_1['email'] = _this.searchedFilters.email ? _this.searchedFilters.email : '';
                    data_1['firstName'] = _this.searchedFilters.firstName ? _this.searchedFilters.firstName : '';
                    data_1['wpassId'] = _this.searchedFilters.wpassId;
                }
                if (_this.dashboard == 'admin' || _this.dashboard == 'partners') {
                    _this.httpService.postRequest(data_1, 'userRegistrationsApi/v1/bulkApproveBusinessUnit').subscribe(function (res) {
                        _this.checkResponse(res, status, data_1['allSelected']);
                    }, function (err) { _this.httpService.onEnd(); });
                }
                else {
                    _this.httpService.postRequest(data_1, 'applicationOperationApi/v1/bulkActionUserApplication').subscribe(function (res) {
                        _this.checkResponse(res, status, data_1['allSelected']);
                    }, function (err) { _this.httpService.onEnd(); });
                }
            }
            _this.dialogRef = null;
        });
    };
    MultiApproveRejectComponent.prototype.checkResponse = function (res, status, allSelected) {
        var _this = this;
        if (allSelected) {
            setTimeout(function () {
                _this.httpService.onEnd();
                _this.saveResponse(res, status);
            }, 15000);
        }
        else {
            this.httpService.onEnd();
            this.saveResponse(res, status);
        }
    };
    MultiApproveRejectComponent.prototype.saveResponse = function (res, status) {
        var _this = this;
        var statusTxt;
        if (res) {
            if (status == 'approved') {
                statusTxt = 'after_user_creation_approval_notify';
            }
            else {
                statusTxt = 'Rejected Successfully';
            }
            this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_6__dialog_dialog_component__["a" /* DialogComponent */]);
            this.dialogRef.componentInstance.msg = statusTxt;
            this.dialogRef.afterClosed().subscribe(function (result) {
                if (_this.dashboard == 'admin') {
                    _this.commonService.changeAdminDashboardData();
                }
                else if (_this.dashboard == 'partners') {
                    _this.commonService.changePartnersDashboardData();
                }
                else if (_this.dashboard == 'applicationManagerView') {
                    _this.commonService.changeApplicationDashboardData();
                }
            });
        }
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", Object)
    ], MultiApproveRejectComponent.prototype, "childData", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", Object)
    ], MultiApproveRejectComponent.prototype, "searchedFilters", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", Object)
    ], MultiApproveRejectComponent.prototype, "dashboard", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", Object)
    ], MultiApproveRejectComponent.prototype, "selectedCount", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", Object)
    ], MultiApproveRejectComponent.prototype, "count", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", Object)
    ], MultiApproveRejectComponent.prototype, "totalCount", void 0);
    MultiApproveRejectComponent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"])({
            selector: 'multi-approve-reject',
            template: __webpack_require__(1273)
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_2__angular_router__["b" /* ActivatedRoute */], __WEBPACK_IMPORTED_MODULE_3__shared_services_http_service__["a" /* HttpService */],
            __WEBPACK_IMPORTED_MODULE_4__angular_material__["c" /* MdDialog */], __WEBPACK_IMPORTED_MODULE_5__shared_services_common_service__["a" /* CommonService */]])
    ], MultiApproveRejectComponent);
    return MultiApproveRejectComponent;
}());



/***/ }),

/***/ 779:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PartnersPageData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partners_page__ = __webpack_require__(294);
/**
 * Created by shubham on 11/4/18.
 */

/**
 * An array of data with an associated page object used for paging
 */
var PartnersPageData = /** @class */ (function () {
    function PartnersPageData() {
        this.data = new Array();
        this.page = new __WEBPACK_IMPORTED_MODULE_0__partners_page__["a" /* PartnersPage */]();
    }
    return PartnersPageData;
}());



/***/ }),

/***/ 780:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PartnersDashboardList; });
/**
 * Created by shubham on 11/4/18.
 */
/**
 * A model for an individual corporate employee
 */
var PartnersDashboardList = /** @class */ (function () {
    function PartnersDashboardList(id, Name, roleName, email, emailVerified, userId_WPASS, languageId, languageName, ownerId, sessionUserManager, status, createdAt) {
        this.id = id;
        this.Name = Name;
        this.roleName = roleName;
        this.email = email;
        this.emailVerified = emailVerified;
        this.userId_WPASS = userId_WPASS;
        this.languageId = languageId;
        this.languageName = languageName;
        this.ownerId = ownerId;
        this.sessionUserManager = sessionUserManager;
        this.status = status;
        this.createdAt = createdAt;
    }
    return PartnersDashboardList;
}());



/***/ }),

/***/ 781:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlockCutCopyPasteDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/**
 * Created by shubham on 23/4/18.
 */


var BlockCutCopyPasteDirective = /** @class */ (function () {
    function BlockCutCopyPasteDirective() {
    }
    BlockCutCopyPasteDirective.prototype.blockPaste = function (e) {
        console.log("Can not paste here");
        e.preventDefault();
    };
    BlockCutCopyPasteDirective.prototype.blockCopy = function (e) {
        console.log("Can not copy here");
        e.preventDefault();
    };
    BlockCutCopyPasteDirective.prototype.blockCut = function (e) {
        console.log("Can not cut here");
        e.preventDefault();
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["HostListener"])('paste', ['$event']),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", Function),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [KeyboardEvent]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:returntype", void 0)
    ], BlockCutCopyPasteDirective.prototype, "blockPaste", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["HostListener"])('copy', ['$event']),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", Function),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [KeyboardEvent]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:returntype", void 0)
    ], BlockCutCopyPasteDirective.prototype, "blockCopy", null);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["HostListener"])('cut', ['$event']),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", Function),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [KeyboardEvent]),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:returntype", void 0)
    ], BlockCutCopyPasteDirective.prototype, "blockCut", null);
    BlockCutCopyPasteDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({
            selector: '[appBlockCutCopyPaste]'
        }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [])
    ], BlockCutCopyPasteDirective);
    return BlockCutCopyPasteDirective;
}());



/***/ }),

/***/ 782:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EChartsDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_theme_macarons__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_theme_macarons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_echarts_theme_macarons__);




var EChartsDirective = /** @class */ (function () {
    function EChartsDirective(el) {
        this.el = el;
    }
    EChartsDirective.prototype.ngAfterViewInit = function () {
        this.myChart = __WEBPACK_IMPORTED_MODULE_2_echarts___default.a.init(this.el.nativeElement, 'macarons');
        if (!this.EChartsOptions)
            return;
        this.myChart.setOption(this.EChartsOptions);
    };
    EChartsDirective.prototype.ngOnChanges = function () { };
    EChartsDirective.prototype.ngOnDestroy = function () {
        if (this.myChart) {
            this.myChart.dispose();
        }
    };
    EChartsDirective.prototype.onResize = function () {
        if (this.myChart) {
            this.myChart.resize();
        }
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", Object)
    ], EChartsDirective.prototype, "EChartsOptions", void 0);
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["HostListener"])('window:resize'),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", Function),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", []),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:returntype", void 0)
    ], EChartsDirective.prototype, "onResize", null);
    EChartsDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[myECharts]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"]])
    ], EChartsDirective);
    return EChartsDirective;
}());



/***/ }),

/***/ 783:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SlimScrollDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery_slimscroll_jquery_slimscroll_min_js__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery_slimscroll_jquery_slimscroll_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery_slimscroll_jquery_slimscroll_min_js__);



var SlimScrollDirective = /** @class */ (function () {
    function SlimScrollDirective(el) {
        this.el = el;
    }
    SlimScrollDirective.prototype.ngAfterViewInit = function () {
        var $el = $(this.el.nativeElement);
        $el.slimScroll({
            height: this.scrollHeight || '100%'
        });
    };
    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:type", String)
    ], SlimScrollDirective.prototype, "scrollHeight", void 0);
    SlimScrollDirective = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[mySlimScroll]' }),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"]])
    ], SlimScrollDirective);
    return SlimScrollDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)))

/***/ }),

/***/ 784:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdminListDashboard; });
/**
 * Created by shubham on 11/4/18.
 */
/**
 * A model for an individual corporate employee
 */
var AdminListDashboard = /** @class */ (function () {
    function AdminListDashboard(id, Name, roleName, email, emailVerified, userId_WPASS, pendingSubUserCount, languageId, languageName, active, status, createdAt) {
        this.id = id;
        this.Name = Name;
        this.roleName = roleName;
        this.email = email;
        this.emailVerified = emailVerified;
        this.userId_WPASS = userId_WPASS;
        this.pendingSubUserCount = pendingSubUserCount;
        this.languageId = languageId;
        this.languageName = languageName;
        this.active = active;
        this.status = status;
        this.createdAt = createdAt;
    }
    return AdminListDashboard;
}());



/***/ }),

/***/ 785:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdminListPageData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adminList_page__ = __webpack_require__(298);
/**
 * Created by shubham on 11/4/18.
 */

/**
 * An array of data with an associated page object used for paging
 */
var AdminListPageData = /** @class */ (function () {
    function AdminListPageData() {
        this.data = new Array();
        this.page = new __WEBPACK_IMPORTED_MODULE_0__adminList_page__["a" /* AdminListPage */]();
    }
    return AdminListPageData;
}());



/***/ }),

/***/ 786:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AdminManagementRoutes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdminManagementRoutingModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__adminManagement_component__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__adminList_adminList_component__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addAdmin_addAdmin_component__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__viewAdmin_viewAdmin_component__ = __webpack_require__(303);
/**
 * Created by shubham on 8/5/18.
 */





var AdminManagementRoutes = [
    {
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_1__adminManagement_component__["a" /* AdminManagementComponent */],
        children: [
            { path: '', redirectTo: '/app/profile', pathMatch: 'full' },
            { path: 'list', component: __WEBPACK_IMPORTED_MODULE_2__adminList_adminList_component__["a" /* AdminListComponent */] },
            { path: 'add', component: __WEBPACK_IMPORTED_MODULE_3__addAdmin_addAdmin_component__["a" /* AddAdminComponent */] },
            { path: 'view/:id', component: __WEBPACK_IMPORTED_MODULE_4__viewAdmin_viewAdmin_component__["a" /* ViewAdminComponent */] },
        ]
    }
];
var AdminManagementRoutingModule = __WEBPACK_IMPORTED_MODULE_0__angular_router__["g" /* RouterModule */].forChild(AdminManagementRoutes);


/***/ }),

/***/ 787:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApplicationListDashboard; });
/**
 * Created by prakash on 22/9/18.
 */
/**
 * A model for an Application listing
 */
var ApplicationListDashboard = /** @class */ (function () {
    function ApplicationListDashboard(id, applicationName, ldapApplicationId, managerNames, customerNumberRequired, skipManagerApproval, multipleRole, status, active, createdAt) {
        this.id = id;
        this.applicationName = applicationName;
        this.ldapApplicationId = ldapApplicationId;
        this.managerNames = managerNames;
        this.customerNumberRequired = customerNumberRequired;
        this.skipManagerApproval = skipManagerApproval;
        this.multipleRole = multipleRole;
        this.status = status;
        this.active = active;
        this.createdAt = createdAt;
    }
    return ApplicationListDashboard;
}());



/***/ }),

/***/ 788:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApplicationListPageData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__applicationList_page__ = __webpack_require__(305);
/**
 * Created by prakash on 22/9/18.
 */

/**
 * An array of data with an associated page object used for paging
 */
var ApplicationListPageData = /** @class */ (function () {
    function ApplicationListPageData() {
        this.data = new Array();
        this.page = new __WEBPACK_IMPORTED_MODULE_0__applicationList_page__["a" /* ApplicationListPage */]();
    }
    return ApplicationListPageData;
}());



/***/ }),

/***/ 789:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ApplicationManagementRoutes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApplicationManagementRoutingModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addApplication_addApplication_component__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__applicationManagement_component__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applicationList_applicationList_component__ = __webpack_require__(306);
/**
 * Created by shubham on 19/9/18.
 */




var ApplicationManagementRoutes = [
    {
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_2__applicationManagement_component__["a" /* ApplicationManagementComponent */],
        children: [
            { path: '', redirectTo: '/app/profile', pathMatch: 'full' },
            { path: 'add', component: __WEBPACK_IMPORTED_MODULE_1__addApplication_addApplication_component__["a" /* AddApplicationComponent */] },
            { path: 'list', component: __WEBPACK_IMPORTED_MODULE_3__applicationList_applicationList_component__["a" /* ApplicationListComponent */] },
            { path: 'view/:id', component: __WEBPACK_IMPORTED_MODULE_1__addApplication_addApplication_component__["a" /* AddApplicationComponent */] }
        ]
    }
];
var ApplicationManagementRoutingModule = __WEBPACK_IMPORTED_MODULE_0__angular_router__["g" /* RouterModule */].forChild(ApplicationManagementRoutes);


/***/ }),

/***/ 790:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BusinessUnitListDashboard; });
/**
 * Created by shubham on 11/4/18.
 */
/**
 * A model for an individual corporate employee
 */
var BusinessUnitListDashboard = /** @class */ (function () {
    function BusinessUnitListDashboard(id, Name, code, active, status, createdAt) {
        this.id = id;
        this.Name = Name;
        this.code = code;
        this.active = active;
        this.status = status;
        this.createdAt = createdAt;
    }
    return BusinessUnitListDashboard;
}());



/***/ }),

/***/ 791:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BusinessUnitListPageData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__businessUnitList_page__ = __webpack_require__(744);
/**
 * Created by shubham on 11/4/18.
 */

/**
 * An array of data with an associated page object used for paging
 */
var BusinessUnitListPageData = /** @class */ (function () {
    function BusinessUnitListPageData() {
        this.data = new Array();
        this.page = new __WEBPACK_IMPORTED_MODULE_0__businessUnitList_page__["a" /* BusinessUnitListPage */]();
    }
    return BusinessUnitListPageData;
}());



/***/ }),

/***/ 792:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ManagerAssignmentRoutes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ManagerAssignmentRoutingModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__managerAssignment_component__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__managerList_managerList_component__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addManager_addManager_component__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__viewManager_viewManager_component__ = __webpack_require__(316);
/**
 * Created by shubham on 10/5/18.
 */





var ManagerAssignmentRoutes = [
    {
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_1__managerAssignment_component__["a" /* ManagerAssignmentComponent */],
        children: [
            { path: '', redirectTo: '/app/profile', pathMatch: 'full' },
            { path: 'list', component: __WEBPACK_IMPORTED_MODULE_2__managerList_managerList_component__["a" /* ManagerListComponent */] },
            { path: 'add', component: __WEBPACK_IMPORTED_MODULE_3__addManager_addManager_component__["a" /* AddManagerComponent */] },
            { path: 'view/:buAssociationId', component: __WEBPACK_IMPORTED_MODULE_4__viewManager_viewManager_component__["a" /* ViewManagerComponent */] }
        ]
    }
];
var ManagerAssignmentRoutingModule = __WEBPACK_IMPORTED_MODULE_0__angular_router__["g" /* RouterModule */].forChild(ManagerAssignmentRoutes);


/***/ }),

/***/ 793:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ManagerListDashboard; });
/**
 * Created by shubham on 10/5/18.
 */
/**
 * A model for an individual corporate employee
 */
var ManagerListDashboard = /** @class */ (function () {
    function ManagerListDashboard(buAssociationId, Name, email, emailVerified, userId_WPASS, pendingSubUserCount, applicationName, countryId, countryName, businessUnitId, businessUnitName, active, status, createdAt) {
        this.buAssociationId = buAssociationId;
        this.Name = Name;
        this.email = email;
        this.emailVerified = emailVerified;
        this.userId_WPASS = userId_WPASS;
        this.pendingSubUserCount = pendingSubUserCount;
        this.applicationName = applicationName;
        this.countryId = countryId;
        this.countryName = countryName;
        this.businessUnitId = countryId;
        this.businessUnitName = countryName;
        this.active = active;
        this.status = status;
        this.createdAt = createdAt;
    }
    return ManagerListDashboard;
}());



/***/ }),

/***/ 794:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ManagerListPageData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__managerList_page__ = __webpack_require__(313);
/**
 * Created by shubham on 10/5/18.
 */

/**
 * An array of data with an associated page object used for paging
 */
var ManagerListPageData = /** @class */ (function () {
    function ManagerListPageData() {
        this.data = new Array();
        this.page = new __WEBPACK_IMPORTED_MODULE_0__managerList_page__["a" /* ManagerListPage */]();
    }
    return ManagerListPageData;
}());



/***/ }),

/***/ 795:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TranslationMessagesPageData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__translation_messages_page__ = __webpack_require__(320);

/**
 * An array of data with an associated page object used for paging
 */
var TranslationMessagesPageData = /** @class */ (function () {
    function TranslationMessagesPageData() {
        this.data = new Array();
        this.page = new __WEBPACK_IMPORTED_MODULE_0__translation_messages_page__["a" /* TranslationMessagePage */]();
    }
    return TranslationMessagesPageData;
}());



/***/ }),

/***/ 796:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TranslationMessagesResultService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__translation_messages__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__translations_messages_list__ = __webpack_require__(797);





/**
 * A server used to mock a paged data result from a server
 */
var TranslationMessagesResultService = /** @class */ (function () {
    function TranslationMessagesResultService() {
        this.rows = {};
        this.applicationsDashboardData = {};
    }
    /**
     * A method that mocks a paged server response
     * @param page The selected page
     * @returns {any} An observable containing the employee data
     */
    TranslationMessagesResultService.prototype.getResults = function (page, listData) {
        var _this = this;
        this.listData = listData;
        return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(listData).map(function (data) { return _this.getPageData(page); });
    };
    /**
     * Package companyData into a PagedData object based on the selected Page
     * @param page The page data used to get the selected data from companyData
     * @returns {PagedData<icsList>} An array of the selected data and page
     */
    TranslationMessagesResultService.prototype.getPageData = function (page) {
        var pageData = new __WEBPACK_IMPORTED_MODULE_3__translation_messages__["a" /* TranslationMessagesPageData */]();
        var offset = this.listData.offset;
        var raw = [];
        for (var l in this.listData) {
            if (Object.keys(this.listData[l]).length > 0) {
                raw[offset + parseInt(l)] = this.listData[l];
            }
        }
        if (this.listData.totalCount) {
            page.totalElements = this.listData.totalCount;
        }
        page.totalPages = page.totalElements / page.size;
        var start = page.pageNumber * page.size;
        var end = Math.min((start + page.size), page.totalElements);
        for (var i = start; i < end; i++) {
            if (raw[i]) {
                var jsonObj = raw[i];
                if (jsonObj) {
                    var list = new __WEBPACK_IMPORTED_MODULE_4__translations_messages_list__["a" /* TranslationMessagesList */](jsonObj['id'], jsonObj['key'], jsonObj['english'], jsonObj['seletedLanguage'], jsonObj['actionFlag']);
                    pageData.data.push(list);
                }
            }
        }
        pageData.page = page;
        return pageData;
    };
    TranslationMessagesResultService = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [])
    ], TranslationMessagesResultService);
    return TranslationMessagesResultService;
}());



/***/ }),

/***/ 797:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TranslationMessagesList; });
var TranslationMessagesList = /** @class */ (function () {
    function TranslationMessagesList(id, key, english, seletedLanguage, actionFlag) {
        this.key = key;
        this.id = id;
        this.english = english;
        this.seletedLanguage = seletedLanguage;
        this.actionFlag = actionFlag;
    }
    return TranslationMessagesList;
}());



/***/ }),

/***/ 798:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserActivityDashboardList; });
var UserActivityDashboardList = /** @class */ (function () {
    function UserActivityDashboardList(username, createdAt, description, email, wpassId) {
        this.username = username;
        this.createdAt = createdAt;
        this.description = description;
        this.email = email;
        this.wpassId = wpassId;
    }
    return UserActivityDashboardList;
}());



/***/ }),

/***/ 799:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserActivityPageData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user_activity_page__ = __webpack_require__(322);

/**
 * An array of data with an associated page object used for paging
 */
var UserActivityPageData = /** @class */ (function () {
    function UserActivityPageData() {
        this.data = new Array();
        this.page = new __WEBPACK_IMPORTED_MODULE_0__user_activity_page__["a" /* UserActivityPage */]();
    }
    return UserActivityPageData;
}());



/***/ }),

/***/ 800:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BusinessUnitListDashboard; });
/**
 * Created by shubham on 20/11/18.
 */
/**
 * A model for an individual corporate employee
 */
var BusinessUnitListDashboard = /** @class */ (function () {
    function BusinessUnitListDashboard(countryId, countryName, businessUnitId, businessUnitName, emailVerified, customerNumber, selectedApplicationNames, status, active) {
        this.countryId = countryId;
        this.countryName = countryName;
        this.businessUnitId = businessUnitId;
        this.businessUnitName = businessUnitName;
        this.emailVerified = emailVerified;
        this.customerNumber = customerNumber;
        this.selectedApplicationNames = selectedApplicationNames;
        this.status = status;
        this.active = active;
    }
    return BusinessUnitListDashboard;
}());



/***/ }),

/***/ 801:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BusinessUnitListPageData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__businessUnitList_page__ = __webpack_require__(328);
/**
 * Created by shubham on 20/11/18.
 */

/**
 * An array of data with an associated page object used for paging
 */
var BusinessUnitListPageData = /** @class */ (function () {
    function BusinessUnitListPageData() {
        this.data = new Array();
        this.page = new __WEBPACK_IMPORTED_MODULE_0__businessUnitList_page__["a" /* BusinessUnitListPage */]();
    }
    return BusinessUnitListPageData;
}());



/***/ }),

/***/ 802:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RequestBusinessUnitRoutes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RequestBusinessUnitRoutingModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request_business_unit_component__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__add_business_unit_add_business_unit_component__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__business_unit_list_business_unit_list_component__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_business_unit_view_business_unit_component__ = __webpack_require__(331);
/**
 * Created by shubham on 19/11/18.
 */





var RequestBusinessUnitRoutes = [
    {
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_1__request_business_unit_component__["a" /* RequestBusinessUnitComponent */],
        children: [
            { path: '', redirectTo: '/app/partners-dashboard', pathMatch: 'full' },
            { path: 'list', component: __WEBPACK_IMPORTED_MODULE_3__business_unit_list_business_unit_list_component__["a" /* BusinessUnitListForUserComponent */] },
            { path: 'add', component: __WEBPACK_IMPORTED_MODULE_2__add_business_unit_add_business_unit_component__["a" /* AddBusinessUnitForUserComponent */] },
            { path: 'view/:id', component: __WEBPACK_IMPORTED_MODULE_4__view_business_unit_view_business_unit_component__["a" /* ViewBusinessUnitForUserComponent */] }
        ]
    }
];
var RequestBusinessUnitRoutingModule = __WEBPACK_IMPORTED_MODULE_0__angular_router__["g" /* RouterModule */].forChild(RequestBusinessUnitRoutes);


/***/ }),

/***/ 803:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UserRoutes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserRoutingModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_component__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__add_edit_user_add_edit_user_component__ = __webpack_require__(332);
/**
 * Created by shubham on 16/4/18.
 */



var UserRoutes = [
    {
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_1__user_component__["a" /* UserComponent */],
        children: [
            { path: '', redirectTo: '/app/partners-dashboard', pathMatch: 'full' },
            { path: 'add', component: __WEBPACK_IMPORTED_MODULE_2__add_edit_user_add_edit_user_component__["a" /* AddEditUserComponent */] },
            { path: 'edit/:id', component: __WEBPACK_IMPORTED_MODULE_2__add_edit_user_add_edit_user_component__["a" /* AddEditUserComponent */] }
        ]
    }
];
var UserRoutingModule = __WEBPACK_IMPORTED_MODULE_0__angular_router__["g" /* RouterModule */].forChild(UserRoutes);


/***/ }),

/***/ 804:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RequestRoutes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RequestRoutingModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_request_component__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__viewPartners_viewPartners_component__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__viewSubUsers_viewSubUsers_component__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__viewApplicationRequest_viewApplicationRequest_component__ = __webpack_require__(336);
/**
 * Created by shubham on 16/4/18.
 */





var RequestRoutes = [
    {
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_1__view_request_component__["b" /* ViewRequestComponent */],
        children: [
            { path: '', redirectTo: '/app/admin-dashboard', pathMatch: 'full' },
            { path: 'viewPartners/:id', component: __WEBPACK_IMPORTED_MODULE_2__viewPartners_viewPartners_component__["a" /* ViewPartnersRequestComponent */] },
            { path: 'viewSubUsers/:id', component: __WEBPACK_IMPORTED_MODULE_3__viewSubUsers_viewSubUsers_component__["a" /* ViewSubUsersRequestComponent */] },
            { path: 'viewApplicationRequest/:id', component: __WEBPACK_IMPORTED_MODULE_4__viewApplicationRequest_viewApplicationRequest_component__["a" /* ViewApplicationRequestComponent */] },
        ]
    }
];
var RequestRoutingModule = __WEBPACK_IMPORTED_MODULE_0__angular_router__["g" /* RouterModule */].forChild(RequestRoutes);


/***/ }),

/***/ 805:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["main"] = main;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser_dynamic__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_app_module__ = __webpack_require__(723);



// depending on the env mode, enable prod mode or add debugging modules
if (true) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["enableProdMode"])();
}
function main() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_platform_browser_dynamic__["a" /* platformBrowserDynamic */])().bootstrapModule(__WEBPACK_IMPORTED_MODULE_2__app_app_module__["a" /* AppModule */]);
}
if (document.readyState === 'complete') {
    main();
}
else {
    document.addEventListener('DOMContentLoaded', main);
}


/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__session_handler_service__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_services_common_service__ = __webpack_require__(24);





var ErrorHandler = /** @class */ (function () {
    function ErrorHandler(router, sessionHandler, commonService) {
        this.router = router;
        this.sessionHandler = sessionHandler;
        this.commonService = commonService;
    }
    ErrorHandler.prototype.handle = function (response) {
        if (response.error != undefined) {
            console.log("handling error");
            if (response.error.code == 401 || response.error.code == 403) {
                console.log("Error : " + response.error.message);
                if (response.error.message == "Access token not valid" || response.error.message == "Session Expired") {
                    this.commonService.setLoginRedirectUrl(window.location.hash);
                }
                this.sessionHandler.clearAllItems();
                //this.sessionHandler.saveItem("lastUrl", window.location.hash);
                this.router.navigate(['/login']);
            }
            else if (response.error.code == 404) {
                console.log("Forbidden : " + response);
                window.location.href = "/#/extra/404";
            }
            else if (response.error.code == 500) {
                console.log("Server Exception : " + response);
                window.location.href = "/#/extra/500";
            }
        }
    };
    ErrorHandler = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __decorate */]([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
        __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __metadata */]("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_3__session_handler_service__["a" /* SessionHandler */], __WEBPACK_IMPORTED_MODULE_4__shared_services_common_service__["a" /* CommonService */]])
    ], ErrorHandler);
    return ErrorHandler;
}());



/***/ })

},[805]);


// WEBPACK FOOTER //
// js/main.2d8ebd27c257e4cb4686.js